/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddSitelinkSets
// ====================================================

export interface AddSitelinkSets_addSitelinkSets_addedSitelinkSets {
  __typename: "GdAddSitelinkSetPayloadItem";
  id: GraphQlLong;
}

export interface AddSitelinkSets_addSitelinkSets_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddSitelinkSets_addSitelinkSets_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddSitelinkSets_addSitelinkSets_validationResult {
  __typename: "GdValidationResult";
  errors: AddSitelinkSets_addSitelinkSets_validationResult_errors[];
  warnings: AddSitelinkSets_addSitelinkSets_validationResult_warnings[];
}

export interface AddSitelinkSets_addSitelinkSets {
  __typename: "GdAddSitelinkSetsPayload";
  addedSitelinkSets: (AddSitelinkSets_addSitelinkSets_addedSitelinkSets | null)[];
  validationResult: AddSitelinkSets_addSitelinkSets_validationResult | null;
}

export interface AddSitelinkSets_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface AddSitelinkSets {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addSitelinkSets: AddSitelinkSets_addSitelinkSets;
  getClientMutationId: AddSitelinkSets_getClientMutationId;
}

export interface AddSitelinkSetsVariables {
  input: GdAddSitelinkSetsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateAdPrices
// ====================================================

export interface updateAdPrices_updateAdPrices_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface updateAdPrices_updateAdPrices {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (updateAdPrices_updateAdPrices_updatedAds | null)[];
}

export interface updateAdPrices {
  updateAdPrices: updateAdPrices_updateAdPrices;
}

export interface updateAdPricesVariables {
  input: GdUpdateAdPriceInput[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateAdsMutation
// ====================================================

export interface UpdateAdsMutation_updateAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface UpdateAdsMutation_updateAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateAdsMutation_updateAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateAdsMutation_updateAds_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateAdsMutation_updateAds_validationResult_errors[];
  warnings: UpdateAdsMutation_updateAds_validationResult_warnings[];
}

export interface UpdateAdsMutation_updateAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (UpdateAdsMutation_updateAds_updatedAds | null)[];
  validationResult: UpdateAdsMutation_updateAds_validationResult | null;
}

export interface UpdateAdsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface UpdateAdsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  updateAds: UpdateAdsMutation_updateAds;
  getClientMutationId: UpdateAdsMutation_getClientMutationId;
}

export interface UpdateAdsMutationVariables {
  input: GdUpdateAdsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddAdsMutation
// ====================================================

export interface AddAdsMutation_addAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface AddAdsMutation_addAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddAdsMutation_addAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddAdsMutation_addAds_validationResult {
  __typename: "GdValidationResult";
  errors: AddAdsMutation_addAds_validationResult_errors[];
  warnings: AddAdsMutation_addAds_validationResult_warnings[];
}

export interface AddAdsMutation_addAds {
  __typename: "GdAddAdsPayload";
  addedAds: (AddAdsMutation_addAds_addedAds | null)[];
  validationResult: AddAdsMutation_addAds_validationResult | null;
}

export interface AddAdsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface AddAdsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addAds: AddAdsMutation_addAds;
  getClientMutationId: AddAdsMutation_getClientMutationId;
}

export interface AddAdsMutationVariables {
  input: GdAddAdsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveAdsMutation
// ====================================================

export interface SaveAdsMutation_addAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface SaveAdsMutation_addAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_addAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_addAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdsMutation_addAds_validationResult_errors[];
  warnings: SaveAdsMutation_addAds_validationResult_warnings[];
}

export interface SaveAdsMutation_addAds {
  __typename: "GdAddAdsPayload";
  addedAds: (SaveAdsMutation_addAds_addedAds | null)[];
  validationResult: SaveAdsMutation_addAds_validationResult | null;
}

export interface SaveAdsMutation_updateAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface SaveAdsMutation_updateAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_updateAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_updateAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdsMutation_updateAds_validationResult_errors[];
  warnings: SaveAdsMutation_updateAds_validationResult_warnings[];
}

export interface SaveAdsMutation_updateAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (SaveAdsMutation_updateAds_updatedAds | null)[];
  validationResult: SaveAdsMutation_updateAds_validationResult | null;
}

export interface SaveAdsMutation_updateSmartAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface SaveAdsMutation_updateSmartAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_updateSmartAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_updateSmartAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdsMutation_updateSmartAds_validationResult_errors[];
  warnings: SaveAdsMutation_updateSmartAds_validationResult_warnings[];
}

export interface SaveAdsMutation_updateSmartAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (SaveAdsMutation_updateSmartAds_updatedAds | null)[];
  validationResult: SaveAdsMutation_updateSmartAds_validationResult | null;
}

export interface SaveAdsMutation_addSmartAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface SaveAdsMutation_addSmartAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_addSmartAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_addSmartAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdsMutation_addSmartAds_validationResult_errors[];
  warnings: SaveAdsMutation_addSmartAds_validationResult_warnings[];
}

export interface SaveAdsMutation_addSmartAds {
  __typename: "GdAddAdsPayload";
  addedAds: (SaveAdsMutation_addSmartAds_addedAds | null)[];
  validationResult: SaveAdsMutation_addSmartAds_validationResult | null;
}

export interface SaveAdsMutation_addCpmAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface SaveAdsMutation_addCpmAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_addCpmAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_addCpmAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdsMutation_addCpmAds_validationResult_errors[];
  warnings: SaveAdsMutation_addCpmAds_validationResult_warnings[];
}

export interface SaveAdsMutation_addCpmAds {
  __typename: "GdAddAdsPayload";
  addedAds: (SaveAdsMutation_addCpmAds_addedAds | null)[];
  validationResult: SaveAdsMutation_addCpmAds_validationResult | null;
}

export interface SaveAdsMutation_updateCpmAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface SaveAdsMutation_updateCpmAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_updateCpmAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_updateCpmAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdsMutation_updateCpmAds_validationResult_errors[];
  warnings: SaveAdsMutation_updateCpmAds_validationResult_warnings[];
}

export interface SaveAdsMutation_updateCpmAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (SaveAdsMutation_updateCpmAds_updatedAds | null)[];
  validationResult: SaveAdsMutation_updateCpmAds_validationResult | null;
}

export interface SaveAdsMutation_addMcBannerAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface SaveAdsMutation_addMcBannerAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_addMcBannerAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_addMcBannerAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdsMutation_addMcBannerAds_validationResult_errors[];
  warnings: SaveAdsMutation_addMcBannerAds_validationResult_warnings[];
}

export interface SaveAdsMutation_addMcBannerAds {
  __typename: "GdAddAdsPayload";
  addedAds: (SaveAdsMutation_addMcBannerAds_addedAds | null)[];
  validationResult: SaveAdsMutation_addMcBannerAds_validationResult | null;
}

export interface SaveAdsMutation_updateMcBannerAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface SaveAdsMutation_updateMcBannerAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_updateMcBannerAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_updateMcBannerAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdsMutation_updateMcBannerAds_validationResult_errors[];
  warnings: SaveAdsMutation_updateMcBannerAds_validationResult_warnings[];
}

export interface SaveAdsMutation_updateMcBannerAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (SaveAdsMutation_updateMcBannerAds_updatedAds | null)[];
  validationResult: SaveAdsMutation_updateMcBannerAds_validationResult | null;
}

export interface SaveAdsMutation_deleteAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_deleteAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_deleteAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdsMutation_deleteAds_validationResult_errors[];
  warnings: SaveAdsMutation_deleteAds_validationResult_warnings[];
}

export interface SaveAdsMutation_deleteAds {
  __typename: "GdAdsMassActionPayload";
  validationResult: SaveAdsMutation_deleteAds_validationResult | null;
}

export interface SaveAdsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface SaveAdsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addAds: SaveAdsMutation_addAds;
  updateAds: SaveAdsMutation_updateAds;
  updateSmartAds: SaveAdsMutation_updateSmartAds;
  addSmartAds: SaveAdsMutation_addSmartAds;
  addCpmAds: SaveAdsMutation_addCpmAds;
  updateCpmAds: SaveAdsMutation_updateCpmAds;
  addMcBannerAds: SaveAdsMutation_addMcBannerAds;
  updateMcBannerAds: SaveAdsMutation_updateMcBannerAds;
  deleteAds: SaveAdsMutation_deleteAds;
  getClientMutationId: SaveAdsMutation_getClientMutationId;
}

export interface SaveAdsMutationVariables {
  addInput: GdAddAdsInput;
  updateInput: GdUpdateAdsInput;
  updateSmartAds: GdUpdateSmartAdsInput;
  smartAds: GdAddSmartAdsInput;
  addCpmAdsInput: GdAddCpmAdsInput;
  updateCpmAdsInput: GdUpdateCpmAdsInput;
  deleteInput: GdAdsMassActionInput;
  addMcBannerInput: GdAddMcBannerAdsInput;
  updateMcBannerInput: GdUpdateMcBannerAdsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveInternalAdsMutation
// ====================================================

export interface SaveInternalAdsMutation_addInternalAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface SaveInternalAdsMutation_addInternalAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveInternalAdsMutation_addInternalAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveInternalAdsMutation_addInternalAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveInternalAdsMutation_addInternalAds_validationResult_errors[];
  warnings: SaveInternalAdsMutation_addInternalAds_validationResult_warnings[];
}

export interface SaveInternalAdsMutation_addInternalAds {
  __typename: "GdAddAdsPayload";
  addedAds: (SaveInternalAdsMutation_addInternalAds_addedAds | null)[];
  validationResult: SaveInternalAdsMutation_addInternalAds_validationResult | null;
}

export interface SaveInternalAdsMutation_updateInternalAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface SaveInternalAdsMutation_updateInternalAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveInternalAdsMutation_updateInternalAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveInternalAdsMutation_updateInternalAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveInternalAdsMutation_updateInternalAds_validationResult_errors[];
  warnings: SaveInternalAdsMutation_updateInternalAds_validationResult_warnings[];
}

export interface SaveInternalAdsMutation_updateInternalAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (SaveInternalAdsMutation_updateInternalAds_updatedAds | null)[];
  validationResult: SaveInternalAdsMutation_updateInternalAds_validationResult | null;
}

export interface SaveInternalAdsMutation_deleteAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveInternalAdsMutation_deleteAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveInternalAdsMutation_deleteAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveInternalAdsMutation_deleteAds_validationResult_errors[];
  warnings: SaveInternalAdsMutation_deleteAds_validationResult_warnings[];
}

export interface SaveInternalAdsMutation_deleteAds {
  __typename: "GdAdsMassActionPayload";
  validationResult: SaveInternalAdsMutation_deleteAds_validationResult | null;
}

export interface SaveInternalAdsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface SaveInternalAdsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addInternalAds: SaveInternalAdsMutation_addInternalAds;
  updateInternalAds: SaveInternalAdsMutation_updateInternalAds;
  deleteAds: SaveInternalAdsMutation_deleteAds;
  getClientMutationId: SaveInternalAdsMutation_getClientMutationId;
}

export interface SaveInternalAdsMutationVariables {
  addInput: GdAddInternalAdsInput;
  updateInput: GdUpdateInternalAdsInput;
  deleteInput: GdAdsMassActionInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddVCards
// ====================================================

export interface AddVCards_addVcards_addedVcards {
  __typename: "GdAddVcardsPayloadItem";
  id: GraphQlLong;
}

export interface AddVCards_addVcards_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddVCards_addVcards_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddVCards_addVcards_validationResult {
  __typename: "GdValidationResult";
  errors: AddVCards_addVcards_validationResult_errors[];
  warnings: AddVCards_addVcards_validationResult_warnings[];
}

export interface AddVCards_addVcards {
  __typename: "GdAddVcardsPayload";
  addedVcards: AddVCards_addVcards_addedVcards[];
  validationResult: AddVCards_addVcards_validationResult | null;
}

export interface AddVCards {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addVcards: AddVCards_addVcards;
}

export interface AddVCardsVariables {
  input: GdAddVcardsInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ArchiveAds
// ====================================================

export interface ArchiveAds_archiveAds {
  __typename: "GdAdsMassActionPayload";
  processedAdIds: GraphQlLong[];
  skippedAdIds: GraphQlLong[];
}

export interface ArchiveAds {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  archiveAds: ArchiveAds_archiveAds;
}

export interface ArchiveAdsVariables {
  input: GdAdsMassActionInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UnarchiveAds
// ====================================================

export interface UnarchiveAds_unarchiveAds {
  __typename: "GdAdsMassActionPayload";
  processedAdIds: GraphQlLong[];
  skippedAdIds: GraphQlLong[];
}

export interface UnarchiveAds {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  unarchiveAds: UnarchiveAds_unarchiveAds;
}

export interface UnarchiveAdsVariables {
  input: GdAdsMassActionInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SuspendAds
// ====================================================

export interface SuspendAds_suspendAds {
  __typename: "GdAdsMassActionPayload";
  processedAdIds: GraphQlLong[];
  skippedAdIds: GraphQlLong[];
}

export interface SuspendAds {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  suspendAds: SuspendAds_suspendAds;
}

export interface SuspendAdsVariables {
  input: GdAdsMassActionInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ResumeAds
// ====================================================

export interface ResumeAds_resumeAds {
  __typename: "GdAdsMassActionPayload";
  processedAdIds: GraphQlLong[];
  skippedAdIds: GraphQlLong[];
}

export interface ResumeAds {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  resumeAds: ResumeAds_resumeAds;
}

export interface ResumeAdsVariables {
  input: GdAdsMassActionInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteAds
// ====================================================

export interface DeleteAds_deleteAds {
  __typename: "GdAdsMassActionPayload";
  processedAdIds: GraphQlLong[];
  skippedAdIds: GraphQlLong[];
}

export interface DeleteAds {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  deleteAds: DeleteAds_deleteAds;
}

export interface DeleteAdsVariables {
  input: GdAdsMassActionInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateImageSmartCenters
// ====================================================

export interface UpdateImageSmartCenters_updateSmartCenters_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateImageSmartCenters_updateSmartCenters_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateImageSmartCenters_updateSmartCenters_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateImageSmartCenters_updateSmartCenters_validationResult_errors[];
  warnings: UpdateImageSmartCenters_updateSmartCenters_validationResult_warnings[];
}

export interface UpdateImageSmartCenters_updateSmartCenters_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UpdateImageSmartCenters_updateSmartCenters_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UpdateImageSmartCenters_updateSmartCenters_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UpdateImageSmartCenters_updateSmartCenters_image_formats {
  __typename: "GdImageFormat";
  imageSize: UpdateImageSmartCenters_updateSmartCenters_image_formats_imageSize;
  path: string;
  smartCenters: UpdateImageSmartCenters_updateSmartCenters_image_formats_smartCenters[] | null;
}

export interface UpdateImageSmartCenters_updateSmartCenters_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UpdateImageSmartCenters_updateSmartCenters_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: UpdateImageSmartCenters_updateSmartCenters_image_formats[] | null;
}

export interface UpdateImageSmartCenters_updateSmartCenters {
  __typename: "GdUpdateSmartCentersPayload";
  validationResult: UpdateImageSmartCenters_updateSmartCenters_validationResult | null;
  image: UpdateImageSmartCenters_updateSmartCenters_image;
}

export interface UpdateImageSmartCenters_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface UpdateImageSmartCenters {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  updateSmartCenters: UpdateImageSmartCenters_updateSmartCenters;
  getClientMutationId: UpdateImageSmartCenters_getClientMutationId;
}

export interface UpdateImageSmartCentersVariables {
  input: GdUpdateSmartCentersInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: GenerateVideoAddition
// ====================================================

export interface GenerateVideoAddition_generateVideoAddition {
  __typename: "GdSmartCreative" | "GdCanvasCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  previewUrl: string;
  width: GraphQlLong | null;
}

export interface GenerateVideoAddition {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  generateVideoAddition: (GenerateVideoAddition_generateVideoAddition | null)[] | null;
}

export interface GenerateVideoAdditionVariables {
  input: GdGenerateVideoAdditionInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveCallouts
// ====================================================

export interface SaveCallouts_saveCallouts_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveCallouts_saveCallouts_validationResult_warnings {
  __typename: "GdDefect";
  params: GraphQlObjectScalar | null;
  path: string;
  code: string;
}

export interface SaveCallouts_saveCallouts_validationResult {
  __typename: "GdValidationResult";
  errors: SaveCallouts_saveCallouts_validationResult_errors[];
  warnings: SaveCallouts_saveCallouts_validationResult_warnings[];
}

export interface SaveCallouts_saveCallouts {
  __typename: "GdSaveCalloutsPayload";
  calloutIds: GraphQlLong[];
  validationResult: SaveCallouts_saveCallouts_validationResult | null;
}

export interface SaveCallouts {
  saveCallouts: SaveCallouts_saveCallouts;
}

export interface SaveCalloutsVariables {
  input: GdSaveCalloutsInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteCallouts
// ====================================================

export interface DeleteCallouts_deleteCallouts_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface DeleteCallouts_deleteCallouts_validationResult_warnings {
  __typename: "GdDefect";
  params: GraphQlObjectScalar | null;
  path: string;
  code: string;
}

export interface DeleteCallouts_deleteCallouts_validationResult {
  __typename: "GdValidationResult";
  errors: DeleteCallouts_deleteCallouts_validationResult_errors[];
  warnings: DeleteCallouts_deleteCallouts_validationResult_warnings[];
}

export interface DeleteCallouts_deleteCallouts {
  __typename: "GdDeleteCalloutsPayload";
  calloutIds: GraphQlLong[];
  validationResult: DeleteCallouts_deleteCallouts_validationResult | null;
}

export interface DeleteCallouts {
  deleteCallouts: DeleteCallouts_deleteCallouts;
}

export interface DeleteCalloutsVariables {
  input: GdDeleteCalloutsInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateCampaigns
// ====================================================

export interface UpdateCampaigns_updateCampaigns_updatedCampaigns {
  __typename: "GdUpdateCampaignPayloadItem";
  id: GraphQlLong;
}

export interface UpdateCampaigns_updateCampaigns_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateCampaigns_updateCampaigns_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateCampaigns_updateCampaigns_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateCampaigns_updateCampaigns_validationResult_errors[];
  warnings: UpdateCampaigns_updateCampaigns_validationResult_warnings[];
}

export interface UpdateCampaigns_updateCampaigns {
  __typename: "GdUpdateCampaignPayload";
  updatedCampaigns: (UpdateCampaigns_updateCampaigns_updatedCampaigns | null)[];
  validationResult: UpdateCampaigns_updateCampaigns_validationResult | null;
}

export interface UpdateCampaigns_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface UpdateCampaigns {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  updateCampaigns: UpdateCampaigns_updateCampaigns;
  getClientMutationId: UpdateCampaigns_getClientMutationId;
}

export interface UpdateCampaignsVariables {
  input: GdUpdateCampaignsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddDialogMutation
// ====================================================

export interface AddDialogMutation_addDialog_dialog {
  __typename: "GdDialog";
  clientId: GraphQlLong;
  id: GraphQlLong | null;
  isActive: boolean;
  name: string;
  skillId: string;
}

export interface AddDialogMutation_addDialog_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddDialogMutation_addDialog_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddDialogMutation_addDialog_validationResult {
  __typename: "GdValidationResult";
  errors: AddDialogMutation_addDialog_validationResult_errors[];
  warnings: AddDialogMutation_addDialog_validationResult_warnings[];
}

export interface AddDialogMutation_addDialog {
  __typename: "GdAddDialogPayload";
  dialog: AddDialogMutation_addDialog_dialog | null;
  validationResult: AddDialogMutation_addDialog_validationResult | null;
}

export interface AddDialogMutation {
  addDialog: AddDialogMutation_addDialog;
}

export interface AddDialogMutationVariables {
  input: GdAddDialogRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RequestFlServiceByClientMutation
// ====================================================

export interface RequestFlServiceByClientMutation_requestFlServiceByClient_freelancerProject_freelancer {
  __typename: "GdFreelancerBase" | "GdFreelancerFull";
  login: string;
}

export interface RequestFlServiceByClientMutation_requestFlServiceByClient_freelancerProject {
  __typename: "GdFreelancerProject";
  id: GraphQlLong;
  startedTime: GraphQlLocalDateTime | null;
  createdTime: GraphQlLocalDateTime;
  freelancer: RequestFlServiceByClientMutation_requestFlServiceByClient_freelancerProject_freelancer | null;
}

export interface RequestFlServiceByClientMutation_requestFlServiceByClient {
  __typename: "GdRequestFlServiceByClientRequestPayload";
  freelancerId: GraphQlLong;
  clientId: GraphQlLong;
  freelancerProject: RequestFlServiceByClientMutation_requestFlServiceByClient_freelancerProject;
}

export interface RequestFlServiceByClientMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  requestFlServiceByClient: RequestFlServiceByClientMutation_requestFlServiceByClient;
}

export interface RequestFlServiceByClientMutationVariables {
  input: GdRequestFlServiceByClientRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AcceptFIServiceByFreelancerMutation
// ====================================================

export interface AcceptFIServiceByFreelancerMutation_acceptFlServiceByFreelancer_freelancerProject {
  __typename: "GdFreelancerProject";
  id: GraphQlLong;
  updatedTime: GraphQlLocalDateTime;
}

export interface AcceptFIServiceByFreelancerMutation_acceptFlServiceByFreelancer {
  __typename: "GdAcceptFlServiceByFreelancerRequestPayload";
  freelancerProject: AcceptFIServiceByFreelancerMutation_acceptFlServiceByFreelancer_freelancerProject;
}

export interface AcceptFIServiceByFreelancerMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  acceptFlServiceByFreelancer: AcceptFIServiceByFreelancerMutation_acceptFlServiceByFreelancer;
}

export interface AcceptFIServiceByFreelancerMutationVariables {
  input: GdAcceptFlServiceByFreelancerRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CancelFIServiceByFreelancerMutation
// ====================================================

export interface CancelFIServiceByFreelancerMutation_cancelFlServiceByFreelancer_freelancerProject {
  __typename: "GdFreelancerProject";
  id: GraphQlLong;
  updatedTime: GraphQlLocalDateTime;
}

export interface CancelFIServiceByFreelancerMutation_cancelFlServiceByFreelancer {
  __typename: "GdCancelFlServiceByFreelancerRequestPayload";
  freelancerProject: CancelFIServiceByFreelancerMutation_cancelFlServiceByFreelancer_freelancerProject;
}

export interface CancelFIServiceByFreelancerMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  cancelFlServiceByFreelancer: CancelFIServiceByFreelancerMutation_cancelFlServiceByFreelancer;
}

export interface CancelFIServiceByFreelancerMutationVariables {
  input: GdCancelFlServiceByFreelancerRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CancelFlServiceByClientMutation
// ====================================================

export interface CancelFlServiceByClientMutation_cancelFlServiceByClient_freelancerProject {
  __typename: "GdFreelancerProject";
  id: GraphQlLong;
  status: GdFreelancerProjectStatus;
}

export interface CancelFlServiceByClientMutation_cancelFlServiceByClient {
  __typename: "GdCancelFlServiceByClientRequestPayload";
  freelancerId: GraphQlLong;
  clientId: GraphQlLong;
  freelancerProject: CancelFlServiceByClientMutation_cancelFlServiceByClient_freelancerProject;
}

export interface CancelFlServiceByClientMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  cancelFlServiceByClient: CancelFlServiceByClientMutation_cancelFlServiceByClient;
}

export interface CancelFlServiceByClientMutationVariables {
  input: GdCancelFlServiceByClientRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateFreelancerStatusMutation
// ====================================================

export interface UpdateFreelancerStatusMutation_updateFreelancerStatus_freelancer {
  __typename: "GdFreelancerBase" | "GdFreelancerFull";
  status: GdFreelancerStatus;
}

export interface UpdateFreelancerStatusMutation_updateFreelancerStatus {
  __typename: "GdUpdateFreelancerCardRequestPayload";
  freelancer: UpdateFreelancerStatusMutation_updateFreelancerStatus_freelancer;
}

export interface UpdateFreelancerStatusMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  updateFreelancerStatus: UpdateFreelancerStatusMutation_updateFreelancerStatus;
}

export interface UpdateFreelancerStatusMutationVariables {
  input: GdUpdateFlStatusRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddFeedbackForFreelancerMutation
// ====================================================

export interface AddFeedbackForFreelancerMutation_addFeedbackForFreelancer_feedback_authorInfo {
  __typename: "GdUserPublicInfo";
  avatarUrl: string;
  login: string;
  name: string;
  userId: GraphQlLong;
}

export interface AddFeedbackForFreelancerMutation_addFeedbackForFreelancer_feedback {
  __typename: "GdFreelancerFeedback";
  authorInfo: AddFeedbackForFreelancerMutation_addFeedbackForFreelancer_feedback_authorInfo | null;
  authorUid: GraphQlLong;
  createdTime: GraphQlLocalDateTime;
  feedbackId: string;
  feedbackText: string;
  freelancerId: GraphQlLong;
  overallMark: GraphQlLong;
  willRecommend: boolean | null;
  moderationStatus: GdFreelancerUgcModerationStatus;
}

export interface AddFeedbackForFreelancerMutation_addFeedbackForFreelancer {
  __typename: "GdAddFeedbackForFreelancerPayload";
  feedback: AddFeedbackForFreelancerMutation_addFeedbackForFreelancer_feedback;
}

export interface AddFeedbackForFreelancerMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addFeedbackForFreelancer: AddFeedbackForFreelancerMutation_addFeedbackForFreelancer;
}

export interface AddFeedbackForFreelancerMutationVariables {
  input: GdAddFeedbackForFreelancerRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateFreelancerFeedbackMutation
// ====================================================

export interface UpdateFreelancerFeedbackMutation_updateFreelancerFeedback_feedback_authorInfo {
  __typename: "GdUserPublicInfo";
  avatarUrl: string;
  login: string;
  name: string;
  userId: GraphQlLong;
}

export interface UpdateFreelancerFeedbackMutation_updateFreelancerFeedback_feedback {
  __typename: "GdFreelancerFeedback";
  authorInfo: UpdateFreelancerFeedbackMutation_updateFreelancerFeedback_feedback_authorInfo | null;
  authorUid: GraphQlLong;
  createdTime: GraphQlLocalDateTime;
  feedbackId: string;
  feedbackText: string;
  freelancerId: GraphQlLong;
  overallMark: GraphQlLong;
  willRecommend: boolean | null;
  moderationStatus: GdFreelancerUgcModerationStatus;
}

export interface UpdateFreelancerFeedbackMutation_updateFreelancerFeedback {
  __typename: "GdUpdateFreelancerFeedbackPayload";
  feedback: UpdateFreelancerFeedbackMutation_updateFreelancerFeedback_feedback;
}

export interface UpdateFreelancerFeedbackMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  updateFreelancerFeedback: UpdateFreelancerFeedbackMutation_updateFreelancerFeedback;
}

export interface UpdateFreelancerFeedbackMutationVariables {
  input: GdUpdateFreelancerFeedbackRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteFreelancerFeedbackMutation
// ====================================================

export interface DeleteFreelancerFeedbackMutation_deleteFreelancerFeedback_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface DeleteFreelancerFeedbackMutation_deleteFreelancerFeedback_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface DeleteFreelancerFeedbackMutation_deleteFreelancerFeedback_validationResult {
  __typename: "GdValidationResult";
  errors: DeleteFreelancerFeedbackMutation_deleteFreelancerFeedback_validationResult_errors[];
  warnings: DeleteFreelancerFeedbackMutation_deleteFreelancerFeedback_validationResult_warnings[];
}

export interface DeleteFreelancerFeedbackMutation_deleteFreelancerFeedback {
  __typename: "GdDeleteFreelancerFeedbackPayload";
  feedbackId: string;
  validationResult: DeleteFreelancerFeedbackMutation_deleteFreelancerFeedback_validationResult | null;
}

export interface DeleteFreelancerFeedbackMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  deleteFreelancerFeedback: DeleteFreelancerFeedbackMutation_deleteFreelancerFeedback;
}

export interface DeleteFreelancerFeedbackMutationVariables {
  input: GdDeleteFreelancerFeedbackRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateUserPhoneMutation
// ====================================================

export interface UpdateUserPhoneMutation_updateUserPhone_user {
  __typename: "GdUserInfo";
  phone: string | null;
}

export interface UpdateUserPhoneMutation_updateUserPhone {
  __typename: "GdUpdateUserPayload";
  user: UpdateUserPhoneMutation_updateUserPhone_user;
}

export interface UpdateUserPhoneMutation {
  /**
   * Обновление номера у subjectUser
   */
  updateUserPhone: UpdateUserPhoneMutation_updateUserPhone;
}

export interface UpdateUserPhoneMutationVariables {
  input: GdUpdateUserPhoneInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateFreelancerCardMutation
// ====================================================

export interface UpdateFreelancerCardMutation_updateFreelancerCard_validationResult_errors {
  __typename: "GdDefect";
  code: string;
}

export interface UpdateFreelancerCardMutation_updateFreelancerCard_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateFreelancerCardMutation_updateFreelancerCard_validationResult_errors[];
}

export interface UpdateFreelancerCardMutation_updateFreelancerCard {
  __typename: "GdUpdateFreelancerCardRequestPayload";
  validationResult: UpdateFreelancerCardMutation_updateFreelancerCard_validationResult | null;
}

export interface UpdateFreelancerCardMutation_updateFreelancerSkills_validationResult_errors {
  __typename: "GdDefect";
  code: string;
}

export interface UpdateFreelancerCardMutation_updateFreelancerSkills_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateFreelancerCardMutation_updateFreelancerSkills_validationResult_errors[];
}

export interface UpdateFreelancerCardMutation_updateFreelancerSkills {
  __typename: "GdUpdateFreelancerSkillsPayload";
  validationResult: UpdateFreelancerCardMutation_updateFreelancerSkills_validationResult | null;
}

export interface UpdateFreelancerCardMutation_updateFreelancer_validationResult_errors {
  __typename: "GdDefect";
  code: string;
}

export interface UpdateFreelancerCardMutation_updateFreelancer_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateFreelancerCardMutation_updateFreelancer_validationResult_errors[];
}

export interface UpdateFreelancerCardMutation_updateFreelancer {
  __typename: "GdUpdateFreelancerPayload";
  validationResult: UpdateFreelancerCardMutation_updateFreelancer_validationResult | null;
}

export interface UpdateFreelancerCardMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  updateFreelancerCard: UpdateFreelancerCardMutation_updateFreelancerCard;
  updateFreelancerSkills: UpdateFreelancerCardMutation_updateFreelancerSkills;
  updateFreelancer: UpdateFreelancerCardMutation_updateFreelancer;
}

export interface UpdateFreelancerCardMutationVariables {
  commonInput: GdUpdateFreelancerCardInput;
  skillsInput: GdUpdateFreelancerSkillInput;
  regionInput: GdUpdateFreelancerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: getMutationId
// ====================================================

export interface getMutationId_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface getMutationId {
  getClientMutationId: getMutationId_getClientMutationId;
}

export interface getMutationIdVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateAdGroup
// ====================================================

export interface UpdateAdGroup_updateTextAdGroup_updatedAdGroupItems {
  __typename: "GdUpdateAdGroupPayloadItem";
  adGroupId: GraphQlLong;
}

export interface UpdateAdGroup_updateTextAdGroup_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateAdGroup_updateTextAdGroup_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateAdGroup_updateTextAdGroup_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateAdGroup_updateTextAdGroup_validationResult_errors[];
  warnings: UpdateAdGroup_updateTextAdGroup_validationResult_warnings[];
}

export interface UpdateAdGroup_updateTextAdGroup {
  __typename: "GdUpdateAdGroupPayload";
  updatedAdGroupItems: (UpdateAdGroup_updateTextAdGroup_updatedAdGroupItems | null)[];
  validationResult: UpdateAdGroup_updateTextAdGroup_validationResult | null;
}

export interface UpdateAdGroup_updateSmartAdGroups_updatedAdGroupItems {
  __typename: "GdUpdateAdGroupPayloadItem";
  adGroupId: GraphQlLong;
}

export interface UpdateAdGroup_updateSmartAdGroups_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateAdGroup_updateSmartAdGroups_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateAdGroup_updateSmartAdGroups_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateAdGroup_updateSmartAdGroups_validationResult_errors[];
  warnings: UpdateAdGroup_updateSmartAdGroups_validationResult_warnings[];
}

export interface UpdateAdGroup_updateSmartAdGroups {
  __typename: "GdUpdateAdGroupPayload";
  updatedAdGroupItems: (UpdateAdGroup_updateSmartAdGroups_updatedAdGroupItems | null)[];
  validationResult: UpdateAdGroup_updateSmartAdGroups_validationResult | null;
}

export interface UpdateAdGroup_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface UpdateAdGroup {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  updateTextAdGroup: UpdateAdGroup_updateTextAdGroup;
  updateSmartAdGroups: UpdateAdGroup_updateSmartAdGroups;
  getClientMutationId: UpdateAdGroup_getClientMutationId;
}

export interface UpdateAdGroupVariables {
  textInput: GdUpdateTextAdGroupInput;
  smartInput: GdUpdatePerformanceAdGroupInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddSmartFilters
// ====================================================

export interface AddSmartFilters_addSmartFilters_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddSmartFilters_addSmartFilters_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddSmartFilters_addSmartFilters_validationResult {
  __typename: "GdValidationResult";
  errors: AddSmartFilters_addSmartFilters_validationResult_errors[];
  warnings: AddSmartFilters_addSmartFilters_validationResult_warnings[];
}

export interface AddSmartFilters_addSmartFilters {
  __typename: "GdAddSmartFiltersPayload";
  validationResult: AddSmartFilters_addSmartFilters_validationResult | null;
}

export interface AddSmartFilters_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface AddSmartFilters {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addSmartFilters: AddSmartFilters_addSmartFilters;
  getClientMutationId: AddSmartFilters_getClientMutationId;
}

export interface AddSmartFiltersVariables {
  input: GdAddSmartFiltersInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteSmartFilters
// ====================================================

export interface DeleteSmartFilters_deleteFilters_deletedItems {
  __typename: "GdDeleteSmartFilterPayloadItem";
  id: GraphQlLong | null;
}

export interface DeleteSmartFilters_deleteFilters_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface DeleteSmartFilters_deleteFilters_validationResult {
  __typename: "GdValidationResult";
  errors: DeleteSmartFilters_deleteFilters_validationResult_errors[];
}

export interface DeleteSmartFilters_deleteFilters {
  __typename: "GdDeleteSmartFilterPayload";
  deletedItems: (DeleteSmartFilters_deleteFilters_deletedItems | null)[];
  validationResult: DeleteSmartFilters_deleteFilters_validationResult | null;
}

export interface DeleteSmartFilters_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface DeleteSmartFilters {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  deleteFilters: DeleteSmartFilters_deleteFilters;
  getClientMutationId: DeleteSmartFilters_getClientMutationId;
}

export interface DeleteSmartFiltersVariables {
  input: GdDeleteSmartFilterInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateSmartFilters
// ====================================================

export interface UpdateSmartFilters_updateFilters_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateSmartFilters_updateFilters_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateSmartFilters_updateFilters_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateSmartFilters_updateFilters_validationResult_errors[];
  warnings: UpdateSmartFilters_updateFilters_validationResult_warnings[];
}

export interface UpdateSmartFilters_updateFilters_updatedItems {
  __typename: "GdUpdateSmartFiltersPayloadItem";
  id: GraphQlLong;
}

export interface UpdateSmartFilters_updateFilters {
  __typename: "GdUpdateSmartFiltersPayload";
  validationResult: UpdateSmartFilters_updateFilters_validationResult | null;
  updatedItems: (UpdateSmartFilters_updateFilters_updatedItems | null)[];
}

export interface UpdateSmartFilters_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface UpdateSmartFilters {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  updateFilters: UpdateSmartFilters_updateFilters;
  getClientMutationId: UpdateSmartFilters_getClientMutationId;
}

export interface UpdateSmartFiltersVariables {
  input: GdUpdateSmartFiltersInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateTextAdGroup
// ====================================================

export interface CreateTextAdGroup_addTextAdGroups_addedAdGroupItems {
  __typename: "GdAddAdGroupPayloadItem";
  adGroupId: GraphQlLong;
}

export interface CreateTextAdGroup_addTextAdGroups_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface CreateTextAdGroup_addTextAdGroups_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface CreateTextAdGroup_addTextAdGroups_validationResult {
  __typename: "GdValidationResult";
  errors: CreateTextAdGroup_addTextAdGroups_validationResult_errors[];
  warnings: CreateTextAdGroup_addTextAdGroups_validationResult_warnings[];
}

export interface CreateTextAdGroup_addTextAdGroups {
  __typename: "GdAddAdGroupPayload";
  addedAdGroupItems: (CreateTextAdGroup_addTextAdGroups_addedAdGroupItems | null)[];
  validationResult: CreateTextAdGroup_addTextAdGroups_validationResult | null;
}

export interface CreateTextAdGroup_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface CreateTextAdGroup {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addTextAdGroups: CreateTextAdGroup_addTextAdGroups;
  getClientMutationId: CreateTextAdGroup_getClientMutationId;
}

export interface CreateTextAdGroupVariables {
  textInput: GdAddTextAdGroupItemInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateSmartAdGroup
// ====================================================

export interface CreateSmartAdGroup_addSmartAdGroups_addedAdGroupItems {
  __typename: "GdAddAdGroupPayloadItem";
  adGroupId: GraphQlLong;
}

export interface CreateSmartAdGroup_addSmartAdGroups_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface CreateSmartAdGroup_addSmartAdGroups_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface CreateSmartAdGroup_addSmartAdGroups_validationResult {
  __typename: "GdValidationResult";
  errors: CreateSmartAdGroup_addSmartAdGroups_validationResult_errors[];
  warnings: CreateSmartAdGroup_addSmartAdGroups_validationResult_warnings[];
}

export interface CreateSmartAdGroup_addSmartAdGroups {
  __typename: "GdAddAdGroupPayload";
  addedAdGroupItems: (CreateSmartAdGroup_addSmartAdGroups_addedAdGroupItems | null)[];
  validationResult: CreateSmartAdGroup_addSmartAdGroups_validationResult | null;
}

export interface CreateSmartAdGroup_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface CreateSmartAdGroup {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addSmartAdGroups: CreateSmartAdGroup_addSmartAdGroups;
  getClientMutationId: CreateSmartAdGroup_getClientMutationId;
}

export interface CreateSmartAdGroupVariables {
  smartInput: GdAddSmartAdGroupItemInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateInternalAdGroups
// ====================================================

export interface updateInternalAdGroups_updateInternalAdGroups_updatedAdGroupItems {
  __typename: "GdUpdateAdGroupPayloadItem";
  adGroupId: GraphQlLong;
}

export interface updateInternalAdGroups_updateInternalAdGroups_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface updateInternalAdGroups_updateInternalAdGroups_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface updateInternalAdGroups_updateInternalAdGroups_validationResult {
  __typename: "GdValidationResult";
  errors: updateInternalAdGroups_updateInternalAdGroups_validationResult_errors[];
  warnings: updateInternalAdGroups_updateInternalAdGroups_validationResult_warnings[];
}

export interface updateInternalAdGroups_updateInternalAdGroups {
  __typename: "GdUpdateAdGroupPayload";
  updatedAdGroupItems: (updateInternalAdGroups_updateInternalAdGroups_updatedAdGroupItems | null)[];
  validationResult: updateInternalAdGroups_updateInternalAdGroups_validationResult | null;
}

export interface updateInternalAdGroups {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  updateInternalAdGroups: updateInternalAdGroups_updateInternalAdGroups;
}

export interface updateInternalAdGroupsVariables {
  internalInput: GdUpdateInternalAdGroupsInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoderateAdsCallouts
// ====================================================

export interface RemoderateAdsCallouts_remoderateAdsCallouts_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface RemoderateAdsCallouts_remoderateAdsCallouts_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface RemoderateAdsCallouts_remoderateAdsCallouts_validationResult {
  __typename: "GdValidationResult";
  errors: RemoderateAdsCallouts_remoderateAdsCallouts_validationResult_errors[];
  warnings: RemoderateAdsCallouts_remoderateAdsCallouts_validationResult_warnings[];
}

export interface RemoderateAdsCallouts_remoderateAdsCallouts {
  __typename: "GdRemoderateAdsCalloutsPayload";
  processedAdGroupIds: GraphQlLong[];
  skippedAdGroupIds: GraphQlLong[];
  validationResult: RemoderateAdsCallouts_remoderateAdsCallouts_validationResult | null;
}

export interface RemoderateAdsCallouts_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface RemoderateAdsCallouts {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  remoderateAdsCallouts: RemoderateAdsCallouts_remoderateAdsCallouts;
  getClientMutationId: RemoderateAdsCallouts_getClientMutationId;
}

export interface RemoderateAdsCalloutsVariables {
  input: GdRemoderateAdsCalloutsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: addInternalAdGroups
// ====================================================

export interface addInternalAdGroups_addInternalAdGroups_addedAdGroupItems {
  __typename: "GdAddAdGroupPayloadItem";
  adGroupId: GraphQlLong;
}

export interface addInternalAdGroups_addInternalAdGroups_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface addInternalAdGroups_addInternalAdGroups_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface addInternalAdGroups_addInternalAdGroups_validationResult {
  __typename: "GdValidationResult";
  errors: addInternalAdGroups_addInternalAdGroups_validationResult_errors[];
  warnings: addInternalAdGroups_addInternalAdGroups_validationResult_warnings[];
}

export interface addInternalAdGroups_addInternalAdGroups {
  __typename: "GdAddAdGroupPayload";
  addedAdGroupItems: (addInternalAdGroups_addInternalAdGroups_addedAdGroupItems | null)[];
  validationResult: addInternalAdGroups_addInternalAdGroups_validationResult | null;
}

export interface addInternalAdGroups {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addInternalAdGroups: addInternalAdGroups_addInternalAdGroups;
}

export interface addInternalAdGroupsVariables {
  internalInput: GdAddInternalAdGroupsInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CopyAdGroupsMutation
// ====================================================

export interface CopyAdGroupsMutation_copyAdGroups_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface CopyAdGroupsMutation_copyAdGroups_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface CopyAdGroupsMutation_copyAdGroups_validationResult {
  __typename: "GdValidationResult";
  errors: CopyAdGroupsMutation_copyAdGroups_validationResult_errors[];
  warnings: CopyAdGroupsMutation_copyAdGroups_validationResult_warnings[];
}

export interface CopyAdGroupsMutation_copyAdGroups {
  __typename: "GdCopyAdGroupsPayload";
  copiedAdGroupIds: GraphQlLong[];
  validationResult: CopyAdGroupsMutation_copyAdGroups_validationResult | null;
}

export interface CopyAdGroupsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface CopyAdGroupsMutation {
  copyAdGroups: CopyAdGroupsMutation_copyAdGroups;
  getClientMutationId: CopyAdGroupsMutation_getClientMutationId;
}

export interface CopyAdGroupsMutationVariables {
  input: GdCopyAdGroupsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateCpmAdGroup
// ====================================================

export interface UpdateCpmAdGroup_saveCpmAdGroups_updatedAdGroupItems {
  __typename: "GdUpdateAdGroupPayloadItem";
  adGroupId: GraphQlLong;
}

export interface UpdateCpmAdGroup_saveCpmAdGroups_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateCpmAdGroup_saveCpmAdGroups_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateCpmAdGroup_saveCpmAdGroups_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateCpmAdGroup_saveCpmAdGroups_validationResult_errors[];
  warnings: UpdateCpmAdGroup_saveCpmAdGroups_validationResult_warnings[];
}

export interface UpdateCpmAdGroup_saveCpmAdGroups {
  __typename: "GdUpdateAdGroupPayload";
  updatedAdGroupItems: (UpdateCpmAdGroup_saveCpmAdGroups_updatedAdGroupItems | null)[];
  validationResult: UpdateCpmAdGroup_saveCpmAdGroups_validationResult | null;
}

export interface UpdateCpmAdGroup_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface UpdateCpmAdGroup {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  saveCpmAdGroups: UpdateCpmAdGroup_saveCpmAdGroups;
  getClientMutationId: UpdateCpmAdGroup_getClientMutationId;
}

export interface UpdateCpmAdGroupVariables {
  cpmInput: GdUpdateCpmAdGroupInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: addMinusKeywordsPacks
// ====================================================

export interface addMinusKeywordsPacks_addMinusKeywordsPacks_addedItems {
  __typename: "GdAddMinusKeywordsPacksPayloadItem";
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
}

export interface addMinusKeywordsPacks_addMinusKeywordsPacks_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface addMinusKeywordsPacks_addMinusKeywordsPacks_validationResult {
  __typename: "GdValidationResult";
  errors: addMinusKeywordsPacks_addMinusKeywordsPacks_validationResult_errors[];
}

export interface addMinusKeywordsPacks_addMinusKeywordsPacks {
  __typename: "GdAddMinusKeywordsPacksPayload";
  addedItems: (addMinusKeywordsPacks_addMinusKeywordsPacks_addedItems | null)[];
  validationResult: addMinusKeywordsPacks_addMinusKeywordsPacks_validationResult | null;
}

export interface addMinusKeywordsPacks {
  /**
   * Создание набора минус-фраз
   */
  addMinusKeywordsPacks: addMinusKeywordsPacks_addMinusKeywordsPacks;
}

export interface addMinusKeywordsPacksVariables {
  input: GdAddMinusKeywordsPacksInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateMinusKeywordsPacks
// ====================================================

export interface updateMinusKeywordsPacks_updateMinusKeywordsPacks_updatedItems {
  __typename: "GdUpdateMinusKeywordsPacksPayloadItem";
  id: GraphQlLong;
  name: string;
  minusKeywords: string[];
}

export interface updateMinusKeywordsPacks_updateMinusKeywordsPacks_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface updateMinusKeywordsPacks_updateMinusKeywordsPacks_validationResult {
  __typename: "GdValidationResult";
  errors: updateMinusKeywordsPacks_updateMinusKeywordsPacks_validationResult_errors[];
}

export interface updateMinusKeywordsPacks_updateMinusKeywordsPacks {
  __typename: "GdUpdateMinusKeywordsPacksPayload";
  updatedItems: (updateMinusKeywordsPacks_updateMinusKeywordsPacks_updatedItems | null)[];
  validationResult: updateMinusKeywordsPacks_updateMinusKeywordsPacks_validationResult | null;
}

export interface updateMinusKeywordsPacks {
  /**
   * Изменение набора минус-фраз
   */
  updateMinusKeywordsPacks: updateMinusKeywordsPacks_updateMinusKeywordsPacks;
}

export interface updateMinusKeywordsPacksVariables {
  input: GdUpdateMinusKeywordsPacksInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: deleteMinusKeywordsPacks
// ====================================================

export interface deleteMinusKeywordsPacks_deleteMinusKeywordsPacks_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface deleteMinusKeywordsPacks_deleteMinusKeywordsPacks_validationResult {
  __typename: "GdValidationResult";
  errors: deleteMinusKeywordsPacks_deleteMinusKeywordsPacks_validationResult_errors[];
}

export interface deleteMinusKeywordsPacks_deleteMinusKeywordsPacks {
  __typename: "GdDeleteMinusKeywordsPacksPayload";
  deletedPackIds: GraphQlLong[];
  validationResult: deleteMinusKeywordsPacks_deleteMinusKeywordsPacks_validationResult | null;
}

export interface deleteMinusKeywordsPacks {
  /**
   * Удаление набора минус-фраз
   */
  deleteMinusKeywordsPacks: deleteMinusKeywordsPacks_deleteMinusKeywordsPacks;
}

export interface deleteMinusKeywordsPacksVariables {
  input: GdDeleteMinusKeywordsPacksInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateAdGroupMinusKeywords
// ====================================================

export interface updateAdGroupMinusKeywords_updateAdGroupMinusKeywords {
  __typename: "GdUpdateAdGroupMinusKeywordsPayload";
  updatedAdGroupIds: GraphQlLong[];
}

export interface updateAdGroupMinusKeywords {
  updateAdGroupMinusKeywords: updateAdGroupMinusKeywords_updateAdGroupMinusKeywords;
}

export interface updateAdGroupMinusKeywordsVariables {
  input: GdUpdateAdGroupMinusKeywordsInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateOrganizations
// ====================================================

export interface UpdateOrganizations_updateOrganizations_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface UpdateOrganizations_updateOrganizations_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateOrganizations_updateOrganizations_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateOrganizations_updateOrganizations_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateOrganizations_updateOrganizations_validationResult_errors[];
  warnings: UpdateOrganizations_updateOrganizations_validationResult_warnings[];
}

export interface UpdateOrganizations_updateOrganizations {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (UpdateOrganizations_updateOrganizations_updatedAds | null)[];
  validationResult: UpdateOrganizations_updateOrganizations_validationResult | null;
}

export interface UpdateOrganizations {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  /**
   * Мутация для массового обновления организаций на баннерах
   */
  updateOrganizations: UpdateOrganizations_updateOrganizations;
}

export interface UpdateOrganizationsVariables {
  input: GdUpdateOrganizationInput[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: FindAndReplaceKeywordsMutation
// ====================================================

export interface FindAndReplaceKeywordsMutation_findAndReplaceKeywords_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface FindAndReplaceKeywordsMutation_findAndReplaceKeywords_validationResult {
  __typename: "GdValidationResult";
  errors: FindAndReplaceKeywordsMutation_findAndReplaceKeywords_validationResult_errors[];
}

export interface FindAndReplaceKeywordsMutation_findAndReplaceKeywords {
  __typename: "GdFindAndReplaceKeywordsPayload";
  cacheKey: string;
  updatedTotalCount: number;
  validationResult: FindAndReplaceKeywordsMutation_findAndReplaceKeywords_validationResult | null;
}

export interface FindAndReplaceKeywordsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface FindAndReplaceKeywordsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  findAndReplaceKeywords: FindAndReplaceKeywordsMutation_findAndReplaceKeywords;
  getClientMutationId: FindAndReplaceKeywordsMutation_getClientMutationId;
}

export interface FindAndReplaceKeywordsMutationVariables {
  input: GdFindAndReplaceKeywordsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteKeywordsMutation
// ====================================================

export interface DeleteKeywordsMutation_deleteKeywords_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface DeleteKeywordsMutation_deleteKeywords_validationResult {
  __typename: "GdValidationResult";
  errors: DeleteKeywordsMutation_deleteKeywords_validationResult_errors[];
}

export interface DeleteKeywordsMutation_deleteKeywords {
  __typename: "GdDeleteKeywordsPayload";
  deletedKeywordIds: GraphQlLong[];
  validationResult: DeleteKeywordsMutation_deleteKeywords_validationResult | null;
}

export interface DeleteKeywordsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface DeleteKeywordsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  deleteKeywords: DeleteKeywordsMutation_deleteKeywords;
  getClientMutationId: DeleteKeywordsMutation_getClientMutationId;
}

export interface DeleteKeywordsMutationVariables {
  input: GdDeleteKeywordsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UnsuspendKeywordsMutation
// ====================================================

export interface UnsuspendKeywordsMutation_unsuspendKeywords_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface UnsuspendKeywordsMutation_unsuspendKeywords_validationResult {
  __typename: "GdValidationResult";
  errors: UnsuspendKeywordsMutation_unsuspendKeywords_validationResult_errors[];
}

export interface UnsuspendKeywordsMutation_unsuspendKeywords {
  __typename: "GdUnsuspendKeywordsPayload";
  unsuspendedKeywordIds: GraphQlLong[];
  validationResult: UnsuspendKeywordsMutation_unsuspendKeywords_validationResult | null;
}

export interface UnsuspendKeywordsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface UnsuspendKeywordsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  unsuspendKeywords: UnsuspendKeywordsMutation_unsuspendKeywords;
  getClientMutationId: UnsuspendKeywordsMutation_getClientMutationId;
}

export interface UnsuspendKeywordsMutationVariables {
  input: GdUnsuspendKeywordsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SuspendKeywordsMutation
// ====================================================

export interface SuspendKeywordsMutation_suspendKeywords_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface SuspendKeywordsMutation_suspendKeywords_validationResult {
  __typename: "GdValidationResult";
  errors: SuspendKeywordsMutation_suspendKeywords_validationResult_errors[];
}

export interface SuspendKeywordsMutation_suspendKeywords {
  __typename: "GdSuspendKeywordsPayload";
  suspendedKeywordIds: GraphQlLong[];
  validationResult: SuspendKeywordsMutation_suspendKeywords_validationResult | null;
}

export interface SuspendKeywordsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface SuspendKeywordsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  suspendKeywords: SuspendKeywordsMutation_suspendKeywords;
  getClientMutationId: SuspendKeywordsMutation_getClientMutationId;
}

export interface SuspendKeywordsMutationVariables {
  input: GdSuspendKeywordsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateKeywordsMutation
// ====================================================

export interface UpdateKeywordsMutation_updateKeywords_updatedKeywords {
  __typename: "GdUpdateKeywordsPayloadItem";
  id: GraphQlLong;
}

export interface UpdateKeywordsMutation_updateKeywords_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface UpdateKeywordsMutation_updateKeywords_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateKeywordsMutation_updateKeywords_validationResult_errors[];
}

export interface UpdateKeywordsMutation_updateKeywords {
  __typename: "GdUpdateKeywordsPayload";
  updatedKeywords: UpdateKeywordsMutation_updateKeywords_updatedKeywords[];
  validationResult: UpdateKeywordsMutation_updateKeywords_validationResult | null;
}

export interface UpdateKeywordsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface UpdateKeywordsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  updateKeywords: UpdateKeywordsMutation_updateKeywords;
  getClientMutationId: UpdateKeywordsMutation_getClientMutationId;
}

export interface UpdateKeywordsMutationVariables {
  input: GdUpdateKeywordsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddKeywordsMutation
// ====================================================

export interface AddKeywordsMutation_addKeywords_addedItems {
  __typename: "GdAddKeywordsPayloadItem";
  keywordId: GraphQlLong;
}

export interface AddKeywordsMutation_addKeywords_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface AddKeywordsMutation_addKeywords_validationResult {
  __typename: "GdValidationResult";
  errors: AddKeywordsMutation_addKeywords_validationResult_errors[];
}

export interface AddKeywordsMutation_addKeywords {
  __typename: "GdAddKeywordsPayload";
  addedItems: AddKeywordsMutation_addKeywords_addedItems[];
  validationResult: AddKeywordsMutation_addKeywords_validationResult | null;
}

export interface AddKeywordsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface AddKeywordsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addKeywords: AddKeywordsMutation_addKeywords;
  getClientMutationId: AddKeywordsMutation_getClientMutationId;
}

export interface AddKeywordsMutationVariables {
  input: GdAddKeywordsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddAdGroupMinusKeywordsMutation
// ====================================================

export interface AddAdGroupMinusKeywordsMutation_addAdGroupMinusKeywords_addedItems {
  __typename: "GdAddAdGroupMinusKeywordsPayloadItem";
  adGroupId: GraphQlLong;
}

export interface AddAdGroupMinusKeywordsMutation_addAdGroupMinusKeywords_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface AddAdGroupMinusKeywordsMutation_addAdGroupMinusKeywords_validationResult {
  __typename: "GdValidationResult";
  errors: AddAdGroupMinusKeywordsMutation_addAdGroupMinusKeywords_validationResult_errors[];
}

export interface AddAdGroupMinusKeywordsMutation_addAdGroupMinusKeywords {
  __typename: "GdAddAdGroupMinusKeywordsPayload";
  addedItems: AddAdGroupMinusKeywordsMutation_addAdGroupMinusKeywords_addedItems[];
  validationResult: AddAdGroupMinusKeywordsMutation_addAdGroupMinusKeywords_validationResult | null;
}

export interface AddAdGroupMinusKeywordsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface AddAdGroupMinusKeywordsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addAdGroupMinusKeywords: AddAdGroupMinusKeywordsMutation_addAdGroupMinusKeywords;
  getClientMutationId: AddAdGroupMinusKeywordsMutation_getClientMutationId;
}

export interface AddAdGroupMinusKeywordsMutationVariables {
  input: GdAddAdGroupMinusKeywordsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: setBidsMutation
// ====================================================

export interface setBidsMutation_setBids_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface setBidsMutation_setBids_validationResult {
  __typename: "GdValidationResult";
  errors: setBidsMutation_setBids_validationResult_errors[];
}

export interface setBidsMutation_setBids {
  __typename: "GdSetBidsPayload";
  showConditionIds: GraphQlLong[];
  validationResult: setBidsMutation_setBids_validationResult | null;
}

export interface setBidsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface setBidsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  setBids: setBidsMutation_setBids;
  getClientMutationId: setBidsMutation_getClientMutationId;
}

export interface setBidsMutationVariables {
  input: GdSetBidsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: setAutoBidsMutation
// ====================================================

export interface setAutoBidsMutation_setAutoBids_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface setAutoBidsMutation_setAutoBids_validationResult {
  __typename: "GdValidationResult";
  errors: setAutoBidsMutation_setAutoBids_validationResult_errors[];
}

export interface setAutoBidsMutation_setAutoBids {
  __typename: "GdSetAutoBidsPayload";
  keywordIds: GraphQlLong[];
  validationResult: setAutoBidsMutation_setAutoBids_validationResult | null;
}

export interface setAutoBidsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface setAutoBidsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  setAutoBids: setAutoBidsMutation_setAutoBids;
  getClientMutationId: setAutoBidsMutation_getClientMutationId;
}

export interface setAutoBidsMutationVariables {
  input: GdSetAutoBidsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: executeRecommendationMutation
// ====================================================

export interface executeRecommendationMutation_executeRecommendation_items {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface executeRecommendationMutation_executeRecommendation {
  __typename: "GdExecuteRecommedationsPayload";
  items: executeRecommendationMutation_executeRecommendation_items[];
}

export interface executeRecommendationMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  executeRecommendation: executeRecommendationMutation_executeRecommendation;
}

export interface executeRecommendationMutationVariables {
  input: GdExecuteRecommedationsInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateRetargetingConditionsMutation
// ====================================================

export interface UpdateRetargetingConditionsMutation_updateRetargetingConditions_rowset {
  __typename: "GdUpdateRetargetingConditionPayloadItem";
  retargetingConditionId: GraphQlLong;
}

export interface UpdateRetargetingConditionsMutation_updateRetargetingConditions_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  params: GraphQlObjectScalar | null;
  code: string;
}

export interface UpdateRetargetingConditionsMutation_updateRetargetingConditions_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateRetargetingConditionsMutation_updateRetargetingConditions_validationResult_errors[];
}

export interface UpdateRetargetingConditionsMutation_updateRetargetingConditions {
  __typename: "GdResult_GdUpdateRetargetingConditionPayloadItem";
  rowset: (UpdateRetargetingConditionsMutation_updateRetargetingConditions_rowset | null)[];
  validationResult: UpdateRetargetingConditionsMutation_updateRetargetingConditions_validationResult | null;
}

export interface UpdateRetargetingConditionsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  updateRetargetingConditions: UpdateRetargetingConditionsMutation_updateRetargetingConditions;
}

export interface UpdateRetargetingConditionsMutationVariables {
  input: GdUpdateRetargetingConditionsInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateRetargetingConditionsMutation
// ====================================================

export interface CreateRetargetingConditionsMutation_createRetargetingConditions_rowset {
  __typename: "GdCreateRetargetingConditionPayloadItem";
  retargetingConditionId: GraphQlLong;
}

export interface CreateRetargetingConditionsMutation_createRetargetingConditions_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  params: GraphQlObjectScalar | null;
  code: string;
}

export interface CreateRetargetingConditionsMutation_createRetargetingConditions_validationResult {
  __typename: "GdValidationResult";
  errors: CreateRetargetingConditionsMutation_createRetargetingConditions_validationResult_errors[];
}

export interface CreateRetargetingConditionsMutation_createRetargetingConditions {
  __typename: "GdResult_GdCreateRetargetingConditionPayloadItem";
  rowset: (CreateRetargetingConditionsMutation_createRetargetingConditions_rowset | null)[];
  validationResult: CreateRetargetingConditionsMutation_createRetargetingConditions_validationResult | null;
}

export interface CreateRetargetingConditionsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  createRetargetingConditions: CreateRetargetingConditionsMutation_createRetargetingConditions;
}

export interface CreateRetargetingConditionsMutationVariables {
  input: GdCreateRetargetingConditionsInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RetargetingCommonPriceEditorMutation
// ====================================================

export interface RetargetingCommonPriceEditorMutation_setBidsRetargeting_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface RetargetingCommonPriceEditorMutation_setBidsRetargeting_validationResult {
  __typename: "GdValidationResult";
  errors: RetargetingCommonPriceEditorMutation_setBidsRetargeting_validationResult_errors[];
}

export interface RetargetingCommonPriceEditorMutation_setBidsRetargeting {
  __typename: "GdSetBidsPayload";
  showConditionIds: GraphQlLong[];
  validationResult: RetargetingCommonPriceEditorMutation_setBidsRetargeting_validationResult | null;
}

export interface RetargetingCommonPriceEditorMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface RetargetingCommonPriceEditorMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  setBidsRetargeting: RetargetingCommonPriceEditorMutation_setBidsRetargeting;
  getClientMutationId: RetargetingCommonPriceEditorMutation_getClientMutationId;
}

export interface RetargetingCommonPriceEditorMutationVariables {
  input: GdSetBidsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ResumeRetargetingsMutation
// ====================================================

export interface ResumeRetargetingsMutation_resumeRetargetings_rowset {
  __typename: "GdResumeRetargetingsPayloadItem";
  retargetingId: GraphQlLong | null;
}

export interface ResumeRetargetingsMutation_resumeRetargetings_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface ResumeRetargetingsMutation_resumeRetargetings_validationResult_warnings {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface ResumeRetargetingsMutation_resumeRetargetings_validationResult {
  __typename: "GdValidationResult";
  errors: ResumeRetargetingsMutation_resumeRetargetings_validationResult_errors[];
  warnings: ResumeRetargetingsMutation_resumeRetargetings_validationResult_warnings[];
}

export interface ResumeRetargetingsMutation_resumeRetargetings {
  __typename: "GdResult_GdResumeRetargetingsPayloadItem";
  successCount: number;
  totalCount: number;
  rowset: (ResumeRetargetingsMutation_resumeRetargetings_rowset | null)[];
  validationResult: ResumeRetargetingsMutation_resumeRetargetings_validationResult | null;
}

export interface ResumeRetargetingsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface ResumeRetargetingsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  resumeRetargetings: ResumeRetargetingsMutation_resumeRetargetings;
  getClientMutationId: ResumeRetargetingsMutation_getClientMutationId;
}

export interface ResumeRetargetingsMutationVariables {
  input: GdResumeRetargetingsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SuspendRetargetingsMutation
// ====================================================

export interface SuspendRetargetingsMutation_suspendRetargetings_rowset {
  __typename: "GdSuspendRetargetingsPayloadItem";
  retargetingId: GraphQlLong;
}

export interface SuspendRetargetingsMutation_suspendRetargetings_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface SuspendRetargetingsMutation_suspendRetargetings_validationResult_warnings {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface SuspendRetargetingsMutation_suspendRetargetings_validationResult {
  __typename: "GdValidationResult";
  errors: SuspendRetargetingsMutation_suspendRetargetings_validationResult_errors[];
  warnings: SuspendRetargetingsMutation_suspendRetargetings_validationResult_warnings[];
}

export interface SuspendRetargetingsMutation_suspendRetargetings {
  __typename: "GdResult_GdSuspendRetargetingsPayloadItem";
  successCount: number;
  totalCount: number;
  rowset: (SuspendRetargetingsMutation_suspendRetargetings_rowset | null)[];
  validationResult: SuspendRetargetingsMutation_suspendRetargetings_validationResult | null;
}

export interface SuspendRetargetingsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface SuspendRetargetingsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  suspendRetargetings: SuspendRetargetingsMutation_suspendRetargetings;
  getClientMutationId: SuspendRetargetingsMutation_getClientMutationId;
}

export interface SuspendRetargetingsMutationVariables {
  input: GdSuspendRetargetingsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteRetargetingsMutation
// ====================================================

export interface DeleteRetargetingsMutation_deleteRetargetings_rowset {
  __typename: "GdDeleteRetargetingsPayloadItem";
  retargetingId: GraphQlLong;
}

export interface DeleteRetargetingsMutation_deleteRetargetings_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface DeleteRetargetingsMutation_deleteRetargetings_validationResult_warnings {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface DeleteRetargetingsMutation_deleteRetargetings_validationResult {
  __typename: "GdValidationResult";
  errors: DeleteRetargetingsMutation_deleteRetargetings_validationResult_errors[];
  warnings: DeleteRetargetingsMutation_deleteRetargetings_validationResult_warnings[];
}

export interface DeleteRetargetingsMutation_deleteRetargetings {
  __typename: "GdResult_GdDeleteRetargetingsPayloadItem";
  successCount: number;
  totalCount: number;
  rowset: (DeleteRetargetingsMutation_deleteRetargetings_rowset | null)[];
  validationResult: DeleteRetargetingsMutation_deleteRetargetings_validationResult | null;
}

export interface DeleteRetargetingsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface DeleteRetargetingsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  deleteRetargetings: DeleteRetargetingsMutation_deleteRetargetings;
  getClientMutationId: DeleteRetargetingsMutation_getClientMutationId;
}

export interface DeleteRetargetingsMutationVariables {
  input: GdDeleteRetargetingsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteRetargetingConditionsMutation
// ====================================================

export interface DeleteRetargetingConditionsMutation_deleteRetargetingConditions_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface DeleteRetargetingConditionsMutation_deleteRetargetingConditions_validationResult {
  __typename: "GdValidationResult";
  errors: DeleteRetargetingConditionsMutation_deleteRetargetingConditions_validationResult_errors[];
}

export interface DeleteRetargetingConditionsMutation_deleteRetargetingConditions {
  __typename: "GdResult_GdDeleteRetargetingConditionsPayloadItem";
  successCount: number;
  totalCount: number;
  validationResult: DeleteRetargetingConditionsMutation_deleteRetargetingConditions_validationResult | null;
}

export interface DeleteRetargetingConditionsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface DeleteRetargetingConditionsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  deleteRetargetingConditions: DeleteRetargetingConditionsMutation_deleteRetargetingConditions;
  getClientMutationId: DeleteRetargetingConditionsMutation_getClientMutationId;
}

export interface DeleteRetargetingConditionsMutationVariables {
  input: GdDeleteRetargetingConditionsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetAutoOverdraftLimit
// ====================================================

export interface SetAutoOverdraftLimit_setAutoOverdraftLimit_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface SetAutoOverdraftLimit_setAutoOverdraftLimit_validationResult {
  __typename: "GdValidationResult";
  errors: SetAutoOverdraftLimit_setAutoOverdraftLimit_validationResult_errors[];
}

export interface SetAutoOverdraftLimit_setAutoOverdraftLimit {
  __typename: "GdSetAutoOverdraftParamsPayload";
  validationResult: SetAutoOverdraftLimit_setAutoOverdraftLimit_validationResult | null;
}

export interface SetAutoOverdraftLimit {
  setAutoOverdraftLimit: SetAutoOverdraftLimit_setAutoOverdraftLimit;
}

export interface SetAutoOverdraftLimitVariables {
  input: GdSetAutoOverdraftParamsInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ResetAutoOverdraftLimit
// ====================================================

export interface ResetAutoOverdraftLimit_resetAutoOverdraftLimit_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface ResetAutoOverdraftLimit_resetAutoOverdraftLimit_validationResult {
  __typename: "GdValidationResult";
  errors: ResetAutoOverdraftLimit_resetAutoOverdraftLimit_validationResult_errors[];
}

export interface ResetAutoOverdraftLimit_resetAutoOverdraftLimit {
  __typename: "GdResetAutoOverdraftParamsPayload";
  autoOverdraftLimit: GraphQlBigDecimal;
  validationResult: ResetAutoOverdraftLimit_resetAutoOverdraftLimit_validationResult | null;
}

export interface ResetAutoOverdraftLimit {
  resetAutoOverdraftLimit: ResetAutoOverdraftLimit_resetAutoOverdraftLimit;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: UaTraitsQuery
// ====================================================

export interface UaTraitsQuery_constants_stringDicts_entries_GdStringDictEntry {
  __typename: "GdStringDictEntry";
  value: string;
}

export interface UaTraitsQuery_constants_stringDicts_entries_GdStringDictEntryWithLongKey {
  __typename: "GdStringDictEntryWithLongKey";
  key: GraphQlLong;
  value: string;
}

export type UaTraitsQuery_constants_stringDicts_entries = UaTraitsQuery_constants_stringDicts_entries_GdStringDictEntry | UaTraitsQuery_constants_stringDicts_entries_GdStringDictEntryWithLongKey;

export interface UaTraitsQuery_constants_stringDicts {
  __typename: "GdStringDictData";
  dictName: GdStringDictName;
  entries: UaTraitsQuery_constants_stringDicts_entries[];
}

export interface UaTraitsQuery_constants {
  __typename: "GdDirectConstants";
  /**
   * Строковые словари
   */
  stringDicts: (UaTraitsQuery_constants_stringDicts | null)[];
}

export interface UaTraitsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  constants: UaTraitsQuery_constants;
}

export interface UaTraitsQueryVariables {
  dictNames: (GdStringDictNameInput | null)[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CampaignsEditDataQuery
// ====================================================

export interface CampaignsEditDataQuery_operator_access_availableFields {
  __typename: "GdAvailableFields";
  campaignFields: GdCampaignsAvailableFields[];
}

export interface CampaignsEditDataQuery_operator_access {
  __typename: "GdOperatorAccess";
  availableFields: CampaignsEditDataQuery_operator_access_availableFields;
}

export interface CampaignsEditDataQuery_operator {
  __typename: "GdOperatorInfo";
  access: CampaignsEditDataQuery_operator_access;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgCpaPerCamp_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgCpaPerCamp {
  __typename: "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgCpaPerCamp_budget | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
  avgBid: GraphQlBigDecimal | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgCpa_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgCpa {
  __typename: "GdCampaignStrategyAvgCpa";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgCpa_budget | null;
  goalId: GraphQlLong | null;
  avgCpa: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyRoi_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyRoi {
  __typename: "GdCampaignStrategyRoi";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyRoi_budget | null;
  goalId: GraphQlLong | null;
  profitability: GraphQlBigDecimal | null;
  reserveReturn: GraphQlLong | null;
  roiCoef: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyWeekBudget_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyWeekBudget {
  __typename: "GdCampaignStrategyWeekBudget";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyWeekBudget_budget | null;
  bid: GraphQlBigDecimal | null;
  goalId: GraphQlLong | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyWeekBundle_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyWeekBundle {
  __typename: "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyWeekBundle_budget | null;
  avgBid: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
  clicksLimit: GraphQlLong | null;
}

export type CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy = CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgCpaPerCamp | CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual | CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgCpa | CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyRoi | CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyWeekBudget | CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyWeekBundle;

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierAdTypeAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierExpressAdjustment" | "GdBidModifierInventoryAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export type CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments = CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierMobileAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment;

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments[];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_emailSettings {
  __typename: "GdCampaignEmailSettings";
  allowedEvents: GdCampaignEmailEvent[];
  checkPositionInterval: GdCampaignCheckPositionInterval | null;
  email: string;
  sendAccountNews: boolean | null;
  stopByReachDailyBudget: boolean | null;
  warningBalance: number | null;
  xlsReady: boolean | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_smsSettings_smsTime_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_smsSettings_smsTime_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_smsSettings_smsTime {
  __typename: "GdTimeInterval";
  endTime: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_smsSettings_smsTime_endTime;
  startTime: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_smsSettings_smsTime_startTime;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_smsSettings_events {
  __typename: "GdCampaignSmsEventInfo";
  checked: boolean;
  event: GdCampaignSmsEvent;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_smsSettings {
  __typename: "GdCampaignSmsSettings";
  smsTime: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_smsSettings_smsTime;
  events: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_smsSettings_events[];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification {
  __typename: "GdCampaignNotification";
  emailSettings: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_emailSettings;
  smsSettings: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_smsSettings;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  allowDomainMonitoring: boolean;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  exportId: GraphQlLong;
  name: string;
  type: GdCampaignType;
  flatStrategy: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  bidModifiers: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers[] | null;
  disabledIps: string[] | null;
  notification: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification;
  status: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_status;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgCpaPerCamp_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgCpaPerCamp {
  __typename: "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgCpaPerCamp_budget | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
  avgBid: GraphQlBigDecimal | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgCpa_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgCpa {
  __typename: "GdCampaignStrategyAvgCpa";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgCpa_budget | null;
  goalId: GraphQlLong | null;
  avgCpa: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyRoi_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyRoi {
  __typename: "GdCampaignStrategyRoi";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyRoi_budget | null;
  goalId: GraphQlLong | null;
  profitability: GraphQlBigDecimal | null;
  reserveReturn: GraphQlLong | null;
  roiCoef: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyWeekBudget_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyWeekBudget {
  __typename: "GdCampaignStrategyWeekBudget";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyWeekBudget_budget | null;
  bid: GraphQlBigDecimal | null;
  goalId: GraphQlLong | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyWeekBundle_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyWeekBundle {
  __typename: "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyWeekBundle_budget | null;
  avgBid: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
  clicksLimit: GraphQlLong | null;
}

export type CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy = CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgCpaPerCamp | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyManual | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgCpa | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyRoi | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyWeekBudget | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy_GdCampaignStrategyWeekBundle;

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierAdTypeAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierExpressAdjustment" | "GdBidModifierInventoryAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export type CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments = CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierMobileAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment;

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments[];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_emailSettings {
  __typename: "GdCampaignEmailSettings";
  allowedEvents: GdCampaignEmailEvent[];
  checkPositionInterval: GdCampaignCheckPositionInterval | null;
  email: string;
  sendAccountNews: boolean | null;
  stopByReachDailyBudget: boolean | null;
  warningBalance: number | null;
  xlsReady: boolean | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_smsSettings_smsTime_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_smsSettings_smsTime_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_smsSettings_smsTime {
  __typename: "GdTimeInterval";
  endTime: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_smsSettings_smsTime_endTime;
  startTime: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_smsSettings_smsTime_startTime;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_smsSettings_events {
  __typename: "GdCampaignSmsEventInfo";
  checked: boolean;
  event: GdCampaignSmsEvent;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_smsSettings {
  __typename: "GdCampaignSmsSettings";
  smsTime: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_smsSettings_smsTime;
  events: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_smsSettings_events[];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification {
  __typename: "GdCampaignNotification";
  emailSettings: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_emailSettings;
  smsSettings: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_smsSettings;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  allowDomainMonitoring: boolean;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_meaningfulGoals {
  __typename: "GdMeaningfulGoal";
  goalId: GraphQlLong;
  conversionValue: GraphQlBigDecimal | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_broadMatch {
  __typename: "GdBroadMatch";
  broadMatchFlag: boolean;
  broadMatchGoalId: GraphQlLong | null;
  broadMatchLimit: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_workTimes[];
  phone: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_phone;
  address: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_address;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  exportId: GraphQlLong;
  name: string;
  type: GdCampaignType;
  flatStrategy: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  bidModifiers: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers[] | null;
  disabledIps: string[] | null;
  notification: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification;
  status: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_status;
  contentLanguage: GdContentLanguage | null;
  disabledPlaces: string[] | null;
  meaningfulGoals: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_meaningfulGoals[] | null;
  metrikaCounters: number[] | null;
  hasTitleSubstitution: boolean;
  clientDialogId: GraphQlLong | null;
  hasExtendedGeoTargeting: boolean;
  allowedPageIds: GraphQlLong[] | null;
  hasAddMetrikaTagToUrl: boolean;
  hasAddOpenstatTagToUrl: boolean;
  excludePausedCompetingAds: boolean;
  enableCompanyInfo: boolean;
  broadMatch: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_broadMatch;
  commonVcard: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard | null;
}

export type CampaignsEditDataQuery_client_campaigns_rowset = CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign;

export interface CampaignsEditDataQuery_client_campaigns {
  __typename: "GdCampaignsContext";
  rowset: CampaignsEditDataQuery_client_campaigns_rowset[];
}

export interface CampaignsEditDataQuery_client_notification {
  __typename: "GdClientNotificationInfo";
  smsPhone: string | null;
}

export interface CampaignsEditDataQuery_client_clientConstants_allowedBidModifierTypesByCampaignTypes {
  __typename: "GdAllowedBidModifiersByCampaignType";
  campaignType: GdCampaignType;
  allowedBidModifierTypes: GdBidModifierType[];
}

export interface CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment {
  __typename: "GdAllowedBidModifierValuesABSegment" | "GdAllowedBidModifierValuesAdType" | "GdAllowedBidModifierValuesDemographics" | "GdAllowedBidModifierValuesDesktop" | "GdAllowedBidModifierValuesExpression" | "GdAllowedBidModifierValuesGeo" | "GdAllowedBidModifierValuesInventory" | "GdAllowedBidModifierValuesRetargeting" | "GdAllowedBidModifierValuesSmartTgo" | "GdAllowedBidModifierValuesVideo" | "GdAllowedBidModifierValuesWeather";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment_percentRange;
}

export interface CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile {
  __typename: "GdAllowedBidModifierValuesMobile";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile_percentRange;
  osTypes: GdOsType[];
}

export type CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues = CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment | CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile;

export interface CampaignsEditDataQuery_client_clientConstants {
  __typename: "GdClientConstants";
  allowedBidModifierTypesByCampaignTypes: CampaignsEditDataQuery_client_clientConstants_allowedBidModifierTypesByCampaignTypes[];
  allowedBidModifiersValues: CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues[];
}

export interface CampaignsEditDataQuery_client_broadMatchGoals_campaignGoals_goals {
  __typename: "GdGoal";
  id: GraphQlLong;
  name: string;
}

export interface CampaignsEditDataQuery_client_broadMatchGoals_campaignGoals {
  __typename: "GdCampaignGoals";
  campaignId: GraphQlLong;
  goals: CampaignsEditDataQuery_client_broadMatchGoals_campaignGoals_goals[];
}

export interface CampaignsEditDataQuery_client_broadMatchGoals {
  __typename: "GdBroadMatchGoals";
  campaignGoals: CampaignsEditDataQuery_client_broadMatchGoals_campaignGoals[] | null;
  isMetrikaAvailable: boolean;
}

export interface CampaignsEditDataQuery_client {
  __typename: "GdClient";
  campaigns: CampaignsEditDataQuery_client_campaigns;
  notification: CampaignsEditDataQuery_client_notification;
  clientConstants: CampaignsEditDataQuery_client_clientConstants;
  broadMatchGoals: CampaignsEditDataQuery_client_broadMatchGoals;
}

export interface CampaignsEditDataQuery_constants_defaultValues_campaign {
  __typename: "GdCampaignDefaultValues";
  defaultMeaningfulGoalId: GraphQlLong;
  defaultBroadMatchAllGoalsId: number;
}

export interface CampaignsEditDataQuery_constants_defaultValues {
  __typename: "GdDefaultValues";
  campaign: CampaignsEditDataQuery_constants_defaultValues_campaign;
}

export interface CampaignsEditDataQuery_constants_validation_campaignConstants {
  __typename: "GdDirectConstantsCampaignValidationData";
  maxDisabledPlacesCount: number;
  maxMetrikaCountersNumberForTextCampaign: number;
  maxDisabledIpsCount: number;
  minBroadMatchLimit: number;
  maxBroadMatchLimit: number;
  maxNameLength: number;
}

export interface CampaignsEditDataQuery_constants_validation {
  __typename: "GdDirectConstantsValidationData";
  campaignConstants: CampaignsEditDataQuery_constants_validation_campaignConstants;
}

export interface CampaignsEditDataQuery_constants_metroStations_rowset {
  __typename: "GdMetroStation";
  geoRegionId: number;
  metroStationId: number;
  metroStationName: string;
}

export interface CampaignsEditDataQuery_constants_metroStations {
  __typename: "GdMetroStationsData";
  rowset: CampaignsEditDataQuery_constants_metroStations_rowset[];
}

export interface CampaignsEditDataQuery_constants {
  __typename: "GdDirectConstants";
  defaultValues: CampaignsEditDataQuery_constants_defaultValues;
  validation: CampaignsEditDataQuery_constants_validation;
  /**
   * Станции метрополитена (только для Москвы, Санкт-Петербурга и Киева)
   */
  metroStations: CampaignsEditDataQuery_constants_metroStations;
}

export interface CampaignsEditDataQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  operator: CampaignsEditDataQuery_operator;
  client: CampaignsEditDataQuery_client;
  constants: CampaignsEditDataQuery_constants;
}

export interface CampaignsEditDataQueryVariables {
  login: string;
  campaignInput: GdCampaignsContainerInput;
  broadMatchGoalsInput: GdBroadMatchesContainerInput;
  city?: GdMetroCityInput[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CampaignsAvailableForKeyGoalsQuery
// ====================================================

export interface CampaignsAvailableForKeyGoalsQuery_client_meaningfulGoals_campaignGoals_goals {
  __typename: "GdGoal";
  id: GraphQlLong;
  name: string;
}

export interface CampaignsAvailableForKeyGoalsQuery_client_meaningfulGoals_campaignGoals {
  __typename: "GdCampaignGoals";
  campaignId: GraphQlLong;
  goals: CampaignsAvailableForKeyGoalsQuery_client_meaningfulGoals_campaignGoals_goals[];
}

export interface CampaignsAvailableForKeyGoalsQuery_client_meaningfulGoals {
  __typename: "GdCampaignsGoals";
  isMetrikaAvailable: boolean;
  campaignGoals: CampaignsAvailableForKeyGoalsQuery_client_meaningfulGoals_campaignGoals[] | null;
}

export interface CampaignsAvailableForKeyGoalsQuery_client {
  __typename: "GdClient";
  meaningfulGoals: CampaignsAvailableForKeyGoalsQuery_client_meaningfulGoals;
}

export interface CampaignsAvailableForKeyGoalsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CampaignsAvailableForKeyGoalsQuery_client;
}

export interface CampaignsAvailableForKeyGoalsQueryVariables {
  login: string;
  availableForKeyGoalsInput: GdMeaningfulGoalsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ClientDevQuery
// ====================================================

export interface ClientDevQuery_clientDev {
  __typename: "GdClientDevInfo";
  clientId: GraphQlLong;
  environment: string;
  operatorLogin: string;
  role: RbacRole;
  shard: number;
  uid: GraphQlLong;
  operatorFeatures: string[];
  clientFeatures: string[];
}

export interface ClientDevQuery {
  clientDev: ClientDevQuery_clientDev;
  /**
   * Получить reqId запроса
   */
  reqId: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CommonQuery
// ====================================================

export interface CommonQuery_client_wallets_status {
  __typename: "GdWalletStatus";
  enabled: boolean;
}

export interface CommonQuery_client_wallets_budget {
  __typename: "GdWalletBudget";
  sum: GraphQlBigDecimal | null;
  showMode: GdWalletBudgetShowMode | null;
  type: GdWalletBudgetType;
}

export interface CommonQuery_client_wallets {
  __typename: "GdWallet";
  id: GraphQlLong;
  status: CommonQuery_client_wallets_status;
  budget: CommonQuery_client_wallets_budget;
  sum: GraphQlBigDecimal;
  currency: CurrencyCode;
  actions: GdWalletAction[];
}

export interface CommonQuery_client_access {
  __typename: "GdClientAccess";
  canCreateCampaignTypes: GdCampaignType[];
  canCreateCampaign: boolean;
  canViewInternalAds: boolean;
  canEditInternalAds: boolean;
  canManageLibMinusWords: boolean;
  canManageInternalAdAccessRights: boolean;
  canPayByCash: boolean;
  canManageFavoriteCampaigns: boolean;
  canCopyCampaign: boolean;
  canManageUsingCommander: boolean;
  canMonitorPhrasesPositions: boolean;
  canTransferMoney: boolean;
  operatorIsClient: boolean;
  canUploadDocuments: boolean;
  canManageUsingXLS: boolean;
  canManageRetargertingConditions: boolean;
  canManageTurboLandings: boolean;
  canSeeClientRepresentatives: boolean;
  canManageVCards: boolean;
  canViewOfflineReports: boolean;
  canManageUsingApi: boolean;
  operatorIsClientChief: boolean;
  canManageCreatives: boolean;
  canManageFeeds: boolean;
  canCheckCampaignsStats: boolean;
  canViewUserLogs: boolean;
  canViewMobileApps: boolean;
  canSeeDealsLinkEverywhere: boolean;
  canSeeAgencyClients: boolean;
}

export interface CommonQuery_client_features {
  __typename: "GdClientFeatures";
  isGridEnabled: boolean;
  isGoalsStatEnabled: boolean;
  isMinusWordsLibEnabled: boolean;
  isInternalAdsAllowed: boolean;
  isBidCorrectionSearchEnabled: boolean;
  isCpmCampaignsEnabled: boolean;
  isTextCampaign8SitelinksEnabled: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isCpmVideoSeveralPixelsEnabled: boolean;
  isEmptyRetCondInCpmGroupEnabled: boolean;
  isCpmIndoorSegmentsEnabled: boolean;
  isCpcDeviceModifiersAllowed: boolean;
  isAdmetricaMeasurerCpmBannerAllowed: boolean;
  isAdmetricaMeasurerCpmDealsAllowed: boolean;
  isAdmetricaMeasurerCpmGeoproductAllowed: boolean;
  isAdmetricaMeasurerCpmVideoAllowed: boolean;
  isAdmetricaMeasurerCpmYndxFrontpageAllowed: boolean;
  isAdlooxMeasurerCpmBannerAllowed: boolean;
  isAdlooxMeasurerCpmDealsAllowed: boolean;
  isAdlooxMeasurerCpmGeoproductAllowed: boolean;
  isAdlooxMeasurerCpmVideoAllowed: boolean;
  isAdlooxMeasurerCpmYndxFrontpageAllowed: boolean;
  isAdriverMeasurerCpmBannerAllowed: boolean;
  isAdriverMeasurerCpmDealsAllowed: boolean;
  isAdriverMeasurerCpmGeoproductAllowed: boolean;
  isAdriverMeasurerCpmVideoAllowed: boolean;
  isAdriverMeasurerCpmYndxFrontpageAllowed: boolean;
  isDvMeasurerCpmBannerAllowed: boolean;
  isDvMeasurerCpmDealsAllowed: boolean;
  isDvMeasurerCpmGeoproductAllowed: boolean;
  isDvMeasurerCpmVideoAllowed: boolean;
  isDvMeasurerCpmYndxFrontpageAllowed: boolean;
  isIntegralAdScienceMeasurerCpmBannerAllowed: boolean;
  isIntegralAdScienceMeasurerCpmDealsAllowed: boolean;
  isIntegralAdScienceMeasurerCpmGeoproductAllowed: boolean;
  isIntegralAdScienceMeasurerCpmVideoAllowed: boolean;
  isIntegralAdScienceMeasurerCpmYndxFrontpageAllowed: boolean;
  isMediascopeMeasurerCpmBannerAllowed: boolean;
  isMediascopeMeasurerCpmDealsAllowed: boolean;
  isMediascopeMeasurerCpmGeoproductAllowed: boolean;
  isMediascopeMeasurerCpmVideoAllowed: boolean;
  isMediascopeMeasurerCpmYndxFrontpageAllowed: boolean;
  isMoatMeasurerCpmBannerAllowed: boolean;
  isMoatMeasurerCpmDealsAllowed: boolean;
  isMoatMeasurerCpmGeoproductAllowed: boolean;
  isMoatMeasurerCpmVideoAllowed: boolean;
  isMoatMeasurerCpmYndxFrontpageAllowed: boolean;
  isSizmekMeasurerCpmBannerAllowed: boolean;
  isSizmekMeasurerCpmDealsAllowed: boolean;
  isSizmekMeasurerCpmGeoproductAllowed: boolean;
  isSizmekMeasurerCpmVideoAllowed: boolean;
  isSizmekMeasurerCpmYndxFrontpageAllowed: boolean;
  isTnsEnabled: boolean;
}

export interface CommonQuery_client_info_managersInfo {
  __typename: "GdUserInfo";
  name: string;
  login: string;
  email: string;
  phone: string | null;
}

export interface CommonQuery_client_info_agencyInfo {
  __typename: "GdAgencyInfo";
  clientId: GraphQlLong | null;
  userId: GraphQlLong | null;
  name: string | null;
  login: string | null;
  email: string | null;
  phone: string | null;
  representativeName: string | null;
}

export interface CommonQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
  countryRegionId: GraphQlLong;
  translocalGeotreeType: GdGeotreeType;
  autoVideo: boolean;
  managersInfo: CommonQuery_client_info_managersInfo[];
  agencyInfo: CommonQuery_client_info_agencyInfo | null;
}

export interface CommonQuery_client {
  __typename: "GdClient";
  wallets: CommonQuery_client_wallets[];
  access: CommonQuery_client_access;
  features: CommonQuery_client_features;
  info: CommonQuery_client_info;
}

export interface CommonQuery_constants_strategyConstants {
  __typename: "GdStrategyConstants";
  maxDailyBudgetChangesPerDay: number;
}

export interface CommonQuery_constants_currencyConstants {
  __typename: "GdCurrencyDescription";
  code: CurrencyCode;
  minDailyBudget: GraphQlBigDecimal;
  maxDailyBudget: GraphQlBigDecimal;
  bigRate: GraphQlBigDecimal;
  minPrice: GraphQlBigDecimal;
  maxPrice: GraphQlBigDecimal;
  defaultPrice: GraphQlBigDecimal;
  minCpmPrice: GraphQlBigDecimal;
  maxCpmPrice: GraphQlBigDecimal;
  autobudgetAvgCpaWarning: GraphQlBigDecimal;
  autobudgetAvgPriceWarning: GraphQlBigDecimal;
  autobudgetClicksBundleWarning: number;
  autobudgetMaxPriceWarning: GraphQlBigDecimal;
  autobudgetSumWarning: GraphQlBigDecimal;
  maxAutobudget: GraphQlBigDecimal;
  maxAutobudgetBid: GraphQlBigDecimal;
  maxAutobudgetClicksBundle: number;
  minAutobudget: GraphQlBigDecimal;
  minAutobudgetBid: GraphQlBigDecimal;
  minAutobudgetClicksBundle: number;
  minAutobudgetAvgCpa: GraphQlBigDecimal;
  minAutobudgetAvgPrice: GraphQlBigDecimal;
}

export interface CommonQuery_constants_alertData {
  __typename: "GdAlertData";
  enabled: boolean;
  textRu: string | null;
  textEn: string | null;
}

export interface CommonQuery_constants_validation_libMinusKeywordsConstants {
  __typename: "GdDirectConstantsMinusWordsLibValidationData";
  libMinusKeywordsTextMaxLength: number;
  maxLibraryPacksCount: number;
  maxLinkedPacksToOneAdGroup: number;
  maxNameLength: number;
  maxWordsInMinusPhrase: number;
  nameAllowLetters: string;
  textAllowLetters: string;
}

export interface CommonQuery_constants_validation_adGroupConstants {
  __typename: "GdDirectConstantsAdGroupValidationData";
  maxAdGroupsCountPerUpdate: number;
}

export interface CommonQuery_constants_validation_campaignConstants {
  __typename: "GdDirectConstantsCampaignValidationData";
  minWarningBalanceInPercent: number;
  maxWarningBalanceInPercent: number;
}

export interface CommonQuery_constants_validation {
  __typename: "GdDirectConstantsValidationData";
  libMinusKeywordsConstants: CommonQuery_constants_validation_libMinusKeywordsConstants;
  adGroupConstants: CommonQuery_constants_validation_adGroupConstants;
  campaignConstants: CommonQuery_constants_validation_campaignConstants;
}

export interface CommonQuery_constants_defaultValues_campaign_defaultSmsTimeInterval_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CommonQuery_constants_defaultValues_campaign_defaultSmsTimeInterval_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CommonQuery_constants_defaultValues_campaign_defaultSmsTimeInterval {
  __typename: "GdTimeInterval";
  endTime: CommonQuery_constants_defaultValues_campaign_defaultSmsTimeInterval_endTime;
  startTime: CommonQuery_constants_defaultValues_campaign_defaultSmsTimeInterval_startTime;
}

export interface CommonQuery_constants_defaultValues_campaign {
  __typename: "GdCampaignDefaultValues";
  defaultWarningBalance: number;
  defaultCheckPositionInterval: GdCampaignCheckPositionInterval;
  defaultSmsTimeInterval: CommonQuery_constants_defaultValues_campaign_defaultSmsTimeInterval;
}

export interface CommonQuery_constants_defaultValues {
  __typename: "GdDefaultValues";
  campaign: CommonQuery_constants_defaultValues_campaign;
}

export interface CommonQuery_constants_configuration {
  __typename: "GdConfigurationConstants";
  balanceDomain: string;
  canvasUiDomain: string;
  spravIFrameUrl: string;
}

export interface CommonQuery_constants {
  __typename: "GdDirectConstants";
  /**
   * Максимально допустимая конечная дата для заказа агентсткого оффлайн-отчета
   */
  agencyOfflineReportMaximumDate: GraphQlLocalDate;
  strategyConstants: CommonQuery_constants_strategyConstants;
  currencyConstants: CommonQuery_constants_currencyConstants[];
  alertData: CommonQuery_constants_alertData;
  validation: CommonQuery_constants_validation;
  defaultValues: CommonQuery_constants_defaultValues;
  configuration: CommonQuery_constants_configuration;
}

export interface CommonQuery_operator_info {
  __typename: "GdUserInfo";
  login: string;
}

export interface CommonQuery_operator_access {
  __typename: "GdOperatorAccess";
  canEditInternationalization: boolean;
  canSearchPhrasesDuplicates: boolean;
  canEditAdDomain: boolean;
  canViewInternalAdsInSomeClients: boolean;
  actions: GdOperatorAction[];
}

export interface CommonQuery_operator_officeInfo_cityContact {
  __typename: "GdOfficeContactData";
  description: string;
  cityName: string | null;
  phone: string;
  phoneExtension: string | null;
}

export interface CommonQuery_operator_officeInfo_regionContact {
  __typename: "GdOfficeContactData";
  description: string;
  cityName: string | null;
  phone: string;
  phoneExtension: string | null;
}

export interface CommonQuery_operator_officeInfo_regionContact2 {
  __typename: "GdOfficeContactData";
  description: string;
  cityName: string | null;
  phone: string;
  phoneExtension: string | null;
}

export interface CommonQuery_operator_officeInfo {
  __typename: "GdOfficeInfo";
  cityContact: CommonQuery_operator_officeInfo_cityContact | null;
  regionContact: CommonQuery_operator_officeInfo_regionContact | null;
  regionContact2: CommonQuery_operator_officeInfo_regionContact2 | null;
}

export interface CommonQuery_operator_managerInfo {
  __typename: "GdUserInfo";
  name: string;
  login: string;
  email: string;
  phone: string | null;
}

export interface CommonQuery_operator_chiefInfo {
  __typename: "GdUserInfo";
  name: string;
  login: string;
  email: string;
  phone: string | null;
}

export interface CommonQuery_operator_agencyInfo {
  __typename: "GdUserInfo";
  name: string;
  login: string;
  email: string;
  phone: string | null;
}

export interface CommonQuery_operator_features {
  __typename: "GdOperatorFeatures";
  isAdGroupUpdateAllowed: boolean;
  isBannerUpdateAllowed: boolean;
  isCpmBannerUpdateAllowed: boolean;
  isBannerAimingAllowed: boolean;
  isBannerAimingCpmAllowed: boolean;
  isPerformanceAdEditAllowed: boolean;
  isOutdoorGroupsEditAllowed: boolean;
  isIndoorGroupsEditAllowed: boolean;
  isRetargetingGridEnabled: boolean;
  isAdsMassEditAllowed: boolean;
  isCampaignUpdateAllowed: boolean;
  isCpmAdGroupUpdateAllowed: boolean;
  isVideoGroupsEditAllowed: boolean;
  isGeoproductGroupsEditAllowed: boolean;
  isAudioGroupsEditAllowed: boolean;
  isMcBannerDnaEnabled: boolean;
}

export interface CommonQuery_operator {
  __typename: "GdOperatorInfo";
  tuneSecretKey: string | null;
  workCurrency: CurrencyCode;
  isSelfAgency: boolean;
  isAgency: boolean;
  info: CommonQuery_operator_info | null;
  access: CommonQuery_operator_access;
  officeInfo: CommonQuery_operator_officeInfo;
  managerInfo: CommonQuery_operator_managerInfo | null;
  chiefInfo: CommonQuery_operator_chiefInfo | null;
  agencyInfo: CommonQuery_operator_agencyInfo | null;
  features: CommonQuery_operator_features | null;
}

export interface CommonQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CommonQuery_client;
  constants: CommonQuery_constants;
  operator: CommonQuery_operator;
}

export interface CommonQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FindAndReplaceKeywordsPreview
// ====================================================

export interface FindAndReplaceKeywordsPreview_getFindAndReplaceKeywordsPreview_rowset {
  __typename: "GdFindAndReplaceKeywordsPreviewPayloadItem";
  minusKeywords: string[];
  changedMinusKeywords: string[] | null;
  keyword: string;
  changedKeyword: string | null;
}

export interface FindAndReplaceKeywordsPreview_getFindAndReplaceKeywordsPreview_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface FindAndReplaceKeywordsPreview_getFindAndReplaceKeywordsPreview_validationResult {
  __typename: "GdValidationResult";
  errors: FindAndReplaceKeywordsPreview_getFindAndReplaceKeywordsPreview_validationResult_errors[];
}

export interface FindAndReplaceKeywordsPreview_getFindAndReplaceKeywordsPreview {
  __typename: "GdFindAndReplaceKeywordsPreviewPayload";
  cacheKey: string;
  totalCount: number;
  rowset: FindAndReplaceKeywordsPreview_getFindAndReplaceKeywordsPreview_rowset[];
  validationResult: FindAndReplaceKeywordsPreview_getFindAndReplaceKeywordsPreview_validationResult | null;
}

export interface FindAndReplaceKeywordsPreview {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  getFindAndReplaceKeywordsPreview: FindAndReplaceKeywordsPreview_getFindAndReplaceKeywordsPreview;
}

export interface FindAndReplaceKeywordsPreviewVariables {
  input: GdFindAndReplaceKeywordsInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CommonWalletQuery
// ====================================================

export interface CommonWalletQuery_client_wallets_status {
  __typename: "GdWalletStatus";
  enabled: boolean;
}

export interface CommonWalletQuery_client_wallets {
  __typename: "GdWallet";
  sum: GraphQlBigDecimal;
  currency: CurrencyCode;
  status: CommonWalletQuery_client_wallets_status;
}

export interface CommonWalletQuery_client {
  __typename: "GdClient";
  wallets: CommonWalletQuery_client_wallets[];
}

export interface CommonWalletQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CommonWalletQuery_client;
}

export interface CommonWalletQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: BalanceCartDataQuery
// ====================================================

export interface BalanceCartDataQuery_client_wallets {
  __typename: "GdWallet";
  id: GraphQlLong;
}

export interface BalanceCartDataQuery_client_features {
  __typename: "GdClientFeatures";
  isB2bBalanceCartEnabled: boolean;
}

export interface BalanceCartDataQuery_client {
  __typename: "GdClient";
  wallets: BalanceCartDataQuery_client_wallets[];
  features: BalanceCartDataQuery_client_features;
}

export interface BalanceCartDataQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: BalanceCartDataQuery_client;
}

export interface BalanceCartDataQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: DealsCount
// ====================================================

export interface DealsCount_client_deals {
  __typename: "GdDealsContext";
  totalCount: number;
}

export interface DealsCount_client {
  __typename: "GdClient";
  deals: DealsCount_client_deals;
}

export interface DealsCount {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: DealsCount_client;
}

export interface DealsCountVariables {
  login: string;
  dealsFilter?: GdiDealFilterInput | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: HeaderClientInfoQuery
// ====================================================

export interface HeaderClientInfoQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  chiefUserId: GraphQlLong;
  agencyClientId: GraphQlLong | null;
}

export interface HeaderClientInfoQuery_client_features {
  __typename: "GdClientFeatures";
  isMinusWordsLibEnabled: boolean;
}

export interface HeaderClientInfoQuery_client_wallets_status {
  __typename: "GdWalletStatus";
  enabled: boolean;
}

export interface HeaderClientInfoQuery_client_wallets_budget {
  __typename: "GdWalletBudget";
  sum: GraphQlBigDecimal | null;
  showMode: GdWalletBudgetShowMode | null;
  type: GdWalletBudgetType;
}

export interface HeaderClientInfoQuery_client_wallets {
  __typename: "GdWallet";
  id: GraphQlLong;
  status: HeaderClientInfoQuery_client_wallets_status;
  budget: HeaderClientInfoQuery_client_wallets_budget;
  sum: GraphQlBigDecimal;
  currency: CurrencyCode;
  actions: GdWalletAction[];
}

export interface HeaderClientInfoQuery_client {
  __typename: "GdClient";
  info: HeaderClientInfoQuery_client_info;
  features: HeaderClientInfoQuery_client_features;
  wallets: HeaderClientInfoQuery_client_wallets[];
}

export interface HeaderClientInfoQuery {
  client: HeaderClientInfoQuery_client;
}

export interface HeaderClientInfoQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: MenuHeaderQuery
// ====================================================

export interface MenuHeaderQuery_menuHeader {
  __typename: "GdMenuHeaderInfo";
  allowedMenuItems: GdMenuItem[];
}

export interface MenuHeaderQuery {
  menuHeader: MenuHeaderQuery_menuHeader;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: HeaderInfoQuery
// ====================================================

export interface HeaderInfoQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  chiefUserId: GraphQlLong;
  agencyClientId: GraphQlLong | null;
}

export interface HeaderInfoQuery_client_deals {
  __typename: "GdDealsContext";
  totalCount: number;
}

export interface HeaderInfoQuery_client_features {
  __typename: "GdClientFeatures";
  isMinusWordsLibEnabled: boolean;
  isB2bBalanceCartEnabled: boolean;
}

export interface HeaderInfoQuery_client_access {
  __typename: "GdClientAccess";
  canSeeDealsLinkEverywhere: boolean;
}

export interface HeaderInfoQuery_client_wallets_status {
  __typename: "GdWalletStatus";
  enabled: boolean;
}

export interface HeaderInfoQuery_client_wallets_budget {
  __typename: "GdWalletBudget";
  sum: GraphQlBigDecimal | null;
  showMode: GdWalletBudgetShowMode | null;
  type: GdWalletBudgetType;
}

export interface HeaderInfoQuery_client_wallets {
  __typename: "GdWallet";
  id: GraphQlLong;
  status: HeaderInfoQuery_client_wallets_status;
  budget: HeaderInfoQuery_client_wallets_budget;
  sum: GraphQlBigDecimal;
  currency: CurrencyCode;
  actions: GdWalletAction[];
}

export interface HeaderInfoQuery_client {
  __typename: "GdClient";
  info: HeaderInfoQuery_client_info;
  deals: HeaderInfoQuery_client_deals;
  features: HeaderInfoQuery_client_features;
  access: HeaderInfoQuery_client_access;
  wallets: HeaderInfoQuery_client_wallets[];
}

export interface HeaderInfoQuery_operator_info {
  __typename: "GdUserInfo";
  userId: GraphQlLong;
}

export interface HeaderInfoQuery_operator {
  __typename: "GdOperatorInfo";
  info: HeaderInfoQuery_operator_info | null;
  isAgency: boolean;
}

export interface HeaderInfoQuery {
  /**
   * Получить reqId запроса
   */
  getReqId: string;
  client: HeaderInfoQuery_client;
  operator: HeaderInfoQuery_operator;
}

export interface HeaderInfoQueryVariables {
  login: string;
  dealsFilter?: GdiDealFilterInput | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: WalletInfoQuery
// ====================================================

export interface WalletInfoQuery_client_wallets_status {
  __typename: "GdWalletStatus";
  enabled: boolean;
}

export interface WalletInfoQuery_client_wallets_budget {
  __typename: "GdWalletBudget";
  sum: GraphQlBigDecimal | null;
  showMode: GdWalletBudgetShowMode | null;
  type: GdWalletBudgetType;
}

export interface WalletInfoQuery_client_wallets {
  __typename: "GdWallet";
  id: GraphQlLong;
  status: WalletInfoQuery_client_wallets_status;
  budget: WalletInfoQuery_client_wallets_budget;
  sum: GraphQlBigDecimal;
  currency: CurrencyCode;
  actions: GdWalletAction[];
}

export interface WalletInfoQuery_client {
  __typename: "GdClient";
  wallets: WalletInfoQuery_client_wallets[];
}

export interface WalletInfoQuery {
  /**
   * Получить reqId запроса
   */
  getReqId: string;
  client: WalletInfoQuery_client;
}

export interface WalletInfoQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CheckClientMutationStateQuery
// ====================================================

export interface CheckClientMutationStateQuery_checkClientMutationState {
  __typename: "GdCheckClientMutationStatePayload";
  state: GdClientMutationState;
}

export interface CheckClientMutationStateQuery {
  checkClientMutationState: CheckClientMutationStateQuery_checkClientMutationState;
}

export interface CheckClientMutationStateQueryVariables {
  input: GdCheckClientMutationStateInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AuthorizationQuery
// ====================================================

export interface AuthorizationQuery_operator_chiefInfo {
  __typename: "GdUserInfo";
  login: string;
  clientId: GraphQlLong;
  userId: GraphQlLong;
}

export interface AuthorizationQuery_operator {
  __typename: "GdOperatorInfo";
  chiefInfo: AuthorizationQuery_operator_chiefInfo | null;
  isFreelancer: boolean;
}

export interface AuthorizationQuery {
  operator: AuthorizationQuery_operator;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ClientMetrikaCountersQuery
// ====================================================

export interface ClientMetrikaCountersQuery_client_metrikaCounters {
  __typename: "GdClientMetrikaCounters";
  counters: number[] | null;
  isMetrikaAvailable: boolean;
}

export interface ClientMetrikaCountersQuery_client {
  __typename: "GdClient";
  metrikaCounters: ClientMetrikaCountersQuery_client_metrikaCounters;
}

export interface ClientMetrikaCountersQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: ClientMetrikaCountersQuery_client;
}

export interface ClientMetrikaCountersQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CryptaSegments
// ====================================================

export interface CryptaSegments_cryptaSegments_rowset {
  __typename: "GdCryptaSegment";
  id: GraphQlLong;
  type: WebGoalType;
  name: string;
  parentId: GraphQlLong | null;
  description: string;
  interestType: CryptaInterestTypeWeb | null;
  canSelectAll: boolean | null;
  mutuallyExclusiveIds: GraphQlLong[] | null;
}

export interface CryptaSegments_cryptaSegments {
  __typename: "GdCryptaSegmentsContext";
  totalCount: number;
  rowset: CryptaSegments_cryptaSegments_rowset[];
}

export interface CryptaSegments {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  cryptaSegments: CryptaSegments_cryptaSegments;
}

export interface CryptaSegmentsVariables {
  input: GdCryptaSegmentsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: DealsQuery
// ====================================================

export interface DealsQuery_client_deals_rowset_placements {
  __typename: "GdiDealPlacement";
  domain: string | null;
  formats: (string | null)[] | null;
}

export interface DealsQuery_client_deals_rowset {
  __typename: "GdiDeal";
  id: GraphQlLong;
  name: string | null;
  status: StatusDirect;
  completeReason: CompleteReason | null;
  dateStart: GraphQlLocalDateTime | null;
  dateEnd: GraphQlLocalDateTime | null;
  description: string | null;
  expectedMoneyPerWeek: GraphQlLong | null;
  expectedImpressionsPerWeek: GraphQlLong | null;
  dealType: DealType;
  contacts: string | null;
  minPrice: GraphQlBigDecimal | null;
  targetingsText: string | null;
  agencyFeePercent: GraphQlBigDecimal | null;
  currencyCode: string | null;
  publisherName: string | null;
  numberOfLinkedCampaigns: number | null;
  clicks: GraphQlLong | null;
  cpc: GraphQlBigDecimal | null;
  cpm: GraphQlBigDecimal | null;
  ctr: GraphQlBigDecimal | null;
  placements: DealsQuery_client_deals_rowset_placements[] | null;
  shows: GraphQlLong | null;
  spent: GraphQlBigDecimal | null;
}

export interface DealsQuery_client_deals {
  __typename: "GdDealsContext";
  rowset: DealsQuery_client_deals_rowset[];
  totalCount: number;
  cacheKey: string;
  dealIds: GraphQlLong[];
}

export interface DealsQuery_client {
  __typename: "GdClient";
  deals: DealsQuery_client_deals;
}

export interface DealsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: DealsQuery_client;
}

export interface DealsQueryVariables {
  login: string;
  limit?: number | null;
  offset?: number | null;
  selectedDealIds?: GraphQlLong[] | null;
  needStats: boolean;
  orderBy?: GdDealOrderByInput[] | null;
  filter?: GdiDealFilterInput | null;
  cacheKey?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: DialogsQuery
// ====================================================

export interface DialogsQuery_client_dialogs {
  __typename: "GdDialog";
  id: GraphQlLong | null;
  name: string;
  isActive: boolean;
  skillId: string;
}

export interface DialogsQuery_client {
  __typename: "GdClient";
  dialogs: (DialogsQuery_client_dialogs | null)[];
  chiefLogin: string;
}

export interface DialogsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: DialogsQuery_client;
}

export interface DialogsQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CampaignsQuery
// ====================================================

export interface CampaignsQuery_client_features {
  __typename: "GdClientFeatures";
  isWalletEnabled: boolean;
  hasMetrikaCounters: boolean;
  hasEcommerce: boolean;
  hasCampaignsWithCPAStrategy: boolean;
  enabledRecommendationTypes: GdiRecommendationType[];
  isBannerPricesOnGridEnabled: boolean;
  isInternalAdsAllowed: boolean;
  isCpmCampaignsEnabled: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isTurboForSerpWizardAllowed: boolean;
  isBrandLiftAllowed: boolean;
}

export interface CampaignsQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
  countryRegionId: GraphQlLong;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi = CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_keys[];
  kpi: CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi;
}

export type CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations = CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithoutKpi | CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi;

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_flatStrategy = CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_flatStrategy_GdCampaignStrategyAvgClick | CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_flatStrategy_GdCampaignStrategyManual;

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_status_timeTargetStatus;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign {
  __typename: "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  agencyId: GraphQlLong | null;
  name: string;
  index: number;
  currency: CurrencyCode | null;
  type: GdCampaignType;
  sum: GraphQlBigDecimal | null;
  hasAds: boolean;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  recommendations: CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_recommendations[] | null;
  flatStrategy: CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_flatStrategy;
  status: CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_status;
  access: CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_access;
  stats: CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_stats;
  goalStats: CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign_goalStats[] | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi = CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_keys[];
  kpi: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi;
}

export type CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations = CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithoutKpi | CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi;

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy = CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_brandSurveyStatus {
  __typename: "GdBrandSurveyStatus";
  surveyStatus: GdSurveyStatus;
  reasonIds: GraphQlLong[];
  brandSurveyStopReasons: GdBrandSurveyStopReason[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign";
  id: GraphQlLong;
  agencyId: GraphQlLong | null;
  name: string;
  index: number;
  currency: CurrencyCode | null;
  type: GdCampaignType;
  sum: GraphQlBigDecimal | null;
  hasAds: boolean;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  recommendations: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations[] | null;
  flatStrategy: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy;
  status: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_status;
  access: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_access;
  stats: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_stats;
  goalStats: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_goalStats[] | null;
  brandSurveyId: string | null;
  brandSurveyStatus: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_brandSurveyStatus | null;
}

export type CampaignsQuery_client_campaigns_rowset = CampaignsQuery_client_campaigns_rowset_GdCpmDealsCampaign | CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign;

export interface CampaignsQuery_client_campaigns_totalStats {
  __typename: "GdEntityStats";
  cost: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  clicks: GraphQlLong | null;
  ctr: GraphQlBigDecimal | null;
}

export interface CampaignsQuery_client_campaigns {
  __typename: "GdCampaignsContext";
  rowset: CampaignsQuery_client_campaigns_rowset[];
  totalCount: number;
  campaignIds: GraphQlLong[];
  cacheKey: string;
  totalStats: CampaignsQuery_client_campaigns_totalStats;
}

export interface CampaignsQuery_client {
  __typename: "GdClient";
  chiefLogin: string;
  features: CampaignsQuery_client_features;
  info: CampaignsQuery_client_info;
  campaigns: CampaignsQuery_client_campaigns;
}

export interface CampaignsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CampaignsQuery_client;
}

export interface CampaignsQueryVariables {
  login: string;
  campaignInput: GdCampaignsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CampaignPayActionInfoQuery
// ====================================================

export interface CampaignPayActionInfoQuery_client_campaigns_features {
  __typename: "GdCampaignsFeatures";
  campaignTypes: GdCampaignType[];
}

export interface CampaignPayActionInfoQuery_client_campaigns_rowset_access {
  __typename: "GdCampaignAccess";
  actions: GdCampaignAction[];
}

export interface CampaignPayActionInfoQuery_client_campaigns_rowset_status {
  __typename: "GdCampaignStatus";
  moderationStatus: GdCampaignStatusModerate;
}

export interface CampaignPayActionInfoQuery_client_campaigns_rowset {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  access: CampaignPayActionInfoQuery_client_campaigns_rowset_access;
  status: CampaignPayActionInfoQuery_client_campaigns_rowset_status;
}

export interface CampaignPayActionInfoQuery_client_campaigns {
  __typename: "GdCampaignsContext";
  features: CampaignPayActionInfoQuery_client_campaigns_features;
  rowset: CampaignPayActionInfoQuery_client_campaigns_rowset[];
}

export interface CampaignPayActionInfoQuery_client {
  __typename: "GdClient";
  campaigns: CampaignPayActionInfoQuery_client_campaigns;
}

export interface CampaignPayActionInfoQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CampaignPayActionInfoQuery_client;
}

export interface CampaignPayActionInfoQueryVariables {
  login: string;
  campaignInput: GdCampaignsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GroupsQuery
// ====================================================

export interface GroupsQuery_client_features {
  __typename: "GdClientFeatures";
  isWalletEnabled: boolean;
  hasMetrikaCounters: boolean;
  hasEcommerce: boolean;
  hasCampaignsWithCPAStrategy: boolean;
  enabledRecommendationTypes: GdiRecommendationType[];
  isBannerPricesOnGridEnabled: boolean;
  isInternalAdsAllowed: boolean;
  isCpmCampaignsEnabled: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isTurboForSerpWizardAllowed: boolean;
  isBrandLiftAllowed: boolean;
}

export interface GroupsQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
  countryRegionId: GraphQlLong;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign = GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdTextCampaign | GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi = GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi;
}

export type GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations = GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithoutKpi | GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi;

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canBeDeleted: boolean;
  canEdit: boolean;
  canRemoderateAdsCallouts: boolean;
  canAcceptAdsCalloutsModeration: boolean;
  canBeSentToModeration: boolean;
  canBeSentToModerationByClient: boolean;
  canBeSentToRemoderation: boolean;
  canAcceptModeration: boolean;
  canBeSentToBS: boolean;
  canCopy: boolean;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  bsEverSynced: boolean;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdMcBannerAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  name: string;
  type: GdAdGroupType;
  campaignId: GraphQlLong;
  id: GraphQlLong;
  index: number;
  campaign: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_campaign;
  recommendations: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_recommendations[] | null;
  minusKeywords: string[];
  regionsInfo: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_regionsInfo;
  access: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_access;
  stats: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_stats;
  status: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_status;
  goalStats: GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup_goalStats[] | null;
  availableShowConditionTypes: GdShowConditionType[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign = GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi = GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi;
}

export type GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations = GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithoutKpi | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi;

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canBeDeleted: boolean;
  canEdit: boolean;
  canRemoderateAdsCallouts: boolean;
  canAcceptAdsCalloutsModeration: boolean;
  canBeSentToModeration: boolean;
  canBeSentToModerationByClient: boolean;
  canBeSentToRemoderation: boolean;
  canAcceptModeration: boolean;
  canBeSentToBS: boolean;
  canCopy: boolean;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  bsEverSynced: boolean;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  name: string;
  type: GdAdGroupType;
  campaignId: GraphQlLong;
  id: GraphQlLong;
  index: number;
  campaign: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign;
  recommendations: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations[] | null;
  minusKeywords: string[];
  regionsInfo: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_regionsInfo;
  access: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_access;
  stats: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_stats;
  status: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_status;
  goalStats: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_goalStats[] | null;
  availableShowConditionTypes: GdShowConditionType[];
  mainDomain: string | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign = GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi = GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi;
}

export type GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations = GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithoutKpi | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi;

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canBeDeleted: boolean;
  canEdit: boolean;
  canRemoderateAdsCallouts: boolean;
  canAcceptAdsCalloutsModeration: boolean;
  canBeSentToModeration: boolean;
  canBeSentToModerationByClient: boolean;
  canBeSentToRemoderation: boolean;
  canAcceptModeration: boolean;
  canBeSentToBS: boolean;
  canCopy: boolean;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  bsEverSynced: boolean;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  name: string;
  type: GdAdGroupType;
  campaignId: GraphQlLong;
  id: GraphQlLong;
  index: number;
  campaign: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign;
  recommendations: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations[] | null;
  minusKeywords: string[];
  regionsInfo: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_regionsInfo;
  access: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_access;
  stats: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_stats;
  status: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_status;
  goalStats: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_goalStats[] | null;
  availableShowConditionTypes: GdShowConditionType[];
  storeHref: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdCpmBannerCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_flatStrategy = GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_flatStrategy = GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign = GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdCpmBannerCampaign | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign;

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi = GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi;
}

export type GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations = GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithoutKpi | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi;

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_access {
  __typename: "GdAdGroupAccess";
  canBeDeleted: boolean;
  canEdit: boolean;
  canRemoderateAdsCallouts: boolean;
  canAcceptAdsCalloutsModeration: boolean;
  canBeSentToModeration: boolean;
  canBeSentToModerationByClient: boolean;
  canBeSentToRemoderation: boolean;
  canAcceptModeration: boolean;
  canBeSentToBS: boolean;
  canCopy: boolean;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_status {
  __typename: "GdAdGroupStatus";
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  bsEverSynced: boolean;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingInternalNetwork {
  __typename: "GdAdditionalTargetingInternalNetwork";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingIsBrowser {
  __typename: "GdAdditionalTargetingIsBrowser";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingIsTablet {
  __typename: "GdAdditionalTargetingIsTablet";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingIsMobile {
  __typename: "GdAdditionalTargetingIsMobile";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingIsTouch {
  __typename: "GdAdditionalTargetingIsTouch";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingUserAgents {
  __typename: "GdAdditionalTargetingUserAgents";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingOsNames_value {
  __typename: "GdAdditionalTargetingUatraits";
  targetingValueEntryId: GraphQlLong;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingOsNames {
  __typename: "GdAdditionalTargetingOsNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingOsNames_value[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingOsFamilies_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingOsFamilies {
  __typename: "GdAdditionalTargetingOsFamilies";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingOsFamilies_value[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserNames_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserNames {
  __typename: "GdAdditionalTargetingBrowserNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserNames_value[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserEngines_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserEngines {
  __typename: "GdAdditionalTargetingBrowserEngines";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserEngines_value[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceVendors_value {
  __typename: "GdAdditionalTargetingUatraits";
  targetingValueEntryId: GraphQlLong;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceVendors {
  __typename: "GdAdditionalTargetingDeviceVendors";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceVendors_value[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceNames {
  __typename: "GdAdditionalTargetingDeviceNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingInterfaceLangs {
  __typename: "GdAdditionalTargetingInterfaceLangs";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: InterfaceLang[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingQueryReferers {
  __typename: "GdAdditionalTargetingQueryReferers";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingYandexUids {
  __typename: "GdAdditionalTargetingYandexUids";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingShowDates {
  __typename: "GdAdditionalTargetingShowDates";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLocalDate[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup {
  __typename: "GdInternalAdGroup";
  name: string;
  type: GdAdGroupType;
  campaignId: GraphQlLong;
  id: GraphQlLong;
  index: number;
  campaign: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign;
  recommendations: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations[] | null;
  minusKeywords: string[];
  regionsInfo: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_regionsInfo;
  access: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_access;
  stats: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_stats;
  status: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_status;
  goalStats: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_goalStats[] | null;
  availableShowConditionTypes: GdShowConditionType[];
  level: GraphQlLong | null;
  targetingInternalNetwork: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingInternalNetwork | null;
  targetingIsBrowser: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingIsBrowser | null;
  targetingIsTablet: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingIsTablet | null;
  targetingIsMobile: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingIsMobile | null;
  targetingIsTouch: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingIsTouch | null;
  targetingUserAgents: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingUserAgents | null;
  targetingOsNames: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingOsNames | null;
  targetingOsFamilies: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingOsFamilies | null;
  targetingBrowserNames: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserNames | null;
  targetingBrowserEngines: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserEngines | null;
  targetingDeviceVendors: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceVendors | null;
  targetingDeviceNames: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceNames | null;
  targetingInterfaceLangs: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingInterfaceLangs | null;
  targetingQueryReferers: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingQueryReferers | null;
  targetingYandexUids: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingYandexUids | null;
  targetingShowDates: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingShowDates | null;
  startTime: GraphQlLocalDateTime | null;
  finishTime: GraphQlLocalDateTime | null;
}

export type GroupsQuery_client_adGroups_rowset = GroupsQuery_client_adGroups_rowset_GdCpmAudioAdGroup | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup;

export interface GroupsQuery_client_adGroups_features {
  __typename: "GdAdGroupFeatures";
  hasAdGroupsOverLimit: boolean;
}

export interface GroupsQuery_client_adGroups_totalStats {
  __typename: "GdEntityStats";
  shows: GraphQlLong | null;
  clicks: GraphQlLong | null;
  ctr: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
}

export interface GroupsQuery_client_adGroups {
  __typename: "GdAdGroupsContext";
  rowset: GroupsQuery_client_adGroups_rowset[];
  features: GroupsQuery_client_adGroups_features;
  totalCount: number;
  adGroupIds: GraphQlLong[];
  cacheKey: string;
  totalStats: GroupsQuery_client_adGroups_totalStats;
}

export interface GroupsQuery_client {
  __typename: "GdClient";
  chiefLogin: string;
  features: GroupsQuery_client_features;
  info: GroupsQuery_client_info;
  adGroups: GroupsQuery_client_adGroups;
}

export interface GroupsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: GroupsQuery_client;
}

export interface GroupsQueryVariables {
  login: string;
  adGroupInput: GdAdGroupsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GroupsMassActionsCount
// ====================================================

export interface GroupsMassActionsCount_client_adGroups_features {
  __typename: "GdAdGroupFeatures";
  canRemoderateAdsCalloutsCount: number;
  canAcceptAdsCalloutsModerationCount: number;
  canBeDeletedAdGroupsCount: number;
  canBeSentToModerationAdGroupsCount: number;
  canBeSentToBSAdGroupsCount: number;
  canBeSentToRemoderationAdGroupsCount: number;
  canAcceptModerationAdGroupsCount: number;
  canBeSentToModerationByClientAdGroupsCount: number;
  canBeCopied: number;
}

export interface GroupsMassActionsCount_client_adGroups {
  __typename: "GdAdGroupsContext";
  features: GroupsMassActionsCount_client_adGroups_features;
}

export interface GroupsMassActionsCount_client {
  __typename: "GdClient";
  adGroups: GroupsMassActionsCount_client_adGroups;
}

export interface GroupsMassActionsCount {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: GroupsMassActionsCount_client;
}

export interface GroupsMassActionsCountVariables {
  login: string;
  adGroupInput: GdAdGroupsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PhrasesQuery
// ====================================================

export interface PhrasesQuery_client_features {
  __typename: "GdClientFeatures";
  isWalletEnabled: boolean;
  hasMetrikaCounters: boolean;
  hasEcommerce: boolean;
  hasCampaignsWithCPAStrategy: boolean;
  enabledRecommendationTypes: GdiRecommendationType[];
  isBannerPricesOnGridEnabled: boolean;
  isInternalAdsAllowed: boolean;
  isCpmCampaignsEnabled: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isTurboForSerpWizardAllowed: boolean;
  isBrandLiftAllowed: boolean;
}

export interface PhrasesQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
  countryRegionId: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_status {
  __typename: "GdShowConditionStatus";
  suspended: boolean;
  primaryStatus: GdShowConditionPrimaryStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_access;
  mainAd: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_access;
  mainAd: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_regionsInfo;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_access;
  mainAd: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_access;
  mainAd: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_regionsInfo;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_access {
  __typename: "GdShowConditionAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_pokazometerData_allCostsAndClicks {
  __typename: "GdPokazometerCostsAndClicksItem";
  clicks: number;
  price: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_pokazometerData_priceForCoverage {
  __typename: "GdPokazometerPriceForCoverageItem";
  coverage: number;
  price: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_pokazometerData {
  __typename: "GdPokazometerData";
  allCostsAndClicks: PhrasesQuery_client_showConditions_rowset_GdKeyword_pokazometerData_allCostsAndClicks[];
  priceForCoverage: PhrasesQuery_client_showConditions_rowset_GdKeyword_pokazometerData_priceForCoverage[];
  maxShows: number | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_auctionData_auctionDataItems {
  __typename: "GdAuctionDataItem";
  bid: GraphQlBigDecimal;
  amnestyPrice: GraphQlBigDecimal;
  trafficVolume: GraphQlLong;
  showInTable: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_auctionData {
  __typename: "GdAuctionData";
  auctionDataItems: PhrasesQuery_client_showConditions_rowset_GdKeyword_auctionData_auctionDataItems[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword {
  __typename: "GdKeyword";
  id: GraphQlLong;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_status;
  adGroup: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_access;
  adsInAdGroupCount: number;
  mainAd: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd | null;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  index: number;
  type: GdShowConditionType;
  stats: PhrasesQuery_client_showConditions_rowset_GdKeyword_stats;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdKeyword_goalStats[] | null;
  priceContext: GraphQlBigDecimal | null;
  weightedCtr: GraphQlBigDecimal;
  autobudgetPriority: GdShowConditionAutobudgetPriority | null;
  showsForecast: GraphQlLong | null;
  price: GraphQlBigDecimal | null;
  usePhraseTrafaretAuction: boolean;
  minusKeywords: string[];
  pokazometerData: PhrasesQuery_client_showConditions_rowset_GdKeyword_pokazometerData | null;
  keyword: string;
  auctionData: PhrasesQuery_client_showConditions_rowset_GdKeyword_auctionData | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_status {
  __typename: "GdShowConditionStatus";
  suspended: boolean;
  primaryStatus: GdShowConditionPrimaryStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_access;
  mainAd: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_access;
  mainAd: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_regionsInfo;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_access;
  mainAd: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_access;
  mainAd: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_regionsInfo;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_access {
  __typename: "GdShowConditionAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch {
  __typename: "GdRelevanceMatch";
  id: GraphQlLong;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_status;
  adGroup: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_access;
  adsInAdGroupCount: number;
  mainAd: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd | null;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  index: number;
  type: GdShowConditionType;
  stats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_stats;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_goalStats[] | null;
  autobudgetPriority: GdShowConditionAutobudgetPriority | null;
  price: GraphQlBigDecimal | null;
  priceContext: GraphQlBigDecimal | null;
}

export type PhrasesQuery_client_showConditions_rowset = PhrasesQuery_client_showConditions_rowset_GdKeyword | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch;

export interface PhrasesQuery_client_showConditions_features {
  __typename: "GdShowConditionFeatures";
  commonPlatform: GdCampaignPlatform[];
  commonCampaignTypes: GdCampaignType[];
}

export interface PhrasesQuery_client_showConditions_totalStats {
  __typename: "GdEntityStats";
  shows: GraphQlLong | null;
  clicks: GraphQlLong | null;
  ctr: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
}

export interface PhrasesQuery_client_showConditions {
  __typename: "GdShowConditionsContext";
  rowset: PhrasesQuery_client_showConditions_rowset[];
  totalCount: number;
  showConditionIds: GraphQlLong[];
  features: PhrasesQuery_client_showConditions_features;
  totalStats: PhrasesQuery_client_showConditions_totalStats;
  hasObjectsOverLimit: boolean;
  cacheKey: string;
}

export interface PhrasesQuery_client {
  __typename: "GdClient";
  chiefLogin: string;
  features: PhrasesQuery_client_features;
  info: PhrasesQuery_client_info;
  showConditions: PhrasesQuery_client_showConditions;
}

export interface PhrasesQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: PhrasesQuery_client;
}

export interface PhrasesQueryVariables {
  showConditionsInput: GdShowConditionsContainerInput;
  login?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: TargetingQuery
// ====================================================

export interface TargetingQuery_client_features {
  __typename: "GdClientFeatures";
  isWalletEnabled: boolean;
  hasMetrikaCounters: boolean;
  hasEcommerce: boolean;
  hasCampaignsWithCPAStrategy: boolean;
  enabledRecommendationTypes: GdiRecommendationType[];
  isBannerPricesOnGridEnabled: boolean;
  isInternalAdsAllowed: boolean;
  isCpmCampaignsEnabled: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isTurboForSerpWizardAllowed: boolean;
  isBrandLiftAllowed: boolean;
}

export interface TargetingQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
  countryRegionId: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_access;
  mainAd: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_access;
  mainAd: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_regionsInfo;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_access;
  mainAd: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_access;
  mainAd: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_regionsInfo;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdCpmAudioAdGroup | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_status {
  __typename: "GdShowConditionStatus";
  primaryStatus: GdShowConditionPrimaryStatus;
  deleted: boolean;
  suspended: boolean;
  statusModerate: GdShowConditionStatusModerate;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_access {
  __typename: "GdShowConditionAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword {
  __typename: "GdKeyword";
  id: GraphQlLong;
  adGroupId: GraphQlLong;
  adGroup: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_access;
  stats: TargetingQuery_client_showConditions_rowset_GdKeyword_stats;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_access;
  mainAd: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_access;
  mainAd: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_regionsInfo;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_access;
  mainAd: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_access;
  mainAd: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_regionsInfo;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_status {
  __typename: "GdShowConditionStatus";
  primaryStatus: GdShowConditionPrimaryStatus;
  deleted: boolean;
  suspended: boolean;
  statusModerate: GdShowConditionStatusModerate;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_access {
  __typename: "GdShowConditionAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch {
  __typename: "GdRelevanceMatch";
  id: GraphQlLong;
  adGroupId: GraphQlLong;
  adGroup: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_access;
  stats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_stats;
  price: GraphQlBigDecimal | null;
  autobudgetPriority: GdShowConditionAutobudgetPriority | null;
}

export type TargetingQuery_client_showConditions_rowset = TargetingQuery_client_showConditions_rowset_GdKeyword | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch;

export interface TargetingQuery_client_showConditions {
  __typename: "GdShowConditionsContext";
  rowset: TargetingQuery_client_showConditions_rowset[];
  cacheKey: string;
  totalCount: number;
  showConditionIds: GraphQlLong[];
  hasObjectsOverLimit: boolean;
}

export interface TargetingQuery_client {
  __typename: "GdClient";
  chiefLogin: string;
  features: TargetingQuery_client_features;
  info: TargetingQuery_client_info;
  showConditions: TargetingQuery_client_showConditions;
}

export interface TargetingQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: TargetingQuery_client;
}

export interface TargetingQueryVariables {
  login: string;
  showConditionsInput: GdShowConditionsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RetargetingsQuery
// ====================================================

export interface RetargetingsQuery_client_features {
  __typename: "GdClientFeatures";
  isWalletEnabled: boolean;
  hasMetrikaCounters: boolean;
  hasEcommerce: boolean;
  hasCampaignsWithCPAStrategy: boolean;
  enabledRecommendationTypes: GdiRecommendationType[];
  isBannerPricesOnGridEnabled: boolean;
  isInternalAdsAllowed: boolean;
  isCpmCampaignsEnabled: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isTurboForSerpWizardAllowed: boolean;
  isBrandLiftAllowed: boolean;
}

export interface RetargetingsQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
  countryRegionId: GraphQlLong;
}

export interface RetargetingsQuery_client_retargetings_rowset_access {
  __typename: "GdRetargetingAccess";
  canEdit: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_retargetingCondition_conditionRules_goals {
  __typename: "GdGoal";
  id: GraphQlLong;
  type: GdGoalType;
  time: number | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_retargetingCondition_conditionRules {
  __typename: "GdRetargetingConditionRuleItem";
  type: GdRetargetingConditionRuleType;
  interestType: CryptaInterestType | null;
  goals: RetargetingsQuery_client_retargetings_rowset_retargetingCondition_conditionRules_goals[];
}

export interface RetargetingsQuery_client_retargetings_rowset_retargetingCondition {
  __typename: "GdRetargetingCondition";
  name: string;
  description: string | null;
  conditionRules: RetargetingsQuery_client_retargetings_rowset_retargetingCondition_conditionRules[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign = RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_access;
  mainAd: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign = RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative = RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations = RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_access;
  mainAd: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_regionsInfo;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign = RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations = RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_access;
  mainAd: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign = RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative = RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations = RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_access;
  mainAd: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_regionsInfo;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup = RetargetingsQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup;

export interface RetargetingsQuery_client_retargetings_rowset_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface RetargetingsQuery_client_retargetings_rowset {
  __typename: "GdRetargeting";
  access: RetargetingsQuery_client_retargetings_rowset_access;
  retargetingId: GraphQlLong;
  isSuspended: boolean;
  priceContext: GraphQlBigDecimal;
  retargetingCondition: RetargetingsQuery_client_retargetings_rowset_retargetingCondition | null;
  adGroup: RetargetingsQuery_client_retargetings_rowset_adGroup;
  stats: RetargetingsQuery_client_retargetings_rowset_stats;
}

export interface RetargetingsQuery_client_retargetings_totalStats {
  __typename: "GdEntityStats";
  shows: GraphQlLong | null;
  clicks: GraphQlLong | null;
  ctr: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
}

export interface RetargetingsQuery_client_retargetings {
  __typename: "GdRetargetingContext";
  rowset: RetargetingsQuery_client_retargetings_rowset[];
  totalCount: number;
  totalStats: RetargetingsQuery_client_retargetings_totalStats;
  hasObjectsOverLimit: boolean;
  retargetingIds: GraphQlLong[];
  cacheKey: string;
}

export interface RetargetingsQuery_client_goals_rowset {
  __typename: "GdGoal";
  id: GraphQlLong;
  domain: string | null;
  name: string;
  counterId: number | null;
  time: number | null;
}

export interface RetargetingsQuery_client_goals {
  __typename: "GdGoalsContext";
  rowset: RetargetingsQuery_client_goals_rowset[];
}

export interface RetargetingsQuery_client {
  __typename: "GdClient";
  chiefLogin: string;
  features: RetargetingsQuery_client_features;
  info: RetargetingsQuery_client_info;
  retargetings: RetargetingsQuery_client_retargetings;
  goals: RetargetingsQuery_client_goals;
}

export interface RetargetingsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RetargetingsQuery_client;
}

export interface RetargetingsQueryVariables {
  login: string;
  retargetingsInput: GdRetargetingsContainerInput;
  goalsInput: GdGoalsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: UsersProfileQuery
// ====================================================

export interface UsersProfileQuery_cryptaSegments_rowset {
  __typename: "GdCryptaSegment";
  id: GraphQlLong;
  type: WebGoalType;
  name: string;
  parentId: GraphQlLong | null;
  description: string;
  interestType: CryptaInterestTypeWeb | null;
  canSelectAll: boolean | null;
  mutuallyExclusiveIds: GraphQlLong[] | null;
}

export interface UsersProfileQuery_cryptaSegments {
  __typename: "GdCryptaSegmentsContext";
  totalCount: number;
  rowset: UsersProfileQuery_cryptaSegments_rowset[];
}

export interface UsersProfileQuery_client_features {
  __typename: "GdClientFeatures";
  isWalletEnabled: boolean;
  hasMetrikaCounters: boolean;
  hasEcommerce: boolean;
  hasCampaignsWithCPAStrategy: boolean;
  enabledRecommendationTypes: GdiRecommendationType[];
  isBannerPricesOnGridEnabled: boolean;
  isInternalAdsAllowed: boolean;
  isCpmCampaignsEnabled: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isTurboForSerpWizardAllowed: boolean;
  isBrandLiftAllowed: boolean;
}

export interface UsersProfileQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
  countryRegionId: GraphQlLong;
}

export interface UsersProfileQuery_client_retargetings_rowset_access {
  __typename: "GdRetargetingAccess";
  canEdit: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_retargetingCondition_conditionRules_goals {
  __typename: "GdGoal";
  id: GraphQlLong;
  type: GdGoalType;
  time: number | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_retargetingCondition_conditionRules {
  __typename: "GdRetargetingConditionRuleItem";
  type: GdRetargetingConditionRuleType;
  interestType: CryptaInterestType | null;
  goals: UsersProfileQuery_client_retargetings_rowset_retargetingCondition_conditionRules_goals[];
}

export interface UsersProfileQuery_client_retargetings_rowset_retargetingCondition {
  __typename: "GdRetargetingCondition";
  name: string;
  description: string | null;
  conditionRules: UsersProfileQuery_client_retargetings_rowset_retargetingCondition_conditionRules[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign = UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_campaign;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_access;
  mainAd: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign = UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative = UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations = UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_access;
  mainAd: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_regionsInfo;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign = UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations = UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_access;
  mainAd: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign = UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative = UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations = UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_access;
  mainAd: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_regionsInfo;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup = UsersProfileQuery_client_retargetings_rowset_adGroup_GdCpmAudioAdGroup | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup;

export interface UsersProfileQuery_client_retargetings_rowset_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface UsersProfileQuery_client_retargetings_rowset {
  __typename: "GdRetargeting";
  access: UsersProfileQuery_client_retargetings_rowset_access;
  retargetingId: GraphQlLong;
  isSuspended: boolean;
  priceContext: GraphQlBigDecimal;
  retargetingCondition: UsersProfileQuery_client_retargetings_rowset_retargetingCondition | null;
  adGroup: UsersProfileQuery_client_retargetings_rowset_adGroup;
  stats: UsersProfileQuery_client_retargetings_rowset_stats;
}

export interface UsersProfileQuery_client_retargetings_totalStats {
  __typename: "GdEntityStats";
  shows: GraphQlLong | null;
  clicks: GraphQlLong | null;
  ctr: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
}

export interface UsersProfileQuery_client_retargetings {
  __typename: "GdRetargetingContext";
  rowset: UsersProfileQuery_client_retargetings_rowset[];
  totalStats: UsersProfileQuery_client_retargetings_totalStats;
  totalCount: number;
  hasObjectsOverLimit: boolean;
  retargetingIds: GraphQlLong[];
  cacheKey: string;
}

export interface UsersProfileQuery_client_goals_rowset {
  __typename: "GdGoal";
  id: GraphQlLong;
  domain: string | null;
  type: GdGoalType;
  name: string;
  counterId: number | null;
  time: number | null;
}

export interface UsersProfileQuery_client_goals {
  __typename: "GdGoalsContext";
  rowset: UsersProfileQuery_client_goals_rowset[];
}

export interface UsersProfileQuery_client {
  __typename: "GdClient";
  chiefLogin: string;
  features: UsersProfileQuery_client_features;
  info: UsersProfileQuery_client_info;
  retargetings: UsersProfileQuery_client_retargetings;
  goals: UsersProfileQuery_client_goals;
}

export interface UsersProfileQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  cryptaSegments: UsersProfileQuery_cryptaSegments;
  client: UsersProfileQuery_client;
}

export interface UsersProfileQueryVariables {
  login: string;
  retargetingsInput: GdRetargetingsContainerInput;
  goalsInput: GdGoalsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: BannersQuery
// ====================================================

export interface BannersQuery_client_features {
  __typename: "GdClientFeatures";
  isWalletEnabled: boolean;
  hasMetrikaCounters: boolean;
  hasEcommerce: boolean;
  hasCampaignsWithCPAStrategy: boolean;
  enabledRecommendationTypes: GdiRecommendationType[];
  isBannerPricesOnGridEnabled: boolean;
  isInternalAdsAllowed: boolean;
  isCpmCampaignsEnabled: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isTurboForSerpWizardAllowed: boolean;
  isBrandLiftAllowed: boolean;
}

export interface BannersQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
  countryRegionId: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdHtml5Creative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdSmartCreative_layout | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative = BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmGeoproductCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpcVideoCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdVideoAdditionCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmVideoCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmAudioCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmIndoorCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
  placementPagesRequired: boolean;
  hasInactiveResources: (GdAdResources | null)[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations = BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  isAimingAllowed: boolean;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPCVideoAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_status;
  recommendations: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPCVideoAd_stats;
  goalStats: BannersQuery_client_ads_rowset_GdCPCVideoAd_goalStats[] | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup;

export interface BannersQuery_client_ads_rowset_GdTextAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdHtml5Creative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdSmartCreative_layout | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_typedCreative = BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmGeoproductCreative | BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpcVideoCreative | BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdVideoAdditionCreative | BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmVideoCreative | BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmAudioCreative | BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmOutdoorCreative | BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmIndoorCreative | BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdTextAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
  placementPagesRequired: boolean;
  hasInactiveResources: (GdAdResources | null)[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdTextAd_recommendations = BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdTextAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_bannerPrice {
  __typename: "GdAdPrice";
  currency: GdAdPriceCurrency | null;
  prefix: GdAdPricePrefix | null;
  price: string | null;
  priceOld: string | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd {
  __typename: "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  isAimingAllowed: boolean;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: BannersQuery_client_ads_rowset_GdTextAd_adGroup;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdTextAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdTextAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdTextAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdTextAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_status;
  recommendations: BannersQuery_client_ads_rowset_GdTextAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdTextAd_stats;
  goalStats: BannersQuery_client_ads_rowset_GdTextAd_goalStats[] | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdTextAd_sitelinks[] | null;
  flags: string[] | null;
  turboGalleryHref: string | null;
  bannerPrice: BannersQuery_client_ads_rowset_GdTextAd_bannerPrice | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_typedCreative = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdCpmAudioAdGroup | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup;

export interface BannersQuery_client_ads_rowset_GdInternalAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdHtml5Creative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdSmartCreative_layout | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_typedCreative = BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmGeoproductCreative | BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpcVideoCreative | BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdVideoAdditionCreative | BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmVideoCreative | BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmAudioCreative | BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmOutdoorCreative | BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmIndoorCreative | BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdInternalAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
  placementPagesRequired: boolean;
  hasInactiveResources: (GdAdResources | null)[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_recommendations = BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdInternalAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd {
  __typename: "GdInternalAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  isAimingAllowed: boolean;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: BannersQuery_client_ads_rowset_GdInternalAd_adGroup;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdInternalAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdInternalAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdInternalAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdInternalAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_status;
  recommendations: BannersQuery_client_ads_rowset_GdInternalAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdInternalAd_stats;
  goalStats: BannersQuery_client_ads_rowset_GdInternalAd_goalStats[] | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdInternalAd_sitelinks[] | null;
  flags: string[] | null;
  description: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdHtml5Creative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative_layout | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmGeoproductCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpcVideoCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdVideoAdditionCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmVideoCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmAudioCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmIndoorCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
  placementPagesRequired: boolean;
  hasInactiveResources: (GdAdResources | null)[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_placementPages {
  __typename: "GdPlacementPageModerationResult";
  bannerId: GraphQlLong;
  comment: string | null;
  createTime: GraphQlLocalDateTime;
  id: GraphQlLong;
  pageId: GraphQlLong;
  statusModerate: StatusModerateBannerPage;
  version: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd {
  __typename: "GdCPMOutdoorBannerAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  isAimingAllowed: boolean;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_status;
  recommendations: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_stats;
  goalStats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_goalStats[] | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_sitelinks[] | null;
  flags: string[] | null;
  placementPages: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_placementPages[];
}

export type BannersQuery_client_ads_rowset = BannersQuery_client_ads_rowset_GdCPCVideoAd | BannersQuery_client_ads_rowset_GdTextAd | BannersQuery_client_ads_rowset_GdInternalAd | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd;

export interface BannersQuery_client_ads_totalStats {
  __typename: "GdEntityStats";
  shows: GraphQlLong | null;
  clicks: GraphQlLong | null;
  ctr: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
}

export interface BannersQuery_client_ads {
  __typename: "GdAdsContext";
  rowset: BannersQuery_client_ads_rowset[];
  totalCount: number;
  adIds: GraphQlLong[];
  cacheKey: string;
  totalStats: BannersQuery_client_ads_totalStats;
  hasObjectsOverLimit: boolean;
}

export interface BannersQuery_client {
  __typename: "GdClient";
  chiefLogin: string;
  features: BannersQuery_client_features;
  info: BannersQuery_client_info;
  ads: BannersQuery_client_ads;
}

export interface BannersQuery_operator_features {
  __typename: "GdOperatorFeatures";
  isBannerUpdateAllowed: boolean;
  isCpmBannerUpdateAllowed: boolean;
}

export interface BannersQuery_operator {
  __typename: "GdOperatorInfo";
  features: BannersQuery_operator_features | null;
}

export interface BannersQuery_constants_configuration {
  __typename: "GdConfigurationConstants";
  canvasUiDomain: string;
}

export interface BannersQuery_constants {
  __typename: "GdDirectConstants";
  configuration: BannersQuery_constants_configuration;
}

export interface BannersQuery_placements_placements {
  __typename: "GdPlacement";
  caption: string;
  id: GraphQlLong;
}

export interface BannersQuery_placements {
  __typename: "GdPlacementContext";
  placements: BannersQuery_placements_placements[];
}

export interface BannersQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: BannersQuery_client;
  operator: BannersQuery_operator;
  constants: BannersQuery_constants;
  placements: BannersQuery_placements;
}

export interface BannersQueryVariables {
  login: string;
  adsInput: GdAdsContainerInput;
  placementsInput: GdPlacementFilterInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: BannersPreviewQuery
// ====================================================

export interface BannersPreviewQuery_client_ads_rowset_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign = BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_campaign;
  access: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_access;
  mainAd: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign = BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative = BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations = BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_campaign;
  access: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign = BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations = BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign = BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative = BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations = BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_campaign;
  access: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_access;
  mainAd: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersPreviewQuery_client_ads_rowset_adGroup = BannersPreviewQuery_client_ads_rowset_adGroup_GdCpmAudioAdGroup | BannersPreviewQuery_client_ads_rowset_adGroup_GdDynamicAdGroup | BannersPreviewQuery_client_ads_rowset_adGroup_GdMobileContentAdGroup | BannersPreviewQuery_client_ads_rowset_adGroup_GdSmartAdGroup;

export interface BannersPreviewQuery_client_ads_rowset_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_image_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_image_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_image_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_bannerImage_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_bannerImage_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersPreviewQuery_client_ads_rowset_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_typedCreative = BannersPreviewQuery_client_ads_rowset_typedCreative_GdSmartCreative | BannersPreviewQuery_client_ads_rowset_typedCreative_GdCanvasCreative;

export interface BannersPreviewQuery_client_ads_rowset_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersPreviewQuery_client_ads_rowset {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  domain: string | null;
  dynamicDisclaimer: string | null;
  linkTail: string | null;
  type: GdAdType;
  href: string | null;
  access: BannersPreviewQuery_client_ads_rowset_access;
  status: BannersPreviewQuery_client_ads_rowset_status;
  adGroup: BannersPreviewQuery_client_ads_rowset_adGroup;
  image: BannersPreviewQuery_client_ads_rowset_image | null;
  bannerImage: BannersPreviewQuery_client_ads_rowset_bannerImage | null;
  typedCreative: BannersPreviewQuery_client_ads_rowset_typedCreative | null;
  sitelinks: BannersPreviewQuery_client_ads_rowset_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersPreviewQuery_client_ads {
  __typename: "GdAdsContext";
  rowset: BannersPreviewQuery_client_ads_rowset[];
  totalCount: number;
}

export interface BannersPreviewQuery_client {
  __typename: "GdClient";
  chiefLogin: string;
  ads: BannersPreviewQuery_client_ads;
}

export interface BannersPreviewQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: BannersPreviewQuery_client;
}

export interface BannersPreviewQueryVariables {
  login: string;
  adsInput: GdAdsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GroupAdQuery
// ====================================================

export interface GroupAdQuery_client_ads_rowset {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
}

export interface GroupAdQuery_client_ads {
  __typename: "GdAdsContext";
  rowset: GroupAdQuery_client_ads_rowset[];
}

export interface GroupAdQuery_client {
  __typename: "GdClient";
  ads: GroupAdQuery_client_ads;
}

export interface GroupAdQuery_callouts {
  __typename: "GdCallout";
  id: GraphQlLong;
}

export interface GroupAdQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: GroupAdQuery_client;
  callouts: (GroupAdQuery_callouts | null)[];
}

export interface GroupAdQueryVariables {
  login: string;
  adsInput: GdAdsContainerInput;
  calloutsFilter: GdCalloutFilterInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GroupBannersQuery
// ====================================================

export interface GroupBannersQuery_client_ads_rowset_creative {
  __typename: "GdCreative";
  height: GraphQlLong | null;
  width: GraphQlLong | null;
}

export interface GroupBannersQuery_client_ads_rowset_typedCreative_GdSmartCreative_moderationInfo_aspects {
  __typename: "GdModerationInfoAspect";
  height: GraphQlLong;
  width: GraphQlLong;
}

export interface GroupBannersQuery_client_ads_rowset_typedCreative_GdSmartCreative_moderationInfo {
  __typename: "GdModerationInfo";
  aspects: GroupBannersQuery_client_ads_rowset_typedCreative_GdSmartCreative_moderationInfo_aspects[] | null;
}

export interface GroupBannersQuery_client_ads_rowset_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  creativeType: GdCreativeType;
  moderationInfo: GroupBannersQuery_client_ads_rowset_typedCreative_GdSmartCreative_moderationInfo | null;
}

export interface GroupBannersQuery_client_ads_rowset_typedCreative_GdCanvasCreative_moderationInfo_aspects {
  __typename: "GdModerationInfoAspect";
  height: GraphQlLong;
  width: GraphQlLong;
}

export interface GroupBannersQuery_client_ads_rowset_typedCreative_GdCanvasCreative_moderationInfo {
  __typename: "GdModerationInfo";
  aspects: GroupBannersQuery_client_ads_rowset_typedCreative_GdCanvasCreative_moderationInfo_aspects[] | null;
}

export interface GroupBannersQuery_client_ads_rowset_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeType: GdCreativeType;
  moderationInfo: GroupBannersQuery_client_ads_rowset_typedCreative_GdCanvasCreative_moderationInfo | null;
  isAdaptive: boolean | null;
}

export type GroupBannersQuery_client_ads_rowset_typedCreative = GroupBannersQuery_client_ads_rowset_typedCreative_GdSmartCreative | GroupBannersQuery_client_ads_rowset_typedCreative_GdCanvasCreative;

export interface GroupBannersQuery_client_ads_rowset {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  creative: GroupBannersQuery_client_ads_rowset_creative | null;
  typedCreative: GroupBannersQuery_client_ads_rowset_typedCreative | null;
}

export interface GroupBannersQuery_client_ads {
  __typename: "GdAdsContext";
  rowset: GroupBannersQuery_client_ads_rowset[];
}

export interface GroupBannersQuery_client {
  __typename: "GdClient";
  ads: GroupBannersQuery_client_ads;
}

export interface GroupBannersQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: GroupBannersQuery_client;
}

export interface GroupBannersQueryVariables {
  login: string;
  adsInput: GdAdsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CalloutsIdsQuery
// ====================================================

export interface CalloutsIdsQuery_callouts {
  __typename: "GdCallout";
  id: GraphQlLong;
}

export interface CalloutsIdsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  callouts: (CalloutsIdsQuery_callouts | null)[];
}

export interface CalloutsIdsQueryVariables {
  login: string;
  calloutsFilter: GdCalloutFilterInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: TurbolandingQuery
// ====================================================

export interface TurbolandingQuery_turbolandings {
  __typename: "GdTurbolanding";
  id: GraphQlLong;
  clientId: GraphQlLong;
  name: string;
  href: string;
}

export interface TurbolandingQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  turbolandings: (TurbolandingQuery_turbolandings | null)[];
}

export interface TurbolandingQueryVariables {
  login: string;
  filter: GdTurbolandingFilterInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ImagesQueryForEdit
// ====================================================

export interface ImagesQueryForEdit_images_rowset_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface ImagesQueryForEdit_images_rowset_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface ImagesQueryForEdit_images_rowset_formats {
  __typename: "GdImageFormat";
  imageSize: ImagesQueryForEdit_images_rowset_formats_imageSize;
  path: string;
  smartCenters: ImagesQueryForEdit_images_rowset_formats_smartCenters[] | null;
}

export interface ImagesQueryForEdit_images_rowset_imageSize {
  __typename: "GdImageSize";
  width: number;
  height: number;
}

export interface ImagesQueryForEdit_images_rowset {
  __typename: "GdImage";
  avatarsHost: GdAdImageAvatarsHost;
  createTime: GraphQlLocalDateTime;
  imageHash: string;
  mdsGroupId: GraphQlLong | null;
  name: string | null;
  namespace: GdAdImageNamespace;
  type: GdAdImageType;
  formats: ImagesQueryForEdit_images_rowset_formats[] | null;
  imageSize: ImagesQueryForEdit_images_rowset_imageSize;
}

export interface ImagesQueryForEdit_images {
  __typename: "GdImagesContext";
  cacheKey: string;
  imageHashes: string[];
  rowset: ImagesQueryForEdit_images_rowset[];
  totalCount: number;
}

export interface ImagesQueryForEdit {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  images: ImagesQueryForEdit_images;
}

export interface ImagesQueryForEditVariables {
  login: string;
  cacheKey: string;
  filter: GdImageFilterInput;
  limitOffset: GdLimitOffsetInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: BannersQueryForEdit
// ====================================================

export interface BannersQueryForEdit_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface BannersQueryForEdit_client_features {
  __typename: "GdClientFeatures";
  isWalletEnabled: boolean;
  hasMetrikaCounters: boolean;
  hasEcommerce: boolean;
  hasCampaignsWithCPAStrategy: boolean;
  enabledRecommendationTypes: GdiRecommendationType[];
  isBannerPricesOnGridEnabled: boolean;
  isInternalAdsAllowed: boolean;
  isCpmCampaignsEnabled: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isTurboForSerpWizardAllowed: boolean;
  isBrandLiftAllowed: boolean;
}

export interface BannersQueryForEdit_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmGeoproductCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdVideoAdditionCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmAudioCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdHtml5Creative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmIndoorCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpcVideoCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmVideoCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string;
  title: string;
  turbolanding: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_sitelinks_turbolanding | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_bannerImage | null;
  callouts: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_callouts[] | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_sitelinks[] | null;
  turbolanding: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_turbolanding | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdCpmAudioAdGroup | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmGeoproductCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdVideoAdditionCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmAudioCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdHtml5Creative | BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmOutdoorCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmIndoorCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpcVideoCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmVideoCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string;
  title: string;
  turbolanding: BannersQueryForEdit_client_ads_rowset_GdTextAd_sitelinks_turbolanding | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerPrice {
  __typename: "GdAdPrice";
  currency: GdAdPriceCurrency | null;
  prefix: GdAdPricePrefix | null;
  price: string | null;
  priceOld: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd {
  __typename: "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: BannersQueryForEdit_client_ads_rowset_GdTextAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerImage | null;
  callouts: BannersQueryForEdit_client_ads_rowset_GdTextAd_callouts[] | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdTextAd_sitelinks[] | null;
  turbolanding: BannersQueryForEdit_client_ads_rowset_GdTextAd_turbolanding | null;
  turboGalleryHref: string | null;
  bannerPrice: BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerPrice | null;
  permalinkId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmGeoproductCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdVideoAdditionCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmAudioCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdHtml5Creative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmIndoorCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpcVideoCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmVideoCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string;
  title: string;
  turbolanding: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_sitelinks_turbolanding | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_pixels {
  __typename: "GdPixel";
  kind: GdPixelKind;
  url: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_measurers {
  __typename: "GdBannerMeasurer";
  measurerSystem: GdBannerMeasurerSystem;
  params: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd {
  __typename: "GdCPMBannerAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_bannerImage | null;
  callouts: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_callouts[] | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_sitelinks[] | null;
  turbolanding: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_turbolanding | null;
  pixels: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_pixels[];
  measurers: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_measurers[] | null;
  tnsId: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmGeoproductCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdVideoAdditionCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmAudioCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdHtml5Creative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmIndoorCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpcVideoCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmVideoCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string;
  title: string;
  turbolanding: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_sitelinks_turbolanding | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_pixels {
  __typename: "GdPixel";
  kind: GdPixelKind;
  url: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_placementPages {
  __typename: "GdPlacementPageModerationResult";
  bannerId: GraphQlLong;
  comment: string | null;
  createTime: GraphQlLocalDateTime;
  id: GraphQlLong;
  pageId: GraphQlLong;
  statusModerate: StatusModerateBannerPage;
  version: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd {
  __typename: "GdCPMOutdoorBannerAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage | null;
  callouts: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_callouts[] | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_sitelinks[] | null;
  turbolanding: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_turbolanding | null;
  pixels: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_pixels[];
  placementPages: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_placementPages[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmGeoproductCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdVideoAdditionCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmAudioCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdHtml5Creative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmIndoorCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpcVideoCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmVideoCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string;
  title: string;
  turbolanding: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_sitelinks_turbolanding | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_pixels {
  __typename: "GdPixel";
  kind: GdPixelKind;
  url: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd {
  __typename: "GdCPMAudioBannerAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_bannerImage | null;
  callouts: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_callouts[] | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_sitelinks[] | null;
  turbolanding: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_turbolanding | null;
  pixels: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_pixels[];
}

export type BannersQueryForEdit_client_ads_rowset = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdTextAd | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd;

export interface BannersQueryForEdit_client_ads {
  __typename: "GdAdsContext";
  rowset: BannersQueryForEdit_client_ads_rowset[];
  totalCount: number;
  adIds: GraphQlLong[];
  hasObjectsOverLimit: boolean;
}

export interface BannersQueryForEdit_client_campaigns_rowset {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  promocodeRestrictedDomain: string[] | null;
}

export interface BannersQueryForEdit_client_campaigns {
  __typename: "GdCampaignsContext";
  rowset: BannersQueryForEdit_client_campaigns_rowset[];
}

export interface BannersQueryForEdit_client {
  __typename: "GdClient";
  chiefLogin: string;
  features: BannersQueryForEdit_client_features;
  info: BannersQueryForEdit_client_info;
  ads: BannersQueryForEdit_client_ads;
  campaigns: BannersQueryForEdit_client_campaigns;
}

export interface BannersQueryForEdit_operator_features {
  __typename: "GdOperatorFeatures";
  isBannerUpdateAllowed: boolean;
  isCpmBannerUpdateAllowed: boolean;
}

export interface BannersQueryForEdit_operator_access {
  __typename: "GdOperatorAccess";
  canEditAdDomain: boolean;
}

export interface BannersQueryForEdit_operator {
  __typename: "GdOperatorInfo";
  features: BannersQueryForEdit_operator_features | null;
  access: BannersQueryForEdit_operator_access;
}

export interface BannersQueryForEdit_constants_validation_adConstants {
  __typename: "GdDirectConstantsAdValidationData";
  maxLengthTitle: number;
  maxLengthTitleWord: number;
  maxLengthTitleExtension: number;
  maxLengthBody: number;
  maxLengthBodyWord: number;
  narrowSymbols: string;
  maxNumberOfNarrowCharacters: number;
  allowAdLetters: string;
  maxLengthHref: number;
  maxLengthTurboGalleryHref: number;
  maxLengthDisplayHref: number;
  allowAdDisplayHrefLetters: string;
  aggregationDomains: string[];
}

export interface BannersQueryForEdit_constants_validation_vcardConstants {
  __typename: "GdDirectConstantsVcardValidationData";
  companyNameMaxLength: number;
  contactPersonMaxLength: number;
  contactEmailMaxLength: number;
  extraMessageMaxLength: number;
  countryMaxLength: number;
  cityMaxLength: number;
  streetMaxLength: number;
  houseWithBuildingMaxLength: number;
  apartmentMaxLength: number;
  instantMessengerLoginMaxLength: number;
  pointOnMapLongitudeMin: GraphQlBigDecimal;
  pointOnMapLongitudeMax: GraphQlBigDecimal;
  pointOnMapLatitudeMin: GraphQlBigDecimal;
  pointOnMapLatitudeMax: GraphQlBigDecimal;
  countryCodeMaxLength: number;
  cityCodeMaxLength: number;
  phoneNumberMinLength: number;
  phoneNumberMaxLength: number;
  extensionMaxLength: number;
  entirePhoneMinLength: number;
  entirePhoneMaxLength: number;
  entirePhoneWithExtensionMaxLength: number;
}

export interface BannersQueryForEdit_constants_validation_calloutConstants {
  __typename: "GdDirectConstantsCalloutValidationData";
  calloutLettersAllowed: string;
  calloutTextMaxLength: number;
  calloutsOnClientMaxCount: number;
  calloutsOnClientMaxCountWithDeleted: number;
}

export interface BannersQueryForEdit_constants_validation_sitelinkConstants {
  __typename: "GdDirectConstantsSitelinkValidationData";
  allowLetters: string;
  maxDescriptionLength: number;
  maxHrefLength: number;
  maxTitleLength: number;
  sitelinkMaxCount: number;
}

export interface BannersQueryForEdit_constants_validation {
  __typename: "GdDirectConstantsValidationData";
  adConstants: BannersQueryForEdit_constants_validation_adConstants;
  vcardConstants: BannersQueryForEdit_constants_validation_vcardConstants;
  calloutConstants: BannersQueryForEdit_constants_validation_calloutConstants;
  sitelinkConstants: BannersQueryForEdit_constants_validation_sitelinkConstants;
}

export interface BannersQueryForEdit_constants_configuration {
  __typename: "GdConfigurationConstants";
  turbolandingUnifiedApiUrl: string;
  canvasUiDomain: string;
}

export interface BannersQueryForEdit_constants {
  __typename: "GdDirectConstants";
  validation: BannersQueryForEdit_constants_validation;
  configuration: BannersQueryForEdit_constants_configuration;
}

export interface BannersQueryForEdit_placements_placements {
  __typename: "GdPlacement";
  caption: string;
  id: GraphQlLong;
}

export interface BannersQueryForEdit_placements {
  __typename: "GdPlacementContext";
  placements: BannersQueryForEdit_placements_placements[];
}

export interface BannersQueryForEdit {
  callouts: (BannersQueryForEdit_callouts | null)[];
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: BannersQueryForEdit_client;
  operator: BannersQueryForEdit_operator;
  constants: BannersQueryForEdit_constants;
  placements: BannersQueryForEdit_placements;
}

export interface BannersQueryForEditVariables {
  login: string;
  adsInput: GdAdsContainerInput;
  campaignsInput: GdCampaignsContainerInput;
  placementsInput: GdPlacementFilterInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: BaseInfoForBannerCreationQuery
// ====================================================

export interface BaseInfoForBannerCreationQuery_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface BaseInfoForBannerCreationQuery_client_features {
  __typename: "GdClientFeatures";
  isWalletEnabled: boolean;
  hasMetrikaCounters: boolean;
  hasEcommerce: boolean;
  hasCampaignsWithCPAStrategy: boolean;
  enabledRecommendationTypes: GdiRecommendationType[];
  isBannerPricesOnGridEnabled: boolean;
  isInternalAdsAllowed: boolean;
  isCpmCampaignsEnabled: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isTurboForSerpWizardAllowed: boolean;
  isBrandLiftAllowed: boolean;
}

export interface BaseInfoForBannerCreationQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  platform: GdCampaignPlatform;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  flatStrategy: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdCpmBannerCampaign_flatStrategy;
  name: string;
  id: GraphQlLong;
  type: GdCampaignType;
  access: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdCpmBannerCampaign_access;
  promocodeRestrictedDomain: string[] | null;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  platform: GdCampaignPlatform;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign {
  __typename: "GdTextCampaign";
  flatStrategy: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_flatStrategy;
  name: string;
  id: GraphQlLong;
  type: GdCampaignType;
  access: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_access;
  promocodeRestrictedDomain: string[] | null;
  lastChangedVcardId: GraphQlLong | null;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_flatStrategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  platform: GdCampaignPlatform;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  flatStrategy: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_flatStrategy;
  name: string;
  id: GraphQlLong;
  type: GdCampaignType;
  access: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_access;
  promocodeRestrictedDomain: string[] | null;
  lastChangedVcardId: GraphQlLong | null;
}

export type BaseInfoForBannerCreationQuery_client_campaigns_rowset = BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdCpmBannerCampaign | BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign | BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign;

export interface BaseInfoForBannerCreationQuery_client_campaigns {
  __typename: "GdCampaignsContext";
  rowset: BaseInfoForBannerCreationQuery_client_campaigns_rowset[];
}

export interface BaseInfoForBannerCreationQuery_client_adGroups_rowset_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BaseInfoForBannerCreationQuery_client_adGroups_rowset_status {
  __typename: "GdAdGroupStatus";
  primaryStatus: GdAdGroupPrimaryStatus;
}

export interface BaseInfoForBannerCreationQuery_client_adGroups_rowset {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  id: GraphQlLong;
  adsCount: number;
  name: string;
  type: GdAdGroupType;
  access: BaseInfoForBannerCreationQuery_client_adGroups_rowset_access;
  status: BaseInfoForBannerCreationQuery_client_adGroups_rowset_status;
}

export interface BaseInfoForBannerCreationQuery_client_adGroups {
  __typename: "GdAdGroupsContext";
  rowset: BaseInfoForBannerCreationQuery_client_adGroups_rowset[];
}

export interface BaseInfoForBannerCreationQuery_client {
  __typename: "GdClient";
  chiefLogin: string;
  features: BaseInfoForBannerCreationQuery_client_features;
  info: BaseInfoForBannerCreationQuery_client_info;
  campaigns: BaseInfoForBannerCreationQuery_client_campaigns;
  adGroups: BaseInfoForBannerCreationQuery_client_adGroups;
}

export interface BaseInfoForBannerCreationQuery_operator_features {
  __typename: "GdOperatorFeatures";
  isBannerUpdateAllowed: boolean;
  isCpmBannerUpdateAllowed: boolean;
}

export interface BaseInfoForBannerCreationQuery_operator_access {
  __typename: "GdOperatorAccess";
  canEditAdDomain: boolean;
}

export interface BaseInfoForBannerCreationQuery_operator {
  __typename: "GdOperatorInfo";
  features: BaseInfoForBannerCreationQuery_operator_features | null;
  access: BaseInfoForBannerCreationQuery_operator_access;
}

export interface BaseInfoForBannerCreationQuery_constants_validation_adConstants {
  __typename: "GdDirectConstantsAdValidationData";
  maxLengthTitle: number;
  maxLengthTitleWord: number;
  maxLengthTitleExtension: number;
  maxLengthBody: number;
  maxLengthBodyWord: number;
  narrowSymbols: string;
  maxNumberOfNarrowCharacters: number;
  allowAdLetters: string;
  maxLengthHref: number;
  maxLengthTurboGalleryHref: number;
  maxLengthDisplayHref: number;
  allowAdDisplayHrefLetters: string;
  aggregationDomains: string[];
}

export interface BaseInfoForBannerCreationQuery_constants_validation_vcardConstants {
  __typename: "GdDirectConstantsVcardValidationData";
  companyNameMaxLength: number;
  contactPersonMaxLength: number;
  contactEmailMaxLength: number;
  extraMessageMaxLength: number;
  countryMaxLength: number;
  cityMaxLength: number;
  streetMaxLength: number;
  houseWithBuildingMaxLength: number;
  apartmentMaxLength: number;
  instantMessengerLoginMaxLength: number;
  pointOnMapLongitudeMin: GraphQlBigDecimal;
  pointOnMapLongitudeMax: GraphQlBigDecimal;
  pointOnMapLatitudeMin: GraphQlBigDecimal;
  pointOnMapLatitudeMax: GraphQlBigDecimal;
  countryCodeMaxLength: number;
  cityCodeMaxLength: number;
  phoneNumberMinLength: number;
  phoneNumberMaxLength: number;
  extensionMaxLength: number;
  entirePhoneMinLength: number;
  entirePhoneMaxLength: number;
  entirePhoneWithExtensionMaxLength: number;
}

export interface BaseInfoForBannerCreationQuery_constants_validation_calloutConstants {
  __typename: "GdDirectConstantsCalloutValidationData";
  calloutLettersAllowed: string;
  calloutTextMaxLength: number;
  calloutsOnClientMaxCount: number;
  calloutsOnClientMaxCountWithDeleted: number;
}

export interface BaseInfoForBannerCreationQuery_constants_validation_sitelinkConstants {
  __typename: "GdDirectConstantsSitelinkValidationData";
  allowLetters: string;
  maxDescriptionLength: number;
  maxHrefLength: number;
  maxTitleLength: number;
  sitelinkMaxCount: number;
}

export interface BaseInfoForBannerCreationQuery_constants_validation {
  __typename: "GdDirectConstantsValidationData";
  adConstants: BaseInfoForBannerCreationQuery_constants_validation_adConstants;
  vcardConstants: BaseInfoForBannerCreationQuery_constants_validation_vcardConstants;
  calloutConstants: BaseInfoForBannerCreationQuery_constants_validation_calloutConstants;
  sitelinkConstants: BaseInfoForBannerCreationQuery_constants_validation_sitelinkConstants;
}

export interface BaseInfoForBannerCreationQuery_constants_configuration {
  __typename: "GdConfigurationConstants";
  turbolandingUnifiedApiUrl: string;
  canvasUiDomain: string;
}

export interface BaseInfoForBannerCreationQuery_constants {
  __typename: "GdDirectConstants";
  validation: BaseInfoForBannerCreationQuery_constants_validation;
  configuration: BaseInfoForBannerCreationQuery_constants_configuration;
}

export interface BaseInfoForBannerCreationQuery {
  callouts: (BaseInfoForBannerCreationQuery_callouts | null)[];
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: BaseInfoForBannerCreationQuery_client;
  operator: BaseInfoForBannerCreationQuery_operator;
  constants: BaseInfoForBannerCreationQuery_constants;
}

export interface BaseInfoForBannerCreationQueryVariables {
  login: string;
  campaignInput: GdCampaignsContainerInput;
  adGroupInput: GdAdGroupsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: InternalBannersQueryForEdit
// ====================================================

export interface InternalBannersQueryForEdit_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_templateVars {
  __typename: "GdTemplateVariable";
  templateResourceId: GraphQlLong;
  value: string | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_status_timeTargetStatus;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_flatStrategy = InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyAvgClick | InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyManual;

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign {
  __typename: "GdInternalFreeCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  placeId: GraphQlLong;
  status: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_status;
  access: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_access;
  flatStrategy: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_flatStrategy;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_status_timeTargetStatus;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_flatStrategy = InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyAvgClick | InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyManual;

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign {
  __typename: "GdInternalDistribCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  placeId: GraphQlLong;
  status: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_status;
  access: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_access;
  flatStrategy: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_flatStrategy;
}

export type InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign = InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdCpmBannerCampaign | InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign | InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign;

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  campaign: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign;
  access: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_access;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_regionsInfo;
  status: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd {
  __typename: "GdInternalAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  description: string | null;
  templateId: GraphQlLong;
  templateVars: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_templateVars[];
  access: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_access;
  adGroup: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup;
  status: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_status;
}

export type InternalBannersQueryForEdit_client_ads_rowset = InternalBannersQueryForEdit_client_ads_rowset_GdCPCVideoAd | InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd;

export interface InternalBannersQueryForEdit_client_ads {
  __typename: "GdAdsContext";
  rowset: InternalBannersQueryForEdit_client_ads_rowset[];
  totalCount: number;
  adIds: GraphQlLong[];
  hasObjectsOverLimit: boolean;
}

export interface InternalBannersQueryForEdit_client {
  __typename: "GdClient";
  chiefLogin: string;
  info: InternalBannersQueryForEdit_client_info;
  ads: InternalBannersQueryForEdit_client_ads;
}

export interface InternalBannersQueryForEdit {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: InternalBannersQueryForEdit_client;
}

export interface InternalBannersQueryForEditVariables {
  login: string;
  adsInput: GdAdsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: InternalBannersQueryForCreation
// ====================================================

export interface InternalBannersQueryForCreation_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_status_timeTargetStatus;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_flatStrategy = InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyAvgClick | InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyManual;

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign {
  __typename: "GdInternalFreeCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  placeId: GraphQlLong;
  status: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_status;
  access: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_access;
  flatStrategy: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_flatStrategy;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_status_timeTargetStatus;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_flatStrategy = InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyAvgClick | InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyManual;

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign {
  __typename: "GdInternalDistribCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  placeId: GraphQlLong;
  status: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_status;
  access: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_access;
  flatStrategy: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_flatStrategy;
}

export type InternalBannersQueryForCreation_client_adGroups_rowset_campaign = InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdCpmBannerCampaign | InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign | InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign;

export interface InternalBannersQueryForCreation_client_adGroups_rowset_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  campaign: InternalBannersQueryForCreation_client_adGroups_rowset_campaign;
  access: InternalBannersQueryForCreation_client_adGroups_rowset_access;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: InternalBannersQueryForCreation_client_adGroups_rowset_regionsInfo;
  status: InternalBannersQueryForCreation_client_adGroups_rowset_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface InternalBannersQueryForCreation_client_adGroups {
  __typename: "GdAdGroupsContext";
  rowset: InternalBannersQueryForCreation_client_adGroups_rowset[];
}

export interface InternalBannersQueryForCreation_client {
  __typename: "GdClient";
  chiefLogin: string;
  info: InternalBannersQueryForCreation_client_info;
  adGroups: InternalBannersQueryForCreation_client_adGroups;
}

export interface InternalBannersQueryForCreation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: InternalBannersQueryForCreation_client;
}

export interface InternalBannersQueryForCreationVariables {
  login: string;
  adGroupsInput: GdAdGroupsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: InternalTemplateResourcesQuery
// ====================================================

export interface InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_choices {
  __typename: "GdResourceValueChoice";
  display: string;
  value: string;
}

export interface InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdBasicValueRestriction {
  __typename: "GdBasicValueRestriction";
  type: GdResourceValueRestrictionType;
  strict: boolean;
  defectCode: string;
}

export interface InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdUrlCorrectRestriction {
  __typename: "GdUrlCorrectRestriction";
  type: GdResourceValueRestrictionType;
  strict: boolean;
  defectCode: string;
  isHttpsOnly: boolean;
}

export interface InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdLengthValueRestriction {
  __typename: "GdLengthValueRestriction";
  type: GdResourceValueRestrictionType;
  strict: boolean;
  defectCode: string;
  length: number;
}

export interface InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdImageFormatValueRestriction {
  __typename: "GdImageFormatValueRestriction";
  type: GdResourceValueRestrictionType;
  strict: boolean;
  defectCode: string;
  format: GdRestrictionImageFormat[];
}

export interface InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdImageSizeKbMaxValueRestriction {
  __typename: "GdImageSizeKbMaxValueRestriction";
  type: GdResourceValueRestrictionType;
  strict: boolean;
  defectCode: string;
  size: number;
}

export interface InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdImageDimensionsValueRestriction {
  __typename: "GdImageDimensionsValueRestriction";
  type: GdResourceValueRestrictionType;
  strict: boolean;
  defectCode: string;
  width: number | null;
  height: number | null;
}

export type InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions = InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdBasicValueRestriction | InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdUrlCorrectRestriction | InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdLengthValueRestriction | InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdImageFormatValueRestriction | InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdImageSizeKbMaxValueRestriction | InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdImageDimensionsValueRestriction;

export interface InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources {
  __typename: "GdResourceInfo";
  id: string;
  label: string;
  type: GdResourceType;
  choices: InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_choices[] | null;
  valueRestrictions: InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions[];
}

export interface InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resourceRestrictions {
  __typename: "GdResourceRestriction";
  required: string[];
  absent: string[];
}

export interface InternalTemplateResourcesQuery_client_internalAdTemplateInfo {
  __typename: "GdInternalTemplateInfo";
  campaignId: string;
  templateId: string;
  resources: InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources[];
  resourceRestrictions: InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resourceRestrictions[];
}

export interface InternalTemplateResourcesQuery_client {
  __typename: "GdClient";
  internalAdTemplateInfo: (InternalTemplateResourcesQuery_client_internalAdTemplateInfo | null)[];
}

export interface InternalTemplateResourcesQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: InternalTemplateResourcesQuery_client;
}

export interface InternalTemplateResourcesQueryVariables {
  login: string;
  entries: GdInternalTemplateInfoRequestEntryInput[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: InternalTemplatePlacesQuery
// ====================================================

export interface InternalTemplatePlacesQuery_constants_internalTemplatePlaces_rowset {
  __typename: "GdInternalTemplatePlace";
  placeId: GraphQlLong;
  templateId: GraphQlLong;
}

export interface InternalTemplatePlacesQuery_constants_internalTemplatePlaces {
  __typename: "GdInternalTemplatePlacesData";
  rowset: InternalTemplatePlacesQuery_constants_internalTemplatePlaces_rowset[];
}

export interface InternalTemplatePlacesQuery_constants {
  __typename: "GdDirectConstants";
  /**
   * Набор связей места с шаблонами для внутренней рекламы
   */
  internalTemplatePlaces: InternalTemplatePlacesQuery_constants_internalTemplatePlaces;
}

export interface InternalTemplatePlacesQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  constants: InternalTemplatePlacesQuery_constants;
}

export interface InternalTemplatePlacesQueryVariables {
  placesIds?: GraphQlLong[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: VCardsForBannersEdit
// ====================================================

export interface VCardsForBannersEdit_vcards_rowset_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface VCardsForBannersEdit_vcards_rowset_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface VCardsForBannersEdit_vcards_rowset_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface VCardsForBannersEdit_vcards_rowset_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: VCardsForBannersEdit_vcards_rowset_workTimes_startTime;
  endTime: VCardsForBannersEdit_vcards_rowset_workTimes_endTime;
}

export interface VCardsForBannersEdit_vcards_rowset_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface VCardsForBannersEdit_vcards_rowset_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface VCardsForBannersEdit_vcards_rowset_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: VCardsForBannersEdit_vcards_rowset_address_pointOnMap | null;
}

export interface VCardsForBannersEdit_vcards_rowset {
  __typename: "GdVcard";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: VCardsForBannersEdit_vcards_rowset_instantMessenger | null;
  workTimes: VCardsForBannersEdit_vcards_rowset_workTimes[];
  phone: VCardsForBannersEdit_vcards_rowset_phone;
  address: VCardsForBannersEdit_vcards_rowset_address;
}

export interface VCardsForBannersEdit_vcards {
  __typename: "GdVcardsContext";
  rowset: VCardsForBannersEdit_vcards_rowset[];
}

export interface VCardsForBannersEdit {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  vcards: VCardsForBannersEdit_vcards;
}

export interface VCardsForBannersEditVariables {
  login: string;
  vcardIdIn?: GraphQlLong[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: MetroStationsQuery
// ====================================================

export interface MetroStationsQuery_constants_metroStations_rowset {
  __typename: "GdMetroStation";
  geoRegionId: number;
  metroStationId: number;
  metroStationName: string;
}

export interface MetroStationsQuery_constants_metroStations {
  __typename: "GdMetroStationsData";
  rowset: MetroStationsQuery_constants_metroStations_rowset[];
}

export interface MetroStationsQuery_constants {
  __typename: "GdDirectConstants";
  /**
   * Станции метрополитена (только для Москвы, Санкт-Петербурга и Киева)
   */
  metroStations: MetroStationsQuery_constants_metroStations;
}

export interface MetroStationsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  constants: MetroStationsQuery_constants;
}

export interface MetroStationsQueryVariables {
  city?: GdMetroCityInput[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMetroByCoordinates
// ====================================================

export interface GetMetroByCoordinates_getMetroByCoordinates {
  __typename: "GdGeoToolsResponse";
  geoId: GraphQlLong;
}

export interface GetMetroByCoordinates {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  getMetroByCoordinates: GetMetroByCoordinates_getMetroByCoordinates | null;
}

export interface GetMetroByCoordinatesVariables {
  coordinates: GdCoordinatesInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetGeoByAddress
// ====================================================

export interface GetGeoByAddress_getGeoByAddress {
  __typename: "GdGeoToolsResponse";
  geoId: GraphQlLong;
}

export interface GetGeoByAddress {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  getGeoByAddress: GetGeoByAddress_getGeoByAddress | null;
}

export interface GetGeoByAddressVariables {
  address: GdGeoToolsAddressInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetGeoByCoordinates
// ====================================================

export interface GetGeoByCoordinates_getGeoByCoordinates {
  __typename: "GdGeoToolsResponse";
  geoId: GraphQlLong;
}

export interface GetGeoByCoordinates {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  getGeoByCoordinates: GetGeoByCoordinates_getGeoByCoordinates | null;
}

export interface GetGeoByCoordinatesVariables {
  coordinates: GdCoordinatesInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: validateAdPrice
// ====================================================

export interface validateAdPrice_validateAdPrice_errors {
  __typename: "GdDefect";
  code: string;
  path: string;
  params: GraphQlObjectScalar | null;
}

export interface validateAdPrice_validateAdPrice {
  __typename: "GdValidationResult";
  errors: validateAdPrice_validateAdPrice_errors[];
}

export interface validateAdPrice {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  validateAdPrice: validateAdPrice_validateAdPrice | null;
}

export interface validateAdPriceVariables {
  bannerPrice: (GdAdPriceInput | null)[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GroupsQueryForEdit
// ====================================================

export interface GroupsQueryForEdit_client_clientConstants_allowedBidModifierTypesByAdGroupTypes {
  __typename: "GdAllowedBidModifiersByAdGroupType";
  adGroupType: GdAdGroupType;
  allowedBidModifierTypes: GdBidModifierType[];
}

export interface GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment {
  __typename: "GdAllowedBidModifierValuesABSegment" | "GdAllowedBidModifierValuesAdType" | "GdAllowedBidModifierValuesDemographics" | "GdAllowedBidModifierValuesDesktop" | "GdAllowedBidModifierValuesExpression" | "GdAllowedBidModifierValuesGeo" | "GdAllowedBidModifierValuesInventory" | "GdAllowedBidModifierValuesRetargeting" | "GdAllowedBidModifierValuesSmartTgo" | "GdAllowedBidModifierValuesVideo" | "GdAllowedBidModifierValuesWeather";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment_percentRange;
}

export interface GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile {
  __typename: "GdAllowedBidModifierValuesMobile";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile_percentRange;
  osTypes: GdOsType[];
}

export type GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues = GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment | GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile;

export interface GroupsQueryForEdit_client_clientConstants_clientLimits {
  __typename: "GdClientLimits";
  keywordsCountLimit: GraphQlLong;
}

export interface GroupsQueryForEdit_client_clientConstants {
  __typename: "GdClientConstants";
  allowedBidModifierTypesByAdGroupTypes: GroupsQueryForEdit_client_clientConstants_allowedBidModifierTypesByAdGroupTypes[];
  allowedBidModifiersValues: GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues[];
  clientLimits: GroupsQueryForEdit_client_clientConstants_clientLimits;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_campaign_flatStrategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  platform: GdCampaignPlatform;
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_campaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  flatStrategy: GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_campaign_flatStrategy;
  type: GdCampaignType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierAdTypeAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierExpressAdjustment" | "GdBidModifierInventoryAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_bidModifiers_adjustments = GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_bidModifiers_adjustments[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup {
  __typename: "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdDynamicAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdTextAdGroup";
  access: GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_access;
  regionsInfo: GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_regionsInfo;
  campaign: GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  libraryMinusKeywordsPacks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup_bidModifiers[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_campaign_flatStrategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  platform: GdCampaignPlatform;
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_campaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  flatStrategy: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_campaign_flatStrategy;
  type: GdCampaignType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierAdTypeAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierExpressAdjustment" | "GdBidModifierInventoryAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments = GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  access: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_access;
  regionsInfo: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_regionsInfo;
  campaign: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  libraryMinusKeywordsPacks: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers[] | null;
  feedId: GraphQlLong;
  fieldToUseAsBody: string | null;
  fieldToUseAsName: string | null;
  trackingParams: string | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_campaign_flatStrategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  platform: GdCampaignPlatform;
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_campaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  flatStrategy: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_campaign_flatStrategy;
  type: GdCampaignType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierAdTypeAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierExpressAdjustment" | "GdBidModifierInventoryAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments = GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingInternalNetwork {
  __typename: "GdAdditionalTargetingInternalNetwork";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingIsBrowser {
  __typename: "GdAdditionalTargetingIsBrowser";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingIsTablet {
  __typename: "GdAdditionalTargetingIsTablet";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingIsMobile {
  __typename: "GdAdditionalTargetingIsMobile";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingIsTouch {
  __typename: "GdAdditionalTargetingIsTouch";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingUserAgents {
  __typename: "GdAdditionalTargetingUserAgents";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingOsNames_value {
  __typename: "GdAdditionalTargetingUatraits";
  targetingValueEntryId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingOsNames {
  __typename: "GdAdditionalTargetingOsNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingOsNames_value[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingOsFamilies_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingOsFamilies {
  __typename: "GdAdditionalTargetingOsFamilies";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingOsFamilies_value[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserNames_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserNames {
  __typename: "GdAdditionalTargetingBrowserNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserNames_value[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserEngines_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserEngines {
  __typename: "GdAdditionalTargetingBrowserEngines";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserEngines_value[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceVendors_value {
  __typename: "GdAdditionalTargetingUatraits";
  targetingValueEntryId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceVendors {
  __typename: "GdAdditionalTargetingDeviceVendors";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceVendors_value[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceNames {
  __typename: "GdAdditionalTargetingDeviceNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingInterfaceLangs {
  __typename: "GdAdditionalTargetingInterfaceLangs";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: InterfaceLang[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingQueryReferers {
  __typename: "GdAdditionalTargetingQueryReferers";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingYandexUids {
  __typename: "GdAdditionalTargetingYandexUids";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingShowDates {
  __typename: "GdAdditionalTargetingShowDates";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLocalDate[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup {
  __typename: "GdInternalAdGroup";
  access: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_access;
  regionsInfo: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_regionsInfo;
  campaign: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  libraryMinusKeywordsPacks: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers[] | null;
  level: GraphQlLong | null;
  targetingInternalNetwork: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingInternalNetwork | null;
  targetingIsBrowser: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingIsBrowser | null;
  targetingIsTablet: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingIsTablet | null;
  targetingIsMobile: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingIsMobile | null;
  targetingIsTouch: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingIsTouch | null;
  targetingUserAgents: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingUserAgents | null;
  targetingOsNames: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingOsNames | null;
  targetingOsFamilies: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingOsFamilies | null;
  targetingBrowserNames: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserNames | null;
  targetingBrowserEngines: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserEngines | null;
  targetingDeviceVendors: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceVendors | null;
  targetingDeviceNames: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceNames | null;
  targetingInterfaceLangs: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingInterfaceLangs | null;
  targetingQueryReferers: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingQueryReferers | null;
  targetingYandexUids: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingYandexUids | null;
  targetingShowDates: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingShowDates | null;
  startTime: GraphQlLocalDateTime | null;
  finishTime: GraphQlLocalDateTime | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_campaign_flatStrategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  platform: GdCampaignPlatform;
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_campaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  flatStrategy: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_campaign_flatStrategy;
  type: GdCampaignType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierAdTypeAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierExpressAdjustment" | "GdBidModifierInventoryAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments = GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup {
  __typename: "GdCpmVideoAdGroup";
  access: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_access;
  regionsInfo: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_regionsInfo;
  campaign: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  libraryMinusKeywordsPacks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers[] | null;
  videoGoals: GdVideoGoalType[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_flatStrategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  platform: GdCampaignPlatform;
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_campaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  flatStrategy: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_flatStrategy;
  type: GdCampaignType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierAdTypeAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierExpressAdjustment" | "GdBidModifierInventoryAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments = GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup";
  access: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_access;
  regionsInfo: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_regionsInfo;
  campaign: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  libraryMinusKeywordsPacks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers[] | null;
  videoGoals: GdVideoGoalType[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_campaign_flatStrategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  platform: GdCampaignPlatform;
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_campaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  flatStrategy: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_campaign_flatStrategy;
  type: GdCampaignType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierAdTypeAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierExpressAdjustment" | "GdBidModifierInventoryAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments = GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_pageBlocks {
  __typename: "GdAdGroupPageBlock";
  impId: GraphQlLong;
  pageId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup {
  __typename: "GdCpmOutdoorAdGroup";
  access: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_access;
  regionsInfo: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_regionsInfo;
  campaign: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  libraryMinusKeywordsPacks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers[] | null;
  videoGoals: GdVideoGoalType[];
  pageBlocks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_pageBlocks[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_campaign_flatStrategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  platform: GdCampaignPlatform;
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_campaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  flatStrategy: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_campaign_flatStrategy;
  type: GdCampaignType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierAdTypeAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierExpressAdjustment" | "GdBidModifierInventoryAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments = GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_pageBlocks {
  __typename: "GdAdGroupPageBlock";
  impId: GraphQlLong;
  pageId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup {
  __typename: "GdCpmIndoorAdGroup";
  access: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_access;
  regionsInfo: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_regionsInfo;
  campaign: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  libraryMinusKeywordsPacks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers[] | null;
  videoGoals: GdVideoGoalType[];
  pageBlocks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_pageBlocks[];
}

export type GroupsQueryForEdit_client_adGroups_rowset = GroupsQueryForEdit_client_adGroups_rowset_GdCpmBannerAdGroup | GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup | GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup | GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup | GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup | GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup | GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup;

export interface GroupsQueryForEdit_client_adGroups {
  __typename: "GdAdGroupsContext";
  rowset: GroupsQueryForEdit_client_adGroups_rowset[];
  totalCount: number;
  adGroupIds: GraphQlLong[];
}

export interface GroupsQueryForEdit_client_retargetings_rowset {
  __typename: "GdRetargeting";
  adGroupId: GraphQlLong;
  retargetingConditionId: GraphQlLong;
  retargetingId: GraphQlLong;
  priceContext: GraphQlBigDecimal;
}

export interface GroupsQueryForEdit_client_retargetings {
  __typename: "GdRetargetingContext";
  rowset: GroupsQueryForEdit_client_retargetings_rowset[];
}

export interface GroupsQueryForEdit_client_showConditions_rowset_GdKeyword {
  __typename: "GdKeyword";
  id: GraphQlLong;
  keyword: string;
  minusKeywords: string[];
  adGroupId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_showConditions_rowset_GdRelevanceMatch {
  __typename: "GdRelevanceMatch";
  id: GraphQlLong;
  adGroupId: GraphQlLong;
}

export type GroupsQueryForEdit_client_showConditions_rowset = GroupsQueryForEdit_client_showConditions_rowset_GdKeyword | GroupsQueryForEdit_client_showConditions_rowset_GdRelevanceMatch;

export interface GroupsQueryForEdit_client_showConditions {
  __typename: "GdShowConditionsContext";
  rowset: GroupsQueryForEdit_client_showConditions_rowset[];
}

export interface GroupsQueryForEdit_client_smartFilters_rowset_conditions {
  __typename: "GdSmartFilterCondition";
  field: string;
  operator: GdSmartFilterConditionOperator;
  stringValue: string;
}

export interface GroupsQueryForEdit_client_smartFilters_rowset {
  __typename: "GdSmartFilter";
  id: GraphQlLong;
  adGroupId: GraphQlLong;
  name: string;
  autobudgetPriority: GdShowConditionAutobudgetPriority | null;
  priceCpa: GraphQlBigDecimal | null;
  priceCpc: GraphQlBigDecimal | null;
  targetFunnel: GdSmartFilterTargetFunnel;
  tab: GdSmartFilterTab;
  conditions: GroupsQueryForEdit_client_smartFilters_rowset_conditions[];
}

export interface GroupsQueryForEdit_client_smartFilters {
  __typename: "GdSmartFiltersContext";
  rowset: GroupsQueryForEdit_client_smartFilters_rowset[];
}

export interface GroupsQueryForEdit_client_feeds_rowset_categories {
  __typename: "GdFeedCategory";
  categoryId: GraphQlBigInteger;
  offerCount: GraphQlLong | null;
  parentCategoryId: GraphQlBigInteger;
  name: string;
  isDeleted: boolean;
}

export interface GroupsQueryForEdit_client_feeds_rowset {
  __typename: "GdFeed";
  id: GraphQlLong;
  name: string;
  updateStatus: GdUpdateStatus;
  businessType: GdBusinessType;
  categories: GroupsQueryForEdit_client_feeds_rowset_categories[];
  feedType: GdFeedType | null;
}

export interface GroupsQueryForEdit_client_feeds {
  __typename: "GdFeedsContext";
  rowset: GroupsQueryForEdit_client_feeds_rowset[];
}

export interface GroupsQueryForEdit_client {
  __typename: "GdClient";
  chiefLogin: string;
  clientConstants: GroupsQueryForEdit_client_clientConstants;
  adGroups: GroupsQueryForEdit_client_adGroups;
  retargetings: GroupsQueryForEdit_client_retargetings;
  showConditions: GroupsQueryForEdit_client_showConditions;
  smartFilters: GroupsQueryForEdit_client_smartFilters;
  feeds: GroupsQueryForEdit_client_feeds;
}

export interface GroupsQueryForEdit {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: GroupsQueryForEdit_client;
}

export interface GroupsQueryForEditVariables {
  login: string;
  adGroupsInput: GdAdGroupsContainerInput;
  showConditionsInput: GdShowConditionsContainerInput;
  smartFiltersInput: GdSmartFiltersContainerInput;
  retargetingsInput: GdRetargetingsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GroupsQueryKeywordsAndRetargeting
// ====================================================

export interface GroupsQueryKeywordsAndRetargeting_client_retargetings_rowset_retargetingCondition {
  __typename: "GdRetargetingCondition";
  name: string;
}

export interface GroupsQueryKeywordsAndRetargeting_client_retargetings_rowset {
  __typename: "GdRetargeting";
  retargetingCondition: GroupsQueryKeywordsAndRetargeting_client_retargetings_rowset_retargetingCondition | null;
}

export interface GroupsQueryKeywordsAndRetargeting_client_retargetings {
  __typename: "GdRetargetingContext";
  rowset: GroupsQueryKeywordsAndRetargeting_client_retargetings_rowset[];
}

export interface GroupsQueryKeywordsAndRetargeting_client_showConditions_rowset_GdRelevanceMatch {
  __typename: "GdRelevanceMatch";
  id: GraphQlLong;
}

export interface GroupsQueryKeywordsAndRetargeting_client_showConditions_rowset_GdKeyword {
  __typename: "GdKeyword";
  id: GraphQlLong;
  keyword: string;
}

export type GroupsQueryKeywordsAndRetargeting_client_showConditions_rowset = GroupsQueryKeywordsAndRetargeting_client_showConditions_rowset_GdRelevanceMatch | GroupsQueryKeywordsAndRetargeting_client_showConditions_rowset_GdKeyword;

export interface GroupsQueryKeywordsAndRetargeting_client_showConditions {
  __typename: "GdShowConditionsContext";
  rowset: GroupsQueryKeywordsAndRetargeting_client_showConditions_rowset[];
}

export interface GroupsQueryKeywordsAndRetargeting_client {
  __typename: "GdClient";
  retargetings: GroupsQueryKeywordsAndRetargeting_client_retargetings;
  showConditions: GroupsQueryKeywordsAndRetargeting_client_showConditions;
}

export interface GroupsQueryKeywordsAndRetargeting {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: GroupsQueryKeywordsAndRetargeting_client;
}

export interface GroupsQueryKeywordsAndRetargetingVariables {
  login: string;
  showConditionsInput: GdShowConditionsContainerInput;
  retargetingsInput: GdRetargetingsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ProductsListQuery
// ====================================================

export interface ProductsListQuery_products_rowset_restrictions_conditions {
  __typename: "GdProductRestrictionCondition";
  name: string;
}

export interface ProductsListQuery_products_rowset_restrictions {
  __typename: "GdProductRestriction";
  id: GraphQlLong;
  groupType: AdGroupType;
  conditions: ProductsListQuery_products_rowset_restrictions_conditions[];
}

export interface ProductsListQuery_products_rowset {
  __typename: "GdProduct";
  id: GraphQlLong;
  type: GdProductType;
  restrictions: ProductsListQuery_products_rowset_restrictions[];
}

export interface ProductsListQuery_products {
  __typename: "GdProductContext";
  totalCount: number;
  rowset: ProductsListQuery_products_rowset[];
}

export interface ProductsListQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  products: ProductsListQuery_products;
}

export interface ProductsListQueryVariables {
  productFilterInput: GdProductContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SmartFiltersQuery
// ====================================================

export interface SmartFiltersQuery_client_smartFilters_rowset_conditions {
  __typename: "GdSmartFilterCondition";
  field: string;
  operator: GdSmartFilterConditionOperator;
  stringValue: string;
}

export interface SmartFiltersQuery_client_smartFilters_rowset {
  __typename: "GdSmartFilter";
  id: GraphQlLong;
  adGroupId: GraphQlLong;
  name: string;
  autobudgetPriority: GdShowConditionAutobudgetPriority | null;
  priceCpa: GraphQlBigDecimal | null;
  priceCpc: GraphQlBigDecimal | null;
  targetFunnel: GdSmartFilterTargetFunnel;
  tab: GdSmartFilterTab;
  conditions: SmartFiltersQuery_client_smartFilters_rowset_conditions[];
}

export interface SmartFiltersQuery_client_smartFilters {
  __typename: "GdSmartFiltersContext";
  rowset: SmartFiltersQuery_client_smartFilters_rowset[];
}

export interface SmartFiltersQuery_client {
  __typename: "GdClient";
  smartFilters: SmartFiltersQuery_client_smartFilters;
}

export interface SmartFiltersQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: SmartFiltersQuery_client;
}

export interface SmartFiltersQueryVariables {
  login: string;
  smartFiltersInput: GdSmartFiltersContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CampaignBasicDataForGroupEdit
// ====================================================

export interface CampaignBasicDataForGroupEdit_client_campaigns_rowset_flatStrategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
}

export interface CampaignBasicDataForGroupEdit_client_campaigns_rowset {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  type: GdCampaignType;
  name: string;
  defaultRegionIds: (GraphQlLong | null)[];
  flatStrategy: CampaignBasicDataForGroupEdit_client_campaigns_rowset_flatStrategy;
}

export interface CampaignBasicDataForGroupEdit_client_campaigns {
  __typename: "GdCampaignsContext";
  rowset: CampaignBasicDataForGroupEdit_client_campaigns_rowset[];
}

export interface CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifierTypesByAdGroupTypes {
  __typename: "GdAllowedBidModifiersByAdGroupType";
  adGroupType: GdAdGroupType;
  allowedBidModifierTypes: GdBidModifierType[];
}

export interface CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment {
  __typename: "GdAllowedBidModifierValuesABSegment" | "GdAllowedBidModifierValuesAdType" | "GdAllowedBidModifierValuesDemographics" | "GdAllowedBidModifierValuesDesktop" | "GdAllowedBidModifierValuesExpression" | "GdAllowedBidModifierValuesGeo" | "GdAllowedBidModifierValuesInventory" | "GdAllowedBidModifierValuesRetargeting" | "GdAllowedBidModifierValuesSmartTgo" | "GdAllowedBidModifierValuesVideo" | "GdAllowedBidModifierValuesWeather";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment_percentRange;
}

export interface CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile {
  __typename: "GdAllowedBidModifierValuesMobile";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile_percentRange;
  osTypes: GdOsType[];
}

export type CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues = CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment | CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile;

export interface CampaignBasicDataForGroupEdit_client_clientConstants_clientLimits {
  __typename: "GdClientLimits";
  keywordsCountLimit: GraphQlLong;
}

export interface CampaignBasicDataForGroupEdit_client_clientConstants {
  __typename: "GdClientConstants";
  allowedBidModifierTypesByAdGroupTypes: CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifierTypesByAdGroupTypes[];
  allowedBidModifiersValues: CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues[];
  clientLimits: CampaignBasicDataForGroupEdit_client_clientConstants_clientLimits;
}

export interface CampaignBasicDataForGroupEdit_client {
  __typename: "GdClient";
  campaigns: CampaignBasicDataForGroupEdit_client_campaigns;
  clientConstants: CampaignBasicDataForGroupEdit_client_clientConstants;
}

export interface CampaignBasicDataForGroupEdit {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CampaignBasicDataForGroupEdit_client;
}

export interface CampaignBasicDataForGroupEditVariables {
  login: string;
  campInput: GdCampaignsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CreativesQuery
// ====================================================

export interface CreativesQuery_creatives_rowset_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  previewUrl: string;
  width: GraphQlLong | null;
}

export interface CreativesQuery_creatives_rowset_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  previewUrl: string;
  width: GraphQlLong | null;
  isAdaptive: boolean | null;
}

export interface CreativesQuery_creatives_rowset_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  previewUrl: string;
  width: GraphQlLong | null;
  isImage: boolean;
}

export type CreativesQuery_creatives_rowset = CreativesQuery_creatives_rowset_GdSmartCreative | CreativesQuery_creatives_rowset_GdCanvasCreative | CreativesQuery_creatives_rowset_GdHtml5Creative;

export interface CreativesQuery_creatives {
  __typename: "GdCreativesContext";
  cacheKey: string;
  creativeIds: GraphQlLong[];
  rowset: CreativesQuery_creatives_rowset[];
  totalCount: number;
}

export interface CreativesQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  creatives: CreativesQuery_creatives;
}

export interface CreativesQueryVariables {
  input: GdCreativesContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SmartFeedSchemaQuery
// ====================================================

export interface SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterNumberField_operators {
  __typename: "GdSmartFilterOperator";
  maxItems: number;
  type: GdSmartFilterConditionOperator;
}

export interface SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterNumberField {
  __typename: "GdSmartFilterNumberField";
  name: string;
  operators: SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterNumberField_operators[];
  max: number;
  min: number;
  precision: number;
}

export interface SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterStringField_operators {
  __typename: "GdSmartFilterOperator";
  maxItems: number;
  type: GdSmartFilterConditionOperator;
}

export interface SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterStringField {
  __typename: "GdSmartFilterStringField";
  name: string;
  operators: SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterStringField_operators[];
  maxLength: number;
  minLength: number;
  pattern: string | null;
}

export interface SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterEnumField_operators {
  __typename: "GdSmartFilterOperator";
  maxItems: number;
  type: GdSmartFilterConditionOperator;
}

export interface SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterEnumField {
  __typename: "GdSmartFilterEnumField";
  name: string;
  operators: SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterEnumField_operators[];
  values: string[];
}

export type SmartFeedSchemaQuery_constants_smartFilterSchemas_fields = SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterNumberField | SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterStringField | SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterEnumField;

export interface SmartFeedSchemaQuery_constants_smartFilterSchemas {
  __typename: "GdSmartFilterSchema";
  fields: SmartFeedSchemaQuery_constants_smartFilterSchemas_fields[];
}

export interface SmartFeedSchemaQuery_constants {
  __typename: "GdDirectConstants";
  smartFilterSchemas: (SmartFeedSchemaQuery_constants_smartFilterSchemas | null)[] | null;
}

export interface SmartFeedSchemaQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  constants: SmartFeedSchemaQuery_constants;
}

export interface SmartFeedSchemaQueryVariables {
  input?: GdSmartFilterSchemaQueryInput | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PerformanceCreativesQuery
// ====================================================

export interface PerformanceCreativesQuery_client_ads_rowset_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdTextAd";
}

export interface PerformanceCreativesQuery_client_ads_rowset_GdSmartAd_creative {
  __typename: "GdCreative";
  creativeId: GraphQlLong;
}

export interface PerformanceCreativesQuery_client_ads_rowset_GdSmartAd {
  __typename: "GdSmartAd";
  creative: PerformanceCreativesQuery_client_ads_rowset_GdSmartAd_creative | null;
}

export type PerformanceCreativesQuery_client_ads_rowset = PerformanceCreativesQuery_client_ads_rowset_GdCPCVideoAd | PerformanceCreativesQuery_client_ads_rowset_GdSmartAd;

export interface PerformanceCreativesQuery_client_ads {
  __typename: "GdAdsContext";
  rowset: PerformanceCreativesQuery_client_ads_rowset[];
}

export interface PerformanceCreativesQuery_client_adGroups_rowset_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdTextAdGroup";
}

export interface PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup_availableCreatives_rowset_layout {
  __typename: "GdCreativeLayout";
  id: GraphQlLong;
  imgSrc: string | null;
  name: string | null;
}

export interface PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup_availableCreatives_rowset_theme {
  __typename: "GdCreativeTheme";
  id: GraphQlLong;
  name: string | null;
}

export interface PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup_availableCreatives_rowset_usedInCampaigns {
  __typename: "GdCampaignForLink";
  id: GraphQlLong;
  name: string;
}

export interface PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup_availableCreatives_rowset {
  __typename: "GdSmartCreative";
  groupId: GraphQlLong | null;
  groupName: string | null;
  creativeId: GraphQlLong;
  businessType: GdCreativeBusinessType;
  statusModerate: GdCreativeStatusModerate;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup_availableCreatives_rowset_layout | null;
  theme: PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup_availableCreatives_rowset_theme | null;
  usedInCampaigns: PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup_availableCreatives_rowset_usedInCampaigns[];
  regionIds: GraphQlLong[];
}

export interface PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup_availableCreatives {
  __typename: "GdAvailableCreativesContext";
  rowset: PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup_availableCreatives_rowset[];
}

export interface PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  availableCreatives: PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup_availableCreatives | null;
}

export type PerformanceCreativesQuery_client_adGroups_rowset = PerformanceCreativesQuery_client_adGroups_rowset_GdCpmAudioAdGroup | PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup;

export interface PerformanceCreativesQuery_client_adGroups {
  __typename: "GdAdGroupsContext";
  rowset: PerformanceCreativesQuery_client_adGroups_rowset[];
}

export interface PerformanceCreativesQuery_client {
  __typename: "GdClient";
  ads: PerformanceCreativesQuery_client_ads;
  adGroups: PerformanceCreativesQuery_client_adGroups;
}

export interface PerformanceCreativesQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: PerformanceCreativesQuery_client;
}

export interface PerformanceCreativesQueryVariables {
  login: string;
  adsInput: GdAdsContainerInput;
  adGroupInput: GdAdGroupsContainerInput;
  limit: number;
  offset: number;
  order: OrderInput;
  idOrName: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FeedsQuery
// ====================================================

export interface FeedsQuery_client_feeds_rowset_categories {
  __typename: "GdFeedCategory";
  categoryId: GraphQlBigInteger;
  offerCount: GraphQlLong | null;
  parentCategoryId: GraphQlBigInteger;
  name: string;
  isDeleted: boolean;
}

export interface FeedsQuery_client_feeds_rowset {
  __typename: "GdFeed";
  id: GraphQlLong;
  name: string;
  updateStatus: GdUpdateStatus;
  businessType: GdBusinessType;
  categories: FeedsQuery_client_feeds_rowset_categories[];
  feedType: GdFeedType | null;
}

export interface FeedsQuery_client_feeds {
  __typename: "GdFeedsContext";
  rowset: FeedsQuery_client_feeds_rowset[];
}

export interface FeedsQuery_client {
  __typename: "GdClient";
  feeds: FeedsQuery_client_feeds;
}

export interface FeedsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: FeedsQuery_client;
}

export interface FeedsQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SmartFiltersGridQuery
// ====================================================

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_campaign;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_access;
  mainAd: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_access;
  mainAd: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_regionsInfo;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_access;
  mainAd: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_access;
  mainAd: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_regionsInfo;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdCpmAudioAdGroup | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_conditions {
  __typename: "GdSmartFilterCondition";
  field: string;
  operator: GdSmartFilterConditionOperator;
  stringValue: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_stats {
  __typename: "GdEntityStats";
  avgClickCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
  cost: GraphQlBigDecimal | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_status {
  __typename: "GdSmartFilterStatus";
  primaryStatus: GdSmartFilterPrimaryStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset {
  __typename: "GdSmartFilter";
  id: GraphQlLong;
  adGroup: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup;
  name: string;
  autobudgetPriority: GdShowConditionAutobudgetPriority | null;
  priceCpa: GraphQlBigDecimal | null;
  priceCpc: GraphQlBigDecimal | null;
  targetFunnel: GdSmartFilterTargetFunnel;
  tab: GdSmartFilterTab;
  conditions: SmartFiltersGridQuery_client_smartFilters_rowset_conditions[];
  stats: SmartFiltersGridQuery_client_smartFilters_rowset_stats;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_status;
}

export interface SmartFiltersGridQuery_client_smartFilters_totalStats {
  __typename: "GdEntityStats";
  shows: GraphQlLong | null;
  ctr: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
}

export interface SmartFiltersGridQuery_client_smartFilters {
  __typename: "GdSmartFiltersContext";
  rowset: SmartFiltersGridQuery_client_smartFilters_rowset[];
  cacheKey: string;
  smartFilterIds: GraphQlLong[];
  totalCount: number;
  totalStats: SmartFiltersGridQuery_client_smartFilters_totalStats | null;
}

export interface SmartFiltersGridQuery_client {
  __typename: "GdClient";
  chiefLogin: string;
  smartFilters: SmartFiltersGridQuery_client_smartFilters;
}

export interface SmartFiltersGridQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: SmartFiltersGridQuery_client;
}

export interface SmartFiltersGridQueryVariables {
  login: string;
  smartFiltersInput: GdSmartFiltersContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CopyAdGroupsInfoQuery
// ====================================================

export interface CopyAdGroupsInfoQuery_client_adGroups_rowset_campaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  type: GdCampaignType;
  name: string;
  id: GraphQlLong;
}

export interface CopyAdGroupsInfoQuery_client_adGroups_rowset {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  name: string;
  id: GraphQlLong;
  campaign: CopyAdGroupsInfoQuery_client_adGroups_rowset_campaign;
}

export interface CopyAdGroupsInfoQuery_client_adGroups {
  __typename: "GdAdGroupsContext";
  rowset: CopyAdGroupsInfoQuery_client_adGroups_rowset[];
}

export interface CopyAdGroupsInfoQuery_client {
  __typename: "GdClient";
  adGroups: CopyAdGroupsInfoQuery_client_adGroups;
}

export interface CopyAdGroupsInfoQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CopyAdGroupsInfoQuery_client;
}

export interface CopyAdGroupsInfoQueryVariables {
  login: string;
  adGroupInput: GdAdGroupsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GoalsQuery
// ====================================================

export interface GoalsQuery_client_campaignGoals_rowset {
  __typename: "GdGoal";
  id: GraphQlLong;
  name: string;
}

export interface GoalsQuery_client_campaignGoals {
  __typename: "GdGoalsContext";
  rowset: GoalsQuery_client_campaignGoals_rowset[];
}

export interface GoalsQuery_client {
  __typename: "GdClient";
  campaignGoals: GoalsQuery_client_campaignGoals;
}

export interface GoalsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: GoalsQuery_client;
}

export interface GoalsQueryVariables {
  login: string;
  goalsInput: GdCampaignGoalsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GroupKeywordsQuery
// ====================================================

export interface GroupKeywordsQuery_client_showConditions_rowset_GdRelevanceMatch {
  __typename: "GdRelevanceMatch";
  id: GraphQlLong;
}

export interface GroupKeywordsQuery_client_showConditions_rowset_GdKeyword {
  __typename: "GdKeyword";
  id: GraphQlLong;
  keyword: string;
}

export type GroupKeywordsQuery_client_showConditions_rowset = GroupKeywordsQuery_client_showConditions_rowset_GdRelevanceMatch | GroupKeywordsQuery_client_showConditions_rowset_GdKeyword;

export interface GroupKeywordsQuery_client_showConditions {
  __typename: "GdShowConditionsContext";
  rowset: GroupKeywordsQuery_client_showConditions_rowset[];
}

export interface GroupKeywordsQuery_client {
  __typename: "GdClient";
  showConditions: GroupKeywordsQuery_client_showConditions;
}

export interface GroupKeywordsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: GroupKeywordsQuery_client;
}

export interface GroupKeywordsQueryVariables {
  login: string;
  input: GdShowConditionsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ReachQuery
// ====================================================

export interface ReachQuery_reach_basic {
  __typename: "GdReachInfo";
  reach: GraphQlLong | null;
  reachLessThan: GraphQlLong | null;
}

export interface ReachQuery_reach_detailed {
  __typename: "GdReachInfo";
  reach: GraphQlLong | null;
  reachLessThan: GraphQlLong | null;
}

export interface ReachQuery_reach {
  __typename: "GdReachResult";
  basic: ReachQuery_reach_basic | null;
  detailed: ReachQuery_reach_detailed | null;
  requestId: string;
}

export interface ReachQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  reach: ReachQuery_reach;
}

export interface ReachQueryVariables {
  input: GdReachRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ReachRecommendationQuery
// ====================================================

export interface ReachRecommendationQuery_reachRecommendation_bannerFormats {
  __typename: "GdBannerFormatIncreasePercent";
  format: string;
  increasePercent: GraphQlBigDecimal | null;
}

export interface ReachRecommendationQuery_reachRecommendation {
  __typename: "GdReachRecommendationResult";
  bannerFormats: ReachRecommendationQuery_reachRecommendation_bannerFormats[] | null;
  requestId: string;
}

export interface ReachRecommendationQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  reachRecommendation: ReachRecommendationQuery_reachRecommendation;
}

export interface ReachRecommendationQueryVariables {
  input: GdReachRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RecommendationsAdsGroupEditQuery
// ====================================================

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi = RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_keys[];
  kpi: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi;
}

export type RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations = RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi | RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi;

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  id: GraphQlLong;
  type: GdAdGroupType;
  name: string;
  recommendations: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations[] | null;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups {
  __typename: "GdAdGroupsContext";
  rowset: RecommendationsAdsGroupEditQuery_client_adGroups_rowset[];
}

export interface RecommendationsAdsGroupEditQuery_client {
  __typename: "GdClient";
  adGroups: RecommendationsAdsGroupEditQuery_client_adGroups;
}

export interface RecommendationsAdsGroupEditQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RecommendationsAdsGroupEditQuery_client;
}

export interface RecommendationsAdsGroupEditQueryVariables {
  login: string;
  adGroupInput: GdAdGroupsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RecommendationsGroupEditQuery
// ====================================================

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi = RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_keys[];
  kpi: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi;
}

export type RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations = RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi | RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi;

export interface RecommendationsGroupEditQuery_client_adGroups_rowset {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  id: GraphQlLong;
  type: GdAdGroupType;
  name: string;
  recommendations: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations[] | null;
}

export interface RecommendationsGroupEditQuery_client_adGroups {
  __typename: "GdAdGroupsContext";
  rowset: RecommendationsGroupEditQuery_client_adGroups_rowset[];
}

export interface RecommendationsGroupEditQuery_client {
  __typename: "GdClient";
  adGroups: RecommendationsGroupEditQuery_client_adGroups;
}

export interface RecommendationsGroupEditQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RecommendationsGroupEditQuery_client;
}

export interface RecommendationsGroupEditQueryVariables {
  login: string;
  adGroupInput: GdAdGroupsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ReachOutdoorQuery
// ====================================================

export interface ReachOutdoorQuery_reachOutdoor {
  __typename: "GdReachOutdoorResult";
  otsCapacity: GraphQlLong | null;
  reach: GraphQlLong | null;
  reachLessThan: GraphQlLong | null;
  requestId: string;
}

export interface ReachOutdoorQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  reachOutdoor: ReachOutdoorQuery_reachOutdoor | null;
}

export interface ReachOutdoorQueryVariables {
  input: GdOutdoorReachRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ReachIndoorQuery
// ====================================================

export interface ReachIndoorQuery_reachIndoor {
  __typename: "GdReachIndoorResult";
  otsCapacity: GraphQlLong | null;
  reach: GraphQlLong | null;
  reachLessThan: GraphQlLong | null;
  requestId: string;
}

export interface ReachIndoorQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  reachIndoor: ReachIndoorQuery_reachIndoor | null;
}

export interface ReachIndoorQueryVariables {
  input: GdIndoorReachRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FreelancersListUpdateQuery
// ====================================================

export interface FreelancersListUpdateQuery_freelancersList_privateData_newestCard_contacts {
  __typename: "GdFreelancerContacts";
  siteUrl: string | null;
  whatsApp: string | null;
  phone: string;
  icq: string | null;
  telegram: string | null;
  email: string;
  viber: string | null;
  skype: string | null;
}

export interface FreelancersListUpdateQuery_freelancersList_privateData_newestCard {
  __typename: "GdFreelancerCard";
  statusModerate: GdFreelancersCardStatusModerate;
  briefInfo: string;
  avatarUrl: string;
  contacts: FreelancersListUpdateQuery_freelancersList_privateData_newestCard_contacts;
}

export interface FreelancersListUpdateQuery_freelancersList_privateData_advQuality {
  __typename: "GdFreelancerAdvQuality";
  advQualityRank: GraphQlLong | null;
  advQualityRating: GraphQlBigDecimal | null;
}

export interface FreelancersListUpdateQuery_freelancersList_privateData {
  __typename: "GdFreelancerPrivateData";
  freelancerId: GraphQlLong;
  /**
   * Последняя версия карточки вне зависимости от статуса
   */
  newestCard: FreelancersListUpdateQuery_freelancersList_privateData_newestCard | null;
  /**
   * ОКР-рейтинг специалиста.
   */
  advQuality: FreelancersListUpdateQuery_freelancersList_privateData_advQuality | null;
}

export interface FreelancersListUpdateQuery_freelancersList {
  __typename: "GdFreelancerBase";
  /**
   * Приватные данные фрилансера. null, если у оператора нет прав на просмотр
   */
  privateData: FreelancersListUpdateQuery_freelancersList_privateData | null;
}

export interface FreelancersListUpdateQuery_client_freelancerProjects {
  __typename: "GdClientProject";
  freelancerId: GraphQlLong;
}

export interface FreelancersListUpdateQuery_client {
  __typename: "GdClient";
  freelancerProjects: FreelancersListUpdateQuery_client_freelancerProjects[];
}

export interface FreelancersListUpdateQuery {
  freelancersList: (FreelancersListUpdateQuery_freelancersList | null)[];
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: FreelancersListUpdateQuery_client;
}

export interface FreelancersListUpdateQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FreelancerRegisteredQuery
// ====================================================

export interface FreelancerRegisteredQuery_freelancersList_privateData_newestCard_contacts {
  __typename: "GdFreelancerContacts";
  siteUrl: string | null;
  whatsApp: string | null;
  phone: string;
  icq: string | null;
  telegram: string | null;
  email: string;
  viber: string | null;
  skype: string | null;
}

export interface FreelancerRegisteredQuery_freelancersList_privateData_newestCard {
  __typename: "GdFreelancerCard";
  statusModerate: GdFreelancersCardStatusModerate;
  briefInfo: string;
  avatarUrl: string;
  contacts: FreelancerRegisteredQuery_freelancersList_privateData_newestCard_contacts;
}

export interface FreelancerRegisteredQuery_freelancersList_privateData_advQuality {
  __typename: "GdFreelancerAdvQuality";
  advQualityRank: GraphQlLong | null;
  advQualityRating: GraphQlBigDecimal | null;
}

export interface FreelancerRegisteredQuery_freelancersList_privateData {
  __typename: "GdFreelancerPrivateData";
  freelancerId: GraphQlLong;
  /**
   * Последняя версия карточки вне зависимости от статуса
   */
  newestCard: FreelancerRegisteredQuery_freelancersList_privateData_newestCard | null;
  /**
   * ОКР-рейтинг специалиста.
   */
  advQuality: FreelancerRegisteredQuery_freelancersList_privateData_advQuality | null;
}

export interface FreelancerRegisteredQuery_freelancersList_card {
  __typename: "GdFreelancerCard";
  avatarUrl: string;
}

export interface FreelancerRegisteredQuery_freelancersList_feedbacks_authorInfo {
  __typename: "GdUserPublicInfo";
  avatarUrl: string;
  login: string;
  name: string;
  userId: GraphQlLong;
}

export interface FreelancerRegisteredQuery_freelancersList_feedbacks {
  __typename: "GdFreelancerFeedback";
  authorInfo: FreelancerRegisteredQuery_freelancersList_feedbacks_authorInfo | null;
  authorUid: GraphQlLong;
  createdTime: GraphQlLocalDateTime;
  feedbackId: string;
  feedbackText: string;
  freelancerId: GraphQlLong;
  overallMark: GraphQlLong;
  willRecommend: boolean | null;
  moderationStatus: GdFreelancerUgcModerationStatus;
}

export interface FreelancerRegisteredQuery_freelancersList {
  __typename: "GdFreelancerBase";
  /**
   * Приватные данные фрилансера. null, если у оператора нет прав на просмотр
   */
  privateData: FreelancerRegisteredQuery_freelancersList_privateData | null;
  fio: string;
  login: string;
  card: FreelancerRegisteredQuery_freelancersList_card | null;
  feedbacks: FreelancerRegisteredQuery_freelancersList_feedbacks[] | null;
}

export interface FreelancerRegisteredQuery_constants {
  __typename: "GdDirectConstants";
  /**
   * Количество частных специалистов по настройке Директа
   */
  freelancersCount: number | null;
}

export interface FreelancerRegisteredQuery_client_info_chiefUser {
  __typename: "GdUserInfo";
  name: string;
  avatarUrl: string;
  phone: string | null;
}

export interface FreelancerRegisteredQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  chiefUser: FreelancerRegisteredQuery_client_info_chiefUser;
}

export interface FreelancerRegisteredQuery_client_freelancerProjects_freelancer {
  __typename: "GdFreelancerBase" | "GdFreelancerFull";
  login: string;
}

export interface FreelancerRegisteredQuery_client_freelancerProjects {
  __typename: "GdClientProject";
  id: GraphQlLong;
  freelancerId: GraphQlLong;
  createdTime: GraphQlLocalDateTime;
  startedTime: GraphQlLocalDateTime | null;
  status: GdFreelancerProjectStatus;
  freelancer: FreelancerRegisteredQuery_client_freelancerProjects_freelancer | null;
}

export interface FreelancerRegisteredQuery_client_hasCooperation {
  __typename: "GdClientProject";
  id: GraphQlLong;
}

export interface FreelancerRegisteredQuery_client_access {
  __typename: "GdClientAccess";
  canRequestFlService: boolean;
}

export interface FreelancerRegisteredQuery_client {
  __typename: "GdClient";
  info: FreelancerRegisteredQuery_client_info;
  freelancerProjects: FreelancerRegisteredQuery_client_freelancerProjects[];
  hasCooperation: FreelancerRegisteredQuery_client_hasCooperation[];
  access: FreelancerRegisteredQuery_client_access;
}

export interface FreelancerRegisteredQuery {
  freelancersList: (FreelancerRegisteredQuery_freelancersList | null)[];
  /**
   * Получить reqId запроса
   */
  reqId: string;
  constants: FreelancerRegisteredQuery_constants;
  client: FreelancerRegisteredQuery_client;
}

export interface FreelancerRegisteredQueryVariables {
  freelancerLogin: string;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FreelancerCustomersQuery
// ====================================================

export interface FreelancerCustomersQuery_freelancersList_privateData_projects_client {
  __typename: "GdFreelancerClient";
  fio: string;
  clientId: GraphQlLong;
  chiefLogin: string;
  phoneNumber: string | null;
}

export interface FreelancerCustomersQuery_freelancersList_privateData_projects {
  __typename: "GdFreelancerProject";
  id: GraphQlLong;
  status: GdFreelancerProjectStatus;
  createdTime: GraphQlLocalDateTime;
  updatedTime: GraphQlLocalDateTime;
  startedTime: GraphQlLocalDateTime | null;
  client: FreelancerCustomersQuery_freelancersList_privateData_projects_client;
}

export interface FreelancerCustomersQuery_freelancersList_privateData {
  __typename: "GdFreelancerPrivateData";
  freelancerId: GraphQlLong;
  projects: FreelancerCustomersQuery_freelancersList_privateData_projects[];
}

export interface FreelancerCustomersQuery_freelancersList {
  __typename: "GdFreelancerBase";
  /**
   * Приватные данные фрилансера. null, если у оператора нет прав на просмотр
   */
  privateData: FreelancerCustomersQuery_freelancersList_privateData | null;
}

export interface FreelancerCustomersQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  freelancersList: (FreelancerCustomersQuery_freelancersList | null)[];
}

export interface FreelancerCustomersQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ClientFreelancerQuery
// ====================================================

export interface ClientFreelancerQuery_client_freelancerProjects_freelancer_card_contacts {
  __typename: "GdFreelancerContacts";
  phone: string;
}

export interface ClientFreelancerQuery_client_freelancerProjects_freelancer_card {
  __typename: "GdFreelancerCard";
  contacts: ClientFreelancerQuery_client_freelancerProjects_freelancer_card_contacts;
  avatarUrl: string;
}

export interface ClientFreelancerQuery_client_freelancerProjects_freelancer {
  __typename: "GdFreelancerBase" | "GdFreelancerFull";
  login: string;
  fio: string;
  card: ClientFreelancerQuery_client_freelancerProjects_freelancer_card | null;
}

export interface ClientFreelancerQuery_client_freelancerProjects {
  __typename: "GdClientProject";
  freelancer: ClientFreelancerQuery_client_freelancerProjects_freelancer | null;
  status: GdFreelancerProjectStatus;
}

export interface ClientFreelancerQuery_client_info_chiefUser {
  __typename: "GdUserInfo";
  phone: string | null;
  avatarUrl: string;
  name: string;
}

export interface ClientFreelancerQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  chiefUser: ClientFreelancerQuery_client_info_chiefUser;
}

export interface ClientFreelancerQuery_client {
  __typename: "GdClient";
  chiefLogin: string;
  freelancerProjects: ClientFreelancerQuery_client_freelancerProjects[];
  info: ClientFreelancerQuery_client_info;
}

export interface ClientFreelancerQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: ClientFreelancerQuery_client;
}

export interface ClientFreelancerQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FreelancerEditorQuery
// ====================================================

export interface FreelancerEditorQuery_constants_freelancerSkillTypes {
  __typename: "GdFreelancerSkillType";
  name: string;
  skillCode: string;
  skillId: GraphQlLong;
}

export interface FreelancerEditorQuery_constants {
  __typename: "GdDirectConstants";
  freelancerSkillTypes: FreelancerEditorQuery_constants_freelancerSkillTypes[];
}

export interface FreelancerEditorQuery_freelancersList_certificates {
  __typename: "GdFreelancerCertificate";
  certId: GraphQlLong;
  type: GdFreelancerCertificateType;
  link: string;
}

export interface FreelancerEditorQuery_freelancersList_skills {
  __typename: "GdFreelancerSkill";
  name: string;
  skillId: GraphQlLong;
  days: string;
  price: GraphQlBigDecimal;
  duration: GdFreelancerSkillOfferDuration;
}

export interface FreelancerEditorQuery_freelancersList_privateData_newestCard_contacts {
  __typename: "GdFreelancerContacts";
  siteUrl: string | null;
  whatsApp: string | null;
  phone: string;
  icq: string | null;
  telegram: string | null;
  email: string;
  viber: string | null;
  skype: string | null;
}

export interface FreelancerEditorQuery_freelancersList_privateData_newestCard {
  __typename: "GdFreelancerCard";
  briefInfo: string;
  avatarUrl: string;
  contacts: FreelancerEditorQuery_freelancersList_privateData_newestCard_contacts;
}

export interface FreelancerEditorQuery_freelancersList_privateData {
  __typename: "GdFreelancerPrivateData";
  freelancerId: GraphQlLong;
  /**
   * Последняя версия карточки вне зависимости от статуса
   */
  newestCard: FreelancerEditorQuery_freelancersList_privateData_newestCard | null;
}

export interface FreelancerEditorQuery_freelancersList_card_contacts {
  __typename: "GdFreelancerContacts";
  siteUrl: string | null;
  whatsApp: string | null;
  phone: string;
  icq: string | null;
  telegram: string | null;
  email: string;
  viber: string | null;
  skype: string | null;
}

export interface FreelancerEditorQuery_freelancersList_card {
  __typename: "GdFreelancerCard";
  briefInfo: string;
  avatarUrl: string;
  contacts: FreelancerEditorQuery_freelancersList_card_contacts;
}

export interface FreelancerEditorQuery_freelancersList_region_translation {
  __typename: "GdFreelancerRegionTranslation";
  region: string;
  country: string;
}

export interface FreelancerEditorQuery_freelancersList_region {
  __typename: "GdFreelancerRegion";
  regionId: GraphQlLong;
  translation: FreelancerEditorQuery_freelancersList_region_translation;
}

export interface FreelancerEditorQuery_freelancersList {
  __typename: "GdFreelancerBase";
  fio: string;
  login: string;
  createTime: GraphQlLocalDateTime;
  certificates: FreelancerEditorQuery_freelancersList_certificates[];
  skills: FreelancerEditorQuery_freelancersList_skills[];
  /**
   * Приватные данные фрилансера. null, если у оператора нет прав на просмотр
   */
  privateData: FreelancerEditorQuery_freelancersList_privateData | null;
  card: FreelancerEditorQuery_freelancersList_card | null;
  /**
   * Данные о стране и названии региона фрилансера.
   */
  region: FreelancerEditorQuery_freelancersList_region | null;
}

export interface FreelancerEditorQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  constants: FreelancerEditorQuery_constants;
  freelancersList: (FreelancerEditorQuery_freelancersList | null)[];
}

export interface FreelancerEditorQueryVariables {
  freelancerLogin: string;
  lang: GdLanguageInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: minusPhraseLibraryQuery
// ====================================================

export interface minusPhraseLibraryQuery_getLibraryMinusKeywordsPacks_rowset {
  __typename: "GdGetMinusKeywordsPacksItem";
  id: GraphQlLong;
  linkedAdGroupsCount: GraphQlLong;
  minusKeywords: string[];
  name: string;
}

export interface minusPhraseLibraryQuery_getLibraryMinusKeywordsPacks {
  __typename: "GdGetMinusKeywordsPacksPayload";
  cacheKey: string;
  rowset: minusPhraseLibraryQuery_getLibraryMinusKeywordsPacks_rowset[];
  totalCount: number;
}

export interface minusPhraseLibraryQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  /**
   * Получение библиотечных наборов минус-фраз
   */
  getLibraryMinusKeywordsPacks: minusPhraseLibraryQuery_getLibraryMinusKeywordsPacks;
}

export interface minusPhraseLibraryQueryVariables {
  input: GdGetMinusKeywordsPacksInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: minusPhraseLibraryGridQuery
// ====================================================

export interface minusPhraseLibraryGridQuery_getLibraryMinusKeywordsPacks_rowset {
  __typename: "GdGetMinusKeywordsPacksItem";
  id: GraphQlLong;
  linkedAdGroupsCount: GraphQlLong;
  minusKeywords: string[];
  name: string;
}

export interface minusPhraseLibraryGridQuery_getLibraryMinusKeywordsPacks {
  __typename: "GdGetMinusKeywordsPacksPayload";
  cacheKey: string;
  rowset: minusPhraseLibraryGridQuery_getLibraryMinusKeywordsPacks_rowset[];
  totalCount: number;
}

export interface minusPhraseLibraryGridQuery_client_campaigns_rowset {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
}

export interface minusPhraseLibraryGridQuery_client_campaigns {
  __typename: "GdCampaignsContext";
  rowset: minusPhraseLibraryGridQuery_client_campaigns_rowset[];
}

export interface minusPhraseLibraryGridQuery_client {
  __typename: "GdClient";
  campaigns: minusPhraseLibraryGridQuery_client_campaigns;
}

export interface minusPhraseLibraryGridQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  /**
   * Получение библиотечных наборов минус-фраз
   */
  getLibraryMinusKeywordsPacks: minusPhraseLibraryGridQuery_getLibraryMinusKeywordsPacks;
  client: minusPhraseLibraryGridQuery_client;
}

export interface minusPhraseLibraryGridQueryVariables {
  minusPhraseInput: GdGetMinusKeywordsPacksInput;
  login: string;
  campaignInput: GdCampaignsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ClientMobileAppsQuery
// ====================================================

export interface ClientMobileAppsQuery_client_access {
  __typename: "GdClientAccess";
  canViewMobileApps: boolean;
  canEditMobileApps: boolean;
  canEditMobileAppDomain: boolean;
  canViewMobileAppDomain: boolean;
}

export interface ClientMobileAppsQuery_client {
  __typename: "GdClient";
  access: ClientMobileAppsQuery_client_access;
}

export interface ClientMobileAppsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: ClientMobileAppsQuery_client;
}

export interface ClientMobileAppsQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: OrganizationsQuery
// ====================================================

export interface OrganizationsQuery_organizations_address {
  __typename: "GdAddress";
  geoId: number;
  apartment: string | null;
  city: string;
  country: string;
  street: string | null;
  metroStationName: string | null;
  metroStationId: number | null;
  houseWithBuilding: string | null;
}

export interface OrganizationsQuery_organizations_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface OrganizationsQuery_organizations_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface OrganizationsQuery_organizations_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface OrganizationsQuery_organizations_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  endTime: OrganizationsQuery_organizations_workTimes_endTime;
  startTime: OrganizationsQuery_organizations_workTimes_startTime;
}

export interface OrganizationsQuery_organizations {
  __typename: "GdOrganization";
  permalinkId: GraphQlLong;
  address: OrganizationsQuery_organizations_address | null;
  cabinetUrl: string;
  profileUrl: string;
  chainId: GraphQlLong | null;
  companyName: string;
  email: string | null;
  phone: OrganizationsQuery_organizations_phone | null;
  rubric: string | null;
  statusPublish: GdOrganizationStatusPublish;
  urls: string[];
  workTimes: OrganizationsQuery_organizations_workTimes[];
}

export interface OrganizationsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  organizations: (OrganizationsQuery_organizations | null)[];
}

export interface OrganizationsQueryVariables {
  input: GdOrganizationsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PlacementsQuery
// ====================================================

export interface PlacementsQuery_placements_regionDictionary {
  __typename: "GdRegionDesc";
  id: GraphQlLong;
  nameEn: string | null;
  nameRu: string | null;
  nameTr: string | null;
  nameUa: string | null;
}

export interface PlacementsQuery_placements_facilityDictionary {
  __typename: "GdStringDictEntryWithLongKey";
  key: GraphQlLong;
  value: string;
}

export interface PlacementsQuery_placements_zoneDictionary {
  __typename: "GdStringDictEntryWithLongKey";
  key: GraphQlLong;
  value: string;
}

export interface PlacementsQuery_placements_placements {
  __typename: "GdPlacement";
  operatorName: string | null;
  caption: string;
  domain: string;
  id: GraphQlLong;
  isDeleted: boolean;
  isTesting: boolean;
  isYandexPage: boolean;
  login: string;
  type: PlacementType;
}

export interface PlacementsQuery_placements_placementBlocks_GdOutdoorPlacementBlock_sizes {
  __typename: "GdBlockSize";
  height: number | null;
  width: number | null;
}

export interface PlacementsQuery_placements_placementBlocks_GdOutdoorPlacementBlock_photos_formats {
  __typename: "GdPlacementFormat";
  height: number;
  path: string;
  width: number;
}

export interface PlacementsQuery_placements_placementBlocks_GdOutdoorPlacementBlock_photos {
  __typename: "GdPlacementPhoto";
  formats: PlacementsQuery_placements_placementBlocks_GdOutdoorPlacementBlock_photos_formats[];
}

export interface PlacementsQuery_placements_placementBlocks_GdOutdoorPlacementBlock_resolution {
  __typename: "GdBlockSize";
  height: number | null;
  width: number | null;
}

export interface PlacementsQuery_placements_placementBlocks_GdOutdoorPlacementBlock {
  __typename: "GdOutdoorPlacementBlock";
  blockCaption: string | null;
  blockId: GraphQlLong;
  isDeleted: boolean;
  lastChange: GraphQlLocalDateTime;
  pageId: GraphQlLong;
  sizes: PlacementsQuery_placements_placementBlocks_GdOutdoorPlacementBlock_sizes[];
  address: string;
  coordinates: string;
  duration: number;
  direction: number;
  facilityType: number;
  geoId: GraphQlLong | null;
  height: number;
  hidden: boolean | null;
  photos: PlacementsQuery_placements_placementBlocks_GdOutdoorPlacementBlock_photos[] | null;
  resolution: PlacementsQuery_placements_placementBlocks_GdOutdoorPlacementBlock_resolution;
  width: number;
}

export interface PlacementsQuery_placements_placementBlocks_GdIndoorPlacementBlock_sizes {
  __typename: "GdBlockSize";
  height: number | null;
  width: number | null;
}

export interface PlacementsQuery_placements_placementBlocks_GdIndoorPlacementBlock_photos_formats {
  __typename: "GdPlacementFormat";
  height: number;
  path: string;
  width: number;
}

export interface PlacementsQuery_placements_placementBlocks_GdIndoorPlacementBlock_photos {
  __typename: "GdPlacementPhoto";
  formats: PlacementsQuery_placements_placementBlocks_GdIndoorPlacementBlock_photos_formats[];
}

export interface PlacementsQuery_placements_placementBlocks_GdIndoorPlacementBlock_resolution {
  __typename: "GdBlockSize";
  height: number | null;
  width: number | null;
}

export interface PlacementsQuery_placements_placementBlocks_GdIndoorPlacementBlock {
  __typename: "GdIndoorPlacementBlock";
  blockCaption: string | null;
  blockId: GraphQlLong;
  isDeleted: boolean;
  lastChange: GraphQlLocalDateTime;
  pageId: GraphQlLong;
  sizes: PlacementsQuery_placements_placementBlocks_GdIndoorPlacementBlock_sizes[];
  geoId: GraphQlLong | null;
  address: string;
  coordinates: string;
  facilityType: number;
  zoneCategory: number;
  aspectRatio: number[];
  hidden: boolean | null;
  photos: PlacementsQuery_placements_placementBlocks_GdIndoorPlacementBlock_photos[] | null;
  resolution: PlacementsQuery_placements_placementBlocks_GdIndoorPlacementBlock_resolution;
}

export type PlacementsQuery_placements_placementBlocks = PlacementsQuery_placements_placementBlocks_GdOutdoorPlacementBlock | PlacementsQuery_placements_placementBlocks_GdIndoorPlacementBlock;

export interface PlacementsQuery_placements {
  __typename: "GdPlacementContext";
  regionDictionary: PlacementsQuery_placements_regionDictionary[];
  facilityDictionary: PlacementsQuery_placements_facilityDictionary[];
  zoneDictionary: PlacementsQuery_placements_zoneDictionary[];
  placements: PlacementsQuery_placements_placements[];
  placementBlocks: PlacementsQuery_placements_placementBlocks[];
}

export interface PlacementsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  placements: PlacementsQuery_placements;
}

export interface PlacementsQueryVariables {
  input: GdPlacementFilterInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RecommendationsPageQuery
// ====================================================

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithoutKpi {
  __typename: "GdRecommendationSummaryWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  totalCount: number;
  campaignIds: GraphQlLong[];
  keys: RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithoutKpi_keys[];
}

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
}

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export type RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi = RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget;

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_items_rowset {
  __typename: "GdRecommendationItem";
  clicks: GraphQlLong;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
  name: string;
}

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_items {
  __typename: "GdRecommendationItems";
  rowset: RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_items_rowset[];
}

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi {
  __typename: "GdRecommendationSummaryWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  totalCount: number;
  campaignIds: GraphQlLong[];
  keys: RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_keys[];
  kpi: RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi;
  items: RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_items;
}

export type RecommendationsPageQuery_client_recommendationsSummary_rowset = RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithoutKpi | RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi;

export interface RecommendationsPageQuery_client_recommendationsSummary {
  __typename: "GdRecommendationSummaryContext";
  rowset: RecommendationsPageQuery_client_recommendationsSummary_rowset[];
}

export interface RecommendationsPageQuery_client {
  __typename: "GdClient";
  recommendationsSummary: RecommendationsPageQuery_client_recommendationsSummary;
}

export interface RecommendationsPageQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RecommendationsPageQuery_client;
}

export interface RecommendationsPageQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: DailyBudgetRecommendationsGridQuery
// ====================================================

export interface DailyBudgetRecommendationsGridQuery_client_features {
  __typename: "GdClientFeatures";
  enabledRecommendationTypes: GdiRecommendationType[];
}

export interface DailyBudgetRecommendationsGridQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
}

export interface DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_stats {
  __typename: "GdEntityStats";
  clicks: GraphQlLong | null;
  cost: GraphQlBigDecimal | null;
}

export interface DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
}

export interface DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
  recommendedDailyBudget: GraphQlBigDecimal;
  currentDailyBudget: GraphQlBigDecimal;
}

export type DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi = DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget;

export interface DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  kpi: DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi;
  keys: DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_keys[];
}

export type DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations = DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithoutKpi | DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi;

export interface DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_flatStrategy_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_flatStrategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  budget: DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_flatStrategy_budget | null;
}

export interface DailyBudgetRecommendationsGridQuery_client_campaigns_rowset {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  stats: DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_stats;
  recommendations: DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations[] | null;
  flatStrategy: DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_flatStrategy;
  type: GdCampaignType;
  name: string;
  id: GraphQlLong;
  currency: CurrencyCode | null;
}

export interface DailyBudgetRecommendationsGridQuery_client_campaigns {
  __typename: "GdCampaignsContext";
  rowset: DailyBudgetRecommendationsGridQuery_client_campaigns_rowset[];
  totalCount: number;
  campaignIds: GraphQlLong[];
}

export interface DailyBudgetRecommendationsGridQuery_client {
  __typename: "GdClient";
  features: DailyBudgetRecommendationsGridQuery_client_features;
  info: DailyBudgetRecommendationsGridQuery_client_info;
  campaigns: DailyBudgetRecommendationsGridQuery_client_campaigns;
}

export interface DailyBudgetRecommendationsGridQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: DailyBudgetRecommendationsGridQuery_client;
}

export interface DailyBudgetRecommendationsGridQueryVariables {
  login: string;
  campaignInput: GdCampaignsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RemovePagesFromBlackListRecommendationGridQuery
// ====================================================

export interface RemovePagesFromBlackListRecommendationGridQuery_client_features {
  __typename: "GdClientFeatures";
  enabledRecommendationTypes: GdiRecommendationType[];
}

export interface RemovePagesFromBlackListRecommendationGridQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
}

export interface RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiDailyBudget" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives";
}

export interface RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackList {
  __typename: "GdRecommendationKpiRemovePagesFromBlackList";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
  pageName: string;
}

export type RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithKpi_kpi = RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackList;

export interface RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithKpi_keys[];
  kpi: RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithKpi_kpi;
}

export type RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations = RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithoutKpi | RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithKpi;

export interface RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset {
  __typename: "GdPage";
  name: string;
  recommendations: RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations[];
}

export interface RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages {
  __typename: "GdPageContext";
  totalCount: number;
  rowset: RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset[];
}

export interface RemovePagesFromBlackListRecommendationGridQuery_client {
  __typename: "GdClient";
  features: RemovePagesFromBlackListRecommendationGridQuery_client_features;
  info: RemovePagesFromBlackListRecommendationGridQuery_client_info;
  forbiddenPages: RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages;
}

export interface RemovePagesFromBlackListRecommendationGridQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RemovePagesFromBlackListRecommendationGridQuery_client;
}

export interface RemovePagesFromBlackListRecommendationGridQueryVariables {
  login: string;
  offset?: number | null;
  orderBy?: GdPageOrderByInput[] | null;
  count?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SwitchOnAutotargetingRecommendationsGridQuery
// ====================================================

export interface SwitchOnAutotargetingRecommendationsGridQuery_client_features {
  __typename: "GdClientFeatures";
  enabledRecommendationTypes: GdiRecommendationType[];
}

export interface SwitchOnAutotargetingRecommendationsGridQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
}

export interface SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_stats {
  __typename: "GdEntityStats";
  clicks: GraphQlLong | null;
  cost: GraphQlBigDecimal | null;
}

export interface SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiDailyBudget" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
}

export interface SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  kpi: SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi;
  keys: SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_keys[];
}

export type SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations = SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi | SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi;

export interface SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_campaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
}

export interface SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  stats: SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_stats;
  recommendations: SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations[] | null;
  name: string;
  id: GraphQlLong;
  campaign: SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_campaign;
}

export interface SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups {
  __typename: "GdAdGroupsContext";
  rowset: SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset[];
  totalCount: number;
}

export interface SwitchOnAutotargetingRecommendationsGridQuery_client {
  __typename: "GdClient";
  features: SwitchOnAutotargetingRecommendationsGridQuery_client_features;
  info: SwitchOnAutotargetingRecommendationsGridQuery_client_info;
  adGroups: SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups;
}

export interface SwitchOnAutotargetingRecommendationsGridQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: SwitchOnAutotargetingRecommendationsGridQuery_client;
}

export interface SwitchOnAutotargetingRecommendationsGridQueryVariables {
  login: string;
  adGroupInput: GdAdGroupsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RecommendationsGridSummaryQuery
// ====================================================

export interface RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithoutKpi {
  __typename: "GdRecommendationSummaryWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  totalCount: number;
  keys: RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithoutKpi_keys[];
}

export interface RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
}

export interface RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export type RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi = RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget;

export interface RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi {
  __typename: "GdRecommendationSummaryWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  totalCount: number;
  keys: RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_keys[];
  kpi: RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi;
}

export type RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset = RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithoutKpi | RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi;

export interface RecommendationsGridSummaryQuery_client_recommendationsSummary {
  __typename: "GdRecommendationSummaryContext";
  rowset: RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset[];
}

export interface RecommendationsGridSummaryQuery_client {
  __typename: "GdClient";
  recommendationsSummary: RecommendationsGridSummaryQuery_client_recommendationsSummary;
}

export interface RecommendationsGridSummaryQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RecommendationsGridSummaryQuery_client;
}

export interface RecommendationsGridSummaryQueryVariables {
  login: string;
  types?: (GdiRecommendationTypeInput | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RecommendationsStatusesQuery
// ====================================================

export interface RecommendationsStatusesQuery_client_recommendationsStatuses {
  __typename: "GdiRecommendation";
  status: RecommendationStatus | null;
  cid: GraphQlLong | null;
}

export interface RecommendationsStatusesQuery_client {
  __typename: "GdClient";
  recommendationsStatuses: RecommendationsStatusesQuery_client_recommendationsStatuses[];
}

export interface RecommendationsStatusesQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RecommendationsStatusesQuery_client;
}

export interface RecommendationsStatusesQueryVariables {
  login: string;
  keys?: GdRecommendationKeyInput[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CampaignsIdsQuery
// ====================================================

export interface CampaignsIdsQuery_client_campaigns_rowset {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
}

export interface CampaignsIdsQuery_client_campaigns {
  __typename: "GdCampaignsContext";
  rowset: CampaignsIdsQuery_client_campaigns_rowset[];
}

export interface CampaignsIdsQuery_client {
  __typename: "GdClient";
  campaigns: CampaignsIdsQuery_client_campaigns;
}

export interface CampaignsIdsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CampaignsIdsQuery_client;
}

export interface CampaignsIdsQueryVariables {
  login: string;
  campaignInput: GdCampaignsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CampaignRecommendationsQuery
// ====================================================

export interface CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
}

export interface CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
  recommendedDailyBudget: GraphQlBigDecimal;
  currentDailyBudget: GraphQlBigDecimal;
}

export type CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi = CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget;

export interface CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  kpi: CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi;
  keys: CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_keys[];
}

export type CampaignRecommendationsQuery_client_campaigns_rowset_recommendations = CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithoutKpi | CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi;

export interface CampaignRecommendationsQuery_client_campaigns_rowset {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  recommendations: CampaignRecommendationsQuery_client_campaigns_rowset_recommendations[] | null;
}

export interface CampaignRecommendationsQuery_client_campaigns {
  __typename: "GdCampaignsContext";
  rowset: CampaignRecommendationsQuery_client_campaigns_rowset[];
}

export interface CampaignRecommendationsQuery_client {
  __typename: "GdClient";
  campaigns: CampaignRecommendationsQuery_client_campaigns;
}

export interface CampaignRecommendationsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CampaignRecommendationsQuery_client;
}

export interface CampaignRecommendationsQueryVariables {
  login: string;
  campaignId: GraphQlLong;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: offlineReportList
// ====================================================

export interface offlineReportList_offlineReportList_list {
  __typename: "GdOfflineReport";
  reportId: GraphQlLong;
  uid: GraphQlLong;
  args: string;
  scheduledAt: GraphQlLocalDateTime;
  reportState: OfflineReportState;
  reportType: OfflineReportType;
  reportUrl: string | null;
}

export interface offlineReportList_offlineReportList {
  __typename: "GdOfflineReportResult";
  list: offlineReportList_offlineReportList_list[];
}

export interface offlineReportList {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  /**
   * список оффлайн отчётов
   */
  offlineReportList: offlineReportList_offlineReportList;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: offlineReportCreate
// ====================================================

export interface offlineReportCreate_offlineReportCreate {
  __typename: "GdOfflineReport";
  reportId: GraphQlLong;
  uid: GraphQlLong;
  args: string;
  scheduledAt: GraphQlLocalDateTime;
  reportState: OfflineReportState;
  reportType: OfflineReportType;
}

export interface offlineReportCreate {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  /**
   * запросить создание нового оффлайн отчёта
   */
  offlineReportCreate: offlineReportCreate_offlineReportCreate;
}

export interface offlineReportCreateVariables {
  input: GdOfflineReportResultRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RetargetingConditionsQuery
// ====================================================

export interface RetargetingConditionsQuery_client_retargetingConditions_rowset {
  __typename: "GdRetargetingCondition";
  name: string;
  description: string | null;
  retargetingConditionId: GraphQlLong;
}

export interface RetargetingConditionsQuery_client_retargetingConditions {
  __typename: "GdRetargetingConditionContext";
  rowset: RetargetingConditionsQuery_client_retargetingConditions_rowset[];
}

export interface RetargetingConditionsQuery_client {
  __typename: "GdClient";
  retargetingConditions: RetargetingConditionsQuery_client_retargetingConditions;
}

export interface RetargetingConditionsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RetargetingConditionsQuery_client;
}

export interface RetargetingConditionsQueryVariables {
  login: string;
  input: GdRetargetingConditionsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RetargetingGoalsQuery
// ====================================================

export interface RetargetingGoalsQuery_client_goals_rowset {
  __typename: "GdGoal";
  id: GraphQlLong;
  domain: string | null;
  type: GdGoalType;
  name: string;
  counterId: number | null;
  subtype: GoalSubtype | null;
  uploadingSourceId: string | null;
}

export interface RetargetingGoalsQuery_client_goals {
  __typename: "GdGoalsContext";
  rowset: RetargetingGoalsQuery_client_goals_rowset[];
}

export interface RetargetingGoalsQuery_client {
  __typename: "GdClient";
  goals: RetargetingGoalsQuery_client_goals;
}

export interface RetargetingGoalsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RetargetingGoalsQuery_client;
}

export interface RetargetingGoalsQueryVariables {
  login: string;
  input: GdGoalsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RetargetingConditionEstimationQuery
// ====================================================

export interface RetargetingConditionEstimationQuery_estimateRetargetingCondition_validationResult_errors {
  __typename: "GdDefect";
  code: string;
}

export interface RetargetingConditionEstimationQuery_estimateRetargetingCondition_validationResult {
  __typename: "GdValidationResult";
  errors: RetargetingConditionEstimationQuery_estimateRetargetingCondition_validationResult_errors[];
}

export interface RetargetingConditionEstimationQuery_estimateRetargetingCondition {
  __typename: "GdEstimateRetargetingCondition";
  estimation: GraphQlLong | null;
  validationResult: RetargetingConditionEstimationQuery_estimateRetargetingCondition_validationResult | null;
}

export interface RetargetingConditionEstimationQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  estimateRetargetingCondition: RetargetingConditionEstimationQuery_estimateRetargetingCondition;
}

export interface RetargetingConditionEstimationQueryVariables {
  input: GdEstimateRetargetingConditionContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RetargetingConditionsQueryForGroupEdit
// ====================================================

export interface RetargetingConditionsQueryForGroupEdit_client_retargetingConditions_rowset_goalsInfo {
  __typename: "GdRetargetingConditionGoalsInfo";
  goalDomains: string[];
  hasGeoSegments: boolean;
  hasUnavailableGoals: boolean;
}

export interface RetargetingConditionsQueryForGroupEdit_client_retargetingConditions_rowset_campaigns {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
}

export interface RetargetingConditionsQueryForGroupEdit_client_retargetingConditions_rowset_conditionRules_goals {
  __typename: "GdGoal";
  id: GraphQlLong;
  time: number | null;
  type: GdGoalType;
}

export interface RetargetingConditionsQueryForGroupEdit_client_retargetingConditions_rowset_conditionRules {
  __typename: "GdRetargetingConditionRuleItem";
  goals: RetargetingConditionsQueryForGroupEdit_client_retargetingConditions_rowset_conditionRules_goals[];
  type: GdRetargetingConditionRuleType;
}

export interface RetargetingConditionsQueryForGroupEdit_client_retargetingConditions_rowset {
  __typename: "GdRetargetingCondition";
  name: string;
  description: string | null;
  retargetingConditionId: GraphQlLong;
  availableForRetargeting: boolean;
  goalsInfo: RetargetingConditionsQueryForGroupEdit_client_retargetingConditions_rowset_goalsInfo;
  campaigns: RetargetingConditionsQueryForGroupEdit_client_retargetingConditions_rowset_campaigns[];
  conditionRules: RetargetingConditionsQueryForGroupEdit_client_retargetingConditions_rowset_conditionRules[];
}

export interface RetargetingConditionsQueryForGroupEdit_client_retargetingConditions {
  __typename: "GdRetargetingConditionContext";
  rowset: RetargetingConditionsQueryForGroupEdit_client_retargetingConditions_rowset[];
}

export interface RetargetingConditionsQueryForGroupEdit_client {
  __typename: "GdClient";
  chiefLogin: string;
  retargetingConditions: RetargetingConditionsQueryForGroupEdit_client_retargetingConditions;
}

export interface RetargetingConditionsQueryForGroupEdit {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RetargetingConditionsQueryForGroupEdit_client;
}

export interface RetargetingConditionsQueryForGroupEditVariables {
  login: string;
  retargetingConditionsInput: GdRetargetingConditionsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RetargetingConditionsQueryForCampaignsEdit
// ====================================================

export interface RetargetingConditionsQueryForCampaignsEdit_client_retargetingConditions_rowset {
  __typename: "GdRetargetingCondition";
  name: string;
  retargetingConditionId: GraphQlLong;
}

export interface RetargetingConditionsQueryForCampaignsEdit_client_retargetingConditions {
  __typename: "GdRetargetingConditionContext";
  rowset: RetargetingConditionsQueryForCampaignsEdit_client_retargetingConditions_rowset[];
}

export interface RetargetingConditionsQueryForCampaignsEdit_client {
  __typename: "GdClient";
  retargetingConditions: RetargetingConditionsQueryForCampaignsEdit_client_retargetingConditions;
}

export interface RetargetingConditionsQueryForCampaignsEdit {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RetargetingConditionsQueryForCampaignsEdit_client;
}

export interface RetargetingConditionsQueryForCampaignsEditVariables {
  login: string;
  retargetingConditionsInput: GdRetargetingConditionsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RetargetingConditionsQueryForUserProfile
// ====================================================

export interface RetargetingConditionsQueryForUserProfile_client_retargetingConditions_rowset_conditionRules_goals {
  __typename: "GdGoal";
  id: GraphQlLong;
  time: number | null;
  type: GdGoalType;
}

export interface RetargetingConditionsQueryForUserProfile_client_retargetingConditions_rowset_conditionRules {
  __typename: "GdRetargetingConditionRuleItem";
  interestType: CryptaInterestType | null;
  goals: RetargetingConditionsQueryForUserProfile_client_retargetingConditions_rowset_conditionRules_goals[];
  type: GdRetargetingConditionRuleType;
}

export interface RetargetingConditionsQueryForUserProfile_client_retargetingConditions_rowset {
  __typename: "GdRetargetingCondition";
  name: string;
  retargetingConditionId: GraphQlLong;
  adGroupIds: GraphQlLong[];
  conditionRules: RetargetingConditionsQueryForUserProfile_client_retargetingConditions_rowset_conditionRules[];
}

export interface RetargetingConditionsQueryForUserProfile_client_retargetingConditions {
  __typename: "GdRetargetingConditionContext";
  rowset: RetargetingConditionsQueryForUserProfile_client_retargetingConditions_rowset[];
}

export interface RetargetingConditionsQueryForUserProfile_client {
  __typename: "GdClient";
  chiefLogin: string;
  retargetingConditions: RetargetingConditionsQueryForUserProfile_client_retargetingConditions;
}

export interface RetargetingConditionsQueryForUserProfile {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RetargetingConditionsQueryForUserProfile_client;
}

export interface RetargetingConditionsQueryForUserProfileVariables {
  login: string;
  retargetingConditionsInput: GdRetargetingConditionsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CampaignsSuggestQuery
// ====================================================

export interface CampaignsSuggestQuery_client_campaigns_rowset {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  name: string;
}

export interface CampaignsSuggestQuery_client_campaigns {
  __typename: "GdCampaignsContext";
  rowset: CampaignsSuggestQuery_client_campaigns_rowset[];
}

export interface CampaignsSuggestQuery_client {
  __typename: "GdClient";
  campaigns: CampaignsSuggestQuery_client_campaigns;
}

export interface CampaignsSuggestQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CampaignsSuggestQuery_client;
}

export interface CampaignsSuggestQueryVariables {
  login: string;
  campaignInput: GdCampaignsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CampaignsSuggestListQuery
// ====================================================

export interface CampaignsSuggestListQuery_client_campaigns_rowset_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
}

export interface CampaignsSuggestListQuery_client_campaigns_rowset_flatStrategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  isAutoBudget: boolean;
}

export interface CampaignsSuggestListQuery_client_campaigns_rowset {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  name: string;
  id: GraphQlLong;
  type: GdCampaignType;
  access: CampaignsSuggestListQuery_client_campaigns_rowset_access;
  flatStrategy: CampaignsSuggestListQuery_client_campaigns_rowset_flatStrategy;
}

export interface CampaignsSuggestListQuery_client_campaigns {
  __typename: "GdCampaignsContext";
  rowset: CampaignsSuggestListQuery_client_campaigns_rowset[];
}

export interface CampaignsSuggestListQuery_client {
  __typename: "GdClient";
  campaigns: CampaignsSuggestListQuery_client_campaigns;
}

export interface CampaignsSuggestListQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CampaignsSuggestListQuery_client;
}

export interface CampaignsSuggestListQueryVariables {
  login: string;
  campaignInput: GdCampaignsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GroupsSuggestQuery
// ====================================================

export interface GroupsSuggestQuery_client_adGroups_rowset {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  name: string;
}

export interface GroupsSuggestQuery_client_adGroups {
  __typename: "GdAdGroupsContext";
  rowset: GroupsSuggestQuery_client_adGroups_rowset[];
}

export interface GroupsSuggestQuery_client {
  __typename: "GdClient";
  adGroups: GroupsSuggestQuery_client_adGroups;
}

export interface GroupsSuggestQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: GroupsSuggestQuery_client;
}

export interface GroupsSuggestQueryVariables {
  login: string;
  adGroupInput: GdAdGroupsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GroupsSuggestListQuery
// ====================================================

export interface GroupsSuggestListQuery_client_adGroups_rowset_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GroupsSuggestListQuery_client_adGroups_rowset_status {
  __typename: "GdAdGroupStatus";
  primaryStatus: GdAdGroupPrimaryStatus;
}

export interface GroupsSuggestListQuery_client_adGroups_rowset_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsSuggestListQuery_client_adGroups_rowset_campaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  type: GdCampaignType;
}

export interface GroupsSuggestListQuery_client_adGroups_rowset {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  id: GraphQlLong;
  adsCount: number;
  name: string;
  access: GroupsSuggestListQuery_client_adGroups_rowset_access;
  status: GroupsSuggestListQuery_client_adGroups_rowset_status;
  minusKeywords: string[];
  regionsInfo: GroupsSuggestListQuery_client_adGroups_rowset_regionsInfo;
  campaign: GroupsSuggestListQuery_client_adGroups_rowset_campaign;
}

export interface GroupsSuggestListQuery_client_adGroups {
  __typename: "GdAdGroupsContext";
  rowset: GroupsSuggestListQuery_client_adGroups_rowset[];
}

export interface GroupsSuggestListQuery_client {
  __typename: "GdClient";
  adGroups: GroupsSuggestListQuery_client_adGroups;
}

export interface GroupsSuggestListQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: GroupsSuggestListQuery_client;
}

export interface GroupsSuggestListQueryVariables {
  login: string;
  adGroupInput: GdAdGroupsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: BannersSuggestQuery
// ====================================================

export interface BannersSuggestQuery_client_ads_rowset {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  title: string | null;
}

export interface BannersSuggestQuery_client_ads {
  __typename: "GdAdsContext";
  rowset: BannersSuggestQuery_client_ads_rowset[];
  cacheKey: string;
}

export interface BannersSuggestQuery_client {
  __typename: "GdClient";
  ads: BannersSuggestQuery_client_ads;
}

export interface BannersSuggestQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: BannersSuggestQuery_client;
}

export interface BannersSuggestQueryVariables {
  login: string;
  adsInput: GdAdsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PhrasesSuggestQuery
// ====================================================

export interface PhrasesSuggestQuery_client_showConditions_rowset_GdRelevanceMatch {
  __typename: "GdRelevanceMatch";
}

export interface PhrasesSuggestQuery_client_showConditions_rowset_GdKeyword {
  __typename: "GdKeyword";
  keyword: string;
}

export type PhrasesSuggestQuery_client_showConditions_rowset = PhrasesSuggestQuery_client_showConditions_rowset_GdRelevanceMatch | PhrasesSuggestQuery_client_showConditions_rowset_GdKeyword;

export interface PhrasesSuggestQuery_client_showConditions {
  __typename: "GdShowConditionsContext";
  rowset: PhrasesSuggestQuery_client_showConditions_rowset[];
  cacheKey: string;
}

export interface PhrasesSuggestQuery_client {
  __typename: "GdClient";
  showConditions: PhrasesSuggestQuery_client_showConditions;
}

export interface PhrasesSuggestQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: PhrasesSuggestQuery_client;
}

export interface PhrasesSuggestQueryVariables {
  login: string;
  showConditionsInput: GdShowConditionsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RetargetingsSuggestQuery
// ====================================================

export interface RetargetingsSuggestQuery_client_retargetings_rowset_retargetingCondition {
  __typename: "GdRetargetingCondition";
  name: string;
}

export interface RetargetingsSuggestQuery_client_retargetings_rowset {
  __typename: "GdRetargeting";
  retargetingId: GraphQlLong;
  retargetingCondition: RetargetingsSuggestQuery_client_retargetings_rowset_retargetingCondition | null;
}

export interface RetargetingsSuggestQuery_client_retargetings {
  __typename: "GdRetargetingContext";
  rowset: RetargetingsSuggestQuery_client_retargetings_rowset[];
}

export interface RetargetingsSuggestQuery_client {
  __typename: "GdClient";
  retargetings: RetargetingsSuggestQuery_client_retargetings;
}

export interface RetargetingsSuggestQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RetargetingsSuggestQuery_client;
}

export interface RetargetingsSuggestQueryVariables {
  login: string;
  retargetingsInput: GdRetargetingsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FeedFiltersSuggestQuery
// ====================================================

export interface FeedFiltersSuggestQuery_client_smartFilters_rowset {
  __typename: "GdSmartFilter";
  id: GraphQlLong;
  name: string;
}

export interface FeedFiltersSuggestQuery_client_smartFilters {
  __typename: "GdSmartFiltersContext";
  rowset: FeedFiltersSuggestQuery_client_smartFilters_rowset[];
}

export interface FeedFiltersSuggestQuery_client {
  __typename: "GdClient";
  smartFilters: FeedFiltersSuggestQuery_client_smartFilters;
}

export interface FeedFiltersSuggestQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: FeedFiltersSuggestQuery_client;
}

export interface FeedFiltersSuggestQueryVariables {
  login: string;
  smartFiltersInput: GdSmartFiltersContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: TurboRecomendationQuery
// ====================================================

export interface TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  bid: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  keys: TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  bid: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiDailyBudget" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives";
}

export interface TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite";
  pageLoadedTimingAvg: GraphQlBigDecimal;
}

export type TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithKpi_kpi = TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite;

export interface TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  keys: TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithKpi_kpi;
}

export type TurboRecomendationQuery_client_ads_rowset_recommendations = TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithoutKpi | TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithKpi;

export interface TurboRecomendationQuery_client_ads_rowset {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  recommendations: TurboRecomendationQuery_client_ads_rowset_recommendations[] | null;
}

export interface TurboRecomendationQuery_client_ads {
  __typename: "GdAdsContext";
  rowset: TurboRecomendationQuery_client_ads_rowset[];
}

export interface TurboRecomendationQuery_client {
  __typename: "GdClient";
  ads: TurboRecomendationQuery_client_ads;
}

export interface TurboRecomendationQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: TurboRecomendationQuery_client;
}

export interface TurboRecomendationQueryVariables {
  login: string;
  adsInput: GdAdsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SwitchOffLimitPaymentData
// ====================================================

export interface SwitchOffLimitPaymentData_client_autoOverdraftPaymentOptions_paymentMethods {
  __typename: "GdPaymentMethodInfo";
  code: string;
  name: string;
  selected: boolean;
  limit: GraphQlBigDecimal | null;
}

export interface SwitchOffLimitPaymentData_client_autoOverdraftPaymentOptions_personInfo {
  __typename: "GdPersonInfo";
  id: GraphQlLong;
  name: string;
  selected: boolean;
}

export interface SwitchOffLimitPaymentData_client_autoOverdraftPaymentOptions {
  __typename: "GdPersonPaymentMethodInfo";
  paymentMethods: SwitchOffLimitPaymentData_client_autoOverdraftPaymentOptions_paymentMethods[];
  personInfo: SwitchOffLimitPaymentData_client_autoOverdraftPaymentOptions_personInfo;
}

export interface SwitchOffLimitPaymentData_client {
  __typename: "GdClient";
  autoOverdraftPaymentOptions: SwitchOffLimitPaymentData_client_autoOverdraftPaymentOptions[];
}

export interface SwitchOffLimitPaymentData {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: SwitchOffLimitPaymentData_client;
}

export interface SwitchOffLimitPaymentDataVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ValidationError
// ====================================================

export interface ValidationError {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ValidationWarning
// ====================================================

export interface ValidationWarning {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AddAds
// ====================================================

export interface AddAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface AddAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddAds_validationResult {
  __typename: "GdValidationResult";
  errors: AddAds_validationResult_errors[];
  warnings: AddAds_validationResult_warnings[];
}

export interface AddAds {
  __typename: "GdAddAdsPayload";
  addedAds: (AddAds_addedAds | null)[];
  validationResult: AddAds_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AddCpmAds
// ====================================================

export interface AddCpmAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface AddCpmAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddCpmAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddCpmAds_validationResult {
  __typename: "GdValidationResult";
  errors: AddCpmAds_validationResult_errors[];
  warnings: AddCpmAds_validationResult_warnings[];
}

export interface AddCpmAds {
  __typename: "GdAddAdsPayload";
  addedAds: (AddCpmAds_addedAds | null)[];
  validationResult: AddCpmAds_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UpdateCpmAds
// ====================================================

export interface UpdateCpmAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface UpdateCpmAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateCpmAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateCpmAds_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateCpmAds_validationResult_errors[];
  warnings: UpdateCpmAds_validationResult_warnings[];
}

export interface UpdateCpmAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (UpdateCpmAds_updatedAds | null)[];
  validationResult: UpdateCpmAds_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AddMcBannerAds
// ====================================================

export interface AddMcBannerAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface AddMcBannerAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddMcBannerAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddMcBannerAds_validationResult {
  __typename: "GdValidationResult";
  errors: AddMcBannerAds_validationResult_errors[];
  warnings: AddMcBannerAds_validationResult_warnings[];
}

export interface AddMcBannerAds {
  __typename: "GdAddAdsPayload";
  addedAds: (AddMcBannerAds_addedAds | null)[];
  validationResult: AddMcBannerAds_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UpdateMcBannerAds
// ====================================================

export interface UpdateMcBannerAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface UpdateMcBannerAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateMcBannerAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateMcBannerAds_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateMcBannerAds_validationResult_errors[];
  warnings: UpdateMcBannerAds_validationResult_warnings[];
}

export interface UpdateMcBannerAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (UpdateMcBannerAds_updatedAds | null)[];
  validationResult: UpdateMcBannerAds_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AddSmartAds
// ====================================================

export interface AddSmartAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface AddSmartAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddSmartAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddSmartAds_validationResult {
  __typename: "GdValidationResult";
  errors: AddSmartAds_validationResult_errors[];
  warnings: AddSmartAds_validationResult_warnings[];
}

export interface AddSmartAds {
  __typename: "GdAddAdsPayload";
  addedAds: (AddSmartAds_addedAds | null)[];
  validationResult: AddSmartAds_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UpdateSmartAds
// ====================================================

export interface UpdateSmartAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface UpdateSmartAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateSmartAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateSmartAds_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateSmartAds_validationResult_errors[];
  warnings: UpdateSmartAds_validationResult_warnings[];
}

export interface UpdateSmartAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (UpdateSmartAds_updatedAds | null)[];
  validationResult: UpdateSmartAds_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: DeleteAdsWithValidation
// ====================================================

export interface DeleteAdsWithValidation_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface DeleteAdsWithValidation_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface DeleteAdsWithValidation_validationResult {
  __typename: "GdValidationResult";
  errors: DeleteAdsWithValidation_validationResult_errors[];
  warnings: DeleteAdsWithValidation_validationResult_warnings[];
}

export interface DeleteAdsWithValidation {
  __typename: "GdAdsMassActionPayload";
  validationResult: DeleteAdsWithValidation_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UpdateAds
// ====================================================

export interface UpdateAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface UpdateAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateAds_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateAds_validationResult_errors[];
  warnings: UpdateAds_validationResult_warnings[];
}

export interface UpdateAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (UpdateAds_updatedAds | null)[];
  validationResult: UpdateAds_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AddInternalAds
// ====================================================

export interface AddInternalAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface AddInternalAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddInternalAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddInternalAds_validationResult {
  __typename: "GdValidationResult";
  errors: AddInternalAds_validationResult_errors[];
  warnings: AddInternalAds_validationResult_warnings[];
}

export interface AddInternalAds {
  __typename: "GdAddAdsPayload";
  addedAds: (AddInternalAds_addedAds | null)[];
  validationResult: AddInternalAds_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UpdateInternalAds
// ====================================================

export interface UpdateInternalAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface UpdateInternalAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateInternalAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateInternalAds_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateInternalAds_validationResult_errors[];
  warnings: UpdateInternalAds_validationResult_warnings[];
}

export interface UpdateInternalAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (UpdateInternalAds_updatedAds | null)[];
  validationResult: UpdateInternalAds_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ValidationErrorFragment
// ====================================================

export interface ValidationErrorFragment {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ValidationWarningFragment
// ====================================================

export interface ValidationWarningFragment {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: bidModifiersFragment
// ====================================================

export interface bidModifiersFragment_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierAdTypeAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierExpressAdjustment" | "GdBidModifierInventoryAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface bidModifiersFragment_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface bidModifiersFragment_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface bidModifiersFragment_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface bidModifiersFragment_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface bidModifiersFragment_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: bidModifiersFragment_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export type bidModifiersFragment_adjustments = bidModifiersFragment_adjustments_GdBidModifierABSegmentAdjustment | bidModifiersFragment_adjustments_GdBidModifierRetargetingAdjustment | bidModifiersFragment_adjustments_GdBidModifierDemographicsAdjustment | bidModifiersFragment_adjustments_GdBidModifierMobileAdjustment | bidModifiersFragment_adjustments_GdBidModifierWeatherAdjustment;

export interface bidModifiersFragment {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: bidModifiersFragment_adjustments[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: VCardCampaignDataFragment
// ====================================================

export interface VCardCampaignDataFragment_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface VCardCampaignDataFragment_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface VCardCampaignDataFragment_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface VCardCampaignDataFragment_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: VCardCampaignDataFragment_workTimes_startTime;
  endTime: VCardCampaignDataFragment_workTimes_endTime;
}

export interface VCardCampaignDataFragment_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface VCardCampaignDataFragment_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface VCardCampaignDataFragment_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: VCardCampaignDataFragment_address_pointOnMap | null;
}

export interface VCardCampaignDataFragment {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: VCardCampaignDataFragment_instantMessenger | null;
  workTimes: VCardCampaignDataFragment_workTimes[];
  phone: VCardCampaignDataFragment_phone;
  address: VCardCampaignDataFragment_address;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignsNotificationFragment
// ====================================================

export interface campaignsNotificationFragment_emailSettings {
  __typename: "GdCampaignEmailSettings";
  allowedEvents: GdCampaignEmailEvent[];
  checkPositionInterval: GdCampaignCheckPositionInterval | null;
  email: string;
  sendAccountNews: boolean | null;
  stopByReachDailyBudget: boolean | null;
  warningBalance: number | null;
  xlsReady: boolean | null;
}

export interface campaignsNotificationFragment_smsSettings_smsTime_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface campaignsNotificationFragment_smsSettings_smsTime_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface campaignsNotificationFragment_smsSettings_smsTime {
  __typename: "GdTimeInterval";
  endTime: campaignsNotificationFragment_smsSettings_smsTime_endTime;
  startTime: campaignsNotificationFragment_smsSettings_smsTime_startTime;
}

export interface campaignsNotificationFragment_smsSettings_events {
  __typename: "GdCampaignSmsEventInfo";
  checked: boolean;
  event: GdCampaignSmsEvent;
}

export interface campaignsNotificationFragment_smsSettings {
  __typename: "GdCampaignSmsSettings";
  smsTime: campaignsNotificationFragment_smsSettings_smsTime;
  events: campaignsNotificationFragment_smsSettings_events[];
}

export interface campaignsNotificationFragment {
  __typename: "GdCampaignNotification";
  emailSettings: campaignsNotificationFragment_emailSettings;
  smsSettings: campaignsNotificationFragment_smsSettings;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignVerboseStrategyFragment
// ====================================================

export interface campaignVerboseStrategyFragment_GdCampaignStrategyAvgCpaPerCamp_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignVerboseStrategyFragment_GdCampaignStrategyAvgCpaPerCamp {
  __typename: "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignVerboseStrategyFragment_GdCampaignStrategyAvgCpaPerCamp_budget | null;
}

export interface campaignVerboseStrategyFragment_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignVerboseStrategyFragment_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignVerboseStrategyFragment_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface campaignVerboseStrategyFragment_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignVerboseStrategyFragment_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignVerboseStrategyFragment_GdCampaignStrategyAvgClick_budget | null;
  avgBid: GraphQlBigDecimal | null;
}

export interface campaignVerboseStrategyFragment_GdCampaignStrategyAvgCpa_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignVerboseStrategyFragment_GdCampaignStrategyAvgCpa {
  __typename: "GdCampaignStrategyAvgCpa";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignVerboseStrategyFragment_GdCampaignStrategyAvgCpa_budget | null;
  goalId: GraphQlLong | null;
  avgCpa: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
}

export interface campaignVerboseStrategyFragment_GdCampaignStrategyRoi_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignVerboseStrategyFragment_GdCampaignStrategyRoi {
  __typename: "GdCampaignStrategyRoi";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignVerboseStrategyFragment_GdCampaignStrategyRoi_budget | null;
  goalId: GraphQlLong | null;
  profitability: GraphQlBigDecimal | null;
  reserveReturn: GraphQlLong | null;
  roiCoef: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
}

export interface campaignVerboseStrategyFragment_GdCampaignStrategyWeekBudget_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignVerboseStrategyFragment_GdCampaignStrategyWeekBudget {
  __typename: "GdCampaignStrategyWeekBudget";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignVerboseStrategyFragment_GdCampaignStrategyWeekBudget_budget | null;
  bid: GraphQlBigDecimal | null;
  goalId: GraphQlLong | null;
}

export interface campaignVerboseStrategyFragment_GdCampaignStrategyWeekBundle_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignVerboseStrategyFragment_GdCampaignStrategyWeekBundle {
  __typename: "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignVerboseStrategyFragment_GdCampaignStrategyWeekBundle_budget | null;
  avgBid: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
  clicksLimit: GraphQlLong | null;
}

export type campaignVerboseStrategyFragment = campaignVerboseStrategyFragment_GdCampaignStrategyAvgCpaPerCamp | campaignVerboseStrategyFragment_GdCampaignStrategyManual | campaignVerboseStrategyFragment_GdCampaignStrategyAvgClick | campaignVerboseStrategyFragment_GdCampaignStrategyAvgCpa | campaignVerboseStrategyFragment_GdCampaignStrategyRoi | campaignVerboseStrategyFragment_GdCampaignStrategyWeekBudget | campaignVerboseStrategyFragment_GdCampaignStrategyWeekBundle;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignsStatusFragment
// ====================================================

export interface campaignsStatusFragment {
  __typename: "GdCampaignStatus";
  allowDomainMonitoring: boolean;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: TextCampaignFragment
// ====================================================

export interface TextCampaignFragment_meaningfulGoals {
  __typename: "GdMeaningfulGoal";
  goalId: GraphQlLong;
  conversionValue: GraphQlBigDecimal | null;
}

export interface TextCampaignFragment_broadMatch {
  __typename: "GdBroadMatch";
  broadMatchFlag: boolean;
  broadMatchGoalId: GraphQlLong | null;
  broadMatchLimit: number;
}

export interface TextCampaignFragment_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface TextCampaignFragment_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TextCampaignFragment_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TextCampaignFragment_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: TextCampaignFragment_commonVcard_workTimes_startTime;
  endTime: TextCampaignFragment_commonVcard_workTimes_endTime;
}

export interface TextCampaignFragment_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface TextCampaignFragment_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface TextCampaignFragment_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: TextCampaignFragment_commonVcard_address_pointOnMap | null;
}

export interface TextCampaignFragment_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: TextCampaignFragment_commonVcard_instantMessenger | null;
  workTimes: TextCampaignFragment_commonVcard_workTimes[];
  phone: TextCampaignFragment_commonVcard_phone;
  address: TextCampaignFragment_commonVcard_address;
}

export interface TextCampaignFragment {
  __typename: "GdTextCampaign";
  contentLanguage: GdContentLanguage | null;
  disabledPlaces: string[] | null;
  meaningfulGoals: TextCampaignFragment_meaningfulGoals[] | null;
  metrikaCounters: number[] | null;
  hasTitleSubstitution: boolean;
  clientDialogId: GraphQlLong | null;
  hasExtendedGeoTargeting: boolean;
  allowedPageIds: GraphQlLong[] | null;
  hasAddMetrikaTagToUrl: boolean;
  hasAddOpenstatTagToUrl: boolean;
  excludePausedCompetingAds: boolean;
  enableCompanyInfo: boolean;
  broadMatch: TextCampaignFragment_broadMatch;
  commonVcard: TextCampaignFragment_commonVcard | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ConstantsCurrencyQueryFragment
// ====================================================

export interface ConstantsCurrencyQueryFragment {
  __typename: "GdCurrencyDescription";
  code: CurrencyCode;
  minDailyBudget: GraphQlBigDecimal;
  maxDailyBudget: GraphQlBigDecimal;
  bigRate: GraphQlBigDecimal;
  minPrice: GraphQlBigDecimal;
  maxPrice: GraphQlBigDecimal;
  defaultPrice: GraphQlBigDecimal;
  minCpmPrice: GraphQlBigDecimal;
  maxCpmPrice: GraphQlBigDecimal;
  autobudgetAvgCpaWarning: GraphQlBigDecimal;
  autobudgetAvgPriceWarning: GraphQlBigDecimal;
  autobudgetClicksBundleWarning: number;
  autobudgetMaxPriceWarning: GraphQlBigDecimal;
  autobudgetSumWarning: GraphQlBigDecimal;
  maxAutobudget: GraphQlBigDecimal;
  maxAutobudgetBid: GraphQlBigDecimal;
  maxAutobudgetClicksBundle: number;
  minAutobudget: GraphQlBigDecimal;
  minAutobudgetBid: GraphQlBigDecimal;
  minAutobudgetClicksBundle: number;
  minAutobudgetAvgCpa: GraphQlBigDecimal;
  minAutobudgetAvgPrice: GraphQlBigDecimal;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ConstantsQueryFragment
// ====================================================

export interface ConstantsQueryFragment_strategyConstants {
  __typename: "GdStrategyConstants";
  maxDailyBudgetChangesPerDay: number;
}

export interface ConstantsQueryFragment_currencyConstants {
  __typename: "GdCurrencyDescription";
  code: CurrencyCode;
  minDailyBudget: GraphQlBigDecimal;
  maxDailyBudget: GraphQlBigDecimal;
  bigRate: GraphQlBigDecimal;
  minPrice: GraphQlBigDecimal;
  maxPrice: GraphQlBigDecimal;
  defaultPrice: GraphQlBigDecimal;
  minCpmPrice: GraphQlBigDecimal;
  maxCpmPrice: GraphQlBigDecimal;
  autobudgetAvgCpaWarning: GraphQlBigDecimal;
  autobudgetAvgPriceWarning: GraphQlBigDecimal;
  autobudgetClicksBundleWarning: number;
  autobudgetMaxPriceWarning: GraphQlBigDecimal;
  autobudgetSumWarning: GraphQlBigDecimal;
  maxAutobudget: GraphQlBigDecimal;
  maxAutobudgetBid: GraphQlBigDecimal;
  maxAutobudgetClicksBundle: number;
  minAutobudget: GraphQlBigDecimal;
  minAutobudgetBid: GraphQlBigDecimal;
  minAutobudgetClicksBundle: number;
  minAutobudgetAvgCpa: GraphQlBigDecimal;
  minAutobudgetAvgPrice: GraphQlBigDecimal;
}

export interface ConstantsQueryFragment_alertData {
  __typename: "GdAlertData";
  enabled: boolean;
  textRu: string | null;
  textEn: string | null;
}

export interface ConstantsQueryFragment_validation_libMinusKeywordsConstants {
  __typename: "GdDirectConstantsMinusWordsLibValidationData";
  libMinusKeywordsTextMaxLength: number;
  maxLibraryPacksCount: number;
  maxLinkedPacksToOneAdGroup: number;
  maxNameLength: number;
  maxWordsInMinusPhrase: number;
  nameAllowLetters: string;
  textAllowLetters: string;
}

export interface ConstantsQueryFragment_validation_adGroupConstants {
  __typename: "GdDirectConstantsAdGroupValidationData";
  maxAdGroupsCountPerUpdate: number;
}

export interface ConstantsQueryFragment_validation_campaignConstants {
  __typename: "GdDirectConstantsCampaignValidationData";
  minWarningBalanceInPercent: number;
  maxWarningBalanceInPercent: number;
}

export interface ConstantsQueryFragment_validation {
  __typename: "GdDirectConstantsValidationData";
  libMinusKeywordsConstants: ConstantsQueryFragment_validation_libMinusKeywordsConstants;
  adGroupConstants: ConstantsQueryFragment_validation_adGroupConstants;
  campaignConstants: ConstantsQueryFragment_validation_campaignConstants;
}

export interface ConstantsQueryFragment_defaultValues_campaign_defaultSmsTimeInterval_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface ConstantsQueryFragment_defaultValues_campaign_defaultSmsTimeInterval_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface ConstantsQueryFragment_defaultValues_campaign_defaultSmsTimeInterval {
  __typename: "GdTimeInterval";
  endTime: ConstantsQueryFragment_defaultValues_campaign_defaultSmsTimeInterval_endTime;
  startTime: ConstantsQueryFragment_defaultValues_campaign_defaultSmsTimeInterval_startTime;
}

export interface ConstantsQueryFragment_defaultValues_campaign {
  __typename: "GdCampaignDefaultValues";
  defaultWarningBalance: number;
  defaultCheckPositionInterval: GdCampaignCheckPositionInterval;
  defaultSmsTimeInterval: ConstantsQueryFragment_defaultValues_campaign_defaultSmsTimeInterval;
}

export interface ConstantsQueryFragment_defaultValues {
  __typename: "GdDefaultValues";
  campaign: ConstantsQueryFragment_defaultValues_campaign;
}

export interface ConstantsQueryFragment_configuration {
  __typename: "GdConfigurationConstants";
  balanceDomain: string;
  canvasUiDomain: string;
  spravIFrameUrl: string;
}

export interface ConstantsQueryFragment {
  __typename: "GdDirectConstants";
  /**
   * Максимально допустимая конечная дата для заказа агентсткого оффлайн-отчета
   */
  agencyOfflineReportMaximumDate: GraphQlLocalDate;
  strategyConstants: ConstantsQueryFragment_strategyConstants;
  currencyConstants: ConstantsQueryFragment_currencyConstants[];
  alertData: ConstantsQueryFragment_alertData;
  validation: ConstantsQueryFragment_validation;
  defaultValues: ConstantsQueryFragment_defaultValues;
  configuration: ConstantsQueryFragment_configuration;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CampaignContextFragment
// ====================================================

export interface CampaignContextFragment {
  __typename: "GdClientAccess";
  canCreateCampaignTypes: GdCampaignType[];
  canCreateCampaign: boolean;
  canViewInternalAds: boolean;
  canEditInternalAds: boolean;
  canManageLibMinusWords: boolean;
  canManageInternalAdAccessRights: boolean;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FooterQueryUserInfoFragment
// ====================================================

export interface FooterQueryUserInfoFragment {
  __typename: "GdUserInfo";
  name: string;
  login: string;
  email: string;
  phone: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: OperatorFeaturesFragment
// ====================================================

export interface OperatorFeaturesFragment {
  __typename: "GdOperatorFeatures";
  isAdGroupUpdateAllowed: boolean;
  isBannerUpdateAllowed: boolean;
  isCpmBannerUpdateAllowed: boolean;
  isBannerAimingAllowed: boolean;
  isBannerAimingCpmAllowed: boolean;
  isPerformanceAdEditAllowed: boolean;
  isOutdoorGroupsEditAllowed: boolean;
  isIndoorGroupsEditAllowed: boolean;
  isRetargetingGridEnabled: boolean;
  isAdsMassEditAllowed: boolean;
  isCampaignUpdateAllowed: boolean;
  isCpmAdGroupUpdateAllowed: boolean;
  isVideoGroupsEditAllowed: boolean;
  isGeoproductGroupsEditAllowed: boolean;
  isAudioGroupsEditAllowed: boolean;
  isMcBannerDnaEnabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FooterQueryOfficeInfoFragment
// ====================================================

export interface FooterQueryOfficeInfoFragment {
  __typename: "GdOfficeContactData";
  description: string;
  cityName: string | null;
  phone: string;
  phoneExtension: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FooterQueryOperatorFragment
// ====================================================

export interface FooterQueryOperatorFragment_info {
  __typename: "GdUserInfo";
  login: string;
}

export interface FooterQueryOperatorFragment_access {
  __typename: "GdOperatorAccess";
  canEditInternationalization: boolean;
  canSearchPhrasesDuplicates: boolean;
  canEditAdDomain: boolean;
  canViewInternalAdsInSomeClients: boolean;
  actions: GdOperatorAction[];
}

export interface FooterQueryOperatorFragment_officeInfo_cityContact {
  __typename: "GdOfficeContactData";
  description: string;
  cityName: string | null;
  phone: string;
  phoneExtension: string | null;
}

export interface FooterQueryOperatorFragment_officeInfo_regionContact {
  __typename: "GdOfficeContactData";
  description: string;
  cityName: string | null;
  phone: string;
  phoneExtension: string | null;
}

export interface FooterQueryOperatorFragment_officeInfo_regionContact2 {
  __typename: "GdOfficeContactData";
  description: string;
  cityName: string | null;
  phone: string;
  phoneExtension: string | null;
}

export interface FooterQueryOperatorFragment_officeInfo {
  __typename: "GdOfficeInfo";
  cityContact: FooterQueryOperatorFragment_officeInfo_cityContact | null;
  regionContact: FooterQueryOperatorFragment_officeInfo_regionContact | null;
  regionContact2: FooterQueryOperatorFragment_officeInfo_regionContact2 | null;
}

export interface FooterQueryOperatorFragment_managerInfo {
  __typename: "GdUserInfo";
  name: string;
  login: string;
  email: string;
  phone: string | null;
}

export interface FooterQueryOperatorFragment_chiefInfo {
  __typename: "GdUserInfo";
  name: string;
  login: string;
  email: string;
  phone: string | null;
}

export interface FooterQueryOperatorFragment_agencyInfo {
  __typename: "GdUserInfo";
  name: string;
  login: string;
  email: string;
  phone: string | null;
}

export interface FooterQueryOperatorFragment {
  __typename: "GdOperatorInfo";
  tuneSecretKey: string | null;
  workCurrency: CurrencyCode;
  isSelfAgency: boolean;
  isAgency: boolean;
  info: FooterQueryOperatorFragment_info | null;
  access: FooterQueryOperatorFragment_access;
  officeInfo: FooterQueryOperatorFragment_officeInfo;
  managerInfo: FooterQueryOperatorFragment_managerInfo | null;
  chiefInfo: FooterQueryOperatorFragment_chiefInfo | null;
  agencyInfo: FooterQueryOperatorFragment_agencyInfo | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FooterQueryAgencyInfoFragment
// ====================================================

export interface FooterQueryAgencyInfoFragment {
  __typename: "GdAgencyInfo";
  clientId: GraphQlLong | null;
  userId: GraphQlLong | null;
  name: string | null;
  login: string | null;
  email: string | null;
  phone: string | null;
  representativeName: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FooterQueryClientFragment
// ====================================================

export interface FooterQueryClientFragment_info_managersInfo {
  __typename: "GdUserInfo";
  name: string;
  login: string;
  email: string;
  phone: string | null;
}

export interface FooterQueryClientFragment_info_agencyInfo {
  __typename: "GdAgencyInfo";
  clientId: GraphQlLong | null;
  userId: GraphQlLong | null;
  name: string | null;
  login: string | null;
  email: string | null;
  phone: string | null;
  representativeName: string | null;
}

export interface FooterQueryClientFragment_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
  countryRegionId: GraphQlLong;
  translocalGeotreeType: GdGeotreeType;
  autoVideo: boolean;
  managersInfo: FooterQueryClientFragment_info_managersInfo[];
  agencyInfo: FooterQueryClientFragment_info_agencyInfo | null;
}

export interface FooterQueryClientFragment_access {
  __typename: "GdClientAccess";
  canPayByCash: boolean;
  canManageFavoriteCampaigns: boolean;
  canCopyCampaign: boolean;
  canManageUsingCommander: boolean;
  canMonitorPhrasesPositions: boolean;
  canTransferMoney: boolean;
  operatorIsClient: boolean;
  canUploadDocuments: boolean;
  canManageUsingXLS: boolean;
  canManageRetargertingConditions: boolean;
  canManageTurboLandings: boolean;
  canSeeClientRepresentatives: boolean;
  canManageVCards: boolean;
  canViewOfflineReports: boolean;
  canManageUsingApi: boolean;
  canCreateCampaign: boolean;
  canCreateCampaignTypes: GdCampaignType[];
  operatorIsClientChief: boolean;
  canManageCreatives: boolean;
  canManageFeeds: boolean;
  canCheckCampaignsStats: boolean;
  canViewUserLogs: boolean;
  canViewMobileApps: boolean;
  canSeeDealsLinkEverywhere: boolean;
  canSeeAgencyClients: boolean;
}

export interface FooterQueryClientFragment {
  __typename: "GdClient";
  info: FooterQueryClientFragment_info;
  access: FooterQueryClientFragment_access;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: WalletsDataFragment
// ====================================================

export interface WalletsDataFragment_status {
  __typename: "GdWalletStatus";
  enabled: boolean;
}

export interface WalletsDataFragment_budget {
  __typename: "GdWalletBudget";
  sum: GraphQlBigDecimal | null;
  showMode: GdWalletBudgetShowMode | null;
  type: GdWalletBudgetType;
}

export interface WalletsDataFragment {
  __typename: "GdWallet";
  id: GraphQlLong;
  status: WalletsDataFragment_status;
  budget: WalletsDataFragment_budget;
  sum: GraphQlBigDecimal;
  currency: CurrencyCode;
  actions: GdWalletAction[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CryptaSegmentFragment
// ====================================================

export interface CryptaSegmentFragment {
  __typename: "GdCryptaSegment";
  id: GraphQlLong;
  type: WebGoalType;
  name: string;
  parentId: GraphQlLong | null;
  description: string;
  interestType: CryptaInterestTypeWeb | null;
  canSelectAll: boolean | null;
  mutuallyExclusiveIds: GraphQlLong[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: DealRowFragment
// ====================================================

export interface DealRowFragment_placements {
  __typename: "GdiDealPlacement";
  domain: string | null;
  formats: (string | null)[] | null;
}

export interface DealRowFragment {
  __typename: "GdiDeal";
  id: GraphQlLong;
  name: string | null;
  status: StatusDirect;
  completeReason: CompleteReason | null;
  dateStart: GraphQlLocalDateTime | null;
  dateEnd: GraphQlLocalDateTime | null;
  description: string | null;
  expectedMoneyPerWeek: GraphQlLong | null;
  expectedImpressionsPerWeek: GraphQlLong | null;
  dealType: DealType;
  contacts: string | null;
  minPrice: GraphQlBigDecimal | null;
  targetingsText: string | null;
  agencyFeePercent: GraphQlBigDecimal | null;
  currencyCode: string | null;
  publisherName: string | null;
  numberOfLinkedCampaigns: number | null;
  clicks: GraphQlLong | null;
  cpc: GraphQlBigDecimal | null;
  cpm: GraphQlBigDecimal | null;
  ctr: GraphQlBigDecimal | null;
  placements: DealRowFragment_placements[] | null;
  shows: GraphQlLong | null;
  spent: GraphQlBigDecimal | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ClientFeaturesFragment
// ====================================================

export interface ClientFeaturesFragment {
  __typename: "GdClientFeatures";
  isWalletEnabled: boolean;
  hasMetrikaCounters: boolean;
  hasEcommerce: boolean;
  hasCampaignsWithCPAStrategy: boolean;
  enabledRecommendationTypes: GdiRecommendationType[];
  isBannerPricesOnGridEnabled: boolean;
  isInternalAdsAllowed: boolean;
  isCpmCampaignsEnabled: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isTurboForSerpWizardAllowed: boolean;
  isBrandLiftAllowed: boolean;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: GoalStatsGridFragment
// ====================================================

export interface GoalStatsGridFragment {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignBrandSurveyFragment
// ====================================================

export interface campaignBrandSurveyFragment {
  __typename: "GdBrandSurveyStatus";
  surveyStatus: GdSurveyStatus;
  reasonIds: GraphQlLong[];
  brandSurveyStopReasons: GdBrandSurveyStopReason[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PokazometerDataFragment
// ====================================================

export interface PokazometerDataFragment_allCostsAndClicks {
  __typename: "GdPokazometerCostsAndClicksItem";
  clicks: number;
  price: GraphQlBigDecimal;
}

export interface PokazometerDataFragment_priceForCoverage {
  __typename: "GdPokazometerPriceForCoverageItem";
  coverage: number;
  price: GraphQlBigDecimal;
}

export interface PokazometerDataFragment {
  __typename: "GdPokazometerData";
  allCostsAndClicks: PokazometerDataFragment_allCostsAndClicks[];
  priceForCoverage: PokazometerDataFragment_priceForCoverage[];
  maxShows: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignStrategyBudgetFragment
// ====================================================

export interface campaignStrategyBudgetFragment {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignFlatStrategyFragment
// ====================================================

export interface campaignFlatStrategyFragment_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignFlatStrategyFragment_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignFlatStrategyFragment_GdCampaignStrategyAvgClick_budget | null;
}

export interface campaignFlatStrategyFragment_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignFlatStrategyFragment_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignFlatStrategyFragment_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type campaignFlatStrategyFragment = campaignFlatStrategyFragment_GdCampaignStrategyAvgClick | campaignFlatStrategyFragment_GdCampaignStrategyManual;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: recommendationGraphFragment
// ====================================================

export interface recommendationGraphFragment_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface recommendationGraphFragment {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: recommendationGraphFragment_points[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: recommendationKpiFragment
// ====================================================

export interface recommendationKpiFragment_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface recommendationKpiFragment_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: recommendationKpiFragment_graph_points[];
}

export interface recommendationKpiFragment {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiDailyBudget" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: recommendationKpiFragment_graph;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: recommendationFragment
// ====================================================

export interface recommendationFragment_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface recommendationFragment_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: recommendationFragment_GdRecommendationWithoutKpi_keys[];
}

export interface recommendationFragment_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type recommendationFragment_GdRecommendationWithKpi_kpi = recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface recommendationFragment_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: recommendationFragment_GdRecommendationWithKpi_keys[];
  kpi: recommendationFragment_GdRecommendationWithKpi_kpi;
}

export type recommendationFragment = recommendationFragment_GdRecommendationWithoutKpi | recommendationFragment_GdRecommendationWithKpi;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: timeTargetStatusInfoFragment
// ====================================================

export interface timeTargetStatusInfoFragment {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignStatusInfoFragment
// ====================================================

export interface campaignStatusInfoFragment_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface campaignStatusInfoFragment {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: campaignStatusInfoFragment_timeTargetStatus;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: statsDataFragment
// ====================================================

export interface statsDataFragment {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignRowCpmFragment
// ====================================================

export interface campaignRowCpmFragment_brandSurveyStatus {
  __typename: "GdBrandSurveyStatus";
  surveyStatus: GdSurveyStatus;
  reasonIds: GraphQlLong[];
  brandSurveyStopReasons: GdBrandSurveyStopReason[];
}

export interface campaignRowCpmFragment {
  __typename: "GdCpmBannerCampaign";
  brandSurveyId: string | null;
  brandSurveyStatus: campaignRowCpmFragment_brandSurveyStatus | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignsRowFragment
// ====================================================

export interface campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi = campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_keys[];
  kpi: campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi_kpi;
}

export type campaignsRowFragment_GdCpmDealsCampaign_recommendations = campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithoutKpi | campaignsRowFragment_GdCpmDealsCampaign_recommendations_GdRecommendationWithKpi;

export interface campaignsRowFragment_GdCpmDealsCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignsRowFragment_GdCpmDealsCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignsRowFragment_GdCpmDealsCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface campaignsRowFragment_GdCpmDealsCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignsRowFragment_GdCpmDealsCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignsRowFragment_GdCpmDealsCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type campaignsRowFragment_GdCpmDealsCampaign_flatStrategy = campaignsRowFragment_GdCpmDealsCampaign_flatStrategy_GdCampaignStrategyAvgClick | campaignsRowFragment_GdCpmDealsCampaign_flatStrategy_GdCampaignStrategyManual;

export interface campaignsRowFragment_GdCpmDealsCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface campaignsRowFragment_GdCpmDealsCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: campaignsRowFragment_GdCpmDealsCampaign_status_timeTargetStatus;
}

export interface campaignsRowFragment_GdCpmDealsCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface campaignsRowFragment_GdCpmDealsCampaign_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface campaignsRowFragment_GdCpmDealsCampaign_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface campaignsRowFragment_GdCpmDealsCampaign {
  __typename: "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  agencyId: GraphQlLong | null;
  name: string;
  index: number;
  currency: CurrencyCode | null;
  type: GdCampaignType;
  sum: GraphQlBigDecimal | null;
  hasAds: boolean;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  recommendations: campaignsRowFragment_GdCpmDealsCampaign_recommendations[] | null;
  flatStrategy: campaignsRowFragment_GdCpmDealsCampaign_flatStrategy;
  status: campaignsRowFragment_GdCpmDealsCampaign_status;
  access: campaignsRowFragment_GdCpmDealsCampaign_access;
  stats: campaignsRowFragment_GdCpmDealsCampaign_stats;
  goalStats: campaignsRowFragment_GdCpmDealsCampaign_goalStats[] | null;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_brandSurveyStatus {
  __typename: "GdBrandSurveyStatus";
  surveyStatus: GdSurveyStatus;
  reasonIds: GraphQlLong[];
  brandSurveyStopReasons: GdBrandSurveyStopReason[];
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi = campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_keys[];
  kpi: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi;
}

export type campaignsRowFragment_GdCpmBannerCampaign_recommendations = campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithoutKpi | campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi;

export interface campaignsRowFragment_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignsRowFragment_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignsRowFragment_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type campaignsRowFragment_GdCpmBannerCampaign_flatStrategy = campaignsRowFragment_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | campaignsRowFragment_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface campaignsRowFragment_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: campaignsRowFragment_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface campaignsRowFragment_GdCpmBannerCampaign_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface campaignsRowFragment_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign";
  id: GraphQlLong;
  agencyId: GraphQlLong | null;
  name: string;
  index: number;
  currency: CurrencyCode | null;
  brandSurveyId: string | null;
  brandSurveyStatus: campaignsRowFragment_GdCpmBannerCampaign_brandSurveyStatus | null;
  type: GdCampaignType;
  sum: GraphQlBigDecimal | null;
  hasAds: boolean;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  recommendations: campaignsRowFragment_GdCpmBannerCampaign_recommendations[] | null;
  flatStrategy: campaignsRowFragment_GdCpmBannerCampaign_flatStrategy;
  status: campaignsRowFragment_GdCpmBannerCampaign_status;
  access: campaignsRowFragment_GdCpmBannerCampaign_access;
  stats: campaignsRowFragment_GdCpmBannerCampaign_stats;
  goalStats: campaignsRowFragment_GdCpmBannerCampaign_goalStats[] | null;
}

export type campaignsRowFragment = campaignsRowFragment_GdCpmDealsCampaign | campaignsRowFragment_GdCpmBannerCampaign;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignShortRowFragment
// ====================================================

export interface campaignShortRowFragment_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface campaignShortRowFragment_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: campaignShortRowFragment_status_timeTargetStatus;
}

export interface campaignShortRowFragment_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface campaignShortRowFragment_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignShortRowFragment_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignShortRowFragment_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface campaignShortRowFragment_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignShortRowFragment_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignShortRowFragment_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type campaignShortRowFragment_flatStrategy = campaignShortRowFragment_flatStrategy_GdCampaignStrategyAvgClick | campaignShortRowFragment_flatStrategy_GdCampaignStrategyManual;

export interface campaignShortRowFragment {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: campaignShortRowFragment_status;
  access: campaignShortRowFragment_access;
  flatStrategy: campaignShortRowFragment_flatStrategy;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CampaignTruncatedFragment
// ====================================================

export interface CampaignTruncatedFragment_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface CampaignTruncatedFragment_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: CampaignTruncatedFragment_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface CampaignTruncatedFragment_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface CampaignTruncatedFragment_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignTruncatedFragment_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignTruncatedFragment_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface CampaignTruncatedFragment_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignTruncatedFragment_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignTruncatedFragment_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type CampaignTruncatedFragment_GdCpmBannerCampaign_flatStrategy = CampaignTruncatedFragment_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | CampaignTruncatedFragment_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface CampaignTruncatedFragment_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: CampaignTruncatedFragment_GdCpmBannerCampaign_status;
  access: CampaignTruncatedFragment_GdCpmBannerCampaign_access;
  flatStrategy: CampaignTruncatedFragment_GdCpmBannerCampaign_flatStrategy;
}

export interface CampaignTruncatedFragment_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface CampaignTruncatedFragment_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: CampaignTruncatedFragment_GdTextCampaign_status_timeTargetStatus;
}

export interface CampaignTruncatedFragment_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface CampaignTruncatedFragment_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignTruncatedFragment_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignTruncatedFragment_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface CampaignTruncatedFragment_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignTruncatedFragment_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignTruncatedFragment_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type CampaignTruncatedFragment_GdTextCampaign_flatStrategy = CampaignTruncatedFragment_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | CampaignTruncatedFragment_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface CampaignTruncatedFragment_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: CampaignTruncatedFragment_GdTextCampaign_status;
  access: CampaignTruncatedFragment_GdTextCampaign_access;
  flatStrategy: CampaignTruncatedFragment_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface CampaignTruncatedFragment_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface CampaignTruncatedFragment_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: CampaignTruncatedFragment_GdDynamicCampaign_status_timeTargetStatus;
}

export interface CampaignTruncatedFragment_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface CampaignTruncatedFragment_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignTruncatedFragment_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignTruncatedFragment_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface CampaignTruncatedFragment_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignTruncatedFragment_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignTruncatedFragment_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type CampaignTruncatedFragment_GdDynamicCampaign_flatStrategy = CampaignTruncatedFragment_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | CampaignTruncatedFragment_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface CampaignTruncatedFragment_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: CampaignTruncatedFragment_GdDynamicCampaign_status;
  access: CampaignTruncatedFragment_GdDynamicCampaign_access;
  flatStrategy: CampaignTruncatedFragment_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type CampaignTruncatedFragment = CampaignTruncatedFragment_GdCpmBannerCampaign | CampaignTruncatedFragment_GdTextCampaign | CampaignTruncatedFragment_GdDynamicCampaign;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InternalFreeCampaignTruncatedFragment
// ====================================================

export interface InternalFreeCampaignTruncatedFragment_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface InternalFreeCampaignTruncatedFragment_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: InternalFreeCampaignTruncatedFragment_status_timeTargetStatus;
}

export interface InternalFreeCampaignTruncatedFragment_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface InternalFreeCampaignTruncatedFragment_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalFreeCampaignTruncatedFragment_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalFreeCampaignTruncatedFragment_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface InternalFreeCampaignTruncatedFragment_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalFreeCampaignTruncatedFragment_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalFreeCampaignTruncatedFragment_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type InternalFreeCampaignTruncatedFragment_flatStrategy = InternalFreeCampaignTruncatedFragment_flatStrategy_GdCampaignStrategyAvgClick | InternalFreeCampaignTruncatedFragment_flatStrategy_GdCampaignStrategyManual;

export interface InternalFreeCampaignTruncatedFragment {
  __typename: "GdInternalFreeCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  placeId: GraphQlLong;
  status: InternalFreeCampaignTruncatedFragment_status;
  access: InternalFreeCampaignTruncatedFragment_access;
  flatStrategy: InternalFreeCampaignTruncatedFragment_flatStrategy;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InternalDistribCampaignTruncatedFragment
// ====================================================

export interface InternalDistribCampaignTruncatedFragment_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface InternalDistribCampaignTruncatedFragment_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: InternalDistribCampaignTruncatedFragment_status_timeTargetStatus;
}

export interface InternalDistribCampaignTruncatedFragment_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface InternalDistribCampaignTruncatedFragment_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalDistribCampaignTruncatedFragment_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalDistribCampaignTruncatedFragment_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface InternalDistribCampaignTruncatedFragment_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalDistribCampaignTruncatedFragment_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalDistribCampaignTruncatedFragment_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type InternalDistribCampaignTruncatedFragment_flatStrategy = InternalDistribCampaignTruncatedFragment_flatStrategy_GdCampaignStrategyAvgClick | InternalDistribCampaignTruncatedFragment_flatStrategy_GdCampaignStrategyManual;

export interface InternalDistribCampaignTruncatedFragment {
  __typename: "GdInternalDistribCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  placeId: GraphQlLong;
  status: InternalDistribCampaignTruncatedFragment_status;
  access: InternalDistribCampaignTruncatedFragment_access;
  flatStrategy: InternalDistribCampaignTruncatedFragment_flatStrategy;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdGroupInternalTruncatedFragment
// ====================================================

export interface AdGroupInternalTruncatedFragment_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_status_timeTargetStatus;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_flatStrategy = AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyAvgClick | AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyManual;

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign {
  __typename: "GdInternalFreeCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  placeId: GraphQlLong;
  status: AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_status;
  access: AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_access;
  flatStrategy: AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_flatStrategy;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_status_timeTargetStatus;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_flatStrategy = AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyAvgClick | AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyManual;

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign {
  __typename: "GdInternalDistribCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  placeId: GraphQlLong;
  status: AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_status;
  access: AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_access;
  flatStrategy: AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_flatStrategy;
}

export type AdGroupInternalTruncatedFragment_campaign = AdGroupInternalTruncatedFragment_campaign_GdCpmBannerCampaign | AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign | AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign;

export interface AdGroupInternalTruncatedFragment_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface AdGroupInternalTruncatedFragment_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface AdGroupInternalTruncatedFragment_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface AdGroupInternalTruncatedFragment {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  campaign: AdGroupInternalTruncatedFragment_campaign;
  access: AdGroupInternalTruncatedFragment_access;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: AdGroupInternalTruncatedFragment_regionsInfo;
  status: AdGroupInternalTruncatedFragment_status;
  adsCount: number;
  type: GdAdGroupType;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignBaseInfoRowFragment
// ====================================================

export interface campaignBaseInfoRowFragment_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignBaseInfoRowFragment_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignBaseInfoRowFragment_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface campaignBaseInfoRowFragment_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignBaseInfoRowFragment_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignBaseInfoRowFragment_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type campaignBaseInfoRowFragment_flatStrategy = campaignBaseInfoRowFragment_flatStrategy_GdCampaignStrategyAvgClick | campaignBaseInfoRowFragment_flatStrategy_GdCampaignStrategyManual;

export interface campaignBaseInfoRowFragment_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface campaignBaseInfoRowFragment_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: campaignBaseInfoRowFragment_status_timeTargetStatus;
}

export interface campaignBaseInfoRowFragment_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface campaignBaseInfoRowFragment {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  currency: CurrencyCode | null;
  name: string;
  agencyId: GraphQlLong | null;
  type: GdCampaignType;
  flatStrategy: campaignBaseInfoRowFragment_flatStrategy;
  status: campaignBaseInfoRowFragment_status;
  access: campaignBaseInfoRowFragment_access;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: adsGroupRowFragment
// ====================================================

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsGroupRowFragment_GdCpmAudioAdGroup_campaign = adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign | adsGroupRowFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi = adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsGroupRowFragment_GdCpmAudioAdGroup_recommendations = adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithoutKpi | adsGroupRowFragment_GdCpmAudioAdGroup_recommendations_GdRecommendationWithKpi;

export interface adsGroupRowFragment_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canBeDeleted: boolean;
  canEdit: boolean;
  canRemoderateAdsCallouts: boolean;
  canAcceptAdsCalloutsModeration: boolean;
  canBeSentToModeration: boolean;
  canBeSentToModerationByClient: boolean;
  canBeSentToRemoderation: boolean;
  canAcceptModeration: boolean;
  canBeSentToBS: boolean;
  canCopy: boolean;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  bsEverSynced: boolean;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsGroupRowFragment_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdMcBannerAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  name: string;
  type: GdAdGroupType;
  campaignId: GraphQlLong;
  id: GraphQlLong;
  index: number;
  campaign: adsGroupRowFragment_GdCpmAudioAdGroup_campaign;
  recommendations: adsGroupRowFragment_GdCpmAudioAdGroup_recommendations[] | null;
  minusKeywords: string[];
  regionsInfo: adsGroupRowFragment_GdCpmAudioAdGroup_regionsInfo;
  access: adsGroupRowFragment_GdCpmAudioAdGroup_access;
  stats: adsGroupRowFragment_GdCpmAudioAdGroup_stats;
  status: adsGroupRowFragment_GdCpmAudioAdGroup_status;
  goalStats: adsGroupRowFragment_GdCpmAudioAdGroup_goalStats[] | null;
  availableShowConditionTypes: GdShowConditionType[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsGroupRowFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsGroupRowFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsGroupRowFragment_GdDynamicAdGroup_campaign = adsGroupRowFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign | adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi = adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsGroupRowFragment_GdDynamicAdGroup_recommendations = adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithoutKpi | adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi;

export interface adsGroupRowFragment_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canBeDeleted: boolean;
  canEdit: boolean;
  canRemoderateAdsCallouts: boolean;
  canAcceptAdsCalloutsModeration: boolean;
  canBeSentToModeration: boolean;
  canBeSentToModerationByClient: boolean;
  canBeSentToRemoderation: boolean;
  canAcceptModeration: boolean;
  canBeSentToBS: boolean;
  canCopy: boolean;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  bsEverSynced: boolean;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsGroupRowFragment_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  name: string;
  type: GdAdGroupType;
  campaignId: GraphQlLong;
  id: GraphQlLong;
  index: number;
  campaign: adsGroupRowFragment_GdDynamicAdGroup_campaign;
  recommendations: adsGroupRowFragment_GdDynamicAdGroup_recommendations[] | null;
  minusKeywords: string[];
  regionsInfo: adsGroupRowFragment_GdDynamicAdGroup_regionsInfo;
  access: adsGroupRowFragment_GdDynamicAdGroup_access;
  stats: adsGroupRowFragment_GdDynamicAdGroup_stats;
  mainDomain: string | null;
  status: adsGroupRowFragment_GdDynamicAdGroup_status;
  goalStats: adsGroupRowFragment_GdDynamicAdGroup_goalStats[] | null;
  availableShowConditionTypes: GdShowConditionType[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsGroupRowFragment_GdMobileContentAdGroup_campaign = adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign | adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi = adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsGroupRowFragment_GdMobileContentAdGroup_recommendations = adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithoutKpi | adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi;

export interface adsGroupRowFragment_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canBeDeleted: boolean;
  canEdit: boolean;
  canRemoderateAdsCallouts: boolean;
  canAcceptAdsCalloutsModeration: boolean;
  canBeSentToModeration: boolean;
  canBeSentToModerationByClient: boolean;
  canBeSentToRemoderation: boolean;
  canAcceptModeration: boolean;
  canBeSentToBS: boolean;
  canCopy: boolean;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  bsEverSynced: boolean;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  name: string;
  type: GdAdGroupType;
  campaignId: GraphQlLong;
  id: GraphQlLong;
  index: number;
  campaign: adsGroupRowFragment_GdMobileContentAdGroup_campaign;
  recommendations: adsGroupRowFragment_GdMobileContentAdGroup_recommendations[] | null;
  minusKeywords: string[];
  regionsInfo: adsGroupRowFragment_GdMobileContentAdGroup_regionsInfo;
  access: adsGroupRowFragment_GdMobileContentAdGroup_access;
  stats: adsGroupRowFragment_GdMobileContentAdGroup_stats;
  storeHref: string;
  status: adsGroupRowFragment_GdMobileContentAdGroup_status;
  goalStats: adsGroupRowFragment_GdMobileContentAdGroup_goalStats[] | null;
  availableShowConditionTypes: GdShowConditionType[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdInternalAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdInternalAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdInternalAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsGroupRowFragment_GdInternalAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsGroupRowFragment_GdInternalAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdInternalAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdInternalAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsGroupRowFragment_GdInternalAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsGroupRowFragment_GdInternalAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_flatStrategy = adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_status;
  access: adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_status;
  access: adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsGroupRowFragment_GdInternalAdGroup_campaign = adsGroupRowFragment_GdInternalAdGroup_campaign_GdCpmBannerCampaign | adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign | adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign;

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi = adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsGroupRowFragment_GdInternalAdGroup_recommendations = adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithoutKpi | adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi;

export interface adsGroupRowFragment_GdInternalAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_access {
  __typename: "GdAdGroupAccess";
  canBeDeleted: boolean;
  canEdit: boolean;
  canRemoderateAdsCallouts: boolean;
  canAcceptAdsCalloutsModeration: boolean;
  canBeSentToModeration: boolean;
  canBeSentToModerationByClient: boolean;
  canBeSentToRemoderation: boolean;
  canAcceptModeration: boolean;
  canBeSentToBS: boolean;
  canCopy: boolean;
}

export interface adsGroupRowFragment_GdInternalAdGroup_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingInternalNetwork {
  __typename: "GdAdditionalTargetingInternalNetwork";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingIsBrowser {
  __typename: "GdAdditionalTargetingIsBrowser";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingIsTablet {
  __typename: "GdAdditionalTargetingIsTablet";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingIsMobile {
  __typename: "GdAdditionalTargetingIsMobile";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingIsTouch {
  __typename: "GdAdditionalTargetingIsTouch";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingUserAgents {
  __typename: "GdAdditionalTargetingUserAgents";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingOsNames_value {
  __typename: "GdAdditionalTargetingUatraits";
  targetingValueEntryId: GraphQlLong;
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingOsNames {
  __typename: "GdAdditionalTargetingOsNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: adsGroupRowFragment_GdInternalAdGroup_targetingOsNames_value[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingOsFamilies_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingOsFamilies {
  __typename: "GdAdditionalTargetingOsFamilies";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: adsGroupRowFragment_GdInternalAdGroup_targetingOsFamilies_value[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingBrowserNames_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingBrowserNames {
  __typename: "GdAdditionalTargetingBrowserNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: adsGroupRowFragment_GdInternalAdGroup_targetingBrowserNames_value[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingBrowserEngines_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingBrowserEngines {
  __typename: "GdAdditionalTargetingBrowserEngines";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: adsGroupRowFragment_GdInternalAdGroup_targetingBrowserEngines_value[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingDeviceVendors_value {
  __typename: "GdAdditionalTargetingUatraits";
  targetingValueEntryId: GraphQlLong;
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingDeviceVendors {
  __typename: "GdAdditionalTargetingDeviceVendors";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: adsGroupRowFragment_GdInternalAdGroup_targetingDeviceVendors_value[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingDeviceNames {
  __typename: "GdAdditionalTargetingDeviceNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingInterfaceLangs {
  __typename: "GdAdditionalTargetingInterfaceLangs";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: InterfaceLang[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingQueryReferers {
  __typename: "GdAdditionalTargetingQueryReferers";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingYandexUids {
  __typename: "GdAdditionalTargetingYandexUids";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingShowDates {
  __typename: "GdAdditionalTargetingShowDates";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLocalDate[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_status {
  __typename: "GdAdGroupStatus";
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  bsEverSynced: boolean;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsGroupRowFragment_GdInternalAdGroup {
  __typename: "GdInternalAdGroup";
  name: string;
  type: GdAdGroupType;
  campaignId: GraphQlLong;
  id: GraphQlLong;
  index: number;
  campaign: adsGroupRowFragment_GdInternalAdGroup_campaign;
  recommendations: adsGroupRowFragment_GdInternalAdGroup_recommendations[] | null;
  minusKeywords: string[];
  regionsInfo: adsGroupRowFragment_GdInternalAdGroup_regionsInfo;
  access: adsGroupRowFragment_GdInternalAdGroup_access;
  stats: adsGroupRowFragment_GdInternalAdGroup_stats;
  level: GraphQlLong | null;
  targetingInternalNetwork: adsGroupRowFragment_GdInternalAdGroup_targetingInternalNetwork | null;
  targetingIsBrowser: adsGroupRowFragment_GdInternalAdGroup_targetingIsBrowser | null;
  targetingIsTablet: adsGroupRowFragment_GdInternalAdGroup_targetingIsTablet | null;
  targetingIsMobile: adsGroupRowFragment_GdInternalAdGroup_targetingIsMobile | null;
  targetingIsTouch: adsGroupRowFragment_GdInternalAdGroup_targetingIsTouch | null;
  targetingUserAgents: adsGroupRowFragment_GdInternalAdGroup_targetingUserAgents | null;
  targetingOsNames: adsGroupRowFragment_GdInternalAdGroup_targetingOsNames | null;
  targetingOsFamilies: adsGroupRowFragment_GdInternalAdGroup_targetingOsFamilies | null;
  targetingBrowserNames: adsGroupRowFragment_GdInternalAdGroup_targetingBrowserNames | null;
  targetingBrowserEngines: adsGroupRowFragment_GdInternalAdGroup_targetingBrowserEngines | null;
  targetingDeviceVendors: adsGroupRowFragment_GdInternalAdGroup_targetingDeviceVendors | null;
  targetingDeviceNames: adsGroupRowFragment_GdInternalAdGroup_targetingDeviceNames | null;
  targetingInterfaceLangs: adsGroupRowFragment_GdInternalAdGroup_targetingInterfaceLangs | null;
  targetingQueryReferers: adsGroupRowFragment_GdInternalAdGroup_targetingQueryReferers | null;
  targetingYandexUids: adsGroupRowFragment_GdInternalAdGroup_targetingYandexUids | null;
  targetingShowDates: adsGroupRowFragment_GdInternalAdGroup_targetingShowDates | null;
  startTime: GraphQlLocalDateTime | null;
  finishTime: GraphQlLocalDateTime | null;
  status: adsGroupRowFragment_GdInternalAdGroup_status;
  goalStats: adsGroupRowFragment_GdInternalAdGroup_goalStats[] | null;
  availableShowConditionTypes: GdShowConditionType[];
}

export type adsGroupRowFragment = adsGroupRowFragment_GdCpmAudioAdGroup | adsGroupRowFragment_GdDynamicAdGroup | adsGroupRowFragment_GdMobileContentAdGroup | adsGroupRowFragment_GdInternalAdGroup;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: adImageSmartCentersFragment
// ====================================================

export interface adImageSmartCentersFragment {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: adImageFormatsFragment
// ====================================================

export interface adImageFormatsFragment_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adImageFormatsFragment_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adImageFormatsFragment {
  __typename: "GdImageFormat";
  imageSize: adImageFormatsFragment_imageSize;
  path: string;
  smartCenters: adImageFormatsFragment_smartCenters[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: adImageFragment
// ====================================================

export interface adImageFragment_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adImageFragment_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adImageFragment_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adImageFragment_formats {
  __typename: "GdImageFormat";
  imageSize: adImageFragment_formats_imageSize;
  path: string;
  smartCenters: adImageFragment_formats_smartCenters[] | null;
}

export interface adImageFragment {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adImageFragment_imageSize;
  name: string | null;
  imageHash: string;
  formats: adImageFragment_formats[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: adsPhraseRowFragment
// ====================================================

export interface adsPhraseRowFragment_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPhraseRowFragment_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPhraseRowFragment_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPhraseRowFragment_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPhraseRowFragment_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPhraseRowFragment_image_formats_imageSize;
  path: string;
  smartCenters: adsPhraseRowFragment_image_formats_smartCenters[] | null;
}

export interface adsPhraseRowFragment_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPhraseRowFragment_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPhraseRowFragment_image_formats[] | null;
}

export interface adsPhraseRowFragment_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPhraseRowFragment_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPhraseRowFragment_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPhraseRowFragment_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPhraseRowFragment_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPhraseRowFragment_bannerImage_formats_smartCenters[] | null;
}

export interface adsPhraseRowFragment_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPhraseRowFragment_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPhraseRowFragment_bannerImage_formats[] | null;
}

export interface adsPhraseRowFragment_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPhraseRowFragment_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPhraseRowFragment_typedCreative = adsPhraseRowFragment_typedCreative_GdSmartCreative | adsPhraseRowFragment_typedCreative_GdCanvasCreative;

export interface adsPhraseRowFragment_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPhraseRowFragment_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsPhraseRowFragment_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPhraseRowFragment_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPhraseRowFragment_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi = adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsPhraseRowFragment_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsPhraseRowFragment_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsPhraseRowFragment_recommendations = adsPhraseRowFragment_recommendations_GdRecommendationWithoutKpi | adsPhraseRowFragment_recommendations_GdRecommendationWithKpi;

export interface adsPhraseRowFragment_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsPhraseRowFragment_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsPhraseRowFragment {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsPhraseRowFragment_access;
  domain: string | null;
  href: string | null;
  image: adsPhraseRowFragment_image | null;
  bannerImage: adsPhraseRowFragment_bannerImage | null;
  typedCreative: adsPhraseRowFragment_typedCreative | null;
  status: adsPhraseRowFragment_status;
  goalStats: adsPhraseRowFragment_goalStats[] | null;
  recommendations: adsPhraseRowFragment_recommendations[] | null;
  stats: adsPhraseRowFragment_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsPhraseRowFragment_sitelinks[] | null;
  flags: string[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdGroupTruncatedFragment
// ====================================================

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign = AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdTextCampaign | AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_typedCreative = AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations = AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_status;
  goalStats: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface AdGroupTruncatedFragment_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: AdGroupTruncatedFragment_GdCpmAudioAdGroup_campaign;
  access: AdGroupTruncatedFragment_GdCpmAudioAdGroup_access;
  mainAd: AdGroupTruncatedFragment_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: AdGroupTruncatedFragment_GdCpmAudioAdGroup_regionsInfo;
  status: AdGroupTruncatedFragment_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type AdGroupTruncatedFragment_GdDynamicAdGroup_campaign = AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign | AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_typedCreative = AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations = AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_status;
  goalStats: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign;
  mainDomain: string | null;
  access: AdGroupTruncatedFragment_GdDynamicAdGroup_access;
  mainAd: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: AdGroupTruncatedFragment_GdDynamicAdGroup_regionsInfo;
  status: AdGroupTruncatedFragment_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign = AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign | AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_typedCreative = AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations = AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_status;
  goalStats: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign;
  storeHref: string;
  access: AdGroupTruncatedFragment_GdMobileContentAdGroup_access;
  mainAd: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: AdGroupTruncatedFragment_GdMobileContentAdGroup_regionsInfo;
  status: AdGroupTruncatedFragment_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type AdGroupTruncatedFragment_GdSmartAdGroup_campaign = AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdCpmBannerCampaign | AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign | AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface AdGroupTruncatedFragment_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_typedCreative = AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations = AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_image | null;
  bannerImage: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_typedCreative | null;
  status: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_status;
  goalStats: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: AdGroupTruncatedFragment_GdSmartAdGroup_campaign;
  feedId: GraphQlLong;
  access: AdGroupTruncatedFragment_GdSmartAdGroup_access;
  mainAd: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: AdGroupTruncatedFragment_GdSmartAdGroup_regionsInfo;
  status: AdGroupTruncatedFragment_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export type AdGroupTruncatedFragment = AdGroupTruncatedFragment_GdCpmAudioAdGroup | AdGroupTruncatedFragment_GdDynamicAdGroup | AdGroupTruncatedFragment_GdMobileContentAdGroup | AdGroupTruncatedFragment_GdSmartAdGroup;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: adsRowFragment
// ====================================================

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign = adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_access;
  mainAd: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign = adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative = adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations = adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access;
  mainAd: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign = adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations = adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign = adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative = adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations = adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_access;
  mainAd: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type adsRowFragment_GdCPCVideoAd_adGroup = adsRowFragment_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup;

export interface adsRowFragment_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdHtml5Creative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPCVideoAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface adsRowFragment_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: adsRowFragment_GdCPCVideoAd_typedCreative_GdSmartCreative_layout | null;
}

export interface adsRowFragment_GdCPCVideoAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdCPCVideoAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdCPCVideoAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdCPCVideoAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface adsRowFragment_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdCPCVideoAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_typedCreative = adsRowFragment_GdCPCVideoAd_typedCreative_GdCpmGeoproductCreative | adsRowFragment_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPCVideoAd_typedCreative_GdCpcVideoCreative | adsRowFragment_GdCPCVideoAd_typedCreative_GdVideoAdditionCreative | adsRowFragment_GdCPCVideoAd_typedCreative_GdCpmVideoCreative | adsRowFragment_GdCPCVideoAd_typedCreative_GdCpmAudioCreative | adsRowFragment_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative | adsRowFragment_GdCPCVideoAd_typedCreative_GdCpmIndoorCreative | adsRowFragment_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
  placementPagesRequired: boolean;
  hasInactiveResources: (GdAdResources | null)[];
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPCVideoAd_recommendations = adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragment_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  isAimingAllowed: boolean;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: adsRowFragment_GdCPCVideoAd_adGroup;
  body: string | null;
  access: adsRowFragment_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragment_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragment_GdCPCVideoAd_status;
  recommendations: adsRowFragment_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragment_GdCPCVideoAd_stats;
  goalStats: adsRowFragment_GdCPCVideoAd_goalStats[] | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign = adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign;
  access: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_access;
  mainAd: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign = adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative = adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations = adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign;
  access: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_access;
  mainAd: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign = adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations = adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign;
  access: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign = adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative = adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations = adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign;
  access: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_access;
  mainAd: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type adsRowFragment_GdTextAd_adGroup = adsRowFragment_GdTextAd_adGroup_GdCpmAudioAdGroup | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup;

export interface adsRowFragment_GdTextAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdTextAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_image_formats[] | null;
}

export interface adsRowFragment_GdTextAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdTextAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdHtml5Creative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdTextAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface adsRowFragment_GdTextAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: adsRowFragment_GdTextAd_typedCreative_GdSmartCreative_layout | null;
}

export interface adsRowFragment_GdTextAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdTextAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdTextAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdTextAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface adsRowFragment_GdTextAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdTextAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdTextAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdTextAd_typedCreative = adsRowFragment_GdTextAd_typedCreative_GdCpmGeoproductCreative | adsRowFragment_GdTextAd_typedCreative_GdSmartCreative | adsRowFragment_GdTextAd_typedCreative_GdCpcVideoCreative | adsRowFragment_GdTextAd_typedCreative_GdVideoAdditionCreative | adsRowFragment_GdTextAd_typedCreative_GdCpmVideoCreative | adsRowFragment_GdTextAd_typedCreative_GdCpmAudioCreative | adsRowFragment_GdTextAd_typedCreative_GdCpmOutdoorCreative | adsRowFragment_GdTextAd_typedCreative_GdCpmIndoorCreative | adsRowFragment_GdTextAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdTextAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
  placementPagesRequired: boolean;
  hasInactiveResources: (GdAdResources | null)[];
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdTextAd_recommendations = adsRowFragment_GdTextAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdTextAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdTextAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdTextAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragment_GdTextAd_bannerPrice {
  __typename: "GdAdPrice";
  currency: GdAdPriceCurrency | null;
  prefix: GdAdPricePrefix | null;
  price: string | null;
  priceOld: string | null;
}

export interface adsRowFragment_GdTextAd {
  __typename: "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  isAimingAllowed: boolean;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: adsRowFragment_GdTextAd_adGroup;
  body: string | null;
  access: adsRowFragment_GdTextAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdTextAd_image | null;
  bannerImage: adsRowFragment_GdTextAd_bannerImage | null;
  typedCreative: adsRowFragment_GdTextAd_typedCreative | null;
  status: adsRowFragment_GdTextAd_status;
  recommendations: adsRowFragment_GdTextAd_recommendations[] | null;
  stats: adsRowFragment_GdTextAd_stats;
  goalStats: adsRowFragment_GdTextAd_goalStats[] | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdTextAd_sitelinks[] | null;
  flags: string[] | null;
  turboGalleryHref: string | null;
  bannerPrice: adsRowFragment_GdTextAd_bannerPrice | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign = adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_campaign;
  access: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_access;
  mainAd: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign = adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative = adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations = adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign;
  access: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_access;
  mainAd: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign = adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations = adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign;
  access: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign = adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_typedCreative = adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations = adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign;
  access: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_access;
  mainAd: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type adsRowFragment_GdInternalAd_adGroup = adsRowFragment_GdInternalAd_adGroup_GdCpmAudioAdGroup | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup;

export interface adsRowFragment_GdInternalAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdInternalAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_image_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdHtml5Creative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdInternalAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface adsRowFragment_GdInternalAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: adsRowFragment_GdInternalAd_typedCreative_GdSmartCreative_layout | null;
}

export interface adsRowFragment_GdInternalAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdInternalAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdInternalAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdInternalAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface adsRowFragment_GdInternalAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdInternalAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdInternalAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdInternalAd_typedCreative = adsRowFragment_GdInternalAd_typedCreative_GdCpmGeoproductCreative | adsRowFragment_GdInternalAd_typedCreative_GdSmartCreative | adsRowFragment_GdInternalAd_typedCreative_GdCpcVideoCreative | adsRowFragment_GdInternalAd_typedCreative_GdVideoAdditionCreative | adsRowFragment_GdInternalAd_typedCreative_GdCpmVideoCreative | adsRowFragment_GdInternalAd_typedCreative_GdCpmAudioCreative | adsRowFragment_GdInternalAd_typedCreative_GdCpmOutdoorCreative | adsRowFragment_GdInternalAd_typedCreative_GdCpmIndoorCreative | adsRowFragment_GdInternalAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdInternalAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
  placementPagesRequired: boolean;
  hasInactiveResources: (GdAdResources | null)[];
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdInternalAd_recommendations = adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdInternalAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdInternalAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdInternalAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragment_GdInternalAd {
  __typename: "GdInternalAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  isAimingAllowed: boolean;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: adsRowFragment_GdInternalAd_adGroup;
  body: string | null;
  access: adsRowFragment_GdInternalAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdInternalAd_image | null;
  bannerImage: adsRowFragment_GdInternalAd_bannerImage | null;
  typedCreative: adsRowFragment_GdInternalAd_typedCreative | null;
  status: adsRowFragment_GdInternalAd_status;
  recommendations: adsRowFragment_GdInternalAd_recommendations[] | null;
  stats: adsRowFragment_GdInternalAd_stats;
  goalStats: adsRowFragment_GdInternalAd_goalStats[] | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdInternalAd_sitelinks[] | null;
  flags: string[] | null;
  description: string | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_access;
  mainAd: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_access;
  mainAd: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_access;
  mainAd: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup;

export interface adsRowFragment_GdCPMOutdoorBannerAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdHtml5Creative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative_layout | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_typedCreative = adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpmGeoproductCreative | adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpcVideoCreative | adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdVideoAdditionCreative | adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpmVideoCreative | adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpmAudioCreative | adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative | adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpmIndoorCreative | adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPMOutdoorBannerAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
  placementPagesRequired: boolean;
  hasInactiveResources: (GdAdResources | null)[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_recommendations = adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPMOutdoorBannerAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_placementPages {
  __typename: "GdPlacementPageModerationResult";
  bannerId: GraphQlLong;
  comment: string | null;
  createTime: GraphQlLocalDateTime;
  id: GraphQlLong;
  pageId: GraphQlLong;
  statusModerate: StatusModerateBannerPage;
  version: GraphQlLong;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd {
  __typename: "GdCPMOutdoorBannerAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  isAimingAllowed: boolean;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: adsRowFragment_GdCPMOutdoorBannerAd_adGroup;
  body: string | null;
  access: adsRowFragment_GdCPMOutdoorBannerAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPMOutdoorBannerAd_image | null;
  bannerImage: adsRowFragment_GdCPMOutdoorBannerAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPMOutdoorBannerAd_typedCreative | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_status;
  recommendations: adsRowFragment_GdCPMOutdoorBannerAd_recommendations[] | null;
  stats: adsRowFragment_GdCPMOutdoorBannerAd_stats;
  goalStats: adsRowFragment_GdCPMOutdoorBannerAd_goalStats[] | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPMOutdoorBannerAd_sitelinks[] | null;
  flags: string[] | null;
  placementPages: adsRowFragment_GdCPMOutdoorBannerAd_placementPages[];
}

export type adsRowFragment = adsRowFragment_GdCPCVideoAd | adsRowFragment_GdTextAd | adsRowFragment_GdInternalAd | adsRowFragment_GdCPMOutdoorBannerAd;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: showConditionsRowFragment
// ====================================================

export interface showConditionsRowFragment_GdKeyword_status {
  __typename: "GdShowConditionStatus";
  suspended: boolean;
  primaryStatus: GdShowConditionPrimaryStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign = showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_access;
  mainAd: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign = showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative = showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations = showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_access;
  mainAd: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_regionsInfo;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign = showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations = showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_access;
  mainAd: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign = showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative = showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations = showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_access;
  mainAd: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_regionsInfo;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type showConditionsRowFragment_GdKeyword_adGroup = showConditionsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup;

export interface showConditionsRowFragment_GdKeyword_access {
  __typename: "GdShowConditionAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_mainAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_mainAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_mainAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_mainAd_typedCreative = showConditionsRowFragment_GdKeyword_mainAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdKeyword_mainAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdKeyword_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdKeyword_mainAd_recommendations = showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdKeyword_mainAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdKeyword_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface showConditionsRowFragment_GdKeyword_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdKeyword_mainAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdKeyword_mainAd_image | null;
  bannerImage: showConditionsRowFragment_GdKeyword_mainAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdKeyword_mainAd_typedCreative | null;
  status: showConditionsRowFragment_GdKeyword_mainAd_status;
  goalStats: showConditionsRowFragment_GdKeyword_mainAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdKeyword_mainAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdKeyword_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdKeyword_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface showConditionsRowFragment_GdKeyword_pokazometerData_allCostsAndClicks {
  __typename: "GdPokazometerCostsAndClicksItem";
  clicks: number;
  price: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_pokazometerData_priceForCoverage {
  __typename: "GdPokazometerPriceForCoverageItem";
  coverage: number;
  price: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_pokazometerData {
  __typename: "GdPokazometerData";
  allCostsAndClicks: showConditionsRowFragment_GdKeyword_pokazometerData_allCostsAndClicks[];
  priceForCoverage: showConditionsRowFragment_GdKeyword_pokazometerData_priceForCoverage[];
  maxShows: number | null;
}

export interface showConditionsRowFragment_GdKeyword_auctionData_auctionDataItems {
  __typename: "GdAuctionDataItem";
  bid: GraphQlBigDecimal;
  amnestyPrice: GraphQlBigDecimal;
  trafficVolume: GraphQlLong;
  showInTable: boolean | null;
}

export interface showConditionsRowFragment_GdKeyword_auctionData {
  __typename: "GdAuctionData";
  auctionDataItems: showConditionsRowFragment_GdKeyword_auctionData_auctionDataItems[];
}

export interface showConditionsRowFragment_GdKeyword_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdKeyword_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdKeyword {
  __typename: "GdKeyword";
  id: GraphQlLong;
  status: showConditionsRowFragment_GdKeyword_status;
  adGroup: showConditionsRowFragment_GdKeyword_adGroup;
  access: showConditionsRowFragment_GdKeyword_access;
  adsInAdGroupCount: number;
  mainAd: showConditionsRowFragment_GdKeyword_mainAd | null;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  index: number;
  type: GdShowConditionType;
  priceContext: GraphQlBigDecimal | null;
  weightedCtr: GraphQlBigDecimal;
  autobudgetPriority: GdShowConditionAutobudgetPriority | null;
  showsForecast: GraphQlLong | null;
  price: GraphQlBigDecimal | null;
  usePhraseTrafaretAuction: boolean;
  minusKeywords: string[];
  pokazometerData: showConditionsRowFragment_GdKeyword_pokazometerData | null;
  keyword: string;
  auctionData: showConditionsRowFragment_GdKeyword_auctionData | null;
  stats: showConditionsRowFragment_GdKeyword_stats;
  goalStats: showConditionsRowFragment_GdKeyword_goalStats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_status {
  __typename: "GdShowConditionStatus";
  suspended: boolean;
  primaryStatus: GdShowConditionPrimaryStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_access;
  mainAd: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_access;
  mainAd: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_regionsInfo;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_access;
  mainAd: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_access;
  mainAd: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_regionsInfo;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup;

export interface showConditionsRowFragment_GdRelevanceMatch_access {
  __typename: "GdShowConditionAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_mainAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_mainAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_mainAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_mainAd_typedCreative = showConditionsRowFragment_GdRelevanceMatch_mainAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdRelevanceMatch_mainAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations = showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdRelevanceMatch_mainAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdRelevanceMatch_mainAd_image | null;
  bannerImage: showConditionsRowFragment_GdRelevanceMatch_mainAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdRelevanceMatch_mainAd_typedCreative | null;
  status: showConditionsRowFragment_GdRelevanceMatch_mainAd_status;
  goalStats: showConditionsRowFragment_GdRelevanceMatch_mainAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdRelevanceMatch_mainAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdRelevanceMatch_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdRelevanceMatch_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdRelevanceMatch {
  __typename: "GdRelevanceMatch";
  id: GraphQlLong;
  status: showConditionsRowFragment_GdRelevanceMatch_status;
  adGroup: showConditionsRowFragment_GdRelevanceMatch_adGroup;
  access: showConditionsRowFragment_GdRelevanceMatch_access;
  adsInAdGroupCount: number;
  mainAd: showConditionsRowFragment_GdRelevanceMatch_mainAd | null;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  index: number;
  type: GdShowConditionType;
  autobudgetPriority: GdShowConditionAutobudgetPriority | null;
  price: GraphQlBigDecimal | null;
  priceContext: GraphQlBigDecimal | null;
  stats: showConditionsRowFragment_GdRelevanceMatch_stats;
  goalStats: showConditionsRowFragment_GdRelevanceMatch_goalStats[] | null;
}

export type showConditionsRowFragment = showConditionsRowFragment_GdKeyword | showConditionsRowFragment_GdRelevanceMatch;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: autotargetingsRowFragment
// ====================================================

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign = autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_campaign;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_access;
  mainAd: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign = autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative = autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations = autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_access;
  mainAd: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_regionsInfo;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign = autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations = autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_access;
  mainAd: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign = autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative = autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations = autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_access;
  mainAd: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_regionsInfo;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type autotargetingsRowFragment_GdKeyword_adGroup = autotargetingsRowFragment_GdKeyword_adGroup_GdCpmAudioAdGroup | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup;

export interface autotargetingsRowFragment_GdKeyword_status {
  __typename: "GdShowConditionStatus";
  primaryStatus: GdShowConditionPrimaryStatus;
  deleted: boolean;
  suspended: boolean;
  statusModerate: GdShowConditionStatusModerate;
}

export interface autotargetingsRowFragment_GdKeyword_access {
  __typename: "GdShowConditionAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdKeyword {
  __typename: "GdKeyword";
  id: GraphQlLong;
  adGroupId: GraphQlLong;
  adGroup: autotargetingsRowFragment_GdKeyword_adGroup;
  status: autotargetingsRowFragment_GdKeyword_status;
  access: autotargetingsRowFragment_GdKeyword_access;
  stats: autotargetingsRowFragment_GdKeyword_stats;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_campaign;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_access;
  mainAd: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_access;
  mainAd: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_regionsInfo;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_access;
  mainAd: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_access;
  mainAd: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_regionsInfo;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdCpmAudioAdGroup | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup;

export interface autotargetingsRowFragment_GdRelevanceMatch_status {
  __typename: "GdShowConditionStatus";
  primaryStatus: GdShowConditionPrimaryStatus;
  deleted: boolean;
  suspended: boolean;
  statusModerate: GdShowConditionStatusModerate;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_access {
  __typename: "GdShowConditionAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch {
  __typename: "GdRelevanceMatch";
  id: GraphQlLong;
  adGroupId: GraphQlLong;
  price: GraphQlBigDecimal | null;
  autobudgetPriority: GdShowConditionAutobudgetPriority | null;
  adGroup: autotargetingsRowFragment_GdRelevanceMatch_adGroup;
  status: autotargetingsRowFragment_GdRelevanceMatch_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_access;
  stats: autotargetingsRowFragment_GdRelevanceMatch_stats;
}

export type autotargetingsRowFragment = autotargetingsRowFragment_GdKeyword | autotargetingsRowFragment_GdRelevanceMatch;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: retargetingsRowFragment
// ====================================================

export interface retargetingsRowFragment_access {
  __typename: "GdRetargetingAccess";
  canEdit: boolean;
}

export interface retargetingsRowFragment_retargetingCondition_conditionRules_goals {
  __typename: "GdGoal";
  id: GraphQlLong;
  type: GdGoalType;
  time: number | null;
}

export interface retargetingsRowFragment_retargetingCondition_conditionRules {
  __typename: "GdRetargetingConditionRuleItem";
  type: GdRetargetingConditionRuleType;
  interestType: CryptaInterestType | null;
  goals: retargetingsRowFragment_retargetingCondition_conditionRules_goals[];
}

export interface retargetingsRowFragment_retargetingCondition {
  __typename: "GdRetargetingCondition";
  name: string;
  description: string | null;
  conditionRules: retargetingsRowFragment_retargetingCondition_conditionRules[];
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign = retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface retargetingsRowFragment_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_campaign;
  access: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_access;
  mainAd: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: retargetingsRowFragment_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign = retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_typedCreative = retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations = retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign;
  access: retargetingsRowFragment_adGroup_GdDynamicAdGroup_access;
  mainAd: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: retargetingsRowFragment_adGroup_GdDynamicAdGroup_regionsInfo;
  status: retargetingsRowFragment_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign = retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations = retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign;
  access: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_access;
  mainAd: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign = retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_typedCreative = retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations = retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign;
  access: retargetingsRowFragment_adGroup_GdSmartAdGroup_access;
  mainAd: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: retargetingsRowFragment_adGroup_GdSmartAdGroup_regionsInfo;
  status: retargetingsRowFragment_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type retargetingsRowFragment_adGroup = retargetingsRowFragment_adGroup_GdCpmAudioAdGroup | retargetingsRowFragment_adGroup_GdDynamicAdGroup | retargetingsRowFragment_adGroup_GdMobileContentAdGroup | retargetingsRowFragment_adGroup_GdSmartAdGroup;

export interface retargetingsRowFragment_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface retargetingsRowFragment {
  __typename: "GdRetargeting";
  access: retargetingsRowFragment_access;
  retargetingId: GraphQlLong;
  isSuspended: boolean;
  priceContext: GraphQlBigDecimal;
  retargetingCondition: retargetingsRowFragment_retargetingCondition | null;
  adGroup: retargetingsRowFragment_adGroup;
  stats: retargetingsRowFragment_stats;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: adsPreviewRowFragment
// ====================================================

export interface adsPreviewRowFragment_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign = adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_campaign;
  access: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_access;
  mainAd: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign = adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_typedCreative = adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations = adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsPreviewRowFragment_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_campaign;
  access: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_access;
  mainAd: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_regionsInfo;
  status: adsPreviewRowFragment_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign = adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations = adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsPreviewRowFragment_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_campaign;
  access: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_access;
  mainAd: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: adsPreviewRowFragment_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign = adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_typedCreative = adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations = adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsPreviewRowFragment_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: adsPreviewRowFragment_adGroup_GdSmartAdGroup_campaign;
  access: adsPreviewRowFragment_adGroup_GdSmartAdGroup_access;
  mainAd: adsPreviewRowFragment_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsPreviewRowFragment_adGroup_GdSmartAdGroup_regionsInfo;
  status: adsPreviewRowFragment_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type adsPreviewRowFragment_adGroup = adsPreviewRowFragment_adGroup_GdCpmAudioAdGroup | adsPreviewRowFragment_adGroup_GdDynamicAdGroup | adsPreviewRowFragment_adGroup_GdMobileContentAdGroup | adsPreviewRowFragment_adGroup_GdSmartAdGroup;

export interface adsPreviewRowFragment_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_image_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_image_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_image_formats[] | null;
}

export interface adsPreviewRowFragment_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_bannerImage_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_bannerImage_formats[] | null;
}

export interface adsPreviewRowFragment_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPreviewRowFragment_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPreviewRowFragment_typedCreative = adsPreviewRowFragment_typedCreative_GdSmartCreative | adsPreviewRowFragment_typedCreative_GdCanvasCreative;

export interface adsPreviewRowFragment_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsPreviewRowFragment {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  domain: string | null;
  dynamicDisclaimer: string | null;
  linkTail: string | null;
  type: GdAdType;
  href: string | null;
  access: adsPreviewRowFragment_access;
  status: adsPreviewRowFragment_status;
  adGroup: adsPreviewRowFragment_adGroup;
  image: adsPreviewRowFragment_image | null;
  bannerImage: adsPreviewRowFragment_bannerImage | null;
  typedCreative: adsPreviewRowFragment_typedCreative | null;
  sitelinks: adsPreviewRowFragment_sitelinks[] | null;
  flags: string[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: adConstantsFragment
// ====================================================

export interface adConstantsFragment {
  __typename: "GdDirectConstantsAdValidationData";
  maxLengthTitle: number;
  maxLengthTitleWord: number;
  maxLengthTitleExtension: number;
  maxLengthBody: number;
  maxLengthBodyWord: number;
  narrowSymbols: string;
  maxNumberOfNarrowCharacters: number;
  allowAdLetters: string;
  maxLengthHref: number;
  maxLengthTurboGalleryHref: number;
  maxLengthDisplayHref: number;
  allowAdDisplayHrefLetters: string;
  aggregationDomains: string[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: vcardConstantsFragment
// ====================================================

export interface vcardConstantsFragment {
  __typename: "GdDirectConstantsVcardValidationData";
  companyNameMaxLength: number;
  contactPersonMaxLength: number;
  contactEmailMaxLength: number;
  extraMessageMaxLength: number;
  countryMaxLength: number;
  cityMaxLength: number;
  streetMaxLength: number;
  houseWithBuildingMaxLength: number;
  apartmentMaxLength: number;
  instantMessengerLoginMaxLength: number;
  pointOnMapLongitudeMin: GraphQlBigDecimal;
  pointOnMapLongitudeMax: GraphQlBigDecimal;
  pointOnMapLatitudeMin: GraphQlBigDecimal;
  pointOnMapLatitudeMax: GraphQlBigDecimal;
  countryCodeMaxLength: number;
  cityCodeMaxLength: number;
  phoneNumberMinLength: number;
  phoneNumberMaxLength: number;
  extensionMaxLength: number;
  entirePhoneMinLength: number;
  entirePhoneMaxLength: number;
  entirePhoneWithExtensionMaxLength: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: calloutsConstantsFragment
// ====================================================

export interface calloutsConstantsFragment {
  __typename: "GdDirectConstantsCalloutValidationData";
  calloutLettersAllowed: string;
  calloutTextMaxLength: number;
  calloutsOnClientMaxCount: number;
  calloutsOnClientMaxCountWithDeleted: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: sitelinkConstantsFragment
// ====================================================

export interface sitelinkConstantsFragment {
  __typename: "GdDirectConstantsSitelinkValidationData";
  allowLetters: string;
  maxDescriptionLength: number;
  maxHrefLength: number;
  maxTitleLength: number;
  sitelinkMaxCount: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: calloutFragment
// ====================================================

export interface calloutFragment {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: imageFragment
// ====================================================

export interface imageFragment_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface imageFragment_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface imageFragment_formats {
  __typename: "GdImageFormat";
  imageSize: imageFragment_formats_imageSize;
  path: string;
  smartCenters: imageFragment_formats_smartCenters[] | null;
}

export interface imageFragment_imageSize {
  __typename: "GdImageSize";
  width: number;
  height: number;
}

export interface imageFragment {
  __typename: "GdImage";
  avatarsHost: GdAdImageAvatarsHost;
  createTime: GraphQlLocalDateTime;
  imageHash: string;
  mdsGroupId: GraphQlLong | null;
  name: string | null;
  namespace: GdAdImageNamespace;
  type: GdAdImageType;
  formats: imageFragment_formats[] | null;
  imageSize: imageFragment_imageSize;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: adsRowFragmentForEdit
// ====================================================

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdCpmAudioAdGroup | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup;

export interface adsRowFragmentForEdit_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmGeoproductCreative | adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdVideoAdditionCreative | adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmAudioCreative | adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdHtml5Creative | adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative | adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmIndoorCreative | adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpcVideoCreative | adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmVideoCreative | adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string;
  title: string;
  turbolanding: adsRowFragmentForEdit_GdCPCVideoAd_sitelinks_turbolanding | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: adsRowFragmentForEdit_GdCPCVideoAd_adGroup;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: adsRowFragmentForEdit_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPCVideoAd_bannerImage | null;
  callouts: adsRowFragmentForEdit_GdCPCVideoAd_callouts[] | null;
  typedCreative: adsRowFragmentForEdit_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: adsRowFragmentForEdit_GdCPCVideoAd_sitelinks[] | null;
  turbolanding: adsRowFragmentForEdit_GdCPCVideoAd_turbolanding | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign = adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_campaign;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign = adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative = adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations = adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign = adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations = adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign = adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative = adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations = adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup = adsRowFragmentForEdit_GdTextAd_adGroup_GdCpmAudioAdGroup | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup;

export interface adsRowFragmentForEdit_GdTextAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface adsRowFragmentForEdit_GdTextAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: adsRowFragmentForEdit_GdTextAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_typedCreative = adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmGeoproductCreative | adsRowFragmentForEdit_GdTextAd_typedCreative_GdVideoAdditionCreative | adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmAudioCreative | adsRowFragmentForEdit_GdTextAd_typedCreative_GdHtml5Creative | adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmOutdoorCreative | adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmIndoorCreative | adsRowFragmentForEdit_GdTextAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpcVideoCreative | adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmVideoCreative | adsRowFragmentForEdit_GdTextAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdTextAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface adsRowFragmentForEdit_GdTextAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string;
  title: string;
  turbolanding: adsRowFragmentForEdit_GdTextAd_sitelinks_turbolanding | null;
}

export interface adsRowFragmentForEdit_GdTextAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface adsRowFragmentForEdit_GdTextAd_bannerPrice {
  __typename: "GdAdPrice";
  currency: GdAdPriceCurrency | null;
  prefix: GdAdPricePrefix | null;
  price: string | null;
  priceOld: string | null;
}

export interface adsRowFragmentForEdit_GdTextAd {
  __typename: "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: adsRowFragmentForEdit_GdTextAd_adGroup;
  body: string | null;
  access: adsRowFragmentForEdit_GdTextAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: adsRowFragmentForEdit_GdTextAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdTextAd_bannerImage | null;
  callouts: adsRowFragmentForEdit_GdTextAd_callouts[] | null;
  typedCreative: adsRowFragmentForEdit_GdTextAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdTextAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: adsRowFragmentForEdit_GdTextAd_sitelinks[] | null;
  turbolanding: adsRowFragmentForEdit_GdTextAd_turbolanding | null;
  turboGalleryHref: string | null;
  bannerPrice: adsRowFragmentForEdit_GdTextAd_bannerPrice | null;
  permalinkId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdCpmAudioAdGroup | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup;

export interface adsRowFragmentForEdit_GdCPMBannerAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_typedCreative = adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmGeoproductCreative | adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdVideoAdditionCreative | adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmAudioCreative | adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdHtml5Creative | adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative | adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmIndoorCreative | adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpcVideoCreative | adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmVideoCreative | adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMBannerAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string;
  title: string;
  turbolanding: adsRowFragmentForEdit_GdCPMBannerAd_sitelinks_turbolanding | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_pixels {
  __typename: "GdPixel";
  kind: GdPixelKind;
  url: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_measurers {
  __typename: "GdBannerMeasurer";
  measurerSystem: GdBannerMeasurerSystem;
  params: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd {
  __typename: "GdCPMBannerAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: adsRowFragmentForEdit_GdCPMBannerAd_adGroup;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMBannerAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: adsRowFragmentForEdit_GdCPMBannerAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMBannerAd_bannerImage | null;
  callouts: adsRowFragmentForEdit_GdCPMBannerAd_callouts[] | null;
  typedCreative: adsRowFragmentForEdit_GdCPMBannerAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: adsRowFragmentForEdit_GdCPMBannerAd_sitelinks[] | null;
  turbolanding: adsRowFragmentForEdit_GdCPMBannerAd_turbolanding | null;
  pixels: adsRowFragmentForEdit_GdCPMBannerAd_pixels[];
  measurers: adsRowFragmentForEdit_GdCPMBannerAd_measurers[] | null;
  tnsId: string | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdCpmAudioAdGroup | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmGeoproductCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdVideoAdditionCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmAudioCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdHtml5Creative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmIndoorCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpcVideoCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmVideoCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string;
  title: string;
  turbolanding: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_sitelinks_turbolanding | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_pixels {
  __typename: "GdPixel";
  kind: GdPixelKind;
  url: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_placementPages {
  __typename: "GdPlacementPageModerationResult";
  bannerId: GraphQlLong;
  comment: string | null;
  createTime: GraphQlLocalDateTime;
  id: GraphQlLong;
  pageId: GraphQlLong;
  statusModerate: StatusModerateBannerPage;
  version: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd {
  __typename: "GdCPMOutdoorBannerAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_bannerImage | null;
  callouts: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_callouts[] | null;
  typedCreative: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_sitelinks[] | null;
  turbolanding: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_turbolanding | null;
  pixels: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_pixels[];
  placementPages: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_placementPages[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdCpmBannerCampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdCpmBannerCampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdCpmBannerCampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign_flatStrategy;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  flatStrategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_flatStrategy;
  lastChangedVcardId: GraphQlLong | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdCpmBannerCampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_sitelinks {
  __typename: "GdSitelink";
  href: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdCpmAudioAdGroup | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative = adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmGeoproductCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdVideoAdditionCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmAudioCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdHtml5Creative | adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmIndoorCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpcVideoCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmVideoCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string;
  title: string;
  turbolanding: adsRowFragmentForEdit_GdCPMAudioBannerAd_sitelinks_turbolanding | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_pixels {
  __typename: "GdPixel";
  kind: GdPixelKind;
  url: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd {
  __typename: "GdCPMAudioBannerAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: adsRowFragmentForEdit_GdCPMAudioBannerAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMAudioBannerAd_bannerImage | null;
  callouts: adsRowFragmentForEdit_GdCPMAudioBannerAd_callouts[] | null;
  typedCreative: adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: adsRowFragmentForEdit_GdCPMAudioBannerAd_sitelinks[] | null;
  turbolanding: adsRowFragmentForEdit_GdCPMAudioBannerAd_turbolanding | null;
  pixels: adsRowFragmentForEdit_GdCPMAudioBannerAd_pixels[];
}

export type adsRowFragmentForEdit = adsRowFragmentForEdit_GdCPCVideoAd | adsRowFragmentForEdit_GdTextAd | adsRowFragmentForEdit_GdCPMBannerAd | adsRowFragmentForEdit_GdCPMOutdoorBannerAd | adsRowFragmentForEdit_GdCPMAudioBannerAd;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: configurationFragment
// ====================================================

export interface configurationFragment {
  __typename: "GdConfigurationConstants";
  turbolandingUnifiedApiUrl: string;
  canvasUiDomain: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: adsInternalRowFragmentForEdit
// ====================================================

export interface adsInternalRowFragmentForEdit_templateVars {
  __typename: "GdTemplateVariable";
  templateResourceId: GraphQlLong;
  value: string | null;
}

export interface adsInternalRowFragmentForEdit_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_status_timeTargetStatus;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_flatStrategy = adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign {
  __typename: "GdInternalFreeCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  placeId: GraphQlLong;
  status: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_status;
  access: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_access;
  flatStrategy: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_flatStrategy;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_status_timeTargetStatus;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export type adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_flatStrategy = adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyAvgClick | adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_flatStrategy_GdCampaignStrategyManual;

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign {
  __typename: "GdInternalDistribCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  placeId: GraphQlLong;
  status: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_status;
  access: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_access;
  flatStrategy: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_flatStrategy;
}

export type adsInternalRowFragmentForEdit_adGroup_campaign = adsInternalRowFragmentForEdit_adGroup_campaign_GdCpmBannerCampaign | adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign | adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign;

export interface adsInternalRowFragmentForEdit_adGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsInternalRowFragmentForEdit_adGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsInternalRowFragmentForEdit_adGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsInternalRowFragmentForEdit_adGroup {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  campaign: adsInternalRowFragmentForEdit_adGroup_campaign;
  access: adsInternalRowFragmentForEdit_adGroup_access;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsInternalRowFragmentForEdit_adGroup_regionsInfo;
  status: adsInternalRowFragmentForEdit_adGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsInternalRowFragmentForEdit_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsInternalRowFragmentForEdit {
  __typename: "GdInternalAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  description: string | null;
  templateId: GraphQlLong;
  templateVars: adsInternalRowFragmentForEdit_templateVars[];
  access: adsInternalRowFragmentForEdit_access;
  adGroup: adsInternalRowFragmentForEdit_adGroup;
  status: adsInternalRowFragmentForEdit_status;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PointFragmet
// ====================================================

export interface PointFragmet {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: VCardDataFragment
// ====================================================

export interface VCardDataFragment_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface VCardDataFragment_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface VCardDataFragment_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface VCardDataFragment_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: VCardDataFragment_workTimes_startTime;
  endTime: VCardDataFragment_workTimes_endTime;
}

export interface VCardDataFragment_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface VCardDataFragment_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface VCardDataFragment_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: VCardDataFragment_address_pointOnMap | null;
}

export interface VCardDataFragment {
  __typename: "GdVcard";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: VCardDataFragment_instantMessenger | null;
  workTimes: VCardDataFragment_workTimes[];
  phone: VCardDataFragment_phone;
  address: VCardDataFragment_address;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: adGroupsRowFragmentForEdit
// ====================================================

export interface adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_campaign_flatStrategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  platform: GdCampaignPlatform;
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_campaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  flatStrategy: adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_campaign_flatStrategy;
  type: GdCampaignType;
}

export interface adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierAdTypeAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierExpressAdjustment" | "GdBidModifierInventoryAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export type adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_bidModifiers_adjustments = adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment;

export interface adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_bidModifiers_adjustments[];
}

export interface adGroupsRowFragmentForEdit_GdCpmBannerAdGroup {
  __typename: "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdDynamicAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdTextAdGroup";
  access: adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_access;
  regionsInfo: adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_regionsInfo;
  campaign: adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  libraryMinusKeywordsPacks: adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: adGroupsRowFragmentForEdit_GdCpmBannerAdGroup_bidModifiers[] | null;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_campaign_flatStrategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  platform: GdCampaignPlatform;
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_campaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  flatStrategy: adGroupsRowFragmentForEdit_GdSmartAdGroup_campaign_flatStrategy;
  type: GdCampaignType;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierAdTypeAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierExpressAdjustment" | "GdBidModifierInventoryAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export type adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments = adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment;

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments[];
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  access: adGroupsRowFragmentForEdit_GdSmartAdGroup_access;
  regionsInfo: adGroupsRowFragmentForEdit_GdSmartAdGroup_regionsInfo;
  campaign: adGroupsRowFragmentForEdit_GdSmartAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  libraryMinusKeywordsPacks: adGroupsRowFragmentForEdit_GdSmartAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  feedId: GraphQlLong;
  fieldToUseAsBody: string | null;
  fieldToUseAsName: string | null;
  trackingParams: string | null;
  bidModifiers: adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers[] | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_campaign_flatStrategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  platform: GdCampaignPlatform;
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_campaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  flatStrategy: adGroupsRowFragmentForEdit_GdInternalAdGroup_campaign_flatStrategy;
  type: GdCampaignType;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierAdTypeAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierExpressAdjustment" | "GdBidModifierInventoryAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export type adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments = adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment;

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingInternalNetwork {
  __typename: "GdAdditionalTargetingInternalNetwork";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingIsBrowser {
  __typename: "GdAdditionalTargetingIsBrowser";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingIsTablet {
  __typename: "GdAdditionalTargetingIsTablet";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingIsMobile {
  __typename: "GdAdditionalTargetingIsMobile";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingIsTouch {
  __typename: "GdAdditionalTargetingIsTouch";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingUserAgents {
  __typename: "GdAdditionalTargetingUserAgents";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingOsNames_value {
  __typename: "GdAdditionalTargetingUatraits";
  targetingValueEntryId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingOsNames {
  __typename: "GdAdditionalTargetingOsNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingOsNames_value[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingOsFamilies_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingOsFamilies {
  __typename: "GdAdditionalTargetingOsFamilies";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingOsFamilies_value[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingBrowserNames_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingBrowserNames {
  __typename: "GdAdditionalTargetingBrowserNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingBrowserNames_value[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingBrowserEngines_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingBrowserEngines {
  __typename: "GdAdditionalTargetingBrowserEngines";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingBrowserEngines_value[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingDeviceVendors_value {
  __typename: "GdAdditionalTargetingUatraits";
  targetingValueEntryId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingDeviceVendors {
  __typename: "GdAdditionalTargetingDeviceVendors";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingDeviceVendors_value[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingDeviceNames {
  __typename: "GdAdditionalTargetingDeviceNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingInterfaceLangs {
  __typename: "GdAdditionalTargetingInterfaceLangs";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: InterfaceLang[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingQueryReferers {
  __typename: "GdAdditionalTargetingQueryReferers";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingYandexUids {
  __typename: "GdAdditionalTargetingYandexUids";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingShowDates {
  __typename: "GdAdditionalTargetingShowDates";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLocalDate[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup {
  __typename: "GdInternalAdGroup";
  access: adGroupsRowFragmentForEdit_GdInternalAdGroup_access;
  regionsInfo: adGroupsRowFragmentForEdit_GdInternalAdGroup_regionsInfo;
  campaign: adGroupsRowFragmentForEdit_GdInternalAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  libraryMinusKeywordsPacks: adGroupsRowFragmentForEdit_GdInternalAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers[] | null;
  level: GraphQlLong | null;
  targetingInternalNetwork: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingInternalNetwork | null;
  targetingIsBrowser: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingIsBrowser | null;
  targetingIsTablet: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingIsTablet | null;
  targetingIsMobile: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingIsMobile | null;
  targetingIsTouch: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingIsTouch | null;
  targetingUserAgents: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingUserAgents | null;
  targetingOsNames: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingOsNames | null;
  targetingOsFamilies: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingOsFamilies | null;
  targetingBrowserNames: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingBrowserNames | null;
  targetingBrowserEngines: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingBrowserEngines | null;
  targetingDeviceVendors: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingDeviceVendors | null;
  targetingDeviceNames: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingDeviceNames | null;
  targetingInterfaceLangs: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingInterfaceLangs | null;
  targetingQueryReferers: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingQueryReferers | null;
  targetingYandexUids: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingYandexUids | null;
  targetingShowDates: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingShowDates | null;
  startTime: GraphQlLocalDateTime | null;
  finishTime: GraphQlLocalDateTime | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_campaign_flatStrategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  platform: GdCampaignPlatform;
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_campaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  flatStrategy: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_campaign_flatStrategy;
  type: GdCampaignType;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierAdTypeAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierExpressAdjustment" | "GdBidModifierInventoryAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export type adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments = adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment;

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments[];
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup {
  __typename: "GdCpmVideoAdGroup";
  access: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_access;
  regionsInfo: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_regionsInfo;
  campaign: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  libraryMinusKeywordsPacks: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers[] | null;
  videoGoals: GdVideoGoalType[];
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_campaign_flatStrategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  platform: GdCampaignPlatform;
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_campaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  flatStrategy: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_campaign_flatStrategy;
  type: GdCampaignType;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierAdTypeAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierExpressAdjustment" | "GdBidModifierInventoryAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export type adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments = adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment;

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments[];
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup";
  access: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_access;
  regionsInfo: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_regionsInfo;
  campaign: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  libraryMinusKeywordsPacks: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers[] | null;
  videoGoals: GdVideoGoalType[];
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_campaign_flatStrategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  platform: GdCampaignPlatform;
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_campaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  flatStrategy: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_campaign_flatStrategy;
  type: GdCampaignType;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierAdTypeAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierExpressAdjustment" | "GdBidModifierInventoryAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export type adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments = adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment;

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments[];
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_pageBlocks {
  __typename: "GdAdGroupPageBlock";
  impId: GraphQlLong;
  pageId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup {
  __typename: "GdCpmOutdoorAdGroup";
  access: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_access;
  regionsInfo: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_regionsInfo;
  campaign: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  libraryMinusKeywordsPacks: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers[] | null;
  videoGoals: GdVideoGoalType[];
  pageBlocks: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_pageBlocks[];
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_campaign_flatStrategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  platform: GdCampaignPlatform;
  type: GdCampaignStrategyType;
  isAutoBudget: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_campaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  flatStrategy: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_campaign_flatStrategy;
  type: GdCampaignType;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierAdTypeAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierExpressAdjustment" | "GdBidModifierInventoryAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export type adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments = adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment;

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments[];
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_pageBlocks {
  __typename: "GdAdGroupPageBlock";
  impId: GraphQlLong;
  pageId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup {
  __typename: "GdCpmIndoorAdGroup";
  access: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_access;
  regionsInfo: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_regionsInfo;
  campaign: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  libraryMinusKeywordsPacks: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers[] | null;
  videoGoals: GdVideoGoalType[];
  pageBlocks: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_pageBlocks[];
}

export type adGroupsRowFragmentForEdit = adGroupsRowFragmentForEdit_GdCpmBannerAdGroup | adGroupsRowFragmentForEdit_GdSmartAdGroup | adGroupsRowFragmentForEdit_GdInternalAdGroup | adGroupsRowFragmentForEdit_GdCpmVideoAdGroup | adGroupsRowFragmentForEdit_GdCpmAudioAdGroup | adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup | adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: feedsFragment
// ====================================================

export interface feedsFragment_rowset_categories {
  __typename: "GdFeedCategory";
  categoryId: GraphQlBigInteger;
  offerCount: GraphQlLong | null;
  parentCategoryId: GraphQlBigInteger;
  name: string;
  isDeleted: boolean;
}

export interface feedsFragment_rowset {
  __typename: "GdFeed";
  id: GraphQlLong;
  name: string;
  updateStatus: GdUpdateStatus;
  businessType: GdBusinessType;
  categories: feedsFragment_rowset_categories[];
  feedType: GdFeedType | null;
}

export interface feedsFragment {
  __typename: "GdFeedsContext";
  rowset: feedsFragment_rowset[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: creativeFragment
// ====================================================

export interface creativeFragment_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  previewUrl: string;
  width: GraphQlLong | null;
}

export interface creativeFragment_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  previewUrl: string;
  width: GraphQlLong | null;
  isAdaptive: boolean | null;
}

export interface creativeFragment_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  previewUrl: string;
  width: GraphQlLong | null;
  isImage: boolean;
}

export type creativeFragment = creativeFragment_GdSmartCreative | creativeFragment_GdCanvasCreative | creativeFragment_GdHtml5Creative;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FreelancerFeedbackQueryFragment
// ====================================================

export interface FreelancerFeedbackQueryFragment_authorInfo {
  __typename: "GdUserPublicInfo";
  avatarUrl: string;
  login: string;
  name: string;
  userId: GraphQlLong;
}

export interface FreelancerFeedbackQueryFragment {
  __typename: "GdFreelancerFeedback";
  authorInfo: FreelancerFeedbackQueryFragment_authorInfo | null;
  authorUid: GraphQlLong;
  createdTime: GraphQlLocalDateTime;
  feedbackId: string;
  feedbackText: string;
  freelancerId: GraphQlLong;
  overallMark: GraphQlLong;
  willRecommend: boolean | null;
  moderationStatus: GdFreelancerUgcModerationStatus;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FreelancerContactsFragment
// ====================================================

export interface FreelancerContactsFragment {
  __typename: "GdFreelancerContacts";
  siteUrl: string | null;
  whatsApp: string | null;
  phone: string;
  icq: string | null;
  telegram: string | null;
  email: string;
  viber: string | null;
  skype: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FreelancerServiceFragment
// ====================================================

export interface FreelancerServiceFragment {
  __typename: "GdFreelancerSkillType";
  name: string;
  skillCode: string;
  skillId: GraphQlLong;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FreelancerPrivateDataFragment
// ====================================================

export interface FreelancerPrivateDataFragment_newestCard_contacts {
  __typename: "GdFreelancerContacts";
  siteUrl: string | null;
  whatsApp: string | null;
  phone: string;
  icq: string | null;
  telegram: string | null;
  email: string;
  viber: string | null;
  skype: string | null;
}

export interface FreelancerPrivateDataFragment_newestCard {
  __typename: "GdFreelancerCard";
  statusModerate: GdFreelancersCardStatusModerate;
  briefInfo: string;
  avatarUrl: string;
  contacts: FreelancerPrivateDataFragment_newestCard_contacts;
}

export interface FreelancerPrivateDataFragment_advQuality {
  __typename: "GdFreelancerAdvQuality";
  advQualityRank: GraphQlLong | null;
  advQualityRating: GraphQlBigDecimal | null;
}

export interface FreelancerPrivateDataFragment {
  __typename: "GdFreelancerPrivateData";
  freelancerId: GraphQlLong;
  /**
   * Последняя версия карточки вне зависимости от статуса
   */
  newestCard: FreelancerPrivateDataFragment_newestCard | null;
  /**
   * ОКР-рейтинг специалиста.
   */
  advQuality: FreelancerPrivateDataFragment_advQuality | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: minusPhraseLibraryRowFragment
// ====================================================

export interface minusPhraseLibraryRowFragment {
  __typename: "GdGetMinusKeywordsPacksItem";
  id: GraphQlLong;
  linkedAdGroupsCount: GraphQlLong;
  minusKeywords: string[];
  name: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: minusPhraseLibraryConstantsFragment
// ====================================================

export interface minusPhraseLibraryConstantsFragment {
  __typename: "GdDirectConstantsMinusWordsLibValidationData";
  libMinusKeywordsTextMaxLength: number;
  maxLibraryPacksCount: number;
  maxLinkedPacksToOneAdGroup: number;
  maxNameLength: number;
  maxWordsInMinusPhrase: number;
  nameAllowLetters: string;
  textAllowLetters: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: OutdoorPlacementBlock
// ====================================================

export interface OutdoorPlacementBlock_sizes {
  __typename: "GdBlockSize";
  height: number | null;
  width: number | null;
}

export interface OutdoorPlacementBlock_photos_formats {
  __typename: "GdPlacementFormat";
  height: number;
  path: string;
  width: number;
}

export interface OutdoorPlacementBlock_photos {
  __typename: "GdPlacementPhoto";
  formats: OutdoorPlacementBlock_photos_formats[];
}

export interface OutdoorPlacementBlock_resolution {
  __typename: "GdBlockSize";
  height: number | null;
  width: number | null;
}

export interface OutdoorPlacementBlock {
  __typename: "GdOutdoorPlacementBlock";
  blockCaption: string | null;
  blockId: GraphQlLong;
  isDeleted: boolean;
  lastChange: GraphQlLocalDateTime;
  pageId: GraphQlLong;
  sizes: OutdoorPlacementBlock_sizes[];
  address: string;
  coordinates: string;
  duration: number;
  direction: number;
  facilityType: number;
  geoId: GraphQlLong | null;
  height: number;
  hidden: boolean | null;
  photos: OutdoorPlacementBlock_photos[] | null;
  resolution: OutdoorPlacementBlock_resolution;
  width: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: IndoorPlacementBlock
// ====================================================

export interface IndoorPlacementBlock_sizes {
  __typename: "GdBlockSize";
  height: number | null;
  width: number | null;
}

export interface IndoorPlacementBlock_photos_formats {
  __typename: "GdPlacementFormat";
  height: number;
  path: string;
  width: number;
}

export interface IndoorPlacementBlock_photos {
  __typename: "GdPlacementPhoto";
  formats: IndoorPlacementBlock_photos_formats[];
}

export interface IndoorPlacementBlock_resolution {
  __typename: "GdBlockSize";
  height: number | null;
  width: number | null;
}

export interface IndoorPlacementBlock {
  __typename: "GdIndoorPlacementBlock";
  blockCaption: string | null;
  blockId: GraphQlLong;
  isDeleted: boolean;
  lastChange: GraphQlLocalDateTime;
  pageId: GraphQlLong;
  sizes: IndoorPlacementBlock_sizes[];
  geoId: GraphQlLong | null;
  address: string;
  coordinates: string;
  facilityType: number;
  zoneCategory: number;
  aspectRatio: number[];
  hidden: boolean | null;
  photos: IndoorPlacementBlock_photos[] | null;
  resolution: IndoorPlacementBlock_resolution;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: allowedBidModifiersValuesFragment
// ====================================================

export interface allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesABSegment_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesABSegment {
  __typename: "GdAllowedBidModifierValuesABSegment" | "GdAllowedBidModifierValuesAdType" | "GdAllowedBidModifierValuesDemographics" | "GdAllowedBidModifierValuesDesktop" | "GdAllowedBidModifierValuesExpression" | "GdAllowedBidModifierValuesGeo" | "GdAllowedBidModifierValuesInventory" | "GdAllowedBidModifierValuesRetargeting" | "GdAllowedBidModifierValuesSmartTgo" | "GdAllowedBidModifierValuesVideo" | "GdAllowedBidModifierValuesWeather";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesABSegment_percentRange;
}

export interface allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesMobile_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesMobile {
  __typename: "GdAllowedBidModifierValuesMobile";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesMobile_percentRange;
  osTypes: GdOsType[];
}

export type allowedBidModifiersValuesFragment = allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesABSegment | allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesMobile;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: RecommendationsGridClientFeaturesFragment
// ====================================================

export interface RecommendationsGridClientFeaturesFragment {
  __typename: "GdClientFeatures";
  enabledRecommendationTypes: GdiRecommendationType[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: summaryRecommendationGraphFragment
// ====================================================

export interface summaryRecommendationGraphFragment_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface summaryRecommendationGraphFragment {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: summaryRecommendationGraphFragment_points[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: summaryRecommendationItemsFragment
// ====================================================

export interface summaryRecommendationItemsFragment_rowset {
  __typename: "GdRecommendationItem";
  clicks: GraphQlLong;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
  name: string;
}

export interface summaryRecommendationItemsFragment {
  __typename: "GdRecommendationItems";
  rowset: summaryRecommendationItemsFragment_rowset[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: summaryRecommendationKpiFragment
// ====================================================

export interface summaryRecommendationKpiFragment_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface summaryRecommendationKpiFragment_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: summaryRecommendationKpiFragment_graph_points[];
}

export interface summaryRecommendationKpiFragment {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiDailyBudget" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: summaryRecommendationKpiFragment_graph;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: recommendationKeyFragment
// ====================================================

export interface recommendationKeyFragment {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: summaryRecommendationFragment
// ====================================================

export interface summaryRecommendationFragment_GdRecommendationSummaryWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface summaryRecommendationFragment_GdRecommendationSummaryWithoutKpi {
  __typename: "GdRecommendationSummaryWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  totalCount: number;
  campaignIds: GraphQlLong[];
  keys: summaryRecommendationFragment_GdRecommendationSummaryWithoutKpi_keys[];
}

export interface summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
}

export interface summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export type summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi = summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats | summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget;

export interface summaryRecommendationFragment_GdRecommendationSummaryWithKpi_items_rowset {
  __typename: "GdRecommendationItem";
  clicks: GraphQlLong;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
  name: string;
}

export interface summaryRecommendationFragment_GdRecommendationSummaryWithKpi_items {
  __typename: "GdRecommendationItems";
  rowset: summaryRecommendationFragment_GdRecommendationSummaryWithKpi_items_rowset[];
}

export interface summaryRecommendationFragment_GdRecommendationSummaryWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface summaryRecommendationFragment_GdRecommendationSummaryWithKpi {
  __typename: "GdRecommendationSummaryWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  totalCount: number;
  kpi: summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi;
  items: summaryRecommendationFragment_GdRecommendationSummaryWithKpi_items;
  campaignIds: GraphQlLong[];
  keys: summaryRecommendationFragment_GdRecommendationSummaryWithKpi_keys[];
}

export type summaryRecommendationFragment = summaryRecommendationFragment_GdRecommendationSummaryWithoutKpi | summaryRecommendationFragment_GdRecommendationSummaryWithKpi;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: RecommendationsDailyBudgetGridKpiItemsFragment
// ====================================================

export interface RecommendationsDailyBudgetGridKpiItemsFragment_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
}

export interface RecommendationsDailyBudgetGridKpiItemsFragment_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
  recommendedDailyBudget: GraphQlBigDecimal;
  currentDailyBudget: GraphQlBigDecimal;
}

export type RecommendationsDailyBudgetGridKpiItemsFragment_kpi = RecommendationsDailyBudgetGridKpiItemsFragment_kpi_GdRecommendationKpiAddBannerFormats | RecommendationsDailyBudgetGridKpiItemsFragment_kpi_GdRecommendationKpiDailyBudget;

export interface RecommendationsDailyBudgetGridKpiItemsFragment {
  __typename: "GdRecommendationWithKpi";
  kpi: RecommendationsDailyBudgetGridKpiItemsFragment_kpi;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: RecommendationsDailyBudgetCampaignsRowFragment
// ====================================================

export interface RecommendationsDailyBudgetCampaignsRowFragment_stats {
  __typename: "GdEntityStats";
  clicks: GraphQlLong | null;
  cost: GraphQlBigDecimal | null;
}

export interface RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
}

export interface RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
  recommendedDailyBudget: GraphQlBigDecimal;
  currentDailyBudget: GraphQlBigDecimal;
}

export type RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithKpi_kpi = RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget;

export interface RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  kpi: RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithKpi_kpi;
  keys: RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithKpi_keys[];
}

export type RecommendationsDailyBudgetCampaignsRowFragment_recommendations = RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithoutKpi | RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithKpi;

export interface RecommendationsDailyBudgetCampaignsRowFragment_flatStrategy_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RecommendationsDailyBudgetCampaignsRowFragment_flatStrategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle";
  budget: RecommendationsDailyBudgetCampaignsRowFragment_flatStrategy_budget | null;
}

export interface RecommendationsDailyBudgetCampaignsRowFragment {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  stats: RecommendationsDailyBudgetCampaignsRowFragment_stats;
  recommendations: RecommendationsDailyBudgetCampaignsRowFragment_recommendations[] | null;
  flatStrategy: RecommendationsDailyBudgetCampaignsRowFragment_flatStrategy;
  type: GdCampaignType;
  name: string;
  id: GraphQlLong;
  currency: CurrencyCode | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: RemoveFromBlackListRecommendationKpiFragment
// ====================================================

export interface RemoveFromBlackListRecommendationKpiFragment {
  __typename: "GdRecommendationKpiRemovePagesFromBlackList";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
  pageName: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: RemoveFromBlackListRecommendationsGridRowFragment
// ====================================================

export interface RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiDailyBudget" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives";
}

export interface RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackList {
  __typename: "GdRecommendationKpiRemovePagesFromBlackList";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
  pageName: string;
}

export type RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_kpi = RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackList;

export interface RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_keys[];
  kpi: RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_kpi;
}

export type RemoveFromBlackListRecommendationsGridRowFragment_recommendations = RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithoutKpi | RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi;

export interface RemoveFromBlackListRecommendationsGridRowFragment {
  __typename: "GdPage";
  name: string;
  recommendations: RemoveFromBlackListRecommendationsGridRowFragment_recommendations[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SwitchOnAutotargetingRecommendationsGridRowFragment
// ====================================================

export interface SwitchOnAutotargetingRecommendationsGridRowFragment_stats {
  __typename: "GdEntityStats";
  clicks: GraphQlLong | null;
  cost: GraphQlBigDecimal | null;
}

export interface SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_kpi {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiDailyBudget" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
}

export interface SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  kpi: SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_kpi;
  keys: SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_keys[];
}

export type SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations = SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations_GdRecommendationWithoutKpi | SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi;

export interface SwitchOnAutotargetingRecommendationsGridRowFragment_campaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdDynamicCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
}

export interface SwitchOnAutotargetingRecommendationsGridRowFragment {
  __typename: "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmVideoAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  stats: SwitchOnAutotargetingRecommendationsGridRowFragment_stats;
  recommendations: SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations[] | null;
  name: string;
  id: GraphQlLong;
  campaign: SwitchOnAutotargetingRecommendationsGridRowFragment_campaign;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: recommendationsGridSummaryRowFragment
// ====================================================

export interface recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithoutKpi {
  __typename: "GdRecommendationSummaryWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  totalCount: number;
  keys: recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithoutKpi_keys[];
}

export interface recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
}

export interface recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export type recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi = recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats | recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget;

export interface recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi {
  __typename: "GdRecommendationSummaryWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  totalCount: number;
  keys: recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_keys[];
  kpi: recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi;
}

export type recommendationsGridSummaryRowFragment = recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithoutKpi | recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AdGroupType {
  BASE = "BASE",
  CONTENT_PROMOTION = "CONTENT_PROMOTION",
  CONTENT_PROMOTION_VIDEO = "CONTENT_PROMOTION_VIDEO",
  CPM_AUDIO = "CPM_AUDIO",
  CPM_BANNER = "CPM_BANNER",
  CPM_GEOPRODUCT = "CPM_GEOPRODUCT",
  CPM_INDOOR = "CPM_INDOOR",
  CPM_OUTDOOR = "CPM_OUTDOOR",
  CPM_PRICE = "CPM_PRICE",
  CPM_VIDEO = "CPM_VIDEO",
  CPM_YNDX_FRONTPAGE = "CPM_YNDX_FRONTPAGE",
  DYNAMIC = "DYNAMIC",
  INTERNAL = "INTERNAL",
  MCBANNER = "MCBANNER",
  MOBILE_CONTENT = "MOBILE_CONTENT",
  PERFORMANCE = "PERFORMANCE",
}

export enum BidModifierExpressionOperatorInput {
  EQ = "EQ",
  GE = "GE",
  LE = "LE",
  MATCH_GOAL_CONTEXT = "MATCH_GOAL_CONTEXT",
  NE = "NE",
}

export enum BidModifierExpressionParameterInput {
  CLOUDNESS = "CLOUDNESS",
  PREC_STRENGTH = "PREC_STRENGTH",
  TEMP = "TEMP",
  TRAFFIC_JAM = "TRAFFIC_JAM",
}

export enum ChangeModeInput {
  POSTFIX = "POSTFIX",
  PREFIX = "PREFIX",
  REPLACE = "REPLACE",
}

export enum CompleteReason {
  BY_CLIENT = "BY_CLIENT",
  BY_DATE = "BY_DATE",
  BY_PUBLISHER = "BY_PUBLISHER",
}

export enum CompleteReasonInput {
  BY_CLIENT = "BY_CLIENT",
  BY_DATE = "BY_DATE",
  BY_PUBLISHER = "BY_PUBLISHER",
}

export enum CryptaInterestType {
  all = "all",
  long_term = "long_term",
  short_term = "short_term",
}

export enum CryptaInterestTypeWeb {
  all = "all",
  long_term = "long_term",
  short_term = "short_term",
}

export enum CryptaInterestTypeWebInput {
  all = "all",
  long_term = "long_term",
  short_term = "short_term",
}

export enum CurrencyCode {
  BYN = "BYN",
  CHF = "CHF",
  EUR = "EUR",
  KZT = "KZT",
  RUB = "RUB",
  TRY = "TRY",
  UAH = "UAH",
  USD = "USD",
  YND_FIXED = "YND_FIXED",
}

export enum CurrencyCodeInput {
  BYN = "BYN",
  CHF = "CHF",
  EUR = "EUR",
  KZT = "KZT",
  RUB = "RUB",
  TRY = "TRY",
  UAH = "UAH",
  USD = "USD",
  YND_FIXED = "YND_FIXED",
}

export enum DealType {
  PREFERRED_DEAL = "PREFERRED_DEAL",
  PRIVATE_MARKETPLACE = "PRIVATE_MARKETPLACE",
}

export enum DealTypeInput {
  PREFERRED_DEAL = "PREFERRED_DEAL",
  PRIVATE_MARKETPLACE = "PRIVATE_MARKETPLACE",
}

export enum GdAdGroupModerationStatus {
  ACCEPTED = "ACCEPTED",
  DRAFT = "DRAFT",
  MODERATION = "MODERATION",
  PREACCEPTED = "PREACCEPTED",
  REJECTED = "REJECTED",
}

export enum GdAdGroupOrderByFieldInput {
  CAMPAIGN_ID = "CAMPAIGN_ID",
  CLICKS_FORECAST = "CLICKS_FORECAST",
  COST_FORECAST = "COST_FORECAST",
  ID = "ID",
  NAME = "NAME",
  STAT_AVG_CLICK_COST = "STAT_AVG_CLICK_COST",
  STAT_AVG_CLICK_POSITION = "STAT_AVG_CLICK_POSITION",
  STAT_AVG_DEPTH = "STAT_AVG_DEPTH",
  STAT_AVG_GOAL_COST = "STAT_AVG_GOAL_COST",
  STAT_AVG_SHOW_POSITION = "STAT_AVG_SHOW_POSITION",
  STAT_BOUNCE_RATE = "STAT_BOUNCE_RATE",
  STAT_CLICKS = "STAT_CLICKS",
  STAT_CONVERSION_RATE = "STAT_CONVERSION_RATE",
  STAT_COST = "STAT_COST",
  STAT_COST_PER_ACTION = "STAT_COST_PER_ACTION",
  STAT_CPM_PRICE = "STAT_CPM_PRICE",
  STAT_CTR = "STAT_CTR",
  STAT_GOALS = "STAT_GOALS",
  STAT_PROFITABILITY = "STAT_PROFITABILITY",
  STAT_REVENUE = "STAT_REVENUE",
  STAT_SHOWS = "STAT_SHOWS",
  TYPE = "TYPE",
}

export enum GdAdGroupPrimaryStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
  MODERATION = "MODERATION",
  REJECTED = "REJECTED",
  STOPPED = "STOPPED",
}

export enum GdAdGroupPrimaryStatusDesc {
  PREVIOUS_VERSION_SHOWING = "PREVIOUS_VERSION_SHOWING",
  SHOWING = "SHOWING",
}

export enum GdAdGroupPrimaryStatusInput {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
  MODERATION = "MODERATION",
  REJECTED = "REJECTED",
  STOPPED = "STOPPED",
}

export enum GdAdGroupType {
  CPM_AUDIO = "CPM_AUDIO",
  CPM_BANNER = "CPM_BANNER",
  CPM_GEOPRODUCT = "CPM_GEOPRODUCT",
  CPM_INDOOR = "CPM_INDOOR",
  CPM_OUTDOOR = "CPM_OUTDOOR",
  CPM_VIDEO = "CPM_VIDEO",
  DYNAMIC = "DYNAMIC",
  INTERNAL = "INTERNAL",
  MCBANNER = "MCBANNER",
  MOBILE_CONTENT = "MOBILE_CONTENT",
  PERFORMANCE = "PERFORMANCE",
  TEXT = "TEXT",
}

export enum GdAdGroupTypeInput {
  CPM_AUDIO = "CPM_AUDIO",
  CPM_BANNER = "CPM_BANNER",
  CPM_GEOPRODUCT = "CPM_GEOPRODUCT",
  CPM_INDOOR = "CPM_INDOOR",
  CPM_OUTDOOR = "CPM_OUTDOOR",
  CPM_VIDEO = "CPM_VIDEO",
  DYNAMIC = "DYNAMIC",
  INTERNAL = "INTERNAL",
  MCBANNER = "MCBANNER",
  MOBILE_CONTENT = "MOBILE_CONTENT",
  PERFORMANCE = "PERFORMANCE",
  TEXT = "TEXT",
}

export enum GdAdImageAvatarsHost {
  AVATARS_MDST_YANDEX_NET = "AVATARS_MDST_YANDEX_NET",
  AVATARS_MDS_YANDEX_NET = "AVATARS_MDS_YANDEX_NET",
}

export enum GdAdImageNamespace {
  DIRECT = "DIRECT",
  DIRECT_PICTURE = "DIRECT_PICTURE",
}

export enum GdAdImageType {
  IMAGE_AD = "IMAGE_AD",
  REGULAR = "REGULAR",
  SMALL = "SMALL",
  WIDE = "WIDE",
}

export enum GdAdOrderByFieldInput {
  BANNER_TYPE = "BANNER_TYPE",
  CAMPAIGN_ID = "CAMPAIGN_ID",
  DOMAIN = "DOMAIN",
  GROUP_ID = "GROUP_ID",
  HREF = "HREF",
  ID = "ID",
  LAST_CHANGE = "LAST_CHANGE",
  PRIMARY_STATUS = "PRIMARY_STATUS",
  STATUS = "STATUS",
  STAT_AVG_CLICK_COST = "STAT_AVG_CLICK_COST",
  STAT_AVG_CLICK_POSITION = "STAT_AVG_CLICK_POSITION",
  STAT_AVG_DEPTH = "STAT_AVG_DEPTH",
  STAT_AVG_GOAL_COST = "STAT_AVG_GOAL_COST",
  STAT_AVG_SHOW_POSITION = "STAT_AVG_SHOW_POSITION",
  STAT_BOUNCE_RATE = "STAT_BOUNCE_RATE",
  STAT_CLICKS = "STAT_CLICKS",
  STAT_CONVERSION_RATE = "STAT_CONVERSION_RATE",
  STAT_COST = "STAT_COST",
  STAT_COST_PER_ACTION = "STAT_COST_PER_ACTION",
  STAT_CPM_PRICE = "STAT_CPM_PRICE",
  STAT_CTR = "STAT_CTR",
  STAT_GOALS = "STAT_GOALS",
  STAT_PROFITABILITY = "STAT_PROFITABILITY",
  STAT_REVENUE = "STAT_REVENUE",
  STAT_SHOWS = "STAT_SHOWS",
  TITLE = "TITLE",
  TITLE_EXTENSION = "TITLE_EXTENSION",
}

export enum GdAdPriceCurrency {
  BYN = "BYN",
  CHF = "CHF",
  EUR = "EUR",
  KZT = "KZT",
  RUB = "RUB",
  TRY = "TRY",
  UAH = "UAH",
  USD = "USD",
  UZS = "UZS",
}

export enum GdAdPriceCurrencyInput {
  BYN = "BYN",
  CHF = "CHF",
  EUR = "EUR",
  KZT = "KZT",
  RUB = "RUB",
  TRY = "TRY",
  UAH = "UAH",
  USD = "USD",
  UZS = "UZS",
}

export enum GdAdPricePrefix {
  FROM = "FROM",
  TO = "TO",
}

export enum GdAdPricePrefixInput {
  FROM = "FROM",
  TO = "TO",
}

export enum GdAdPrimaryStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
  MANUALLY_SUSPENDED = "MANUALLY_SUSPENDED",
  MODERATION = "MODERATION",
  MODERATION_REJECTED = "MODERATION_REJECTED",
  TEMPORARILY_SUSPENDED = "TEMPORARILY_SUSPENDED",
}

export enum GdAdPrimaryStatusInput {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
  MANUALLY_SUSPENDED = "MANUALLY_SUSPENDED",
  MODERATION = "MODERATION",
  MODERATION_REJECTED = "MODERATION_REJECTED",
  TEMPORARILY_SUSPENDED = "TEMPORARILY_SUSPENDED",
}

export enum GdAdResources {
  BANNER_IMAGES = "BANNER_IMAGES",
  CALLOUTS = "CALLOUTS",
  CREATIVES = "CREATIVES",
  DISPLAY_HREF = "DISPLAY_HREF",
  IMAGES = "IMAGES",
  SITELINKS = "SITELINKS",
  TURBOLANDINGS = "TURBOLANDINGS",
  VCARD = "VCARD",
  VIDEO_ADDITIONS = "VIDEO_ADDITIONS",
}

export enum GdAdType {
  CPC_VIDEO = "CPC_VIDEO",
  CPM_AUDIO = "CPM_AUDIO",
  CPM_BANNER = "CPM_BANNER",
  CPM_GEOPRODUCT = "CPM_GEOPRODUCT",
  CPM_INDOOR = "CPM_INDOOR",
  CPM_OUTDOOR = "CPM_OUTDOOR",
  CPM_VIDEO = "CPM_VIDEO",
  DYNAMIC = "DYNAMIC",
  IMAGE_AD = "IMAGE_AD",
  INTERNAL = "INTERNAL",
  MCBANNER = "MCBANNER",
  MOBILE_CONTENT = "MOBILE_CONTENT",
  PERFORMANCE = "PERFORMANCE",
  TEXT = "TEXT",
}

export enum GdAdTypeInput {
  CPC_VIDEO = "CPC_VIDEO",
  CPM_AUDIO = "CPM_AUDIO",
  CPM_BANNER = "CPM_BANNER",
  CPM_GEOPRODUCT = "CPM_GEOPRODUCT",
  CPM_INDOOR = "CPM_INDOOR",
  CPM_OUTDOOR = "CPM_OUTDOOR",
  CPM_VIDEO = "CPM_VIDEO",
  DYNAMIC = "DYNAMIC",
  IMAGE_AD = "IMAGE_AD",
  INTERNAL = "INTERNAL",
  MCBANNER = "MCBANNER",
  MOBILE_CONTENT = "MOBILE_CONTENT",
  PERFORMANCE = "PERFORMANCE",
  TEXT = "TEXT",
}

export enum GdAdditionalTargetingJoinType {
  ALL = "ALL",
  ANY = "ANY",
}

export enum GdAdditionalTargetingJoinTypeInput {
  ALL = "ALL",
  ANY = "ANY",
}

export enum GdAdditionalTargetingMode {
  FILTERING = "FILTERING",
  TARGETING = "TARGETING",
}

export enum GdAdditionalTargetingModeInput {
  FILTERING = "FILTERING",
  TARGETING = "TARGETING",
}

export enum GdAdjustmentAdTypeInput {
  CPM_BANNER = "CPM_BANNER",
  CPM_OUTDOOR = "CPM_OUTDOOR",
  CPM_VIDEO = "CPM_VIDEO",
}

export enum GdAgeType {
  _0_17 = "_0_17",
  _18_24 = "_18_24",
  _25_34 = "_25_34",
  _35_44 = "_35_44",
  _45_ = "_45_",
  _45_54 = "_45_54",
  _55_ = "_55_",
}

export enum GdAgeTypeInput {
  _0_17 = "_0_17",
  _18_24 = "_18_24",
  _25_34 = "_25_34",
  _35_44 = "_35_44",
  _45_ = "_45_",
  _45_54 = "_45_54",
  _55_ = "_55_",
}

export enum GdBannerMeasurerSystem {
  ADLOOX = "ADLOOX",
  ADMETRICA = "ADMETRICA",
  ADRIVER = "ADRIVER",
  DV = "DV",
  INTEGRAL_AD_SCIENCE = "INTEGRAL_AD_SCIENCE",
  MEDIASCOPE = "MEDIASCOPE",
  MOAT = "MOAT",
  SIZMEK = "SIZMEK",
}

export enum GdBannerMeasurerSystemInput {
  ADLOOX = "ADLOOX",
  ADMETRICA = "ADMETRICA",
  ADRIVER = "ADRIVER",
  DV = "DV",
  INTEGRAL_AD_SCIENCE = "INTEGRAL_AD_SCIENCE",
  MEDIASCOPE = "MEDIASCOPE",
  MOAT = "MOAT",
  SIZMEK = "SIZMEK",
}

export enum GdBannerTurbolandingStatusModerate {
  NEW = "NEW",
  NO = "NO",
  READY = "READY",
  SENDING = "SENDING",
  SENT = "SENT",
  YES = "YES",
}

export enum GdBidModifierType {
  AB_SEGMENT_MULTIPLIER = "AB_SEGMENT_MULTIPLIER",
  AD_TYPE_MULTIPLIER = "AD_TYPE_MULTIPLIER",
  DEMOGRAPHY_MULTIPLIER = "DEMOGRAPHY_MULTIPLIER",
  DESKTOP_MULTIPLIER = "DESKTOP_MULTIPLIER",
  DISTANCE_MULTIPLIER = "DISTANCE_MULTIPLIER",
  EXPRESS_TRAFFIC_MULTIPLIER = "EXPRESS_TRAFFIC_MULTIPLIER",
  GEO_MULTIPLIER = "GEO_MULTIPLIER",
  INVENTORY_MULTIPLIER = "INVENTORY_MULTIPLIER",
  MOBILE_MULTIPLIER = "MOBILE_MULTIPLIER",
  RETARGETING_MULTIPLIER = "RETARGETING_MULTIPLIER",
  SMART_TGO_MULTIPLIER = "SMART_TGO_MULTIPLIER",
  VIDEO_MULTIPLIER = "VIDEO_MULTIPLIER",
  WEATHER_MULTIPLIER = "WEATHER_MULTIPLIER",
}

export enum GdBidModifierTypeInput {
  AB_SEGMENT_MULTIPLIER = "AB_SEGMENT_MULTIPLIER",
  AD_TYPE_MULTIPLIER = "AD_TYPE_MULTIPLIER",
  DEMOGRAPHY_MULTIPLIER = "DEMOGRAPHY_MULTIPLIER",
  DESKTOP_MULTIPLIER = "DESKTOP_MULTIPLIER",
  DISTANCE_MULTIPLIER = "DISTANCE_MULTIPLIER",
  EXPRESS_TRAFFIC_MULTIPLIER = "EXPRESS_TRAFFIC_MULTIPLIER",
  GEO_MULTIPLIER = "GEO_MULTIPLIER",
  INVENTORY_MULTIPLIER = "INVENTORY_MULTIPLIER",
  MOBILE_MULTIPLIER = "MOBILE_MULTIPLIER",
  RETARGETING_MULTIPLIER = "RETARGETING_MULTIPLIER",
  SMART_TGO_MULTIPLIER = "SMART_TGO_MULTIPLIER",
  VIDEO_MULTIPLIER = "VIDEO_MULTIPLIER",
  WEATHER_MULTIPLIER = "WEATHER_MULTIPLIER",
}

export enum GdBrandSurveyStopReason {
  LOW_BUDGET = "LOW_BUDGET",
  LOW_REACH = "LOW_REACH",
}

export enum GdBusinessType {
  AUTO = "AUTO",
  FLIGHTS = "FLIGHTS",
  HOTELS = "HOTELS",
  NEWS = "NEWS",
  OTHER = "OTHER",
  REALTY = "REALTY",
  RETAIL = "RETAIL",
}

export enum GdBusinessTypeInput {
  AUTO = "AUTO",
  FLIGHTS = "FLIGHTS",
  HOTELS = "HOTELS",
  NEWS = "NEWS",
  OTHER = "OTHER",
  REALTY = "REALTY",
  RETAIL = "RETAIL",
}

export enum GdCalcTypeInput {
  CPC = "CPC",
  CPM = "CPM",
}

export enum GdCalloutStatusModerate {
  NEW = "NEW",
  NO = "NO",
  READY = "READY",
  SENDING = "SENDING",
  SENT = "SENT",
  YES = "YES",
}

export enum GdCampaignAction {
  ACCEPT_SERVICING = "ACCEPT_SERVICING",
  AGENCY_SERVICED = "AGENCY_SERVICED",
  AJAX_SET_AUTO_RESOURCES = "AJAX_SET_AUTO_RESOURCES",
  ALLOW_TRANSFER_MONEY_SUBCLIENT = "ALLOW_TRANSFER_MONEY_SUBCLIENT",
  ARCHIVE_CAMP = "ARCHIVE_CAMP",
  COPY_CAMP_CLIENT = "COPY_CAMP_CLIENT",
  DELETE_CAMP = "DELETE_CAMP",
  EDIT_CAMP = "EDIT_CAMP",
  EDIT_METRICA_COUNTERS = "EDIT_METRICA_COUNTERS",
  LOOKUP = "LOOKUP",
  OFFER_SERVICING = "OFFER_SERVICING",
  OTHER_MANAGER_SERVICED = "OTHER_MANAGER_SERVICED",
  PAY = "PAY",
  PAY_BY_CASH = "PAY_BY_CASH",
  REMODERATE_CAMP = "REMODERATE_CAMP",
  RESUME_CAMP = "RESUME_CAMP",
  SERVICED = "SERVICED",
  SET_AUTO_PRICE = "SET_AUTO_PRICE",
  SHOW_CAMP_SETTINGS = "SHOW_CAMP_SETTINGS",
  SHOW_CAMP_STAT = "SHOW_CAMP_STAT",
  STOP_CAMP = "STOP_CAMP",
  UNARCHIVE_CAMP = "UNARCHIVE_CAMP",
}

export enum GdCampaignAttributionModelInput {
  FIRST_CLICK = "FIRST_CLICK",
  LAST_CLICK = "LAST_CLICK",
  LAST_SIGNIFICANT_CLICK = "LAST_SIGNIFICANT_CLICK",
  LAST_YANDEX_DIRECT_CLICK = "LAST_YANDEX_DIRECT_CLICK",
}

export enum GdCampaignBudgetPeriod {
  CUSTOM = "CUSTOM",
  DAY = "DAY",
  WEEK = "WEEK",
}

export enum GdCampaignBudgetShowMode {
  DEFAULT = "DEFAULT",
  STRETCHED = "STRETCHED",
}

export enum GdCampaignCheckPositionInterval {
  M_15 = "M_15",
  M_30 = "M_30",
  M_60 = "M_60",
}

export enum GdCampaignCheckPositionIntervalInput {
  M_15 = "M_15",
  M_30 = "M_30",
  M_60 = "M_60",
}

export enum GdCampaignEmailEvent {
  CHECK_POSITION = "CHECK_POSITION",
  SEND_ACCOUNT_NEWS = "SEND_ACCOUNT_NEWS",
  STOP_BY_REACH_DAILY_BUDGET = "STOP_BY_REACH_DAILY_BUDGET",
  WARNING_BALANCE = "WARNING_BALANCE",
  XLS_READY = "XLS_READY",
}

export enum GdCampaignOrderByFieldInput {
  ID = "ID",
  NAME = "NAME",
  RECOMMENDATIONS_CLICKS = "RECOMMENDATIONS_CLICKS",
  RECOMMENDATIONS_COST = "RECOMMENDATIONS_COST",
  STAT_AVG_CLICK_COST = "STAT_AVG_CLICK_COST",
  STAT_AVG_CLICK_POSITION = "STAT_AVG_CLICK_POSITION",
  STAT_AVG_DEPTH = "STAT_AVG_DEPTH",
  STAT_AVG_GOAL_COST = "STAT_AVG_GOAL_COST",
  STAT_AVG_SHOW_POSITION = "STAT_AVG_SHOW_POSITION",
  STAT_BOUNCE_RATE = "STAT_BOUNCE_RATE",
  STAT_CLICKS = "STAT_CLICKS",
  STAT_CONVERSION_RATE = "STAT_CONVERSION_RATE",
  STAT_COST = "STAT_COST",
  STAT_COST_PER_ACTION = "STAT_COST_PER_ACTION",
  STAT_CPM_PRICE = "STAT_CPM_PRICE",
  STAT_CTR = "STAT_CTR",
  STAT_GOALS = "STAT_GOALS",
  STAT_PROFITABILITY = "STAT_PROFITABILITY",
  STAT_REVENUE = "STAT_REVENUE",
  STAT_SHOWS = "STAT_SHOWS",
  SUM = "SUM",
  TYPE = "TYPE",
}

export enum GdCampaignPlatform {
  BOTH = "BOTH",
  CONTEXT = "CONTEXT",
  SEARCH = "SEARCH",
}

export enum GdCampaignPlatformInput {
  BOTH = "BOTH",
  CONTEXT = "CONTEXT",
  SEARCH = "SEARCH",
}

export enum GdCampaignPrimaryStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
  MODERATION = "MODERATION",
  MODERATION_DENIED = "MODERATION_DENIED",
  NO_MONEY = "NO_MONEY",
  STOPPED = "STOPPED",
  TEMPORARILY_PAUSED = "TEMPORARILY_PAUSED",
}

export enum GdCampaignPrimaryStatusDesc {
  ADD_MONEY = "ADD_MONEY",
  ADD_MONEY_TO_WALLET = "ADD_MONEY_TO_WALLET",
  IS_IN_PROGRESS = "IS_IN_PROGRESS",
  IS_NOT_RECOVERED = "IS_NOT_RECOVERED",
  IS_OVER = "IS_OVER",
  IS_PAUSED_BY_DAY_BUDGET = "IS_PAUSED_BY_DAY_BUDGET",
  IS_PAUSED_BY_TIMETARGETING = "IS_PAUSED_BY_TIMETARGETING",
  IS_PAUSED_BY_WALLET_DAY_BUDGET = "IS_PAUSED_BY_WALLET_DAY_BUDGET",
  IS_WAITING_START = "IS_WAITING_START",
  NO_ACTIVE_BANNERS = "NO_ACTIVE_BANNERS",
  WAIT_PAYMENT = "WAIT_PAYMENT",
}

export enum GdCampaignPrimaryStatusInput {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
  MODERATION = "MODERATION",
  MODERATION_DENIED = "MODERATION_DENIED",
  NO_MONEY = "NO_MONEY",
  STOPPED = "STOPPED",
  TEMPORARILY_PAUSED = "TEMPORARILY_PAUSED",
}

export enum GdCampaignSmsEvent {
  FINISHED = "FINISHED",
  MODERATION = "MODERATION",
  MONEY_IN = "MONEY_IN",
  MONEY_OUT = "MONEY_OUT",
  MONITORING = "MONITORING",
  STOP_BY_REACH_DAILY_BUDGET = "STOP_BY_REACH_DAILY_BUDGET",
}

export enum GdCampaignSmsEventInput {
  FINISHED = "FINISHED",
  MODERATION = "MODERATION",
  MONEY_IN = "MONEY_IN",
  MONEY_OUT = "MONEY_OUT",
  MONITORING = "MONITORING",
  STOP_BY_REACH_DAILY_BUDGET = "STOP_BY_REACH_DAILY_BUDGET",
}

export enum GdCampaignStatusModerate {
  MEDIAPLAN = "MEDIAPLAN",
  NEW = "NEW",
  NO = "NO",
  READY = "READY",
  SENT = "SENT",
  YES = "YES",
}

export enum GdCampaignStrategyInput {
  AUTOBUDGET_AVG_CPA_PER_CAMP = "AUTOBUDGET_AVG_CPA_PER_CAMP",
  AUTOBUDGET_AVG_CPA_PER_FILTER = "AUTOBUDGET_AVG_CPA_PER_FILTER",
  AUTOBUDGET_AVG_CPC_PER_CAMP = "AUTOBUDGET_AVG_CPC_PER_CAMP",
  AUTOBUDGET_AVG_CPC_PER_FILTER = "AUTOBUDGET_AVG_CPC_PER_FILTER",
  DIFFERENT_PLACES = "DIFFERENT_PLACES",
}

export enum GdCampaignStrategyNameInput {
  AUTOBUDGET = "AUTOBUDGET",
  AUTOBUDGET_AVG_CLICK = "AUTOBUDGET_AVG_CLICK",
  AUTOBUDGET_AVG_CPA = "AUTOBUDGET_AVG_CPA",
  AUTOBUDGET_AVG_CPA_PER_CAMP = "AUTOBUDGET_AVG_CPA_PER_CAMP",
  AUTOBUDGET_AVG_CPA_PER_FILTER = "AUTOBUDGET_AVG_CPA_PER_FILTER",
  AUTOBUDGET_AVG_CPC_PER_CAMP = "AUTOBUDGET_AVG_CPC_PER_CAMP",
  AUTOBUDGET_AVG_CPC_PER_FILTER = "AUTOBUDGET_AVG_CPC_PER_FILTER",
  AUTOBUDGET_AVG_CPI = "AUTOBUDGET_AVG_CPI",
  AUTOBUDGET_MAX_IMPRESSIONS = "AUTOBUDGET_MAX_IMPRESSIONS",
  AUTOBUDGET_MAX_IMPRESSIONS_CUSTOM_PERIOD = "AUTOBUDGET_MAX_IMPRESSIONS_CUSTOM_PERIOD",
  AUTOBUDGET_MAX_REACH = "AUTOBUDGET_MAX_REACH",
  AUTOBUDGET_MAX_REACH_CUSTOM_PERIOD = "AUTOBUDGET_MAX_REACH_CUSTOM_PERIOD",
  AUTOBUDGET_MEDIA = "AUTOBUDGET_MEDIA",
  AUTOBUDGET_ROI = "AUTOBUDGET_ROI",
  AUTOBUDGET_WEEK_BUNDLE = "AUTOBUDGET_WEEK_BUNDLE",
  CPM_DEFAULT = "CPM_DEFAULT",
  DEFAULT_ = "DEFAULT_",
  MIN_PRICE = "MIN_PRICE",
  NO_PREMIUM = "NO_PREMIUM",
}

export enum GdCampaignStrategyType {
  AVG_CLICK = "AVG_CLICK",
  AVG_CPA = "AVG_CPA",
  AVG_CPA_PER_CAMP = "AVG_CPA_PER_CAMP",
  AVG_CPA_PER_FILTER = "AVG_CPA_PER_FILTER",
  AVG_CPC_PER_CAMP = "AVG_CPC_PER_CAMP",
  AVG_CPC_PER_FILTER = "AVG_CPC_PER_FILTER",
  AVG_CPI = "AVG_CPI",
  CPM_DEFAULT = "CPM_DEFAULT",
  CPM_MAX_IMPRESSIONS = "CPM_MAX_IMPRESSIONS",
  CPM_MAX_IMPRESSIONS_CUSTOM_PERIOD = "CPM_MAX_IMPRESSIONS_CUSTOM_PERIOD",
  CPM_MAX_REACH = "CPM_MAX_REACH",
  CPM_MAX_REACH_CUSTOM_PERIOD = "CPM_MAX_REACH_CUSTOM_PERIOD",
  DEFAULT = "DEFAULT",
  NO_PREMIUM = "NO_PREMIUM",
  ROI = "ROI",
  WEEK_BUDGET = "WEEK_BUDGET",
  WEEK_BUNDLE = "WEEK_BUNDLE",
}

export enum GdCampaignStrategyTypeInput {
  AVG_CLICK = "AVG_CLICK",
  AVG_CPA = "AVG_CPA",
  AVG_CPA_PER_CAMP = "AVG_CPA_PER_CAMP",
  AVG_CPA_PER_FILTER = "AVG_CPA_PER_FILTER",
  AVG_CPC_PER_CAMP = "AVG_CPC_PER_CAMP",
  AVG_CPC_PER_FILTER = "AVG_CPC_PER_FILTER",
  AVG_CPI = "AVG_CPI",
  CPM_DEFAULT = "CPM_DEFAULT",
  CPM_MAX_IMPRESSIONS = "CPM_MAX_IMPRESSIONS",
  CPM_MAX_IMPRESSIONS_CUSTOM_PERIOD = "CPM_MAX_IMPRESSIONS_CUSTOM_PERIOD",
  CPM_MAX_REACH = "CPM_MAX_REACH",
  CPM_MAX_REACH_CUSTOM_PERIOD = "CPM_MAX_REACH_CUSTOM_PERIOD",
  DEFAULT = "DEFAULT",
  NO_PREMIUM = "NO_PREMIUM",
  ROI = "ROI",
  WEEK_BUDGET = "WEEK_BUDGET",
  WEEK_BUNDLE = "WEEK_BUNDLE",
}

export enum GdCampaignType {
  CPM_BANNER = "CPM_BANNER",
  CPM_DEALS = "CPM_DEALS",
  CPM_YNDX_FRONTPAGE = "CPM_YNDX_FRONTPAGE",
  DYNAMIC = "DYNAMIC",
  INTERNAL_DISTRIB = "INTERNAL_DISTRIB",
  INTERNAL_FREE = "INTERNAL_FREE",
  MCBANNER = "MCBANNER",
  MOBILE_CONTENT = "MOBILE_CONTENT",
  PERFORMANCE = "PERFORMANCE",
  TEXT = "TEXT",
}

export enum GdCampaignTypeInput {
  CPM_BANNER = "CPM_BANNER",
  CPM_DEALS = "CPM_DEALS",
  CPM_YNDX_FRONTPAGE = "CPM_YNDX_FRONTPAGE",
  DYNAMIC = "DYNAMIC",
  INTERNAL_DISTRIB = "INTERNAL_DISTRIB",
  INTERNAL_FREE = "INTERNAL_FREE",
  MCBANNER = "MCBANNER",
  MOBILE_CONTENT = "MOBILE_CONTENT",
  PERFORMANCE = "PERFORMANCE",
  TEXT = "TEXT",
}

export enum GdCampaignsAvailableFields {
  ALLOWED_PAGE_IDS = "ALLOWED_PAGE_IDS",
  ATTRIBUTION_MODEL = "ATTRIBUTION_MODEL",
  CONTENT_LANGUAGE = "CONTENT_LANGUAGE",
}

export enum GdClientMutationState {
  NOT_SYNCED = "NOT_SYNCED",
  SYNCED = "SYNCED",
  UNKNOWN = "UNKNOWN",
}

export enum GdContentLanguage {
  BE = "BE",
  DE = "DE",
  EN = "EN",
  KZ = "KZ",
  RU = "RU",
  TR = "TR",
  UA = "UA",
}

export enum GdContentLanguageInput {
  BE = "BE",
  DE = "DE",
  EN = "EN",
  KZ = "KZ",
  RU = "RU",
  TR = "TR",
  UA = "UA",
}

export enum GdCpmGroupTypeInput {
  CPM_AUDIO = "CPM_AUDIO",
  CPM_BANNER = "CPM_BANNER",
  CPM_GEOPRODUCT = "CPM_GEOPRODUCT",
  CPM_INDOOR = "CPM_INDOOR",
  CPM_OUTDOOR = "CPM_OUTDOOR",
  CPM_VIDEO = "CPM_VIDEO",
}

export enum GdCreativeBusinessType {
  AUTO = "AUTO",
  FLIGHTS = "FLIGHTS",
  HOTELS = "HOTELS",
  NEWS = "NEWS",
  OTHER = "OTHER",
  REALTY = "REALTY",
  RETAIL = "RETAIL",
}

export enum GdCreativeBusinessTypeInput {
  AUTO = "AUTO",
  FLIGHTS = "FLIGHTS",
  HOTELS = "HOTELS",
  NEWS = "NEWS",
  OTHER = "OTHER",
  REALTY = "REALTY",
  RETAIL = "RETAIL",
}

export enum GdCreativeStatusModerate {
  ERROR = "ERROR",
  NEW = "NEW",
  NO = "NO",
  READY = "READY",
  SENDING = "SENDING",
  SENT = "SENT",
  YES = "YES",
}

export enum GdCreativeType {
  CANVAS = "CANVAS",
  CPC_VIDEO_CREATIVE = "CPC_VIDEO_CREATIVE",
  CPM_AUDIO_CREATIVE = "CPM_AUDIO_CREATIVE",
  CPM_GEOPRODUCT_CREATIVE = "CPM_GEOPRODUCT_CREATIVE",
  CPM_INDOOR_CREATIVE = "CPM_INDOOR_CREATIVE",
  CPM_OUTDOOR_CREATIVE = "CPM_OUTDOOR_CREATIVE",
  CPM_VIDEO_CREATIVE = "CPM_VIDEO_CREATIVE",
  HTML5_CREATIVE = "HTML5_CREATIVE",
  SMART = "SMART",
  VIDEO_ADDITION = "VIDEO_ADDITION",
}

export enum GdCreativeTypeInput {
  CANVAS = "CANVAS",
  CPC_VIDEO_CREATIVE = "CPC_VIDEO_CREATIVE",
  CPM_AUDIO_CREATIVE = "CPM_AUDIO_CREATIVE",
  CPM_GEOPRODUCT_CREATIVE = "CPM_GEOPRODUCT_CREATIVE",
  CPM_INDOOR_CREATIVE = "CPM_INDOOR_CREATIVE",
  CPM_OUTDOOR_CREATIVE = "CPM_OUTDOOR_CREATIVE",
  CPM_VIDEO_CREATIVE = "CPM_VIDEO_CREATIVE",
  HTML5_CREATIVE = "HTML5_CREATIVE",
  SMART = "SMART",
  VIDEO_ADDITION = "VIDEO_ADDITION",
}

export enum GdDayBudgetShowModeInput {
  DEFAULT_ = "DEFAULT_",
  STRETCHED = "STRETCHED",
}

export enum GdFeedType {
  ALIBABA = "ALIBABA",
  ALIEXPRESS = "ALIEXPRESS",
  AUTO_RU = "AUTO_RU",
  CRITEO_TURKEY = "CRITEO_TURKEY",
  GOOGLE_CUSTOM = "GOOGLE_CUSTOM",
  GOOGLE_FLIGHTS = "GOOGLE_FLIGHTS",
  GOOGLE_HOTELS = "GOOGLE_HOTELS",
  GOOGLE_MERCHANT = "GOOGLE_MERCHANT",
  GOOGLE_TRAVEL = "GOOGLE_TRAVEL",
  TRAVEL_BOOKING = "TRAVEL_BOOKING",
  TURKEY_CLIENT_1 = "TURKEY_CLIENT_1",
  TURKEY_CLIENT_10 = "TURKEY_CLIENT_10",
  TURKEY_CLIENT_11 = "TURKEY_CLIENT_11",
  TURKEY_CLIENT_12 = "TURKEY_CLIENT_12",
  TURKEY_CLIENT_13 = "TURKEY_CLIENT_13",
  TURKEY_CLIENT_14 = "TURKEY_CLIENT_14",
  TURKEY_CLIENT_15 = "TURKEY_CLIENT_15",
  TURKEY_CLIENT_16 = "TURKEY_CLIENT_16",
  TURKEY_CLIENT_17 = "TURKEY_CLIENT_17",
  TURKEY_CLIENT_18 = "TURKEY_CLIENT_18",
  TURKEY_CLIENT_19 = "TURKEY_CLIENT_19",
  TURKEY_CLIENT_2 = "TURKEY_CLIENT_2",
  TURKEY_CLIENT_20 = "TURKEY_CLIENT_20",
  TURKEY_CLIENT_21 = "TURKEY_CLIENT_21",
  TURKEY_CLIENT_22 = "TURKEY_CLIENT_22",
  TURKEY_CLIENT_23 = "TURKEY_CLIENT_23",
  TURKEY_CLIENT_24 = "TURKEY_CLIENT_24",
  TURKEY_CLIENT_25 = "TURKEY_CLIENT_25",
  TURKEY_CLIENT_3 = "TURKEY_CLIENT_3",
  TURKEY_CLIENT_4 = "TURKEY_CLIENT_4",
  TURKEY_CLIENT_5 = "TURKEY_CLIENT_5",
  TURKEY_CLIENT_6 = "TURKEY_CLIENT_6",
  TURKEY_CLIENT_7 = "TURKEY_CLIENT_7",
  TURKEY_CLIENT_8 = "TURKEY_CLIENT_8",
  TURKEY_CLIENT_9 = "TURKEY_CLIENT_9",
  TURKEY_JOLLY_TUR = "TURKEY_JOLLY_TUR",
  TURKEY_TEKNOSA = "TURKEY_TEKNOSA",
  YANDEX_CUSTOM = "YANDEX_CUSTOM",
  YANDEX_MARKET = "YANDEX_MARKET",
  YANDEX_REALTY = "YANDEX_REALTY",
  YANDEX_ZEN = "YANDEX_ZEN",
}

export enum GdFeedTypeInput {
  ALIBABA = "ALIBABA",
  ALIEXPRESS = "ALIEXPRESS",
  AUTO_RU = "AUTO_RU",
  CRITEO_TURKEY = "CRITEO_TURKEY",
  GOOGLE_CUSTOM = "GOOGLE_CUSTOM",
  GOOGLE_FLIGHTS = "GOOGLE_FLIGHTS",
  GOOGLE_HOTELS = "GOOGLE_HOTELS",
  GOOGLE_MERCHANT = "GOOGLE_MERCHANT",
  GOOGLE_TRAVEL = "GOOGLE_TRAVEL",
  TRAVEL_BOOKING = "TRAVEL_BOOKING",
  TURKEY_CLIENT_1 = "TURKEY_CLIENT_1",
  TURKEY_CLIENT_10 = "TURKEY_CLIENT_10",
  TURKEY_CLIENT_11 = "TURKEY_CLIENT_11",
  TURKEY_CLIENT_12 = "TURKEY_CLIENT_12",
  TURKEY_CLIENT_13 = "TURKEY_CLIENT_13",
  TURKEY_CLIENT_14 = "TURKEY_CLIENT_14",
  TURKEY_CLIENT_15 = "TURKEY_CLIENT_15",
  TURKEY_CLIENT_16 = "TURKEY_CLIENT_16",
  TURKEY_CLIENT_17 = "TURKEY_CLIENT_17",
  TURKEY_CLIENT_18 = "TURKEY_CLIENT_18",
  TURKEY_CLIENT_19 = "TURKEY_CLIENT_19",
  TURKEY_CLIENT_2 = "TURKEY_CLIENT_2",
  TURKEY_CLIENT_20 = "TURKEY_CLIENT_20",
  TURKEY_CLIENT_21 = "TURKEY_CLIENT_21",
  TURKEY_CLIENT_22 = "TURKEY_CLIENT_22",
  TURKEY_CLIENT_23 = "TURKEY_CLIENT_23",
  TURKEY_CLIENT_24 = "TURKEY_CLIENT_24",
  TURKEY_CLIENT_25 = "TURKEY_CLIENT_25",
  TURKEY_CLIENT_3 = "TURKEY_CLIENT_3",
  TURKEY_CLIENT_4 = "TURKEY_CLIENT_4",
  TURKEY_CLIENT_5 = "TURKEY_CLIENT_5",
  TURKEY_CLIENT_6 = "TURKEY_CLIENT_6",
  TURKEY_CLIENT_7 = "TURKEY_CLIENT_7",
  TURKEY_CLIENT_8 = "TURKEY_CLIENT_8",
  TURKEY_CLIENT_9 = "TURKEY_CLIENT_9",
  TURKEY_JOLLY_TUR = "TURKEY_JOLLY_TUR",
  TURKEY_TEKNOSA = "TURKEY_TEKNOSA",
  YANDEX_CUSTOM = "YANDEX_CUSTOM",
  YANDEX_MARKET = "YANDEX_MARKET",
  YANDEX_REALTY = "YANDEX_REALTY",
  YANDEX_ZEN = "YANDEX_ZEN",
}

export enum GdFindAndReplaceKeywordFieldInput {
  KEYWORD = "KEYWORD",
  MINUS_KEYWORDS = "MINUS_KEYWORDS",
}

export enum GdFreelancerCertificateType {
  DIRECT = "DIRECT",
  DIRECT_PRO = "DIRECT_PRO",
  METRIKA = "METRIKA",
}

export enum GdFreelancerProjectStatus {
  CANCELLED_BY_CLIENT = "CANCELLED_BY_CLIENT",
  CANCELLED_BY_FREELANCER = "CANCELLED_BY_FREELANCER",
  IN_PROGRESS = "IN_PROGRESS",
  NEW = "NEW",
}

export enum GdFreelancerSkillOfferDuration {
  FROM_14_TO_28_DAYS = "FROM_14_TO_28_DAYS",
  FROM_1_TO_3_DAYS = "FROM_1_TO_3_DAYS",
  FROM_1_TO_3_MONTHS = "FROM_1_TO_3_MONTHS",
  FROM_3_TO_7_DAYS = "FROM_3_TO_7_DAYS",
  FROM_7_TO_14_DAYS = "FROM_7_TO_14_DAYS",
  MONTHLY = "MONTHLY",
  MORE_THAN_3_MONTHS = "MORE_THAN_3_MONTHS",
  NOT_DEFINED = "NOT_DEFINED",
}

export enum GdFreelancerSkillOfferDurationInput {
  FROM_14_TO_28_DAYS = "FROM_14_TO_28_DAYS",
  FROM_1_TO_3_DAYS = "FROM_1_TO_3_DAYS",
  FROM_1_TO_3_MONTHS = "FROM_1_TO_3_MONTHS",
  FROM_3_TO_7_DAYS = "FROM_3_TO_7_DAYS",
  FROM_7_TO_14_DAYS = "FROM_7_TO_14_DAYS",
  MONTHLY = "MONTHLY",
  MORE_THAN_3_MONTHS = "MORE_THAN_3_MONTHS",
  NOT_DEFINED = "NOT_DEFINED",
}

export enum GdFreelancerStatus {
  BUSY = "BUSY",
  FREE = "FREE",
}

export enum GdFreelancerStatusInput {
  BUSY = "BUSY",
  FREE = "FREE",
}

export enum GdFreelancerUgcModerationStatus {
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
  IN_PROGRESS = "IN_PROGRESS",
}

export enum GdFreelancersCardStatusModerate {
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
  DRAFT = "DRAFT",
  IN_PROGRESS = "IN_PROGRESS",
}

export enum GdGenderType {
  FEMALE = "FEMALE",
  MALE = "MALE",
}

export enum GdGenderTypeInput {
  FEMALE = "FEMALE",
  MALE = "MALE",
}

export enum GdGeotreeType {
  GLOBAL = "GLOBAL",
  RUSSIAN = "RUSSIAN",
}

export enum GdGoalType {
  AB_SEGMENT = "AB_SEGMENT",
  AUDIENCE = "AUDIENCE",
  AUDIO_GENRES = "AUDIO_GENRES",
  BEHAVIORS = "BEHAVIORS",
  ECOMMERCE = "ECOMMERCE",
  FAMILY = "FAMILY",
  GOAL = "GOAL",
  INTERESTS = "INTERESTS",
  SEGMENT = "SEGMENT",
  SOCIAL_DEMO = "SOCIAL_DEMO",
}

export enum GdGoalTypeInput {
  AB_SEGMENT = "AB_SEGMENT",
  AUDIENCE = "AUDIENCE",
  AUDIO_GENRES = "AUDIO_GENRES",
  BEHAVIORS = "BEHAVIORS",
  ECOMMERCE = "ECOMMERCE",
  FAMILY = "FAMILY",
  GOAL = "GOAL",
  INTERESTS = "INTERESTS",
  SEGMENT = "SEGMENT",
  SOCIAL_DEMO = "SOCIAL_DEMO",
}

export enum GdGroupBlGenerationStatus {
  INAPPLICABLE = "INAPPLICABLE",
  NO = "NO",
  PROCESSING = "PROCESSING",
  YES = "YES",
}

export enum GdInstantMessengerType {
  ICQ = "ICQ",
  JABBER = "JABBER",
  MAIL_AGENT = "MAIL_AGENT",
  MSN = "MSN",
  SKYPE = "SKYPE",
}

export enum GdInstantMessengerTypeInput {
  ICQ = "ICQ",
  JABBER = "JABBER",
  MAIL_AGENT = "MAIL_AGENT",
  MSN = "MSN",
  SKYPE = "SKYPE",
}

export enum GdInventoryTypeInput {
  INBANNER = "INBANNER",
  INPAGE = "INPAGE",
  INSTREAM_WEB = "INSTREAM_WEB",
  INTERSTITIAL = "INTERSTITIAL",
  REWARDED = "REWARDED",
}

export enum GdLanguageInput {
  EN = "EN",
  RU = "RU",
  TR = "TR",
  UK = "UK",
}

export enum GdMenuItem {
  ADMIN = "ADMIN",
  ADMIN_AGENCY = "ADMIN_AGENCY",
  ADMIN_MANAGER = "ADMIN_MANAGER",
  ADVANCED_FORECAST = "ADVANCED_FORECAST",
  AGENCY_SEARCH = "AGENCY_SEARCH",
  CREATE = "CREATE",
  DEALS_LIST = "DEALS_LIST",
  RECOMMENDATIONS = "RECOMMENDATIONS",
  SHOW_AGENCY_CLIENTS = "SHOW_AGENCY_CLIENTS",
  SHOW_CAMPS = "SHOW_CAMPS",
  SHOW_MANAGER_CLIENTS = "SHOW_MANAGER_CLIENTS",
  SHOW_MINUS_KEYWORDS_LIB = "SHOW_MINUS_KEYWORDS_LIB",
  SHOW_SEARCH_PAGE = "SHOW_SEARCH_PAGE",
  WORDSTAT = "WORDSTAT",
}

export enum GdMetroCityInput {
  KYIV = "KYIV",
  MOSCOW = "MOSCOW",
  SAINT_PETERSBURG = "SAINT_PETERSBURG",
}

export enum GdMobileOsTypeInput {
  ANDROID = "ANDROID",
  IOS = "IOS",
}

export enum GdOperationType {
  EQ = "EQ",
  GE = "GE",
  LE = "LE",
}

export enum GdOperationTypeInput {
  EQ = "EQ",
  GE = "GE",
  LE = "LE",
}

export enum GdOperatorAction {
  ACCEPT_ADS_CALLOUTS_MODERATION = "ACCEPT_ADS_CALLOUTS_MODERATION",
  ACCEPT_MODERATION = "ACCEPT_MODERATION",
  COPY = "COPY",
  REMODERATE_ADS_CALLOUTS = "REMODERATE_ADS_CALLOUTS",
  REMODERATE_CAMPAIGN = "REMODERATE_CAMPAIGN",
  SEND_TO_BS = "SEND_TO_BS",
  SEND_TO_MODERATION = "SEND_TO_MODERATION",
  SEND_TO_MODERATION_BY_CLIENT = "SEND_TO_MODERATION_BY_CLIENT",
  SEND_TO_REMODERATION = "SEND_TO_REMODERATION",
}

export enum GdOrganizationStatusPublish {
  PUBLISHED = "PUBLISHED",
  UNKNOWN = "UNKNOWN",
  UNPUBLISHED = "UNPUBLISHED",
}

export enum GdOsType {
  ANDROID = "ANDROID",
  IOS = "IOS",
}

export enum GdOsTypeInput {
  ANDROID = "ANDROID",
  IOS = "IOS",
}

export enum GdPageOrderByFieldInput {
  CLICKS = "CLICKS",
  COST = "COST",
}

export enum GdPixelKind {
  AUDIENCE = "AUDIENCE",
  AUDIT = "AUDIT",
}

export enum GdPixelKindInput {
  AUDIENCE = "AUDIENCE",
  AUDIT = "AUDIT",
}

export enum GdPointPrecision {
  EXACT = "EXACT",
  NEAR = "NEAR",
  NUMBER = "NUMBER",
  OTHER = "OTHER",
  RANGE = "RANGE",
  STREET = "STREET",
}

export enum GdProductCalcTypeInput {
  CPC = "CPC",
  CPM = "CPM",
}

export enum GdProductType {
  ANTICONTEXT = "ANTICONTEXT",
  CPM_AUDIO = "CPM_AUDIO",
  CPM_BANNER = "CPM_BANNER",
  CPM_DEALS = "CPM_DEALS",
  CPM_INDOOR = "CPM_INDOOR",
  CPM_OUTDOOR = "CPM_OUTDOOR",
  CPM_PRICE = "CPM_PRICE",
  CPM_VIDEO = "CPM_VIDEO",
  CPM_YNDX_FRONTPAGE = "CPM_YNDX_FRONTPAGE",
  GEO = "GEO",
  INTERNAL_DISTRIB = "INTERNAL_DISTRIB",
  INTERNAL_FREE = "INTERNAL_FREE",
  MCB = "MCB",
  MCB_PKG = "MCB_PKG",
  MCB_REGIONAL = "MCB_REGIONAL",
  MCB_TURKISH = "MCB_TURKISH",
  SOCDEM = "SOCDEM",
  TEXT = "TEXT",
}

export enum GdProductTypeInput {
  ANTICONTEXT = "ANTICONTEXT",
  CPM_AUDIO = "CPM_AUDIO",
  CPM_BANNER = "CPM_BANNER",
  CPM_DEALS = "CPM_DEALS",
  CPM_INDOOR = "CPM_INDOOR",
  CPM_OUTDOOR = "CPM_OUTDOOR",
  CPM_PRICE = "CPM_PRICE",
  CPM_VIDEO = "CPM_VIDEO",
  CPM_YNDX_FRONTPAGE = "CPM_YNDX_FRONTPAGE",
  GEO = "GEO",
  INTERNAL_DISTRIB = "INTERNAL_DISTRIB",
  INTERNAL_FREE = "INTERNAL_FREE",
  MCB = "MCB",
  MCB_PKG = "MCB_PKG",
  MCB_REGIONAL = "MCB_REGIONAL",
  MCB_TURKISH = "MCB_TURKISH",
  SOCDEM = "SOCDEM",
  TEXT = "TEXT",
}

export enum GdRecommendationSign {
  CPA = "CPA",
  CPC = "CPC",
  ROI = "ROI",
}

export enum GdRecommendationStatus {
  CANCELLED = "CANCELLED",
  DONE = "DONE",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  READY = "READY",
}

export enum GdResourceType {
  AGE = "AGE",
  IMAGE = "IMAGE",
  TEXT = "TEXT",
  URL = "URL",
}

export enum GdResourceValueRestrictionType {
  IMAGE_DIMENSIONS_EQ = "IMAGE_DIMENSIONS_EQ",
  IMAGE_DIMENSIONS_MAX = "IMAGE_DIMENSIONS_MAX",
  IMAGE_DIMENSIONS_MIN = "IMAGE_DIMENSIONS_MIN",
  IMAGE_FORMAT_IN = "IMAGE_FORMAT_IN",
  IMAGE_SIZE_KB_MAX = "IMAGE_SIZE_KB_MAX",
  TEXT_LENGTH_MAX = "TEXT_LENGTH_MAX",
  TEXT_LENGTH_MIN = "TEXT_LENGTH_MIN",
  URL_CORRECT = "URL_CORRECT",
}

export enum GdRestrictionImageFormat {
  GIF = "GIF",
  JPEG = "JPEG",
  PNG = "PNG",
  SVG = "SVG",
}

export enum GdRetargetingBaseStatusInput {
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
}

export enum GdRetargetingConditionRuleType {
  ALL = "ALL",
  NOT = "NOT",
  OR = "OR",
}

export enum GdRetargetingConditionRuleTypeInput {
  ALL = "ALL",
  NOT = "NOT",
  OR = "OR",
}

export enum GdRetargetingConditionTypeInput {
  AB_SEGMENTS = "AB_SEGMENTS",
  DMP = "DMP",
  INTERESTS = "INTERESTS",
  METRIKA_GOALS = "METRIKA_GOALS",
}

export enum GdRetargetingOrderByFieldInput {
  AUTOBUDGET_PRIORITY = "AUTOBUDGET_PRIORITY",
  BANNER_ID = "BANNER_ID",
  CAMPAIGN_ID = "CAMPAIGN_ID",
  GROUP_ID = "GROUP_ID",
  ID = "ID",
  NAME = "NAME",
  PRICE_CONTEXT = "PRICE_CONTEXT",
  RETARGETING_CONDITION_ID = "RETARGETING_CONDITION_ID",
  STAT_AVG_CLICK_COST = "STAT_AVG_CLICK_COST",
  STAT_AVG_CLICK_POSITION = "STAT_AVG_CLICK_POSITION",
  STAT_AVG_DEPTH = "STAT_AVG_DEPTH",
  STAT_AVG_GOAL_COST = "STAT_AVG_GOAL_COST",
  STAT_AVG_SHOW_POSITION = "STAT_AVG_SHOW_POSITION",
  STAT_BOUNCE_RATE = "STAT_BOUNCE_RATE",
  STAT_CLICKS = "STAT_CLICKS",
  STAT_CONVERSION_RATE = "STAT_CONVERSION_RATE",
  STAT_COST = "STAT_COST",
  STAT_CPM_PRICE = "STAT_CPM_PRICE",
  STAT_CTR = "STAT_CTR",
  STAT_GOALS = "STAT_GOALS",
  STAT_PROFITABILITY = "STAT_PROFITABILITY",
  STAT_REVENUE = "STAT_REVENUE",
  STAT_SHOWS = "STAT_SHOWS",
}

export enum GdShowConditionAutobudgetPriority {
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
}

export enum GdShowConditionAutobudgetPriorityInput {
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
}

export enum GdShowConditionBaseStatusInput {
  ACTIVE = "ACTIVE",
  DRAFT = "DRAFT",
  SUSPENDED = "SUSPENDED",
}

export enum GdShowConditionOrderByFieldInput {
  AUTOBUDGET_PRIORITY = "AUTOBUDGET_PRIORITY",
  CAMPAIGN_ID = "CAMPAIGN_ID",
  GROUP_ID = "GROUP_ID",
  ID = "ID",
  KEYWORD = "KEYWORD",
  PRICE = "PRICE",
  PRICE_CONTEXT = "PRICE_CONTEXT",
  STAT_AVG_CLICK_COST = "STAT_AVG_CLICK_COST",
  STAT_AVG_CLICK_POSITION = "STAT_AVG_CLICK_POSITION",
  STAT_AVG_DEPTH = "STAT_AVG_DEPTH",
  STAT_AVG_GOAL_COST = "STAT_AVG_GOAL_COST",
  STAT_AVG_SHOW_POSITION = "STAT_AVG_SHOW_POSITION",
  STAT_BOUNCE_RATE = "STAT_BOUNCE_RATE",
  STAT_CLICKS = "STAT_CLICKS",
  STAT_CONVERSION_RATE = "STAT_CONVERSION_RATE",
  STAT_COST = "STAT_COST",
  STAT_COST_PER_ACTION = "STAT_COST_PER_ACTION",
  STAT_CPM_PRICE = "STAT_CPM_PRICE",
  STAT_CTR = "STAT_CTR",
  STAT_GOALS = "STAT_GOALS",
  STAT_PROFITABILITY = "STAT_PROFITABILITY",
  STAT_REVENUE = "STAT_REVENUE",
  STAT_SHOWS = "STAT_SHOWS",
  TYPE = "TYPE",
}

export enum GdShowConditionPrimaryStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
  MODERATION_REJECTED = "MODERATION_REJECTED",
  STOPPED = "STOPPED",
}

export enum GdShowConditionPrimaryStatusInput {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
  MODERATION_REJECTED = "MODERATION_REJECTED",
  STOPPED = "STOPPED",
}

export enum GdShowConditionStatusModerate {
  NEW = "NEW",
  NO = "NO",
  YES = "YES",
}

export enum GdShowConditionType {
  DYNAMIC_TARGETING = "DYNAMIC_TARGETING",
  FILTERS = "FILTERS",
  KEYWORD = "KEYWORD",
  MOBILE_INTERESTS = "MOBILE_INTERESTS",
  RELEVANCE_MATCH = "RELEVANCE_MATCH",
  RETARGETING = "RETARGETING",
  USER_PROFILE = "USER_PROFILE",
}

export enum GdShowConditionTypeInput {
  DYNAMIC_TARGETING = "DYNAMIC_TARGETING",
  FILTERS = "FILTERS",
  KEYWORD = "KEYWORD",
  MOBILE_INTERESTS = "MOBILE_INTERESTS",
  RELEVANCE_MATCH = "RELEVANCE_MATCH",
  RETARGETING = "RETARGETING",
  USER_PROFILE = "USER_PROFILE",
}

export enum GdSmartFilterBaseStatusInput {
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
}

export enum GdSmartFilterConditionOperator {
  CONTAINS_ANY = "CONTAINS_ANY",
  EQUALS_ANY = "EQUALS_ANY",
  EXISTS = "EXISTS",
  GREATER_THAN = "GREATER_THAN",
  LESS_THAN = "LESS_THAN",
  NOT_CONTAINS_ALL = "NOT_CONTAINS_ALL",
  RANGE = "RANGE",
}

export enum GdSmartFilterConditionOperatorInput {
  CONTAINS_ANY = "CONTAINS_ANY",
  EQUALS_ANY = "EQUALS_ANY",
  EXISTS = "EXISTS",
  GREATER_THAN = "GREATER_THAN",
  LESS_THAN = "LESS_THAN",
  NOT_CONTAINS_ALL = "NOT_CONTAINS_ALL",
  RANGE = "RANGE",
}

export enum GdSmartFilterOrderByFieldInput {
  AUTOBUDGET_PRIORITY = "AUTOBUDGET_PRIORITY",
  CAMPAIGN_ID = "CAMPAIGN_ID",
  FILTER_NAME = "FILTER_NAME",
  GROUP_ID = "GROUP_ID",
  ID = "ID",
  PRICE_CPA = "PRICE_CPA",
  PRICE_CPC = "PRICE_CPC",
  STAT_AVG_CLICK_COST = "STAT_AVG_CLICK_COST",
  STAT_AVG_CLICK_POSITION = "STAT_AVG_CLICK_POSITION",
  STAT_AVG_DEPTH = "STAT_AVG_DEPTH",
  STAT_AVG_GOAL_COST = "STAT_AVG_GOAL_COST",
  STAT_AVG_SHOW_POSITION = "STAT_AVG_SHOW_POSITION",
  STAT_BOUNCE_RATE = "STAT_BOUNCE_RATE",
  STAT_CLICKS = "STAT_CLICKS",
  STAT_CONVERSION_RATE = "STAT_CONVERSION_RATE",
  STAT_COST = "STAT_COST",
  STAT_COST_PER_ACTION = "STAT_COST_PER_ACTION",
  STAT_CPM_PRICE = "STAT_CPM_PRICE",
  STAT_CTR = "STAT_CTR",
  STAT_GOALS = "STAT_GOALS",
  STAT_PROFITABILITY = "STAT_PROFITABILITY",
  STAT_REVENUE = "STAT_REVENUE",
  STAT_SHOWS = "STAT_SHOWS",
}

export enum GdSmartFilterPrimaryStatus {
  ACTIVE = "ACTIVE",
  STOPPED = "STOPPED",
}

export enum GdSmartFilterTab {
  ALL_PRODUCTS = "ALL_PRODUCTS",
  CONDITION = "CONDITION",
  TREE = "TREE",
}

export enum GdSmartFilterTabInput {
  ALL_PRODUCTS = "ALL_PRODUCTS",
  CONDITION = "CONDITION",
  TREE = "TREE",
}

export enum GdSmartFilterTargetFunnel {
  NEW_AUDITORY = "NEW_AUDITORY",
  PRODUCT_PAGE_VISIT = "PRODUCT_PAGE_VISIT",
  SAME_PRODUCTS = "SAME_PRODUCTS",
}

export enum GdSmartFilterTargetFunnelInput {
  NEW_AUDITORY = "NEW_AUDITORY",
  PRODUCT_PAGE_VISIT = "PRODUCT_PAGE_VISIT",
  SAME_PRODUCTS = "SAME_PRODUCTS",
}

export enum GdStatPresetInput {
  CURRENT_MONTH = "CURRENT_MONTH",
  CURRENT_WEEK = "CURRENT_WEEK",
  LAST_30DAYS = "LAST_30DAYS",
  LAST_7DAYS = "LAST_7DAYS",
  PREVIOUS_MONTH = "PREVIOUS_MONTH",
  PREVIOUS_WEEK = "PREVIOUS_WEEK",
  RECOMMENDATIONS_PERIOD = "RECOMMENDATIONS_PERIOD",
  TODAY = "TODAY",
  YESTERDAY = "YESTERDAY",
}

export enum GdStringDictName {
  DISTRIB_SOFT = "DISTRIB_SOFT",
  UA_TRAITS_BROWSER_BASE = "UA_TRAITS_BROWSER_BASE",
  UA_TRAITS_BROWSER_ENGINE = "UA_TRAITS_BROWSER_ENGINE",
  UA_TRAITS_BROWSER_NAME = "UA_TRAITS_BROWSER_NAME",
  UA_TRAITS_DEVICE_VENDOR = "UA_TRAITS_DEVICE_VENDOR",
  UA_TRAITS_OS_FAMILY = "UA_TRAITS_OS_FAMILY",
  UA_TRAITS_OS_NAME = "UA_TRAITS_OS_NAME",
}

export enum GdStringDictNameInput {
  DISTRIB_SOFT = "DISTRIB_SOFT",
  UA_TRAITS_BROWSER_BASE = "UA_TRAITS_BROWSER_BASE",
  UA_TRAITS_BROWSER_ENGINE = "UA_TRAITS_BROWSER_ENGINE",
  UA_TRAITS_BROWSER_NAME = "UA_TRAITS_BROWSER_NAME",
  UA_TRAITS_DEVICE_VENDOR = "UA_TRAITS_DEVICE_VENDOR",
  UA_TRAITS_OS_FAMILY = "UA_TRAITS_OS_FAMILY",
  UA_TRAITS_OS_NAME = "UA_TRAITS_OS_NAME",
}

export enum GdSurveyStatus {
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
  DRAFT = "DRAFT",
  MODERATION = "MODERATION",
  MODERATION_REJECTED = "MODERATION_REJECTED",
  UNFEASIBLE = "UNFEASIBLE",
}

export enum GdUpdateAdGroupMinusKeywordsActionInput {
  ADD = "ADD",
  REMOVE = "REMOVE",
}

export enum GdUpdateStatus {
  DONE = "DONE",
  ERROR = "ERROR",
  NEW = "NEW",
  OUTDATED = "OUTDATED",
  UPDATING = "UPDATING",
}

export enum GdVideoGoalType {
  COMPLETE = "COMPLETE",
  FIRST_QUARTILE = "FIRST_QUARTILE",
  MIDPOINT = "MIDPOINT",
  START = "START",
  THIRD_QUARTILE = "THIRD_QUARTILE",
}

export enum GdVideoGoalTypeInput {
  COMPLETE = "COMPLETE",
  FIRST_QUARTILE = "FIRST_QUARTILE",
  MIDPOINT = "MIDPOINT",
  START = "START",
  THIRD_QUARTILE = "THIRD_QUARTILE",
}

export enum GdWalletAction {
  EDIT = "EDIT",
  PAY = "PAY",
}

export enum GdWalletBudgetShowMode {
  DEFAULT = "DEFAULT",
  STRETCHED = "STRETCHED",
}

export enum GdWalletBudgetType {
  DAY_BUDGET = "DAY_BUDGET",
  NO_BUDGET = "NO_BUDGET",
}

export enum GdWeatherType {
  CLOUDNESS = "CLOUDNESS",
  PREC_STRENGTH = "PREC_STRENGTH",
  TEMP = "TEMP",
}

export enum GdWeatherTypeInput {
  CLOUDNESS = "CLOUDNESS",
  PREC_STRENGTH = "PREC_STRENGTH",
  TEMP = "TEMP",
}

export enum GdiDealOrderByFieldInput {
  CLICKS = "CLICKS",
  COMPLETE_REASON = "COMPLETE_REASON",
  CPC = "CPC",
  CPM = "CPM",
  CTR = "CTR",
  DEAL_TYPE = "DEAL_TYPE",
  ID = "ID",
  MIN_PRICE = "MIN_PRICE",
  NAME = "NAME",
  SHOWS = "SHOWS",
  SPENT = "SPENT",
  STATUS = "STATUS",
}

export enum GdiRecommendationType {
  addAdditionItemCallouts = "addAdditionItemCallouts",
  addBannerDisplayHrefs = "addBannerDisplayHrefs",
  addBannerFormats = "addBannerFormats",
  addImageToBanner = "addImageToBanner",
  addMorePicturesToAdgroup = "addMorePicturesToAdgroup",
  addSiteLinks = "addSiteLinks",
  addTitleExtension = "addTitleExtension",
  addTurboWebSiteToBanner = "addTurboWebSiteToBanner",
  changeAdGroupForModeration = "changeAdGroupForModeration",
  changeAdGroupWithLowStat = "changeAdGroupWithLowStat",
  changeBannerForModeration = "changeBannerForModeration",
  chooseAppropriatePlacementsForAdGroup = "chooseAppropriatePlacementsForAdGroup",
  chooseAppropriatePlacementsForBanner = "chooseAppropriatePlacementsForBanner",
  dailyBudget = "dailyBudget",
  removePagesFromBlackList = "removePagesFromBlackList",
  removePagesFromBlackListOfACampaign = "removePagesFromBlackListOfACampaign",
  sendLicensesBanks = "sendLicensesBanks",
  sendLicensesMedServices = "sendLicensesMedServices",
  sendLicensesPharmacy = "sendLicensesPharmacy",
  switchOnAutotargeting = "switchOnAutotargeting",
  uploadAppropriateCreatives = "uploadAppropriateCreatives",
}

export enum GdiRecommendationTypeInput {
  addAdditionItemCallouts = "addAdditionItemCallouts",
  addBannerDisplayHrefs = "addBannerDisplayHrefs",
  addBannerFormats = "addBannerFormats",
  addImageToBanner = "addImageToBanner",
  addMorePicturesToAdgroup = "addMorePicturesToAdgroup",
  addSiteLinks = "addSiteLinks",
  addTitleExtension = "addTitleExtension",
  addTurboWebSiteToBanner = "addTurboWebSiteToBanner",
  changeAdGroupForModeration = "changeAdGroupForModeration",
  changeAdGroupWithLowStat = "changeAdGroupWithLowStat",
  changeBannerForModeration = "changeBannerForModeration",
  chooseAppropriatePlacementsForAdGroup = "chooseAppropriatePlacementsForAdGroup",
  chooseAppropriatePlacementsForBanner = "chooseAppropriatePlacementsForBanner",
  dailyBudget = "dailyBudget",
  removePagesFromBlackList = "removePagesFromBlackList",
  removePagesFromBlackListOfACampaign = "removePagesFromBlackListOfACampaign",
  sendLicensesBanks = "sendLicensesBanks",
  sendLicensesMedServices = "sendLicensesMedServices",
  sendLicensesPharmacy = "sendLicensesPharmacy",
  switchOnAutotargeting = "switchOnAutotargeting",
  uploadAppropriateCreatives = "uploadAppropriateCreatives",
}

export enum GoalSubtype {
  APPMETRICA_API_KEY = "APPMETRICA_API_KEY",
  APPMETRICA_SEGMENT_ID = "APPMETRICA_SEGMENT_ID",
  COMPOSITION_INTERSECT = "COMPOSITION_INTERSECT",
  COMPOSITION_SUBTRACT = "COMPOSITION_SUBTRACT",
  COMPOSITION_UNION = "COMPOSITION_UNION",
  GEO_CONDITION = "GEO_CONDITION",
  GEO_HOME = "GEO_HOME",
  GEO_LAST = "GEO_LAST",
  GEO_REGULAR = "GEO_REGULAR",
  GEO_WORK = "GEO_WORK",
  LOOKALIKE = "LOOKALIKE",
  METRIKA_COUNTER_ID = "METRIKA_COUNTER_ID",
  METRIKA_GOAL_ID = "METRIKA_GOAL_ID",
  METRIKA_SEGMENT_ID = "METRIKA_SEGMENT_ID",
  PIXEL = "PIXEL",
  UPLOADING_CLIENT_ID = "UPLOADING_CLIENT_ID",
  UPLOADING_CRM = "UPLOADING_CRM",
  UPLOADING_EMAIL = "UPLOADING_EMAIL",
  UPLOADING_IDFA_GAID = "UPLOADING_IDFA_GAID",
  UPLOADING_MAC = "UPLOADING_MAC",
  UPLOADING_PHONE = "UPLOADING_PHONE",
  UPLOADING_YUID = "UPLOADING_YUID",
  URL_EMAIL = "URL_EMAIL",
  URL_IDFA_GAID = "URL_IDFA_GAID",
  URL_PHONE = "URL_PHONE",
  URL_YUID = "URL_YUID",
}

export enum GroupTypeInput {
  AUDIO = "AUDIO",
  BANNER = "BANNER",
  BANNER_IN_METRO = "BANNER_IN_METRO",
  GEOPRODUCT = "GEOPRODUCT",
  INDOOR = "INDOOR",
  MAIN_PAGE = "MAIN_PAGE",
  OUTDOOR = "OUTDOOR",
  UNKNOWN = "UNKNOWN",
  VIDEO = "VIDEO",
}

export enum InterfaceLang {
  BY = "BY",
  EN = "EN",
  KZ = "KZ",
  RU = "RU",
  TR = "TR",
  TT = "TT",
  UK = "UK",
}

export enum InterfaceLangInput {
  BY = "BY",
  EN = "EN",
  KZ = "KZ",
  RU = "RU",
  TR = "TR",
  TT = "TT",
  UK = "UK",
}

export enum LanguageInput {
  AA = "AA",
  AB = "AB",
  AE = "AE",
  AF = "AF",
  AK = "AK",
  AM = "AM",
  AN = "AN",
  AR = "AR",
  AS = "AS",
  AV = "AV",
  AY = "AY",
  AZ = "AZ",
  BA = "BA",
  BE = "BE",
  BG = "BG",
  BH = "BH",
  BI = "BI",
  BM = "BM",
  BN = "BN",
  BO = "BO",
  BR = "BR",
  BS = "BS",
  CA = "CA",
  CE = "CE",
  CH = "CH",
  CO = "CO",
  CR = "CR",
  CS = "CS",
  CU = "CU",
  CV = "CV",
  CY = "CY",
  DA = "DA",
  DE = "DE",
  DV = "DV",
  DZ = "DZ",
  EE = "EE",
  EL = "EL",
  EN = "EN",
  EO = "EO",
  ES = "ES",
  ET = "ET",
  EU = "EU",
  FA = "FA",
  FF = "FF",
  FI = "FI",
  FJ = "FJ",
  FO = "FO",
  FR = "FR",
  FY = "FY",
  GA = "GA",
  GD = "GD",
  GL = "GL",
  GN = "GN",
  GU = "GU",
  GV = "GV",
  HA = "HA",
  HE = "HE",
  HI = "HI",
  HO = "HO",
  HR = "HR",
  HT = "HT",
  HU = "HU",
  HY = "HY",
  IA = "IA",
  ID = "ID",
  IE = "IE",
  IG = "IG",
  II = "II",
  IK = "IK",
  IN = "IN",
  IO = "IO",
  IS = "IS",
  IT = "IT",
  IU = "IU",
  IW = "IW",
  JA = "JA",
  JI = "JI",
  JV = "JV",
  JW = "JW",
  KA = "KA",
  KG = "KG",
  KI = "KI",
  KJ = "KJ",
  KK = "KK",
  KL = "KL",
  KM = "KM",
  KN = "KN",
  KO = "KO",
  KR = "KR",
  KS = "KS",
  KU = "KU",
  KV = "KV",
  KW = "KW",
  KY = "KY",
  LA = "LA",
  LB = "LB",
  LG = "LG",
  LI = "LI",
  LN = "LN",
  LO = "LO",
  LT = "LT",
  LU = "LU",
  LV = "LV",
  MG = "MG",
  MH = "MH",
  MI = "MI",
  MK = "MK",
  ML = "ML",
  MN = "MN",
  MO = "MO",
  MR = "MR",
  MS = "MS",
  MT = "MT",
  MY = "MY",
  NA = "NA",
  NB = "NB",
  ND = "ND",
  NE = "NE",
  NG = "NG",
  NL = "NL",
  NN = "NN",
  NO = "NO",
  NR = "NR",
  NV = "NV",
  NY = "NY",
  OC = "OC",
  OJ = "OJ",
  OM = "OM",
  OR = "OR",
  OS = "OS",
  PA = "PA",
  PI = "PI",
  PL = "PL",
  PS = "PS",
  PT = "PT",
  QU = "QU",
  RM = "RM",
  RN = "RN",
  RO = "RO",
  RU = "RU",
  RW = "RW",
  SA = "SA",
  SC = "SC",
  SD = "SD",
  SE = "SE",
  SG = "SG",
  SH = "SH",
  SI = "SI",
  SK = "SK",
  SL = "SL",
  SM = "SM",
  SN = "SN",
  SO = "SO",
  SQ = "SQ",
  SR = "SR",
  SS = "SS",
  ST = "ST",
  SU = "SU",
  SV = "SV",
  SW = "SW",
  TA = "TA",
  TE = "TE",
  TG = "TG",
  TH = "TH",
  TI = "TI",
  TK = "TK",
  TL = "TL",
  TN = "TN",
  TO = "TO",
  TR = "TR",
  TRANSLIT = "TRANSLIT",
  TS = "TS",
  TT = "TT",
  TW = "TW",
  TY = "TY",
  UG = "UG",
  UK = "UK",
  UNDEFINED = "UNDEFINED",
  UR = "UR",
  UZ = "UZ",
  VE = "VE",
  VI = "VI",
  VO = "VO",
  WA = "WA",
  WO = "WO",
  XH = "XH",
  YI = "YI",
  YO = "YO",
  ZA = "ZA",
  ZH = "ZH",
  ZU = "ZU",
}

export enum OfflineReportState {
  ERROR = "ERROR",
  NEW = "NEW",
  PROCESSING = "PROCESSING",
  READY = "READY",
}

export enum OfflineReportType {
  AGENCY = "AGENCY",
  DOMAINS = "DOMAINS",
}

export enum OfflineReportTypeInput {
  AGENCY = "AGENCY",
  DOMAINS = "DOMAINS",
}

export enum OrderInput {
  ASC = "ASC",
  DESC = "DESC",
}

export enum PlacementType {
  INDOOR = "INDOOR",
  OUTDOOR = "OUTDOOR",
}

export enum PlacementTypeInput {
  INDOOR = "INDOOR",
  OUTDOOR = "OUTDOOR",
}

export enum RbacRole {
  AGENCY = "AGENCY",
  CLIENT = "CLIENT",
  EMPTY = "EMPTY",
  INTERNAL_AD_ADMIN = "INTERNAL_AD_ADMIN",
  INTERNAL_AD_MANAGER = "INTERNAL_AD_MANAGER",
  MANAGER = "MANAGER",
  MEDIA = "MEDIA",
  PLACER = "PLACER",
  SUPER = "SUPER",
  SUPERREADER = "SUPERREADER",
  SUPPORT = "SUPPORT",
}

export enum RecommendationStatus {
  CANCELLED = "CANCELLED",
  DONE = "DONE",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
}

export enum StatusDirect {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  COMPLETED = "COMPLETED",
  RECEIVED = "RECEIVED",
}

export enum StatusDirectInput {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  COMPLETED = "COMPLETED",
  RECEIVED = "RECEIVED",
}

export enum StatusModerateBannerPage {
  MAYBE = "MAYBE",
  NO = "NO",
  READY = "READY",
  SENT = "SENT",
  YES = "YES",
}

export enum TimeTargetStatus {
  ACTIVE = "ACTIVE",
  LATER_THAN_WEEK = "LATER_THAN_WEEK",
  THIS_WEEK = "THIS_WEEK",
  TODAY = "TODAY",
  TOMORROW = "TOMORROW",
}

export enum WebGoalType {
  ab_segment = "ab_segment",
  audience = "audience",
  audio_genres = "audio_genres",
  behaviors = "behaviors",
  ecommerce = "ecommerce",
  family = "family",
  goal = "goal",
  interests = "interests",
  segment = "segment",
  social_demo = "social_demo",
}

export interface GdAcceptFlServiceByFreelancerRequestInput {
  clientId?: GraphQlLong | null;
  projectId?: GraphQlLong | null;
}

export interface GdAdFilterInput {
  titleContains?: string | null;
  titleNotContains?: string | null;
  titleExtensionNotContains?: string | null;
  adIdNotIn?: GraphQlLong[] | null;
  campaignIdIn: GraphQlLong[];
  titleNotIn?: string[] | null;
  sitelinksExists?: boolean | null;
  recommendations?: (GdiRecommendationTypeInput | null)[] | null;
  vcardExists?: boolean | null;
  bodyContains?: string | null;
  titleExtensionIn?: string[] | null;
  bodyNotIn?: string[] | null;
  primaryStatusContains?: GdAdPrimaryStatusInput[] | null;
  hrefIn?: string[] | null;
  goalStats?: GdGoalStatsFilterInput[] | null;
  bodyIn?: string[] | null;
  stats?: GdEntityStatsFilterInput | null;
  adIdIn?: GraphQlLong[] | null;
  titleExtensionContains?: string | null;
  bodyNotContains?: string | null;
  hrefNotIn?: string[] | null;
  typeIn?: GdAdTypeInput[] | null;
  imageExists?: boolean | null;
  adGroupIdIn?: GraphQlLong[] | null;
  archived?: boolean | null;
  titleExtensionNotIn?: string[] | null;
  titleIn?: string[] | null;
  hrefContains?: string | null;
  turbolandingsExist?: boolean | null;
  hrefNotContains?: string | null;
}

export interface GdAdGroupFilterInput {
  nameNotIn?: string[] | null;
  mwPackNameContains?: string | null;
  campaignIdIn: GraphQlLong[];
  libraryMwIdIn?: GraphQlLong[] | null;
  nameIn?: string[] | null;
  typeIn?: GdAdGroupTypeInput[] | null;
  primaryStatusIn?: GdAdGroupPrimaryStatusInput[] | null;
  showConditionTypeIn?: GdShowConditionTypeInput[] | null;
  archived?: boolean | null;
  mwPackNameNotContains?: string | null;
  nameNotContains?: string | null;
  adGroupIdIn?: GraphQlLong[] | null;
  adGroupIdNotIn?: GraphQlLong[] | null;
  goalStats?: GdGoalStatsFilterInput[] | null;
  stats?: GdEntityStatsFilterInput | null;
  nameContains?: string | null;
  recommendations?: (GdiRecommendationTypeInput | null)[] | null;
}

export interface GdAdGroupOrderByInput {
  params?: GdOrderByParamsInput | null;
  order: OrderInput;
  field: GdAdGroupOrderByFieldInput;
}

export interface GdAdGroupPageBlockInput {
  pageId?: GraphQlLong | null;
  impId?: GraphQlLong | null;
}

export interface GdAdGroupsContainerInput {
  orderBy: GdAdGroupOrderByInput[];
  filter: GdAdGroupFilterInput;
  limitOffset: GdLimitOffsetInput;
  cacheKey?: string | null;
  statRequirements: GdStatRequirementsInput;
}

export interface GdAdOrderByInput {
  field: GdAdOrderByFieldInput;
  params?: GdOrderByParamsInput | null;
  order: OrderInput;
}

export interface GdAdPriceInput {
  priceOld?: string | null;
  prefix?: GdAdPricePrefixInput | null;
  currency: GdAdPriceCurrencyInput;
  price: string;
}

export interface GdAddAdGroupMinusKeywordsInput {
  addItems: GdAddAdGroupMinusKeywordsItemInput[];
}

export interface GdAddAdGroupMinusKeywordsItemInput {
  adGroupId: GraphQlLong;
  minusKeywords: string[];
}

export interface GdAddAdInput {
  vcardId?: GraphQlLong | null;
  creativeId?: GraphQlLong | null;
  adPrice?: GdAdPriceInput | null;
  calloutIds?: GraphQlLong[] | null;
  sitelinksSetId?: GraphQlLong | null;
  href?: string | null;
  turbolandingHrefParams?: string | null;
  body: string;
  displayHref?: string | null;
  textBannerImageHash?: string | null;
  turbolandingId?: GraphQlLong | null;
  permalinkId?: GraphQlLong | null;
  adType: GdAdTypeInput;
  titleExtension?: string | null;
  imageCreativeHash?: string | null;
  domain?: string | null;
  turboGalleryHref?: string | null;
  isMobile: boolean;
  title: string;
  adGroupId: GraphQlLong;
}

export interface GdAddAddressInput {
  houseWithBuilding?: string | null;
  metroStationId?: number | null;
  street?: string | null;
  country: string;
  city: string;
  apartment?: string | null;
  pointOnMap?: GdPointOnMapInput | null;
}

export interface GdAddAdsInput {
  saveDraft: boolean;
  adAddItems: GdAddAdInput[];
}

export interface GdAddCampaignVcardInput {
  phone: GdAddPhoneInput;
  workTimes: GdAddWorkTimeInput[];
  instantMessenger?: GdAddInstantMessengerInput | null;
  extraMessage?: string | null;
  contactPerson?: string | null;
  ogrn?: string | null;
  companyName: string;
  address: GdAddAddressInput;
  email?: string | null;
}

export interface GdAddCpmAdInput {
  href?: string | null;
  adType: GdAdTypeInput;
  creativeId?: GraphQlLong | null;
  turbolandingHrefParams?: string | null;
  pixels?: GdPixelInput[] | null;
  measurers?: GdBannerMeasurerInput[] | null;
  adGroupId: GraphQlLong;
  turbolandingId?: GraphQlLong | null;
  tnsId?: string | null;
}

export interface GdAddCpmAdsInput {
  saveDraft: boolean;
  adAddItems: GdAddCpmAdInput[];
}

export interface GdAddDialogRequestInput {
  skillId: string;
}

export interface GdAddFeedbackForFreelancerRequestInput {
  freelancerId: GraphQlLong;
  overallMark: GraphQlLong;
  willRecommend: boolean;
  feedbackText: string;
}

export interface GdAddInstantMessengerInput {
  type: GdInstantMessengerTypeInput;
  login: string;
}

export interface GdAddInternalAdGroupsInput {
  addItems: GdAddInternalAdGroupsItemInput[];
}

export interface GdAddInternalAdGroupsItemInput {
  targetingInternalNetwork?: GdAdditionalTargetingInternalNetworkInput | null;
  level?: GraphQlLong | null;
  targetingQueryReferers?: GdAdditionalTargetingQueryReferersInput | null;
  targetingQueryOptions?: GdAdditionalTargetingQueryOptionsInput | null;
  targetingIsBrowser?: GdAdditionalTargetingIsBrowserInput | null;
  targetingBrowserEngines?: GdAdditionalTargetingBrowserEnginesInput | null;
  targetingYsCookies?: GdAdditionalTargetingYsCookiesInput | null;
  campaignId: GraphQlLong;
  targetingIsYandexPlus?: GdAdditionalTargetingIsYandexPlusInput | null;
  startTime?: GraphQlLocalDateTime | null;
  targetingDeviceNames?: GdAdditionalTargetingDeviceNamesInput | null;
  targetingUserAgents?: GdAdditionalTargetingUserAgentsInput | null;
  targetingShowDates?: GdAdditionalTargetingShowDatesInput | null;
  targetingInterfaceLangs?: GdAdditionalTargetingInterfaceLangsInput | null;
  targetingYandexUids?: GdAdditionalTargetingYandexUidsInput | null;
  name: string;
  targetingOsFamilies?: GdAdditionalTargetingOsFamiliesInput | null;
  targetingDeviceVendors?: GdAdditionalTargetingDeviceVendorsInput | null;
  targetingBrowserNames?: GdAdditionalTargetingBrowserNamesInput | null;
  targetingIsTouch?: GdAdditionalTargetingIsTouchInput | null;
  targetingIsMobile?: GdAdditionalTargetingIsMobileInput | null;
  regionIds: number[];
  rfReset?: number | null;
  targetingIsTablet?: GdAdditionalTargetingIsTabletInput | null;
  targetingClidTypes?: GdAdditionalTargetingClidTypesInput | null;
  targetingDesktopInstalledApps?: GdAdditionalTargetingDesktopInstalledAppsInput | null;
  finishTime?: GraphQlLocalDateTime | null;
  targetingOsNames?: GdAdditionalTargetingOsNamesInput | null;
  targetingTestIds?: GdAdditionalTargetingTestIdsInput | null;
  rf?: number | null;
  targetingClids?: GdAdditionalTargetingClidsInput | null;
  targetingMobileInstalledApps?: GdAdditionalTargetingMobileInstalledAppsInput | null;
}

export interface GdAddInternalAdsInput {
  adAddItems: GdAddInternalAdsItemInput[];
  saveDraft: boolean;
}

export interface GdAddInternalAdsItemInput {
  adGroupId: GraphQlLong;
  description: string;
  templateVars: GdTemplateVariableInput[];
  templateId: GraphQlLong;
}

export interface GdAddKeywordsInput {
  addItems: GdAddKeywordsItemInput[];
}

export interface GdAddKeywordsItemInput {
  autobudgetPriority?: number | null;
  priceContext?: GraphQlBigDecimal | null;
  adGroupId: GraphQlLong;
  price?: GraphQlBigDecimal | null;
  keyword: string;
}

export interface GdAddMcBannerAdInput {
  adImageHash: string;
  adGroupId: GraphQlLong;
  adType: GdAdTypeInput;
  href: string;
}

export interface GdAddMcBannerAdsInput {
  saveDraft: boolean;
  adAddItems: GdAddMcBannerAdInput[];
}

export interface GdAddMinusKeywordsPacksInput {
  addItems: GdAddMinusKeywordsPacksItemInput[];
}

export interface GdAddMinusKeywordsPacksItemInput {
  name: string;
  minusKeywords: string[];
}

export interface GdAddPhoneInput {
  extension?: string | null;
  countryCode: string;
  phoneNumber: string;
  cityCode: string;
}

export interface GdAddSitelinkInput {
  href: string;
  description?: string | null;
  turbolandingId?: GraphQlLong | null;
  title: string;
}

export interface GdAddSitelinkSetInput {
  sitelinks: GdAddSitelinkInput[];
}

export interface GdAddSitelinkSetsInput {
  sitelinkSetsAddItems: GdAddSitelinkSetInput[];
}

export interface GdAddSmartAdGroupItemInput {
  name: string;
  feedId: GraphQlLong;
  campaignId: GraphQlLong;
}

export interface GdAddSmartAdInput {
  creativeId: GraphQlLong;
  adGroupId: GraphQlLong;
}

export interface GdAddSmartAdsInput {
  adAddItems: GdAddSmartAdInput[];
  saveDraft: boolean;
}

export interface GdAddSmartFilterConditionInput {
  operator: GdSmartFilterConditionOperatorInput;
  stringValue: string;
  field: string;
}

export interface GdAddSmartFiltersInput {
  addItems: GdAddSmartFiltersItemInput[];
}

export interface GdAddSmartFiltersItemInput {
  adGroupId: GraphQlLong;
  autobudgetPriority?: GdShowConditionAutobudgetPriorityInput | null;
  conditions: GdAddSmartFilterConditionInput[];
  name: string;
  isSuspended: boolean;
  tab?: GdSmartFilterTabInput | null;
  targetFunnel: GdSmartFilterTargetFunnelInput;
  priceCpa?: GraphQlBigDecimal | null;
  priceCpc?: GraphQlBigDecimal | null;
}

export interface GdAddTextAdGroupItemInput {
  name: string;
  campaignId: GraphQlLong;
}

export interface GdAddVcardInput {
  address: GdAddAddressInput;
  email?: string | null;
  campaignId: GraphQlLong;
  extraMessage?: string | null;
  companyName: string;
  ogrn?: string | null;
  phone: GdAddPhoneInput;
  instantMessenger?: GdAddInstantMessengerInput | null;
  workTimes: GdAddWorkTimeInput[];
  contactPerson?: string | null;
}

export interface GdAddVcardsInput {
  vcardAddItems: GdAddVcardInput[];
}

export interface GdAddWorkTimeInput {
  endTime: GdTimeInput;
  startTime: GdTimeInput;
  daysOfWeek: number[];
}

export interface GdAdditionalTargetingBrowserEnginesInput {
  joinType: GdAdditionalTargetingJoinTypeInput;
  value: GdAdditionalTargetingVersionedInput[];
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingBrowserNamesInput {
  joinType: GdAdditionalTargetingJoinTypeInput;
  value: GdAdditionalTargetingVersionedInput[];
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingClidTypesInput {
  value: GraphQlLong[];
  targetingMode: GdAdditionalTargetingModeInput;
  joinType: GdAdditionalTargetingJoinTypeInput;
}

export interface GdAdditionalTargetingClidsInput {
  joinType: GdAdditionalTargetingJoinTypeInput;
  value: GraphQlLong[];
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingDesktopInstalledAppsInput {
  targetingMode: GdAdditionalTargetingModeInput;
  joinType: GdAdditionalTargetingJoinTypeInput;
  value: GraphQlLong[];
}

export interface GdAdditionalTargetingDeviceNamesInput {
  joinType: GdAdditionalTargetingJoinTypeInput;
  targetingMode: GdAdditionalTargetingModeInput;
  value: string[];
}

export interface GdAdditionalTargetingDeviceVendorsInput {
  joinType: GdAdditionalTargetingJoinTypeInput;
  value: GdAdditionalTargetingUatraitsInput[];
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingInterfaceLangsInput {
  joinType: GdAdditionalTargetingJoinTypeInput;
  targetingMode: GdAdditionalTargetingModeInput;
  value: InterfaceLangInput[];
}

export interface GdAdditionalTargetingInternalNetworkInput {
  joinType: GdAdditionalTargetingJoinTypeInput;
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingIsBrowserInput {
  joinType: GdAdditionalTargetingJoinTypeInput;
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingIsMobileInput {
  targetingMode: GdAdditionalTargetingModeInput;
  joinType: GdAdditionalTargetingJoinTypeInput;
}

export interface GdAdditionalTargetingIsTabletInput {
  targetingMode: GdAdditionalTargetingModeInput;
  joinType: GdAdditionalTargetingJoinTypeInput;
}

export interface GdAdditionalTargetingIsTouchInput {
  joinType: GdAdditionalTargetingJoinTypeInput;
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingIsYandexPlusInput {
  targetingMode: GdAdditionalTargetingModeInput;
  joinType: GdAdditionalTargetingJoinTypeInput;
}

export interface GdAdditionalTargetingMobileInstalledAppsInput {
  targetingMode: GdAdditionalTargetingModeInput;
  joinType: GdAdditionalTargetingJoinTypeInput;
  value: string[];
}

export interface GdAdditionalTargetingOsFamiliesInput {
  value: GdAdditionalTargetingVersionedInput[];
  joinType: GdAdditionalTargetingJoinTypeInput;
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingOsNamesInput {
  joinType: GdAdditionalTargetingJoinTypeInput;
  value: GdAdditionalTargetingUatraitsInput[];
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingQueryOptionsInput {
  targetingMode: GdAdditionalTargetingModeInput;
  joinType: GdAdditionalTargetingJoinTypeInput;
  value: string[];
}

export interface GdAdditionalTargetingQueryReferersInput {
  targetingMode: GdAdditionalTargetingModeInput;
  value: string[];
  joinType: GdAdditionalTargetingJoinTypeInput;
}

export interface GdAdditionalTargetingShowDatesInput {
  targetingMode: GdAdditionalTargetingModeInput;
  joinType: GdAdditionalTargetingJoinTypeInput;
  value: GraphQlLocalDate[];
}

export interface GdAdditionalTargetingTestIdsInput {
  value: GraphQlLong[];
  joinType: GdAdditionalTargetingJoinTypeInput;
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingUatraitsInput {
  targetingValueEntryId: GraphQlLong;
}

export interface GdAdditionalTargetingUserAgentsInput {
  joinType: GdAdditionalTargetingJoinTypeInput;
  value: string[];
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingVersionedInput {
  minVersion?: string | null;
  targetingValueEntryId: GraphQlLong;
  maxVersion?: string | null;
}

export interface GdAdditionalTargetingYandexUidsInput {
  value: string[];
  targetingMode: GdAdditionalTargetingModeInput;
  joinType: GdAdditionalTargetingJoinTypeInput;
}

export interface GdAdditionalTargetingYsCookiesInput {
  targetingMode: GdAdditionalTargetingModeInput;
  value: string[];
  joinType: GdAdditionalTargetingJoinTypeInput;
}

export interface GdAdsContainerInput {
  limitOffset: GdLimitOffsetInput;
  statRequirements: GdStatRequirementsInput;
  cacheKey?: string | null;
  orderBy: GdAdOrderByInput[];
  filter: GdAdFilterInput;
}

export interface GdAdsMassActionInput {
  adIds: GraphQlLong[];
}

export interface GdBannerMeasurerInput {
  measurerSystem?: GdBannerMeasurerSystemInput | null;
  params?: string | null;
}

export interface GdBidModifierDemographicInput {
  gender?: string | null;
  multiplier?: number | null;
  age?: string | null;
}

export interface GdBlockSizeInput {
  width?: number | null;
  height?: number | null;
}

export interface GdBroadMatchContainerInput {
  campaignId: GraphQlLong;
}

export interface GdBroadMatchRequestInput {
  broadMatchGoalId?: GraphQlLong | null;
  broadMatchLimit?: number | null;
  broadMatchFlag?: boolean | null;
}

export interface GdBroadMatchesContainerInput {
  broadMatchContainers: GdBroadMatchContainerInput[];
}

export interface GdCalloutFilterInput {
  deleted?: boolean | null;
}

export interface GdCampaignBiddingStrategyInput {
  strategyData?: GdCampaignStrategyDataInput | null;
  platform?: GdCampaignPlatformInput | null;
  strategy?: GdCampaignStrategyInput | null;
  strategyName?: GdCampaignStrategyNameInput | null;
}

export interface GdCampaignEmailSettingsRequestInput {
  sendAccountNews?: boolean | null;
  email: string;
  warningBalance?: number | null;
  checkPositionInterval?: GdCampaignCheckPositionIntervalInput | null;
  stopByReachDailyBudget?: boolean | null;
  xlsReady?: boolean | null;
}

export interface GdCampaignFilterInput {
  calcType?: GdCalcTypeInput | null;
  minStartDate?: GraphQlLocalDate | null;
  hasSiteMonitoring?: boolean | null;
  campaignIdNotIn?: GraphQlLong[] | null;
  platformIn?: GdCampaignPlatformInput[] | null;
  strategyTypeIn?: GdCampaignStrategyTypeInput[] | null;
  maxFinishDate?: GraphQlLocalDate | null;
  hasBidModifiers?: boolean | null;
  maxStartDate?: GraphQlLocalDate | null;
  archived?: boolean | null;
  recommendations?: (GdiRecommendationTypeInput | null)[] | null;
  campaignIdIn?: GraphQlLong[] | null;
  hasMetrika?: boolean | null;
  goalStats?: GdGoalStatsFilterInput[] | null;
  favorite?: boolean | null;
  nameContains?: string | null;
  typeIn?: GdCampaignTypeInput[] | null;
  stats?: GdEntityStatsFilterInput | null;
  statusIn?: GdCampaignPrimaryStatusInput[] | null;
  minFinishDate?: GraphQlLocalDate | null;
  nameNotContains?: string | null;
  hasBroadmatch?: boolean | null;
  nameIn?: string[] | null;
  currencyArchived?: boolean | null;
  nameNotIn?: string[] | null;
}

export interface GdCampaignGoalFilterInput {
  campaignIdIn?: GraphQlLong[] | null;
}

export interface GdCampaignGoalsContainerInput {
  filter: GdCampaignGoalFilterInput;
}

export interface GdCampaignNotificationRequestInput {
  emailSettings: GdCampaignEmailSettingsRequestInput;
  smsSettings: GdCampaignSmsSettingsRequestInput;
}

export interface GdCampaignOrderByInput {
  order: OrderInput;
  field: GdCampaignOrderByFieldInput;
  params?: GdOrderByParamsInput | null;
}

export interface GdCampaignSmsSettingsRequestInput {
  smsTime: GdTimeIntervalInput;
  enableEvents: GdCampaignSmsEventInput[];
}

export interface GdCampaignStrategyDataInput {
  avgBid?: GraphQlBigDecimal | null;
  reserveReturn?: GraphQlLong | null;
  sum?: GraphQlBigDecimal | null;
  bid?: GraphQlBigDecimal | null;
  limitClicks?: GraphQlLong | null;
  goalId?: GraphQlLong | null;
  avgCpa?: GraphQlBigDecimal | null;
  roiCoef?: GraphQlBigDecimal | null;
  profitability?: GraphQlBigDecimal | null;
}

export interface GdCampaignsContainerInput {
  limitOffset: GdLimitOffsetInput;
  filter: GdCampaignFilterInput;
  orderBy: GdCampaignOrderByInput[];
  cacheKey?: string | null;
  statRequirements: GdStatRequirementsInput;
}

export interface GdCancelFlServiceByClientRequestInput {
  freelancerId?: GraphQlLong | null;
  projectId?: GraphQlLong | null;
}

export interface GdCancelFlServiceByFreelancerRequestInput {
  clientId?: GraphQlLong | null;
  projectId?: GraphQlLong | null;
}

export interface GdCheckClientMutationStateInput {
  login: string;
  mutationId: string;
}

export interface GdClientSearchRequestInput {
  userId?: GraphQlLong | null;
  login?: string | null;
  id?: GraphQlLong | null;
}

export interface GdCoordinatesInput {
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
}

export interface GdCopyAdGroupsInput {
  adGroupIds: GraphQlLong[];
  destinationCampaignId?: GraphQlLong | null;
}

export interface GdCreateRetargetingConditionItemInput {
  name: string;
  type: GdRetargetingConditionTypeInput;
  description?: string | null;
  conditionRules: GdRetargetingConditionRuleItemReqInput[];
}

export interface GdCreateRetargetingConditionsInput {
  retargetingConditions: GdCreateRetargetingConditionItemInput[];
}

export interface GdCreativeFilterInput {
  businessTypeIn?: GdCreativeBusinessTypeInput[] | null;
  creativeTypeIn?: GdCreativeTypeInput[] | null;
  creativeIdIn?: GraphQlLong[] | null;
}

export interface GdCreativesContainerInput {
  filter: GdCreativeFilterInput;
  limitOffset: GdLimitOffsetInput;
  searchBy: GdClientSearchRequestInput;
  cacheKey: string;
}

export interface GdCryptaSegmentFilterInput {
  name?: string | null;
}

export interface GdCryptaSegmentsContainerInput {
  filter: GdCryptaSegmentFilterInput;
}

export interface GdDealOrderByInput {
  order?: OrderInput | null;
  field?: GdiDealOrderByFieldInput | null;
}

export interface GdDeleteCalloutsInput {
  calloutIds: GraphQlLong[];
}

export interface GdDeleteFreelancerFeedbackRequestInput {
  freelancerId: GraphQlLong;
  feedbackId: string;
}

export interface GdDeleteKeywordsInput {
  keywordIds: GraphQlLong[];
}

export interface GdDeleteMinusKeywordsPacksInput {
  minusKeywordPackIds: GraphQlLong[];
}

export interface GdDeleteRetargetingConditionsInput {
  retargetingConditionIds: GraphQlLong[];
}

export interface GdDeleteRetargetingsInput {
  retargetingIds: GraphQlLong[];
}

export interface GdDeleteSmartFilterInput {
  deleteItems: GdDeleteSmartFilterItemInput[];
}

export interface GdDeleteSmartFilterItemInput {
  id?: GraphQlLong | null;
}

export interface GdEntityStatsFilterInput {
  minAvgShowPosition?: GraphQlBigDecimal | null;
  maxAvgShowPosition?: GraphQlBigDecimal | null;
  minBounceRate?: GraphQlBigDecimal | null;
  minCtr?: GraphQlBigDecimal | null;
  maxGoals?: GraphQlLong | null;
  minAvgGoalCost?: GraphQlBigDecimal | null;
  minShows?: GraphQlLong | null;
  maxAvgGoalCost?: GraphQlBigDecimal | null;
  minAvgClickPosition?: GraphQlBigDecimal | null;
  minConversionRate?: GraphQlBigDecimal | null;
  minCost?: GraphQlBigDecimal | null;
  minProfitability?: GraphQlBigDecimal | null;
  maxProfitability?: GraphQlBigDecimal | null;
  minRevenue?: GraphQlBigDecimal | null;
  maxBounceRate?: GraphQlBigDecimal | null;
  maxAvgClickCost?: GraphQlBigDecimal | null;
  minClicks?: GraphQlLong | null;
  minAvgDepth?: GraphQlBigDecimal | null;
  maxCpmPrice?: GraphQlBigDecimal | null;
  minGoals?: GraphQlLong | null;
  maxAvgDepth?: GraphQlBigDecimal | null;
  minCpmPrice?: GraphQlBigDecimal | null;
  maxClicks?: GraphQlLong | null;
  maxShows?: GraphQlLong | null;
  maxCtr?: GraphQlBigDecimal | null;
  maxCost?: GraphQlBigDecimal | null;
  minAvgClickCost?: GraphQlBigDecimal | null;
  maxConversionRate?: GraphQlBigDecimal | null;
  maxRevenue?: GraphQlBigDecimal | null;
  maxAvgClickPosition?: GraphQlBigDecimal | null;
}

export interface GdEstimateRetargetingConditionContainerInput {
  conditionRules?: GdRetargetingConditionRuleItemReqInput[] | null;
}

export interface GdExecuteRecommedationsInput {
  items: GdRecommendationKeyInput[];
}

export interface GdFindAndReplaceKeywordsInput {
  searchOptions: SearchOptionsInput;
  fields: GdFindAndReplaceKeywordFieldInput[];
  changeText: string;
  limitOffset?: GdLimitOffsetInput | null;
  changeMode: ChangeModeInput;
  searchText: string;
  keywordIds: GraphQlLong[];
  cacheKey?: string | null;
}

export interface GdGenerateVideoAdditionInput {
  adGroupIds: GraphQlLong[];
}

export interface GdGeoToolsAddressInput {
  address: string;
}

export interface GdGetMinusKeywordsPacksInput {
  cacheKey?: string | null;
  limitOffset?: GdLimitOffsetInput | null;
  packIdIn?: (GraphQlLong | null)[] | null;
}

export interface GdGoalFilterInput {
  goalTypeIn?: GdGoalTypeInput[] | null;
}

export interface GdGoalMinimalInput {
  time?: number | null;
  id: GraphQlLong;
}

export interface GdGoalStatsFilterInput {
  minGoals?: GraphQlLong | null;
  goalId?: GraphQlLong | null;
  minCostPerAction?: GraphQlBigDecimal | null;
  maxCostPerAction?: GraphQlBigDecimal | null;
  maxGoals?: GraphQlLong | null;
  maxConversionRate?: GraphQlBigDecimal | null;
  minConversionRate?: GraphQlBigDecimal | null;
}

export interface GdGoalsContainerInput {
  filter: GdGoalFilterInput;
}

export interface GdHolidaysSettingsInput {
  endHour?: number | null;
  isShow?: boolean | null;
  startHour?: number | null;
  rateCorrections?: number | null;
}

export interface GdImageFilterInput {
  imageHashIn?: string[] | null;
  width?: number | null;
  maxCreatedDateTime?: GraphQlLocalDateTime | null;
  height?: number | null;
  forAdType?: GdAdTypeInput | null;
  minCreatedDateTime?: GraphQlLocalDateTime | null;
}

export interface GdImageSmartCenterInput {
  ratio?: string | null;
  y?: number | null;
  width?: number | null;
  height?: number | null;
  x?: number | null;
}

export interface GdIndoorReachRequestInput {
  bidModifierDemographic?: GdBidModifierDemographicInput[] | null;
  adGroupId?: GraphQlLong | null;
  videoCreativeIds?: GraphQlLong[] | null;
  campaignId?: GraphQlLong | null;
  pageBlocks?: GdPageBlockInput[] | null;
}

export interface GdInternalTemplateInfoRequestEntryInput {
  campaignId: string;
  templateIds: string[];
}

export interface GdLimitOffsetInput {
  limit: number;
  offset: number;
}

export interface GdMeaningfulGoalContainerInput {
  counterIds?: GraphQlLong[] | null;
  campaignId: GraphQlLong;
}

export interface GdMeaningfulGoalRequestInput {
  goalId: GraphQlLong;
  conversionValue?: GraphQlBigDecimal | null;
}

export interface GdMeaningfulGoalsContainerInput {
  meaningfulGoalContainers: GdMeaningfulGoalContainerInput[];
}

export interface GdOfflineReportResultRequestInput {
  monthTo: string;
  reportType?: OfflineReportTypeInput | null;
  monthFrom: string;
}

export interface GdOrderByParamsInput {
  goalId?: GraphQlLong | null;
}

export interface GdOrganizationsContainerInput {
  permalinkIds: (GraphQlLong | null)[];
  language?: LanguageInput | null;
}

export interface GdOutdoorReachRequestInput {
  videoCreativeIds?: GraphQlLong[] | null;
  pageBlocks?: GdPageBlockInput[] | null;
  adGroupId?: GraphQlLong | null;
  campaignId?: GraphQlLong | null;
}

export interface GdPageBlockInput {
  blockIds?: GraphQlLong[] | null;
  pageId?: GraphQlLong | null;
}

export interface GdPageOrderByInput {
  field?: GdPageOrderByFieldInput | null;
  order?: OrderInput | null;
}

export interface GdPixelInput {
  kind?: GdPixelKindInput | null;
  url?: string | null;
}

export interface GdPlacementFilterInput {
  zoneCategory?: number | null;
  pageIds?: GraphQlLong[] | null;
  placementType?: PlacementTypeInput | null;
  facilityType?: number | null;
  geoId?: GraphQlLong | null;
  adGroupIds?: GraphQlLong[] | null;
}

export interface GdPlatformCorrectionsWebInput {
  desktop?: number | null;
  mobile?: number | null;
  mobileOsType?: GdMobileOsTypeInput | null;
}

export interface GdPointOnMapInput {
  x: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GdProductContainerInput {
  filter: GdProductFilterInput;
}

export interface GdProductFilterInput {
  calcType?: GdProductCalcTypeInput | null;
  id?: GraphQlLong | null;
  currency?: CurrencyCodeInput | null;
  type?: GdProductTypeInput | null;
}

export interface GdReachRequestInput {
  adgroupId?: GraphQlLong | null;
  blockSizes?: GdBlockSizeInput[] | null;
  conditions?: GdRetargetingConditionRuleItemReqInput[] | null;
  excludedDomains?: (string | null)[] | null;
  groupType?: GroupTypeInput | null;
  campaignId?: GraphQlLong | null;
  geo?: (number | null)[] | null;
  videoCreatives?: GdVideoCreativeInput[] | null;
  platformCorrectionsWeb?: GdPlatformCorrectionsWebInput | null;
}

export interface GdRecommendationKeyInput {
  pid?: GraphQlLong | null;
  bid?: GraphQlLong | null;
  type?: GdiRecommendationTypeInput | null;
  userKey2?: string | null;
  timestamp?: GraphQlLong | null;
  userKey1?: string | null;
  cid?: GraphQlLong | null;
  userKey3?: string | null;
}

export interface GdRemoderateAdsCalloutsInput {
  moderateAccept: boolean;
  adGroupIds: GraphQlLong[];
}

export interface GdRequestFlServiceByClientRequestInput {
  freelancerId?: GraphQlLong | null;
}

export interface GdResumeRetargetingsInput {
  retargetingIds: GraphQlLong[];
}

export interface GdRetargetingConditionFilterInput {
  interest?: boolean | null;
  nameNotIn?: string[] | null;
  retargetingConditionTypeIn?: GdRetargetingConditionTypeInput[] | null;
  negative?: boolean | null;
  nameIn?: string[] | null;
  retargetingConditionIdIn?: GraphQlLong[] | null;
  retargetingConditionIdNotIn?: GraphQlLong[] | null;
}

export interface GdRetargetingConditionRuleItemReqInput {
  goals: GdGoalMinimalInput[];
  interestType?: CryptaInterestTypeWebInput | null;
  type: GdRetargetingConditionRuleTypeInput;
}

export interface GdRetargetingConditionsContainerInput {
  filter?: GdRetargetingConditionFilterInput | null;
}

export interface GdRetargetingFilterInput {
  retargetingConditionIdIn?: GraphQlLong[] | null;
  nameNotContains?: string | null;
  stats?: GdEntityStatsFilterInput | null;
  campaignIdIn?: GraphQlLong[] | null;
  adGroupIdIn?: GraphQlLong[] | null;
  retargetingConditionIdNotIn?: GraphQlLong[] | null;
  retargetingIdIn?: GraphQlLong[] | null;
  retargetingIdNotIn?: GraphQlLong[] | null;
  nameContains?: string | null;
  statusIn?: GdRetargetingBaseStatusInput[] | null;
  interest?: boolean | null;
  minPriceContext?: GraphQlBigDecimal | null;
  maxPriceContext?: GraphQlBigDecimal | null;
}

export interface GdRetargetingOrderByInput {
  field?: GdRetargetingOrderByFieldInput | null;
  order: OrderInput;
}

export interface GdRetargetingsContainerInput {
  limitOffset?: GdLimitOffsetInput | null;
  filter?: GdRetargetingFilterInput | null;
  statRequirements: GdStatRequirementsInput;
  orderBy: GdRetargetingOrderByInput[];
  cacheKey?: string | null;
}

export interface GdSaveCalloutsInput {
  saveItems: GdSaveCalloutsItemInput[];
}

export interface GdSaveCalloutsItemInput {
  text: string;
}

export interface GdSetAutoBidsInput {
  networkByCoverage?: GdSetAutoBidsNetworkByCoverageInput | null;
  searchByTrafficVolume?: GdSetAutoBidsSearchByTrafficVolumeInput | null;
  keywordIds: GraphQlLong[];
}

export interface GdSetAutoBidsNetworkByCoverageInput {
  increasePercent: number;
  contextCoverage: number;
  maxBid: GraphQlBigDecimal;
}

export interface GdSetAutoBidsSearchByTrafficVolumeInput {
  targetTrafficVolume: number;
  setMaximum: boolean;
  increasePercentage: number;
  maxBid: GraphQlBigDecimal;
}

export interface GdSetAutoOverdraftParamsInput {
  paymentMethodCode: string;
  autoOverdraftLimit: GraphQlBigDecimal;
  personId: GraphQlLong;
}

export interface GdSetBidsInput {
  exactPriceContext?: GraphQlBigDecimal | null;
  exactPriceSearch?: GraphQlBigDecimal | null;
  showConditionIds?: GraphQlLong[] | null;
  autobudgetPriority?: number | null;
}

export interface GdShowConditionFilterInput {
  keywordIn?: string[] | null;
  showConditionStatusIn?: GdShowConditionPrimaryStatusInput[] | null;
  adGroupIdIn?: GraphQlLong[] | null;
  campaignIdIn: GraphQlLong[];
  minPriceContext?: GraphQlBigDecimal | null;
  minPrice?: GraphQlBigDecimal | null;
  showConditionIdIn?: GraphQlLong[] | null;
  goalStats?: GdGoalStatsFilterInput[] | null;
  statusIn?: GdShowConditionBaseStatusInput[] | null;
  showConditionIdNotIn?: GraphQlLong[] | null;
  keywordContains?: string | null;
  keywordNotIn?: string[] | null;
  maxPriceContext?: GraphQlBigDecimal | null;
  stats?: GdEntityStatsFilterInput | null;
  keywordNotContains?: string | null;
  maxPrice?: GraphQlBigDecimal | null;
  autobudgetPriorityIn?: GdShowConditionAutobudgetPriorityInput[] | null;
  typeIn?: GdShowConditionTypeInput[] | null;
}

export interface GdShowConditionOrderByInput {
  params?: GdOrderByParamsInput | null;
  field: GdShowConditionOrderByFieldInput;
  order: OrderInput;
}

export interface GdShowConditionsContainerInput {
  limitOffset: GdLimitOffsetInput;
  filter: GdShowConditionFilterInput;
  statRequirements: GdStatRequirementsInput;
  cacheKey?: string | null;
  orderBy: GdShowConditionOrderByInput[];
}

export interface GdSmartFilterFilterInput {
  smartFilterIdIn?: GraphQlLong[] | null;
  nameContains?: string | null;
  maxPriceCpa?: GraphQlBigDecimal | null;
  targetFunnelIn?: GdSmartFilterTargetFunnelInput[] | null;
  autobudgetPriorityIn?: GdShowConditionAutobudgetPriorityInput[] | null;
  campaignIdIn: GraphQlLong[];
  minPriceCpa?: GraphQlBigDecimal | null;
  nameNotContains?: string | null;
  adGroupIdIn?: GraphQlLong[] | null;
  goalStats?: GdGoalStatsFilterInput[] | null;
  statusIn?: GdSmartFilterBaseStatusInput[] | null;
  stats?: GdEntityStatsFilterInput | null;
  minPriceCpc?: GraphQlBigDecimal | null;
  maxPriceCpc?: GraphQlBigDecimal | null;
}

export interface GdSmartFilterOrderByInput {
  field: GdSmartFilterOrderByFieldInput;
  order: OrderInput;
  params?: GdOrderByParamsInput | null;
}

export interface GdSmartFilterSchemaQueryInput {
  feedType?: GdFeedTypeInput | null;
  businessType?: GdBusinessTypeInput | null;
}

export interface GdSmartFiltersContainerInput {
  filter: GdSmartFilterFilterInput;
  orderBy?: GdSmartFilterOrderByInput[] | null;
  limitOffset?: GdLimitOffsetInput | null;
  statRequirements?: GdStatRequirementsInput | null;
  cacheKey?: string | null;
}

export interface GdStatRequirementsInput {
  goalIds?: GraphQlLong[] | null;
  from?: GraphQlLocalDate | null;
  to?: GraphQlLocalDate | null;
  preset?: GdStatPresetInput | null;
}

export interface GdSuspendKeywordsInput {
  keywordIds: GraphQlLong[];
}

export interface GdSuspendRetargetingsInput {
  retargetingIds: GraphQlLong[];
}

export interface GdTemplateVariableInput {
  value?: string | null;
  templateResourceId: GraphQlLong;
}

export interface GdTimeInput {
  minute: number;
  hour: number;
}

export interface GdTimeIntervalInput {
  startTime: GdTimeInput;
  endTime: GdTimeInput;
}

export interface GdTimeTargetInput {
  timeBoard?: number[][] | null;
  enabledHolidaysMode?: boolean | null;
  useWorkingWeekends?: boolean | null;
  idTimeZone?: GraphQlLong | null;
  holidaysSettings?: GdHolidaysSettingsInput | null;
}

export interface GdTurboGalleryParamsInput {
  turboGalleryHref?: string | null;
}

export interface GdTurbolandingFilterInput {
  turbolandingIdIn?: GraphQlLong[] | null;
}

export interface GdUnsuspendKeywordsInput {
  keywordIds: GraphQlLong[];
}

export interface GdUpdateAdGroupKeywordItemInput {
  phrase?: string | null;
  id?: GraphQlLong | null;
}

export interface GdUpdateAdGroupMinusKeywordsInput {
  adGroupIds: GraphQlLong[];
  action: GdUpdateAdGroupMinusKeywordsActionInput;
  minusKeywordsPackIds: GraphQlLong[];
}

export interface GdUpdateAdGroupRelevanceMatchItemInput {
  isActive: boolean;
  id?: GraphQlLong | null;
}

export interface GdUpdateAdGroupRetargetingItemInput {
  retCondId: GraphQlLong;
  id?: GraphQlLong | null;
}

export interface GdUpdateAdInput {
  body: string;
  vcardId?: GraphQlLong | null;
  creativeId?: GraphQlLong | null;
  href?: string | null;
  textBannerImageHash?: string | null;
  permalinkId?: GraphQlLong | null;
  isMobile: boolean;
  domain?: string | null;
  turbolandingHrefParams?: string | null;
  adPrice?: GdAdPriceInput | null;
  adType: GdAdTypeInput;
  turboGalleryParams?: GdTurboGalleryParamsInput | null;
  turbolandingId?: GraphQlLong | null;
  sitelinksSetId?: GraphQlLong | null;
  titleExtension?: string | null;
  title: string;
  imageCreativeHash?: string | null;
  id: GraphQlLong;
  calloutIds?: GraphQlLong[] | null;
  displayHref?: string | null;
}

export interface GdUpdateAdPriceInput {
  id: GraphQlLong;
  price?: GdAdPriceInput | null;
}

export interface GdUpdateAdsInput {
  saveDraft: boolean;
  adUpdateItems: GdUpdateAdInput[];
}

export interface GdUpdateBidModifierABSegmentAdjustmentItemInput {
  percent: number;
  abSegmentRetargetingConditionId?: GraphQlLong | null;
  sectionId?: GraphQlLong | null;
  segmentId?: GraphQlLong | null;
  id?: GraphQlLong | null;
}

export interface GdUpdateBidModifierABSegmentInput {
  enabled: boolean;
  adGroupId?: GraphQlLong | null;
  adjustments: GdUpdateBidModifierABSegmentAdjustmentItemInput[];
  campaignId: GraphQlLong;
  type: GdBidModifierTypeInput;
  id?: GraphQlLong | null;
}

export interface GdUpdateBidModifierAdTypeAdjustmentItemInput {
  percent: number;
  id?: GraphQlLong | null;
  adType?: GdAdjustmentAdTypeInput | null;
}

export interface GdUpdateBidModifierAdTypeInput {
  id?: GraphQlLong | null;
  adGroupId?: GraphQlLong | null;
  enabled: boolean;
  adjustments: GdUpdateBidModifierAdTypeAdjustmentItemInput[];
  campaignId: GraphQlLong;
  type: GdBidModifierTypeInput;
}

export interface GdUpdateBidModifierDemographicsAdjustmentItemInput {
  id?: GraphQlLong | null;
  age?: GdAgeTypeInput | null;
  percent: number;
  gender?: GdGenderTypeInput | null;
}

export interface GdUpdateBidModifierDemographicsInput {
  campaignId: GraphQlLong;
  id?: GraphQlLong | null;
  enabled: boolean;
  adjustments: GdUpdateBidModifierDemographicsAdjustmentItemInput[];
  adGroupId?: GraphQlLong | null;
  type: GdBidModifierTypeInput;
}

export interface GdUpdateBidModifierDesktopAdjustmentItemInput {
  percent: number;
  id?: GraphQlLong | null;
}

export interface GdUpdateBidModifierDesktopInput {
  campaignId: GraphQlLong;
  type: GdBidModifierTypeInput;
  id?: GraphQlLong | null;
  adjustment: GdUpdateBidModifierDesktopAdjustmentItemInput;
  adGroupId?: GraphQlLong | null;
  enabled: boolean;
}

export interface GdUpdateBidModifierExpressAdjustmentItemInput {
  condition: GdUpdateBidModifierExpressLiteralInput[][];
  id?: GraphQlLong | null;
  percent: number;
}

export interface GdUpdateBidModifierExpressInput {
  adGroupId?: GraphQlLong | null;
  id?: GraphQlLong | null;
  campaignId: GraphQlLong;
  type: GdBidModifierTypeInput;
  adjustments: GdUpdateBidModifierExpressAdjustmentItemInput[];
  enabled: boolean;
}

export interface GdUpdateBidModifierExpressLiteralInput {
  value: string;
  parameter: BidModifierExpressionParameterInput;
  operation: BidModifierExpressionOperatorInput;
}

export interface GdUpdateBidModifierGeoInput {
  campaignId: GraphQlLong;
  adjustments: GdUpdateBidModifierRegionalAdjustmentItemInput[];
  adGroupId?: GraphQlLong | null;
  id?: GraphQlLong | null;
  enabled: boolean;
  type: GdBidModifierTypeInput;
}

export interface GdUpdateBidModifierInventoryAdjustmentItemInput {
  id?: GraphQlLong | null;
  percent: number;
  inventoryType?: GdInventoryTypeInput | null;
}

export interface GdUpdateBidModifierInventoryInput {
  id?: GraphQlLong | null;
  enabled: boolean;
  campaignId: GraphQlLong;
  adGroupId?: GraphQlLong | null;
  type: GdBidModifierTypeInput;
  adjustments: GdUpdateBidModifierInventoryAdjustmentItemInput[];
}

export interface GdUpdateBidModifierMobileAdjustmentItemInput {
  id?: GraphQlLong | null;
  osType?: GdOsTypeInput | null;
  percent: number;
}

export interface GdUpdateBidModifierMobileInput {
  type: GdBidModifierTypeInput;
  campaignId: GraphQlLong;
  adjustment: GdUpdateBidModifierMobileAdjustmentItemInput;
  id?: GraphQlLong | null;
  enabled: boolean;
  adGroupId?: GraphQlLong | null;
}

export interface GdUpdateBidModifierRegionalAdjustmentItemInput {
  regionId?: number | null;
  id?: GraphQlLong | null;
  hidden?: boolean | null;
  percent: number;
}

export interface GdUpdateBidModifierRetargetingAdjustmentItemInput {
  retargetingConditionId?: GraphQlLong | null;
  percent: number;
  id?: GraphQlLong | null;
}

export interface GdUpdateBidModifierRetargetingInput {
  type: GdBidModifierTypeInput;
  enabled: boolean;
  id?: GraphQlLong | null;
  adGroupId?: GraphQlLong | null;
  campaignId: GraphQlLong;
  adjustments: GdUpdateBidModifierRetargetingAdjustmentItemInput[];
}

export interface GdUpdateBidModifierSmartTgoAdjustmentItemInput {
  id?: GraphQlLong | null;
  percent: number;
}

export interface GdUpdateBidModifierSmartTgoInput {
  type: GdBidModifierTypeInput;
  id?: GraphQlLong | null;
  enabled: boolean;
  campaignId: GraphQlLong;
  adGroupId?: GraphQlLong | null;
  adjustment: GdUpdateBidModifierSmartTgoAdjustmentItemInput;
}

export interface GdUpdateBidModifierVideoAdjustmentItemInput {
  percent: number;
  id?: GraphQlLong | null;
}

export interface GdUpdateBidModifierVideoInput {
  adjustment: GdUpdateBidModifierVideoAdjustmentItemInput;
  id?: GraphQlLong | null;
  type: GdBidModifierTypeInput;
  campaignId: GraphQlLong;
  adGroupId?: GraphQlLong | null;
  enabled: boolean;
}

export interface GdUpdateBidModifierWeatherAdjustmentItemInput {
  expression: GdUpdateBidModifierWeatherExpressionInput[][];
  percent: number;
  id?: GraphQlLong | null;
}

export interface GdUpdateBidModifierWeatherExpressionInput {
  parameter: GdWeatherTypeInput;
  operation: GdOperationTypeInput;
  value: number;
}

export interface GdUpdateBidModifierWeatherInput {
  id?: GraphQlLong | null;
  type: GdBidModifierTypeInput;
  campaignId: GraphQlLong;
  adjustments: GdUpdateBidModifierWeatherAdjustmentItemInput[];
  adGroupId?: GraphQlLong | null;
  enabled: boolean;
}

export interface GdUpdateBidModifiersInput {
  bidModifierABSegment?: GdUpdateBidModifierABSegmentInput | null;
  bidModifierDesktop?: GdUpdateBidModifierDesktopInput | null;
  bidModifierWeather?: GdUpdateBidModifierWeatherInput | null;
  bidModifierVideo?: GdUpdateBidModifierVideoInput | null;
  bidModifierExpress?: GdUpdateBidModifierExpressInput[] | null;
  bidModifierDemographics?: GdUpdateBidModifierDemographicsInput | null;
  bidModifierInventory?: GdUpdateBidModifierInventoryInput | null;
  bidModifierMobile?: GdUpdateBidModifierMobileInput | null;
  bidModifierGeo?: GdUpdateBidModifierGeoInput | null;
  bidModifierRetargeting?: GdUpdateBidModifierRetargetingInput | null;
  bidModifierSmartTgo?: GdUpdateBidModifierSmartTgoInput | null;
  bidModifierAdType?: GdUpdateBidModifierAdTypeInput | null;
}

export interface GdUpdateCampaignUnionInput {
  textCampaign?: GdUpdateTextCampaignInput | null;
}

export interface GdUpdateCampaignsInput {
  campaignUpdateItems: GdUpdateCampaignUnionInput[];
}

export interface GdUpdateCpmAdGroupInput {
  updateCpmAdGroupItems: GdUpdateCpmAdGroupItemInput[];
  isNewGroups: boolean;
}

export interface GdUpdateCpmAdGroupItemInput {
  bidModifiers?: GdUpdateBidModifiersInput | null;
  campaignId?: GraphQlLong | null;
  videoGoals?: GdVideoGoalTypeInput[] | null;
  generalPrice?: GraphQlBigDecimal | null;
  keywords?: GdUpdateAdGroupKeywordItemInput[] | null;
  pageBlocks?: GdAdGroupPageBlockInput[] | null;
  regionIds: number[];
  retargetingCondition?: GdUpdateCpmRetargetingConditionItemInput | null;
  type: GdCpmGroupTypeInput;
  adGroupName: string;
  adGroupId?: GraphQlLong | null;
}

export interface GdUpdateCpmAdInput {
  adType: GdAdTypeInput;
  pixels?: GdPixelInput[] | null;
  measurers?: GdBannerMeasurerInput[] | null;
  id: GraphQlLong;
  turbolandingId?: GraphQlLong | null;
  turbolandingHrefParams?: string | null;
  creativeId?: GraphQlLong | null;
  tnsId?: string | null;
  href?: string | null;
}

export interface GdUpdateCpmAdsInput {
  adUpdateItems: GdUpdateCpmAdInput[];
  saveDraft: boolean;
}

export interface GdUpdateCpmRetargetingConditionItemInput {
  conditionRules: GdRetargetingConditionRuleItemReqInput[];
  name: string;
}

export interface GdUpdateFlStatusRequestInput {
  status?: GdFreelancerStatusInput | null;
}

export interface GdUpdateFreelancerCardInput {
  card?: GdUpdateFreelancerCardItemInput | null;
}

export interface GdUpdateFreelancerCardItemInput {
  contacts?: GdUpdateFreelancerContactsItemInput | null;
  avatarId?: GraphQlLong | null;
  briefInfo?: string | null;
}

export interface GdUpdateFreelancerContactsItemInput {
  town?: string | null;
  email: string;
  icq?: string | null;
  siteUrl?: string | null;
  viber?: string | null;
  skype?: string | null;
  phone: string;
  telegram?: string | null;
  whatsApp?: string | null;
}

export interface GdUpdateFreelancerFeedbackRequestInput {
  willRecommend?: boolean | null;
  feedbackText?: string | null;
  freelancerId: GraphQlLong;
  overallMark?: GraphQlLong | null;
  feedbackId: string;
}

export interface GdUpdateFreelancerInput {
  regionId?: GraphQlLong | null;
}

export interface GdUpdateFreelancerSkillInput {
  skills: GdUpdateFreelancerSkillItemInput[];
}

export interface GdUpdateFreelancerSkillItemInput {
  price: GraphQlLong;
  skillId: GraphQlLong;
  duration?: GdFreelancerSkillOfferDurationInput | null;
  days?: string | null;
}

export interface GdUpdateInternalAdGroupsInput {
  updateItems: GdUpdateInternalAdGroupsItemInput[];
}

export interface GdUpdateInternalAdGroupsItemInput {
  level?: GraphQlLong | null;
  targetingYandexUids?: GdAdditionalTargetingYandexUidsInput | null;
  targetingQueryReferers?: GdAdditionalTargetingQueryReferersInput | null;
  rfReset?: number | null;
  targetingBrowserNames?: GdAdditionalTargetingBrowserNamesInput | null;
  targetingDeviceVendors?: GdAdditionalTargetingDeviceVendorsInput | null;
  targetingClids?: GdAdditionalTargetingClidsInput | null;
  rf?: number | null;
  targetingDesktopInstalledApps?: GdAdditionalTargetingDesktopInstalledAppsInput | null;
  finishTime?: GraphQlLocalDateTime | null;
  targetingIsBrowser?: GdAdditionalTargetingIsBrowserInput | null;
  targetingDeviceNames?: GdAdditionalTargetingDeviceNamesInput | null;
  id: GraphQlLong;
  regionIds: number[];
  targetingIsMobile?: GdAdditionalTargetingIsMobileInput | null;
  targetingIsTablet?: GdAdditionalTargetingIsTabletInput | null;
  name: string;
  targetingOsNames?: GdAdditionalTargetingOsNamesInput | null;
  targetingYsCookies?: GdAdditionalTargetingYsCookiesInput | null;
  targetingBrowserEngines?: GdAdditionalTargetingBrowserEnginesInput | null;
  targetingMobileInstalledApps?: GdAdditionalTargetingMobileInstalledAppsInput | null;
  targetingOsFamilies?: GdAdditionalTargetingOsFamiliesInput | null;
  targetingInterfaceLangs?: GdAdditionalTargetingInterfaceLangsInput | null;
  targetingUserAgents?: GdAdditionalTargetingUserAgentsInput | null;
  targetingIsYandexPlus?: GdAdditionalTargetingIsYandexPlusInput | null;
  startTime?: GraphQlLocalDateTime | null;
  targetingQueryOptions?: GdAdditionalTargetingQueryOptionsInput | null;
  targetingClidTypes?: GdAdditionalTargetingClidTypesInput | null;
  targetingTestIds?: GdAdditionalTargetingTestIdsInput | null;
  targetingInternalNetwork?: GdAdditionalTargetingInternalNetworkInput | null;
  targetingShowDates?: GdAdditionalTargetingShowDatesInput | null;
  targetingIsTouch?: GdAdditionalTargetingIsTouchInput | null;
}

export interface GdUpdateInternalAdsInput {
  adUpdateItems: GdUpdateInternalAdsItemInput[];
  saveDraft: boolean;
}

export interface GdUpdateInternalAdsItemInput {
  description: string;
  templateVars: GdTemplateVariableInput[];
  id: GraphQlLong;
}

export interface GdUpdateKeywordsInput {
  keywordUpdateItems: GdUpdateKeywordsItemInput[];
}

export interface GdUpdateKeywordsItemInput {
  autobudgetPriority?: number | null;
  id: GraphQlLong;
  keyword?: string | null;
  price?: GraphQlBigDecimal | null;
  priceContext?: GraphQlBigDecimal | null;
}

export interface GdUpdateMcBannerAdInput {
  id: GraphQlLong;
  href: string;
  adType: GdAdTypeInput;
  adImageHash: string;
}

export interface GdUpdateMcBannerAdsInput {
  adUpdateItems: GdUpdateMcBannerAdInput[];
  saveDraft: boolean;
}

export interface GdUpdateMinusKeywordsPacksInput {
  updateItems: GdUpdateMinusKeywordsPacksItemInput[];
}

export interface GdUpdateMinusKeywordsPacksItemInput {
  id: GraphQlLong;
  name?: string | null;
  minusKeywords?: string[] | null;
}

export interface GdUpdateOrganizationInput {
  permalinkId?: GraphQlLong | null;
  bannerId: GraphQlLong;
}

export interface GdUpdatePerformanceAdGroupInput {
  updateItems: GdUpdatePerformanceAdGroupItemInput[];
}

export interface GdUpdatePerformanceAdGroupItemInput {
  fieldToUseAsBody?: string | null;
  minusKeywords: string[];
  name: string;
  regionIds: number[];
  libraryMinusKeywordsIds?: GraphQlLong[] | null;
  bidModifiers?: GdUpdateBidModifiersInput | null;
  id: GraphQlLong;
  trackingParams?: string | null;
  fieldToUseAsName?: string | null;
}

export interface GdUpdateRetargetingConditionItemInput {
  type: GdRetargetingConditionTypeInput;
  description?: string | null;
  retargetingConditionId: GraphQlLong;
  name: string;
  conditionRules: GdRetargetingConditionRuleItemReqInput[];
}

export interface GdUpdateRetargetingConditionsInput {
  retargetingConditions?: GdUpdateRetargetingConditionItemInput[] | null;
}

export interface GdUpdateSmartAdInput {
  id: GraphQlLong;
  creativeId: GraphQlLong;
}

export interface GdUpdateSmartAdsInput {
  saveDraft: boolean;
  adUpdateItems: GdUpdateSmartAdInput[];
}

export interface GdUpdateSmartCentersInput {
  imageHash: string;
  smartCenters: GdUpdateSmartCentersItemInput[];
}

export interface GdUpdateSmartCentersItemInput {
  smartCenter: GdImageSmartCenterInput;
  size: string;
}

export interface GdUpdateSmartFilterConditionInput {
  operator: GdSmartFilterConditionOperatorInput;
  stringValue: string;
  field: string;
}

export interface GdUpdateSmartFiltersInput {
  updateItems: GdUpdateSmartFiltersItemInput[];
}

export interface GdUpdateSmartFiltersItemInput {
  targetFunnel?: GdSmartFilterTargetFunnelInput | null;
  id: GraphQlLong;
  priceCpc?: GraphQlBigDecimal | null;
  tab?: GdSmartFilterTabInput | null;
  isSuspended?: boolean | null;
  name?: string | null;
  conditions?: GdUpdateSmartFilterConditionInput[] | null;
  autobudgetPriority?: GdShowConditionAutobudgetPriorityInput | null;
  priceCpa?: GraphQlBigDecimal | null;
}

export interface GdUpdateTextAdGroupInput {
  updateItems: GdUpdateTextAdGroupItemInput[];
}

export interface GdUpdateTextAdGroupItemInput {
  keywords?: GdUpdateAdGroupKeywordItemInput[] | null;
  relevanceMatch?: GdUpdateAdGroupRelevanceMatchItemInput | null;
  useBidModifiers?: boolean | null;
  adGroupId: GraphQlLong;
  retargetings?: GdUpdateAdGroupRetargetingItemInput[] | null;
  regionIds: number[];
  libraryMinusKeywordsIds: GraphQlLong[];
  bidModifiers: GdUpdateBidModifiersInput;
  generalPrice?: GraphQlBigDecimal | null;
  adGroupName: string;
  adGroupMinusKeywords: string[];
}

export interface GdUpdateTextCampaignInput {
  hasExtendedGeoTargeting?: boolean | null;
  id: GraphQlLong;
  hasAddMetrikaTagToUrl?: boolean | null;
  disabledPlaces?: string[] | null;
  biddingStategy: GdCampaignBiddingStrategyInput;
  defaultPermalink?: GraphQlLong | null;
  allowedPageIds?: GraphQlLong[] | null;
  contentLanguage?: GdContentLanguageInput | null;
  notification: GdCampaignNotificationRequestInput;
  startDate: GraphQlLocalDate;
  excludePausedCompetingAds?: boolean | null;
  vcard?: GdAddCampaignVcardInput | null;
  broadMatch?: GdBroadMatchRequestInput | null;
  contextLimit?: number | null;
  isFavorite?: boolean | null;
  meaningfulGoals?: (GdMeaningfulGoalRequestInput | null)[] | null;
  bidModifiers?: GdUpdateBidModifiersInput | null;
  metrikaCounters?: number[] | null;
  enableCompanyInfo?: boolean | null;
  attributionModel?: GdCampaignAttributionModelInput | null;
  enableCpcHold?: boolean | null;
  dayBudgetShowMode?: GdDayBudgetShowModeInput | null;
  dayBudget?: GraphQlBigDecimal | null;
  clientDialogId?: GraphQlLong | null;
  hasTitleSubstitute: boolean;
  name: string;
  abSegmentStatisticRetargetingConditionId?: GraphQlLong | null;
  abSegmentRetargetingConditionId?: GraphQlLong | null;
  hasSiteMonitoring?: boolean | null;
  disabledIps?: string[] | null;
  endDate?: GraphQlLocalDate | null;
  hasAddOpenstatTagToUrl?: boolean | null;
  timeTarget?: GdTimeTargetInput | null;
}

export interface GdUpdateUserPhoneInput {
  phone: string;
}

export interface GdVideoCreativeInput {
  duration?: number | null;
}

export interface GdiDealFilterInput {
  maxCpc?: GraphQlBigDecimal | null;
  minSpent?: GraphQlBigDecimal | null;
  maxSpent?: GraphQlBigDecimal | null;
  maxMinPrice?: GraphQlBigDecimal | null;
  maxCtr?: GraphQlBigDecimal | null;
  completeReasonContains?: (CompleteReasonInput | null)[] | null;
  minMinPrice?: GraphQlBigDecimal | null;
  minNumberOfLinkedCampaigns?: number | null;
  typeIn?: (DealTypeInput | null)[] | null;
  maxNumberOfLinkedCampaigns?: number | null;
  maxShows?: GraphQlLong | null;
  nameNotContains?: string | null;
  minClicks?: GraphQlLong | null;
  nameContains?: string | null;
  minShows?: GraphQlLong | null;
  statusContains?: (StatusDirectInput | null)[] | null;
  dealIdExcluded?: (GraphQlLong | null)[] | null;
  minCpm?: GraphQlBigDecimal | null;
  maxCpm?: GraphQlBigDecimal | null;
  minCpc?: GraphQlBigDecimal | null;
  dealIdIncluded?: (GraphQlLong | null)[] | null;
  maxClicks?: GraphQlLong | null;
  nameNotIn?: (string | null)[] | null;
  minCtr?: GraphQlBigDecimal | null;
  nameIn?: (string | null)[] | null;
}

export interface SearchOptionsInput {
  onlyWholeWords: boolean;
  matchCase: boolean;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
